export default [
  {
   "Name": "YuveYuveYu",
   "Danceability": 0.624,
   "Energy": 0.857,
   "Key": 10,
   "Loudness": -6.25,
   "Mode": 0,
   "Speechness": 0.0542,
   "Acousticness": 0.0208,
   "Instrumentalness": 0.206,
   "Liveness": 0.11,
   "Valence": 0.324,
   "Tempo": 131.926,
   "Type": "audio_features",
   "ID": "6J2VvzKwWc2f0JP5RQVZjq",
   "Uri": "spotify:track:6J2VvzKwWc2f0JP5RQVZjq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6J2VvzKwWc2f0JP5RQVZjq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6J2VvzKwWc2f0JP5RQVZjq",
   "Duration_ms": 282920,
   "time_signature": 4,
   "Genre": "celticmetal"
 },
 {
   "Name": "Milion",
   "Danceability": 0.734,
   "Energy": 0.677,
   "Key": 0,
   "Loudness": -4.12,
   "Mode": 0,
   "Speechness": 0.0471,
   "Acousticness": 0.087,
   "Instrumentalness": 0,
   "Liveness": 0.104,
   "Valence": 0.189,
   "Tempo": 75.053,
   "Type": "audio_features",
   "ID": "7lDuA0zGpNONIAsrwWr4yr",
   "Uri": "spotify:track:7lDuA0zGpNONIAsrwWr4yr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7lDuA0zGpNONIAsrwWr4yr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7lDuA0zGpNONIAsrwWr4yr",
   "Duration_ms": 158500,
   "time_signature": 4,
   "Genre": "balkantrap"
 },
 {
   "Name": "Skolka",
   "Danceability": 0.609,
   "Energy": 0.964,
   "Key": 0,
   "Loudness": -2.088,
   "Mode": 1,
   "Speechness": 0.114,
   "Acousticness": 0.00686,
   "Instrumentalness": 0,
   "Liveness": 0.723,
   "Valence": 0.401,
   "Tempo": 144.076,
   "Type": "audio_features",
   "ID": "1Sq8nGwD8I4TeLa1yiCgDV",
   "Uri": "spotify:track:1Sq8nGwD8I4TeLa1yiCgDV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Sq8nGwD8I4TeLa1yiCgDV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Sq8nGwD8I4TeLa1yiCgDV",
   "Duration_ms": 194480,
   "time_signature": 4,
   "Genre": "slovakrock"
 },
 {
   "Name": "LeavingtheSolarSystem",
   "Danceability": 0.485,
   "Energy": 0.0471,
   "Key": 2,
   "Loudness": -25.273,
   "Mode": 0,
   "Speechness": 0.0499,
   "Acousticness": 0.972,
   "Instrumentalness": 0.86,
   "Liveness": 0.0866,
   "Valence": 0.124,
   "Tempo": 119.979,
   "Type": "audio_features",
   "ID": "1S8Was2vxyk39dgCa0nDfB",
   "Uri": "spotify:track:1S8Was2vxyk39dgCa0nDfB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1S8Was2vxyk39dgCa0nDfB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1S8Was2vxyk39dgCa0nDfB",
   "Duration_ms": 105000,
   "time_signature": 4,
   "Genre": "deepchill-out"
 },
 {
     "Name": "OhYeah",
   "Danceability": 0.776,
   "Energy": 0.646,
   "Key": 2,
   "Loudness": -4.678,
   "Mode": 0,
   "Speechness": 0.0308,
   "Acousticness": 0.37,
   "Instrumentalness": 0.0000196,
   "Liveness": 0.0579,
   "Valence": 0.831,
   "Tempo": 107.009,
   "Type": "audio_features",
   "ID": "6awaTwt2xGyctVOsvN3BhT",
   "Uri": "spotify:track:6awaTwt2xGyctVOsvN3BhT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6awaTwt2xGyctVOsvN3BhT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6awaTwt2xGyctVOsvN3BhT",
   "Duration_ms": 250279,
   "time_signature": 4,
   "Genre": "ghanaianhiphop"
 },
 {
     "Name": "IHaveBeenFloated",
   "Danceability": 0.266,
   "Energy": 0.43,
   "Key": 11,
   "Loudness": -11.758,
   "Mode": 0,
   "Speechness": 0.0313,
   "Acousticness": 0.155,
   "Instrumentalness": 0.0000209,
   "Liveness": 0.203,
   "Valence": 0.226,
   "Tempo": 75.887,
   "Type": "audio_features",
   "ID": "7sggBSMpdtpqtISmXvr8yN",
   "Uri": "spotify:track:7sggBSMpdtpqtISmXvr8yN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7sggBSMpdtpqtISmXvr8yN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7sggBSMpdtpqtISmXvr8yN",
   "Duration_ms": 219521,
   "time_signature": 4,
   "Genre": "e6fi"
 },
 {
     "Name": "Niemandwirdsowiederwerden",
   "Danceability": 0.401,
   "Energy": 0.397,
   "Key": 7,
   "Loudness": -12.719,
   "Mode": 1,
   "Speechness": 0.0329,
   "Acousticness": 0.0866,
   "Instrumentalness": 0.00237,
   "Liveness": 0.113,
   "Valence": 0.489,
   "Tempo": 174.374,
   "Type": "audio_features",
   "ID": "5nuXZXMVG5y4U8QepC3dCD",
   "Uri": "spotify:track:5nuXZXMVG5y4U8QepC3dCD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5nuXZXMVG5y4U8QepC3dCD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5nuXZXMVG5y4U8QepC3dCD",
   "Duration_ms": 282267,
   "time_signature": 4,
   "Genre": "ostrock"
 },
 {
     "Name": "UnsungHeroes",
   "Danceability": 0.474,
   "Energy": 0.704,
   "Key": 10,
   "Loudness": -6.531,
   "Mode": 1,
   "Speechness": 0.0465,
   "Acousticness": 0.000112,
   "Instrumentalness": 0.00287,
   "Liveness": 0.385,
   "Valence": 0.153,
   "Tempo": 131.153,
   "Type": "audio_features",
   "ID": "7uRYuphOE7M6dYuFb4EaAh",
   "Uri": "spotify:track:7uRYuphOE7M6dYuFb4EaAh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7uRYuphOE7M6dYuFb4EaAh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7uRYuphOE7M6dYuFb4EaAh",
   "Duration_ms": 242461,
   "time_signature": 4,
   "Genre": "slovakindie"
 },
 {
     "Name": "Showgh",
   "Danceability": 0.367,
   "Energy": 0.237,
   "Key": 1,
   "Loudness": -14.318,
   "Mode": 1,
   "Speechness": 0.0352,
   "Acousticness": 0.837,
   "Instrumentalness": 0.954,
   "Liveness": 0.112,
   "Valence": 0.295,
   "Tempo": 84.36,
   "Type": "audio_features",
   "ID": "6SYpDgnU7hpDF7Do8JQKh5",
   "Uri": "spotify:track:6SYpDgnU7hpDF7Do8JQKh5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6SYpDgnU7hpDF7Do8JQKh5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6SYpDgnU7hpDF7Do8JQKh5",
   "Duration_ms": 357493,
   "time_signature": 4,
   "Genre": "persiantraditional"
 },
 {
     "Name": "Alea",
   "Danceability": 0.75,
   "Energy": 0.769,
   "Key": 5,
   "Loudness": -2.839,
   "Mode": 0,
   "Speechness": 0.045,
   "Acousticness": 0.39,
   "Instrumentalness": 0.000335,
   "Liveness": 0.0879,
   "Valence": 0.586,
   "Tempo": 109.968,
   "Type": "audio_features",
   "ID": "0zOQVFZvuZcAqRNlQWyF3n",
   "Uri": "spotify:track:0zOQVFZvuZcAqRNlQWyF3n",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0zOQVFZvuZcAqRNlQWyF3n",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0zOQVFZvuZcAqRNlQWyF3n",
   "Duration_ms": 157108,
   "time_signature": 4,
   "Genre": "albanianhiphop"
 },
 {
      "Name": "TallBoogie",
   "Danceability": 0.311,
   "Energy": 0.889,
   "Key": 9,
   "Loudness": -5.681,
   "Mode": 1,
   "Speechness": 0.652,
   "Acousticness": 0.00633,
   "Instrumentalness": 0.243,
   "Liveness": 0.323,
   "Valence": 0.571,
   "Tempo": 200.525,
   "Type": "audio_features",
   "ID": "6NujEiqFKnTMeQ0xURCbUD",
   "Uri": "spotify:track:6NujEiqFKnTMeQ0xURCbUD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6NujEiqFKnTMeQ0xURCbUD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6NujEiqFKnTMeQ0xURCbUD",
   "Duration_ms": 197253,
   "time_signature": 4,
   "Genre": "modernblues"
 },
 {
      "Name": "GirlsLikeYou",
   "Danceability": 0.832,
   "Energy": 0.596,
   "Key": 0,
   "Loudness": -6.981,
   "Mode": 1,
   "Speechness": 0.0475,
   "Acousticness": 0.507,
   "Instrumentalness": 0,
   "Liveness": 0.11,
   "Valence": 0.359,
   "Tempo": 124.962,
   "Type": "audio_features",
   "ID": "3Nr6Pi2uoxHTGbYfPDYccH",
   "Uri": "spotify:track:3Nr6Pi2uoxHTGbYfPDYccH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3Nr6Pi2uoxHTGbYfPDYccH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3Nr6Pi2uoxHTGbYfPDYccH",
   "Duration_ms": 217685,
   "time_signature": 4,
   "Genre": "canadianpop"
 },
 {
      "Name": "Lambreta",
   "Danceability": 0.695,
   "Energy": 0.171,
   "Key": 9,
   "Loudness": -12.284,
   "Mode": 1,
   "Speechness": 0.101,
   "Acousticness": 0.849,
   "Instrumentalness": 0.0349,
   "Liveness": 0.108,
   "Valence": 0.396,
   "Tempo": 132.887,
   "Type": "audio_features",
   "ID": "6OrNf46vJrHqNP3IFpmvhV",
   "Uri": "spotify:track:6OrNf46vJrHqNP3IFpmvhV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6OrNf46vJrHqNP3IFpmvhV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6OrNf46vJrHqNP3IFpmvhV",
   "Duration_ms": 144240,
   "time_signature": 3,
   "Genre": "portuguesefolk"
 },
 {
      "Name": "Steentje",
   "Danceability": 0.682,
   "Energy": 0.455,
   "Key": 7,
   "Loudness": -9.738,
   "Mode": 0,
   "Speechness": 0.0902,
   "Acousticness": 0.663,
   "Instrumentalness": 0.0602,
   "Liveness": 0.12,
   "Valence": 0.424,
   "Tempo": 71.976,
   "Type": "audio_features",
   "ID": "2j4sbzmSxCjlZJzBQ5OpUC",
   "Uri": "spotify:track:2j4sbzmSxCjlZJzBQ5OpUC",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2j4sbzmSxCjlZJzBQ5OpUC",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2j4sbzmSxCjlZJzBQ5OpUC",
   "Duration_ms": 216347,
   "time_signature": 4,
   "Genre": "belgianpop"
 },
 {
      "Name": "Égfelé",
   "Danceability": 0.518,
   "Energy": 0.85,
   "Key": 5,
   "Loudness": -4.032,
   "Mode": 1,
   "Speechness": 0.034,
   "Acousticness": 0.207,
   "Instrumentalness": 0.000246,
   "Liveness": 0.0798,
   "Valence": 0.2,
   "Tempo": 129.988,
   "Type": "audio_features",
   "ID": "0JxchgesbHnLwg18ZBeSKZ",
   "Uri": "spotify:track:0JxchgesbHnLwg18ZBeSKZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0JxchgesbHnLwg18ZBeSKZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0JxchgesbHnLwg18ZBeSKZ",
   "Duration_ms": 356960,
   "time_signature": 4,
   "Genre": "runefolk"
 },
 {
      "Name": "Crumblenaut",
   "Danceability": 0.694,
   "Energy": 0.831,
   "Key": 8,
   "Loudness": -7.31,
   "Mode": 1,
   "Speechness": 0.0569,
   "Acousticness": 0.0814,
   "Instrumentalness": 0.106,
   "Liveness": 0.225,
   "Valence": 0.762,
   "Tempo": 145.987,
   "Type": "audio_features",
   "ID": "6U9h1p24DYdPAzro5zafKr",
   "Uri": "spotify:track:6U9h1p24DYdPAzro5zafKr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6U9h1p24DYdPAzro5zafKr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6U9h1p24DYdPAzro5zafKr",
   "Duration_ms": 391227,
   "time_signature": 4,
   "Genre": "psychill"
 },
 {
      "Name": "EightSoundsLikeAte",
   "Danceability": 0.607,
   "Energy": 0.654,
   "Key": 1,
   "Loudness": -8.427,
   "Mode": 1,
   "Speechness": 0.94,
   "Acousticness": 0.766,
   "Instrumentalness": 0,
   "Liveness": 0.94,
   "Valence": 0.622,
   "Tempo": 64.188,
   "Type": "audio_features",
   "ID": "0tf3jClFUzVYF7Fe2bfFjV",
   "Uri": "spotify:track:0tf3jClFUzVYF7Fe2bfFjV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0tf3jClFUzVYF7Fe2bfFjV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0tf3jClFUzVYF7Fe2bfFjV",
   "Duration_ms": 202773,
   "time_signature": 4,
   "Genre": "deepcomedy"
 },
 {
      "Name": "BadLiar",
   "Danceability": 0.383,
   "Energy": 0.637,
   "Key": 3,
   "Loudness": -6.993,
   "Mode": 1,
   "Speechness": 0.0703,
   "Acousticness": 0.0722,
   "Instrumentalness": 0,
   "Liveness": 0.368,
   "Valence": 0.0827,
   "Tempo": 177.913,
   "Type": "audio_features",
   "ID": "1erDNx55IWAE9OYuBTRYgc",
   "Uri": "spotify:track:1erDNx55IWAE9OYuBTRYgc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1erDNx55IWAE9OYuBTRYgc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1erDNx55IWAE9OYuBTRYgc",
   "Duration_ms": 260773,
   "time_signature": 4,
   "Genre": "lapop"
 },
 {
    "Name": "WarmUp-Summertime/FlyMetotheMoon",
   "Danceability": 0.734,
   "Energy": 0.0498,
   "Key": 9,
   "Loudness": -20.955,
   "Mode": 0,
   "Speechness": 0.209,
   "Acousticness": 0.985,
   "Instrumentalness": 0.83,
   "Liveness": 0.116,
   "Valence": 0.65,
   "Tempo": 112.057,
   "Type": "audio_features",
   "ID": "1KCBaq5olu8Vat0UKv2xLk",
   "Uri": "spotify:track:1KCBaq5olu8Vat0UKv2xLk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1KCBaq5olu8Vat0UKv2xLk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1KCBaq5olu8Vat0UKv2xLk",
   "Duration_ms": 152420,
   "time_signature": 4,
   "Genre": "balletclass"
 },
 {
    "Name": "CelicaOsSang",
   "Danceability": 0.746,
   "Energy": 0.927,
   "Key": 11,
   "Loudness": -7.06,
   "Mode": 0,
   "Speechness": 0.0392,
   "Acousticness": 0.368,
   "Instrumentalness": 0.00273,
   "Liveness": 0.144,
   "Valence": 0.92,
   "Tempo": 136.587,
   "Type": "audio_features",
   "ID": "37oDSmxNfKs1mnYETKDnA7",
   "Uri": "spotify:track:37oDSmxNfKs1mnYETKDnA7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/37oDSmxNfKs1mnYETKDnA7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/37oDSmxNfKs1mnYETKDnA7",
   "Duration_ms": 279478,
   "time_signature": 4,
   "Genre": "khmer"
 },
 {
    "Name": "Refuse/Resist",
   "Danceability": 0.475,
   "Energy": 0.953,
   "Key": 2,
   "Loudness": -6.95,
   "Mode": 1,
   "Speechness": 0.147,
   "Acousticness": 0.000288,
   "Instrumentalness": 0.00337,
   "Liveness": 0.104,
   "Valence": 0.224,
   "Tempo": 118.033,
   "Type": "audio_features",
   "ID": "2OoS1aZFAFscH1cUiKlazH",
   "Uri": "spotify:track:2OoS1aZFAFscH1cUiKlazH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2OoS1aZFAFscH1cUiKlazH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2OoS1aZFAFscH1cUiKlazH",
   "Duration_ms": 199227,
   "time_signature": 4,
   "Genre": "groovemetal"
 },
 {
    "Name": "LittleBrother-Instrumental",
   "Danceability": 0.442,
   "Energy": 0.236,
   "Key": 0,
   "Loudness": -14.048,
   "Mode": 1,
   "Speechness": 0.0327,
   "Acousticness": 0.984,
   "Instrumentalness": 0.947,
   "Liveness": 0.251,
   "Valence": 0.206,
   "Tempo": 77.378,
   "Type": "audio_features",
   "ID": "5M5Koy1MEDGQ081SivilWW",
   "Uri": "spotify:track:5M5Koy1MEDGQ081SivilWW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5M5Koy1MEDGQ081SivilWW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5M5Koy1MEDGQ081SivilWW",
   "Duration_ms": 263507,
   "time_signature": 4,
   "Genre": "pianoblues"
 },
 {
    "Name": "Ruoska",
   "Danceability": 0.328,
   "Energy": 0.764,
   "Key": 2,
   "Loudness": -5.054,
   "Mode": 0,
   "Speechness": 0.078,
   "Acousticness": 0.0000173,
   "Instrumentalness": 0.734,
   "Liveness": 0.188,
   "Valence": 0.0386,
   "Tempo": 119.797,
   "Type": "audio_features",
   "ID": "3yx1BDkbzVkqt0YQli2KGH",
   "Uri": "spotify:track:3yx1BDkbzVkqt0YQli2KGH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3yx1BDkbzVkqt0YQli2KGH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3yx1BDkbzVkqt0YQli2KGH",
   "Duration_ms": 363373,
   "time_signature": 4,
   "Genre": "dronemetal"
 },
 {
    "Name": "Uppercut",
   "Danceability": 0.329,
   "Energy": 0.846,
   "Key": 9,
   "Loudness": -5.712,
   "Mode": 1,
   "Speechness": 0.0735,
   "Acousticness": 0.000054,
   "Instrumentalness": 0.561,
   "Liveness": 0.364,
   "Valence": 0.473,
   "Tempo": 79.997,
   "Type": "audio_features",
   "ID": "7tDYlqNuO788KIiWJxfgHh",
   "Uri": "spotify:track:7tDYlqNuO788KIiWJxfgHh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7tDYlqNuO788KIiWJxfgHh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7tDYlqNuO788KIiWJxfgHh",
   "Duration_ms": 164701,
   "time_signature": 4,
   "Genre": "dreampop"
 },
 {
    "Name": "Shoreline",
   "Danceability": 0.344,
   "Energy": 0.7,
   "Key": 7,
   "Loudness": -4.198,
   "Mode": 0,
   "Speechness": 0.041,
   "Acousticness": 0.00412,
   "Instrumentalness": 0.000694,
   "Liveness": 0.378,
   "Valence": 0.527,
   "Tempo": 113.332,
   "Type": "audio_features",
   "ID": "77jVczOFXfbdugN4djsIqs",
   "Uri": "spotify:track:77jVczOFXfbdugN4djsIqs",
   "Ref_Track": "https://api.spotify.com/v1/tracks/77jVczOFXfbdugN4djsIqs",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/77jVczOFXfbdugN4djsIqs",
   "Duration_ms": 259920,
   "time_signature": 4,
   "Genre": "swedishindiepop"
 },
 {
    "Name": "DDU-DUDDU-DU",
   "Danceability": 0.671,
   "Energy": 0.859,
   "Key": 4,
   "Loudness": -3.922,
   "Mode": 0,
   "Speechness": 0.0833,
   "Acousticness": 0.0323,
   "Instrumentalness": 0,
   "Liveness": 0.267,
   "Valence": 0.389,
   "Tempo": 139.931,
   "Type": "audio_features",
   "ID": "2aI2k39nfa3KFsa4JclQzw",
   "Uri": "spotify:track:2aI2k39nfa3KFsa4JclQzw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2aI2k39nfa3KFsa4JclQzw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2aI2k39nfa3KFsa4JclQzw",
   "Duration_ms": 209355,
   "time_signature": 4,
   "Genre": "undergroundpowerpop"
 },
 {
    "Name": "BermondseyBosom(Left)",
   "Danceability": 0.371,
   "Energy": 0.799,
   "Key": 4,
   "Loudness": -10.872,
   "Mode": 1,
   "Speechness": 0.184,
   "Acousticness": 0.802,
   "Instrumentalness": 0.000103,
   "Liveness": 0.108,
   "Valence": 0.471,
   "Tempo": 94.482,
   "Type": "audio_features",
   "ID": "0YPflIsuvtoBVFeWf7uQoH",
   "Uri": "spotify:track:0YPflIsuvtoBVFeWf7uQoH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0YPflIsuvtoBVFeWf7uQoH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0YPflIsuvtoBVFeWf7uQoH",
   "Duration_ms": 74811,
   "time_signature": 4,
   "Genre": "sungpoetry"
 },
 {
    "Name": "AviéntenseTodos",
   "Danceability": 0.606,
   "Energy": 0.876,
   "Key": 2,
   "Loudness": -6.584,
   "Mode": 1,
   "Speechness": 0.137,
   "Acousticness": 0.234,
   "Instrumentalness": 0.0045,
   "Liveness": 0.0625,
   "Valence": 0.941,
   "Tempo": 168.628,
   "Type": "audio_features",
   "ID": "7Gv8f9DqZ4tyGmVt9MKNpI",
   "Uri": "spotify:track:7Gv8f9DqZ4tyGmVt9MKNpI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7Gv8f9DqZ4tyGmVt9MKNpI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7Gv8f9DqZ4tyGmVt9MKNpI",
   "Duration_ms": 126381,
   "time_signature": 4,
   "Genre": "mexicanrock-and-roll"
 },
 {
    "Name": "EnoughtoBelieve-JamieJonesRemix",
   "Danceability": 0.698,
   "Energy": 0.831,
   "Key": 1,
   "Loudness": -7.095,
   "Mode": 1,
   "Speechness": 0.0373,
   "Acousticness": 0.00108,
   "Instrumentalness": 0.266,
   "Liveness": 0.161,
   "Valence": 0.138,
   "Tempo": 123.988,
   "Type": "audio_features",
   "ID": "6BVZyHVBeNkPaLF2e7G0c1",
   "Uri": "spotify:track:6BVZyHVBeNkPaLF2e7G0c1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6BVZyHVBeNkPaLF2e7G0c1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6BVZyHVBeNkPaLF2e7G0c1",
   "Duration_ms": 314873,
   "time_signature": 4,
   "Genre": "minimaldub"
 },
 {
    "Name": "SingfromtheGallows",
   "Danceability": 0.483,
   "Energy": 0.891,
   "Key": 8,
   "Loudness": -5.39,
   "Mode": 1,
   "Speechness": 0.0464,
   "Acousticness": 0.0000453,
   "Instrumentalness": 0.227,
   "Liveness": 0.114,
   "Valence": 0.148,
   "Tempo": 129.996,
   "Type": "audio_features",
   "ID": "6dwLxarWQMqJNdAboua4T0",
   "Uri": "spotify:track:6dwLxarWQMqJNdAboua4T0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6dwLxarWQMqJNdAboua4T0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6dwLxarWQMqJNdAboua4T0",
   "Duration_ms": 281582,
   "time_signature": 4,
   "Genre": "belgianmetal"
 },
 {
      "Name": "Can\\tLetGo",
   "Danceability": 0.649,
   "Energy": 0.794,
   "Key": 6,
   "Loudness": -9.46,
   "Mode": 1,
   "Speechness": 0.0352,
   "Acousticness": 0.144,
   "Instrumentalness": 0.000302,
   "Liveness": 0.072,
   "Valence": 0.966,
   "Tempo": 127.792,
   "Type": "audio_features",
   "ID": "6a44RET0b0enJMb5PVQlr8",
   "Uri": "spotify:track:6a44RET0b0enJMb5PVQlr8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6a44RET0b0enJMb5PVQlr8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6a44RET0b0enJMb5PVQlr8",
   "Duration_ms": 208693,
   "time_signature": 4,
   "Genre": "raregroove"
 },
 {
      "Name": "21stCenturyRush-Sy&UnknownRemix",
   "Danceability": 0.342,
   "Energy": 0.982,
   "Key": 0,
   "Loudness": -4.947,
   "Mode": 1,
   "Speechness": 0.0559,
   "Acousticness": 0.000348,
   "Instrumentalness": 0.559,
   "Liveness": 0.369,
   "Valence": 0.178,
   "Tempo": 180.006,
   "Type": "audio_features",
   "ID": "3IlOMZngIoKFWxnfobSjgr",
   "Uri": "spotify:track:3IlOMZngIoKFWxnfobSjgr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3IlOMZngIoKFWxnfobSjgr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3IlOMZngIoKFWxnfobSjgr",
   "Duration_ms": 255973,
   "time_signature": 4,
   "Genre": "newrave"
 },
 {
      "Name": "GimmeChocolate!!",
   "Danceability": 0.616,
   "Energy": 0.985,
   "Key": 11,
   "Loudness": -1.598,
   "Mode": 1,
   "Speechness": 0.0832,
   "Acousticness": 0.000273,
   "Instrumentalness": 0.000145,
   "Liveness": 0.111,
   "Valence": 0.487,
   "Tempo": 109.979,
   "Type": "audio_features",
   "ID": "17ZOICUf4FYlzOAQajt3rN",
   "Uri": "spotify:track:17ZOICUf4FYlzOAQajt3rN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/17ZOICUf4FYlzOAQajt3rN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/17ZOICUf4FYlzOAQajt3rN",
   "Duration_ms": 230613,
   "time_signature": 4,
   "Genre": "japanesedeathmetal"
 },
 {
      "Name": "L3na7arb",
   "Danceability": 0.759,
   "Energy": 0.639,
   "Key": 10,
   "Loudness": -7.605,
   "Mode": 0,
   "Speechness": 0.336,
   "Acousticness": 0.239,
   "Instrumentalness": 0,
   "Liveness": 0.11,
   "Valence": 0.448,
   "Tempo": 86.897,
   "Type": "audio_features",
   "ID": "0itjkUVj6g4Q8pGIM1KDsb",
   "Uri": "spotify:track:0itjkUVj6g4Q8pGIM1KDsb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0itjkUVj6g4Q8pGIM1KDsb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0itjkUVj6g4Q8pGIM1KDsb",
   "Duration_ms": 335360,
   "time_signature": 4,
   "Genre": "arabichiphop"
 },
 {
      "Name": "Homofugitvelutumbra(PassacagliadellaVita)",
   "Danceability": 0.487,
   "Energy": 0.144,
   "Key": 9,
   "Loudness": -21.35,
   "Mode": 0,
   "Speechness": 0.0492,
   "Acousticness": 0.92,
   "Instrumentalness": 0.0000995,
   "Liveness": 0.077,
   "Valence": 0.357,
   "Tempo": 118.757,
   "Type": "audio_features",
   "ID": "4tR6ADm4od5ywAuNzTQBfT",
   "Uri": "spotify:track:4tR6ADm4od5ywAuNzTQBfT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4tR6ADm4od5ywAuNzTQBfT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4tR6ADm4od5ywAuNzTQBfT",
   "Duration_ms": 257320,
   "time_signature": 4,
   "Genre": "italianbaroque"
 },
 {
      "Name": "WhenTheLightsAreDown",
   "Danceability": 0.29,
   "Energy": 0.944,
   "Key": 10,
   "Loudness": -6.377,
   "Mode": 0,
   "Speechness": 0.0789,
   "Acousticness": 0.0000417,
   "Instrumentalness": 0.0495,
   "Liveness": 0.119,
   "Valence": 0.361,
   "Tempo": 169.959,
   "Type": "audio_features",
   "ID": "2kHhZ63nmJYUL7pYoTpBP7",
   "Uri": "spotify:track:2kHhZ63nmJYUL7pYoTpBP7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2kHhZ63nmJYUL7pYoTpBP7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2kHhZ63nmJYUL7pYoTpBP7",
   "Duration_ms": 221467,
   "time_signature": 4,
   "Genre": "gothicmetal"
 },
 {
      "Name": "CountingEveryBlessing",
   "Danceability": 0.55,
   "Energy": 0.681,
   "Key": 9,
   "Loudness": -4.759,
   "Mode": 1,
   "Speechness": 0.0334,
   "Acousticness": 0.136,
   "Instrumentalness": 0,
   "Liveness": 0.216,
   "Valence": 0.174,
   "Tempo": 89.989,
   "Type": "audio_features",
   "ID": "7ewrtrIaGOiKh3G0zD5egG",
   "Uri": "spotify:track:7ewrtrIaGOiKh3G0zD5egG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7ewrtrIaGOiKh3G0zD5egG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7ewrtrIaGOiKh3G0zD5egG",
   "Duration_ms": 302781,
   "time_signature": 4,
   "Genre": "worship"
 },
 {
      "Name": "LaPlaga(DigitallyRemasteredRemix)",
   "Danceability": 0.791,
   "Energy": 0.559,
   "Key": 8,
   "Loudness": -7.136,
   "Mode": 0,
   "Speechness": 0.229,
   "Acousticness": 0.0559,
   "Instrumentalness": 0,
   "Liveness": 0.236,
   "Valence": 0.92,
   "Tempo": 87.956,
   "Type": "audio_features",
   "ID": "6U6UoE9LfZjeM6esvEdgCP",
   "Uri": "spotify:track:6U6UoE9LfZjeM6esvEdgCP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6U6UoE9LfZjeM6esvEdgCP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6U6UoE9LfZjeM6esvEdgCP",
   "Duration_ms": 227000,
   "time_signature": 4,
   "Genre": "undergroundlatinhiphop"
 },
 {
      "Name": "ArchaicCorrespondence",
   "Danceability": 0.503,
   "Energy": 0.961,
   "Key": 0,
   "Loudness": -6.055,
   "Mode": 1,
   "Speechness": 0.0442,
   "Acousticness": 0.0000858,
   "Instrumentalness": 0.314,
   "Liveness": 0.112,
   "Valence": 0.296,
   "Tempo": 120.024,
   "Type": "audio_features",
   "ID": "4dH8jfyvkm18cgn0nPxSER",
   "Uri": "spotify:track:4dH8jfyvkm18cgn0nPxSER",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4dH8jfyvkm18cgn0nPxSER",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4dH8jfyvkm18cgn0nPxSER",
   "Duration_ms": 295093,
   "time_signature": 4,
   "Genre": "norwegianmetal"
 },
 {
      "Name": "OfItsOwnKind",
   "Danceability": 0.274,
   "Energy": 0.36,
   "Key": 8,
   "Loudness": -13.556,
   "Mode": 1,
   "Speechness": 0.0386,
   "Acousticness": 0.821,
   "Instrumentalness": 0.94,
   "Liveness": 0.101,
   "Valence": 0.192,
   "Tempo": 106.789,
   "Type": "audio_features",
   "ID": "7pufqAWLZoZiMAtW5Wofyi",
   "Uri": "spotify:track:7pufqAWLZoZiMAtW5Wofyi",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7pufqAWLZoZiMAtW5Wofyi",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7pufqAWLZoZiMAtW5Wofyi",
   "Duration_ms": 445281,
   "time_signature": 4,
   "Genre": "dronefolk"
 },
 {
      "Name": "Roundabout-RemasteredVersion",
   "Danceability": 0.41,
   "Energy": 0.761,
   "Key": 4,
   "Loudness": -9.453,
   "Mode": 0,
   "Speechness": 0.0687,
   "Acousticness": 0.0682,
   "Instrumentalness": 0.0077,
   "Liveness": 0.0758,
   "Valence": 0.391,
   "Tempo": 132.889,
   "Type": "audio_features",
   "ID": "0YveezON7jpiaHA8fnUHxN",
   "Uri": "spotify:track:0YveezON7jpiaHA8fnUHxN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0YveezON7jpiaHA8fnUHxN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0YveezON7jpiaHA8fnUHxN",
   "Duration_ms": 510573,
   "time_signature": 4,
   "Genre": "zeuhl"
 },
 {
      "Name": "Closer",
   "Danceability": 0.748,
   "Energy": 0.524,
   "Key": 8,
   "Loudness": -5.599,
   "Mode": 1,
   "Speechness": 0.0338,
   "Acousticness": 0.414,
   "Instrumentalness": 0,
   "Liveness": 0.111,
   "Valence": 0.661,
   "Tempo": 95.01,
   "Type": "audio_features",
   "ID": "7BKLCZ1jbUBVqRi2FVlTVw",
   "Uri": "spotify:track:7BKLCZ1jbUBVqRi2FVlTVw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7BKLCZ1jbUBVqRi2FVlTVw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7BKLCZ1jbUBVqRi2FVlTVw",
   "Duration_ms": 244960,
   "time_signature": 4,
   "Genre": "oratory"
 },
 {
      "Name": "GoodEnough",
   "Danceability": 0.469,
   "Energy": 0.905,
   "Key": 0,
   "Loudness": -3.822,
   "Mode": 1,
   "Speechness": 0.0728,
   "Acousticness": 0.000113,
   "Instrumentalness": 0.0000174,
   "Liveness": 0.264,
   "Valence": 0.462,
   "Tempo": 176.153,
   "Type": "audio_features",
   "ID": "5iDxtzSfInBqOuCPbbPbm8",
   "Uri": "spotify:track:5iDxtzSfInBqOuCPbbPbm8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5iDxtzSfInBqOuCPbbPbm8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5iDxtzSfInBqOuCPbbPbm8",
   "Duration_ms": 192720,
   "time_signature": 3,
   "Genre": "mathpop"
 },
 {
      "Name": "DoinafromOltenia",
   "Danceability": 0.302,
   "Energy": 0.0804,
   "Key": 11,
   "Loudness": -21.985,
   "Mode": 0,
   "Speechness": 0.0449,
   "Acousticness": 0.983,
   "Instrumentalness": 0.875,
   "Liveness": 0.205,
   "Valence": 0.0408,
   "Tempo": 103.877,
   "Type": "audio_features",
   "ID": "6EBcge9RDiffjv52MYHJmc",
   "Uri": "spotify:track:6EBcge9RDiffjv52MYHJmc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6EBcge9RDiffjv52MYHJmc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6EBcge9RDiffjv52MYHJmc",
   "Duration_ms": 155880,
   "time_signature": 3,
   "Genre": "romanianfolk"
 },
 {
      "Name": "ChandaniPayala",
   "Danceability": 0.428,
   "Energy": 0.693,
   "Key": 3,
   "Loudness": -7.831,
   "Mode": 1,
   "Speechness": 0.054,
   "Acousticness": 0.127,
   "Instrumentalness": 0,
   "Liveness": 0.178,
   "Valence": 0.541,
   "Tempo": 109.146,
   "Type": "audio_features",
   "ID": "6BOQ0TpV5ieNFR5REZsoK8",
   "Uri": "spotify:track:6BOQ0TpV5ieNFR5REZsoK8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6BOQ0TpV5ieNFR5REZsoK8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6BOQ0TpV5ieNFR5REZsoK8",
   "Duration_ms": 301227,
   "time_signature": 5,
   "Genre": "sinhala"
 },
 {
      "Name": "AnotherSky",
   "Danceability": 0.575,
   "Energy": 0.701,
   "Key": 1,
   "Loudness": -7.051,
   "Mode": 1,
   "Speechness": 0.0713,
   "Acousticness": 0.387,
   "Instrumentalness": 0.048,
   "Liveness": 0.0955,
   "Valence": 0.826,
   "Tempo": 116.373,
   "Type": "audio_features",
   "ID": "1kGE7GfvlbMmOpZybMOSEH",
   "Uri": "spotify:track:1kGE7GfvlbMmOpZybMOSEH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1kGE7GfvlbMmOpZybMOSEH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1kGE7GfvlbMmOpZybMOSEH",
   "Duration_ms": 293187,
   "time_signature": 4,
   "Genre": "deeplatinjazz"
 },
 {
      "Name": "WhitehouseRoad(Live)",
   "Danceability": 0.516,
   "Energy": 0.433,
   "Key": 0,
   "Loudness": -8.881,
   "Mode": 1,
   "Speechness": 0.0292,
   "Acousticness": 0.768,
   "Instrumentalness": 0,
   "Liveness": 0.724,
   "Valence": 0.463,
   "Tempo": 154.755,
   "Type": "audio_features",
   "ID": "7E5UxJ0cGdN2cKlzNBobaY",
   "Uri": "spotify:track:7E5UxJ0cGdN2cKlzNBobaY",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7E5UxJ0cGdN2cKlzNBobaY",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7E5UxJ0cGdN2cKlzNBobaY",
   "Duration_ms": 274973,
   "time_signature": 4,
   "Genre": "alternativeamericana"
 },
 {
      "Name": "BetterDay",
   "Danceability": 0.492,
   "Energy": 0.567,
   "Key": 10,
   "Loudness": -5.984,
   "Mode": 1,
   "Speechness": 0.0239,
   "Acousticness": 0.0378,
   "Instrumentalness": 0,
   "Liveness": 0.173,
   "Valence": 0.328,
   "Tempo": 79.374,
   "Type": "audio_features",
   "ID": "0k7AYarupFQ2RHN1niWSAD",
   "Uri": "spotify:track:0k7AYarupFQ2RHN1niWSAD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0k7AYarupFQ2RHN1niWSAD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0k7AYarupFQ2RHN1niWSAD",
   "Duration_ms": 225067,
   "time_signature": 4,
   "Genre": "birminghamindie"
 },
 {
      "Name": "BreakingtheLaw",
   "Danceability": 0.362,
   "Energy": 0.961,
   "Key": 2,
   "Loudness": -5.664,
   "Mode": 1,
   "Speechness": 0.0857,
   "Acousticness": 0.024,
   "Instrumentalness": 0.00000935,
   "Liveness": 0.159,
   "Valence": 0.491,
   "Tempo": 164.019,
   "Type": "audio_features",
   "ID": "2RaA6kIcvomt77qlIgGhCT",
   "Uri": "spotify:track:2RaA6kIcvomt77qlIgGhCT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2RaA6kIcvomt77qlIgGhCT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2RaA6kIcvomt77qlIgGhCT",
   "Duration_ms": 153840,
   "time_signature": 4,
   "Genre": "bostonmetal"
 },
 {
      "Name": "Talk",
   "Danceability": 0.9,
   "Energy": 0.4,
   "Key": 0,
   "Loudness": -8.443,
   "Mode": 1,
   "Speechness": 0.124,
   "Acousticness": 0.0501,
   "Instrumentalness": 0,
   "Liveness": 0.0876,
   "Valence": 0.338,
   "Tempo": 136.001,
   "Type": "audio_features",
   "ID": "0rTV5WefWd1J3OwIheTzxM",
   "Uri": "spotify:track:0rTV5WefWd1J3OwIheTzxM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0rTV5WefWd1J3OwIheTzxM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0rTV5WefWd1J3OwIheTzxM",
   "Duration_ms": 197487,
   "time_signature": 4,
   "Genre": "go-go"
 },
 {
      "Name": "GrowUp",
   "Danceability": 0.823,
   "Energy": 0.7,
   "Key": 11,
   "Loudness": -6.588,
   "Mode": 0,
   "Speechness": 0.077,
   "Acousticness": 0.0733,
   "Instrumentalness": 0.000063,
   "Liveness": 0.685,
   "Valence": 0.537,
   "Tempo": 123.05,
   "Type": "audio_features",
   "ID": "5I1K6LJMvIdV5kpHS8tMkr",
   "Uri": "spotify:track:5I1K6LJMvIdV5kpHS8tMkr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5I1K6LJMvIdV5kpHS8tMkr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5I1K6LJMvIdV5kpHS8tMkr",
   "Duration_ms": 169837,
   "time_signature": 4,
   "Genre": "tropicalhouse"
 },
 {
      "Name": "EresTú",
   "Danceability": 0.618,
   "Energy": 0.307,
   "Key": 2,
   "Loudness": -10.875,
   "Mode": 1,
   "Speechness": 0.046,
   "Acousticness": 0.806,
   "Instrumentalness": 0,
   "Liveness": 0.108,
   "Valence": 0.458,
   "Tempo": 188.115,
   "Type": "audio_features",
   "ID": "2dEVAvwPAJrWFErXxREGVX",
   "Uri": "spotify:track:2dEVAvwPAJrWFErXxREGVX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2dEVAvwPAJrWFErXxREGVX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2dEVAvwPAJrWFErXxREGVX",
   "Duration_ms": 228253,
   "time_signature": 4,
   "Genre": "spanishfolk"
 },
 {
      "Name": "DobrijAbend",
   "Danceability": 0.372,
   "Energy": 0.928,
   "Key": 5,
   "Loudness": -3.91,
   "Mode": 0,
   "Speechness": 0.143,
   "Acousticness": 0.0627,
   "Instrumentalness": 0,
   "Liveness": 0.169,
   "Valence": 0.657,
   "Tempo": 179.4,
   "Type": "audio_features",
   "ID": "2Nh0TZTgCEuNnyxLvbJlI8",
   "Uri": "spotify:track:2Nh0TZTgCEuNnyxLvbJlI8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Nh0TZTgCEuNnyxLvbJlI8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Nh0TZTgCEuNnyxLvbJlI8",
   "Duration_ms": 284213,
   "time_signature": 4,
   "Genre": "russianpunk"
 },
 {
      "Name": "FlyAtNight",
   "Danceability": 0.377,
   "Energy": 0.863,
   "Key": 7,
   "Loudness": -4.728,
   "Mode": 1,
   "Speechness": 0.0607,
   "Acousticness": 0.224,
   "Instrumentalness": 0.0258,
   "Liveness": 0.112,
   "Valence": 0.484,
   "Tempo": 138.865,
   "Type": "audio_features",
   "ID": "6rjZpO715XItLmXQpmQp89",
   "Uri": "spotify:track:6rjZpO715XItLmXQpmQp89",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6rjZpO715XItLmXQpmQp89",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6rjZpO715XItLmXQpmQp89",
   "Duration_ms": 295187,
   "time_signature": 4,
   "Genre": "canadianrock"
 },
 {
      "Name": "She\\sInLoveWithTheBoy-SingleVersion",
   "Danceability": 0.782,
   "Energy": 0.677,
   "Key": 3,
   "Loudness": -8.199,
   "Mode": 1,
   "Speechness": 0.0314,
   "Acousticness": 0.566,
   "Instrumentalness": 0.00000271,
   "Liveness": 0.172,
   "Valence": 0.77,
   "Tempo": 125.006,
   "Type": "audio_features",
   "ID": "2ulBBx6YQ3qY3ci34RadtN",
   "Uri": "spotify:track:2ulBBx6YQ3qY3ci34RadtN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2ulBBx6YQ3qY3ci34RadtN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2ulBBx6YQ3qY3ci34RadtN",
   "Duration_ms": 248200,
   "time_signature": 4,
   "Genre": "country"
 },
 {
      "Name": "Norgaard",
   "Danceability": 0.323,
   "Energy": 0.847,
   "Key": 11,
   "Loudness": -4.716,
   "Mode": 1,
   "Speechness": 0.0348,
   "Acousticness": 0.00000512,
   "Instrumentalness": 0.0208,
   "Liveness": 0.25,
   "Valence": 0.859,
   "Tempo": 173.914,
   "Type": "audio_features",
   "ID": "1Q8reqCOXg2yqNr47HGo9X",
   "Uri": "spotify:track:1Q8reqCOXg2yqNr47HGo9X",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Q8reqCOXg2yqNr47HGo9X",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Q8reqCOXg2yqNr47HGo9X",
   "Duration_ms": 98400,
   "time_signature": 4,
   "Genre": "liverpoolindie"
 },
 {
      "Name": "YoGabbaGabba!Theme",
   "Danceability": 0.506,
   "Energy": 0.954,
   "Key": 7,
   "Loudness": -4.357,
   "Mode": 1,
   "Speechness": 0.444,
   "Acousticness": 0.29,
   "Instrumentalness": 0.00000773,
   "Liveness": 0.132,
   "Valence": 0.543,
   "Tempo": 74.726,
   "Type": "audio_features",
   "ID": "4RXfMr8jC9En4qchn8Bt5y",
   "Uri": "spotify:track:4RXfMr8jC9En4qchn8Bt5y",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4RXfMr8jC9En4qchn8Bt5y",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4RXfMr8jC9En4qchn8Bt5y",
   "Duration_ms": 55125,
   "time_signature": 4,
   "Genre": "gabba"
 },
 {
      "Name": "Ambrosia",
   "Danceability": 0.717,
   "Energy": 0.484,
   "Key": 5,
   "Loudness": -11.153,
   "Mode": 0,
   "Speechness": 0.0331,
   "Acousticness": 0.401,
   "Instrumentalness": 0.834,
   "Liveness": 0.247,
   "Valence": 0.176,
   "Tempo": 127.976,
   "Type": "audio_features",
   "ID": "1eKOWBC53maiSzMYGILlzF",
   "Uri": "spotify:track:1eKOWBC53maiSzMYGILlzF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1eKOWBC53maiSzMYGILlzF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1eKOWBC53maiSzMYGILlzF",
   "Duration_ms": 368594,
   "time_signature": 4,
   "Genre": "substep"
 },
 {
      "Name": "NoMesmoLugar",
   "Danceability": 0.584,
   "Energy": 0.685,
   "Key": 9,
   "Loudness": -4.842,
   "Mode": 1,
   "Speechness": 0.0496,
   "Acousticness": 0.202,
   "Instrumentalness": 0,
   "Liveness": 0.118,
   "Valence": 0.783,
   "Tempo": 171.73,
   "Type": "audio_features",
   "ID": "0N2dEvaKpjOzppGn0elCSc",
   "Uri": "spotify:track:0N2dEvaKpjOzppGn0elCSc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0N2dEvaKpjOzppGn0elCSc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0N2dEvaKpjOzppGn0elCSc",
   "Duration_ms": 179489,
   "time_signature": 4,
   "Genre": "mandepop"
 },
 {
      "Name": "ComeGoWithMe",
   "Danceability": 0.66,
   "Energy": 0.511,
   "Key": 5,
   "Loudness": -10.016,
   "Mode": 0,
   "Speechness": 0.047,
   "Acousticness": 0.784,
   "Instrumentalness": 0,
   "Liveness": 0.117,
   "Valence": 0.545,
   "Tempo": 127.603,
   "Type": "audio_features",
   "ID": "4eRdlW0SvlRpq285jI9uf5",
   "Uri": "spotify:track:4eRdlW0SvlRpq285jI9uf5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4eRdlW0SvlRpq285jI9uf5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4eRdlW0SvlRpq285jI9uf5",
   "Duration_ms": 160467,
   "time_signature": 4,
   "Genre": "doo-wop"
 },
 {
      "Name": "ThisIsIt",
   "Danceability": 0.793,
   "Energy": 0.886,
   "Key": 7,
   "Loudness": -7.644,
   "Mode": 1,
   "Speechness": 0.0807,
   "Acousticness": 0.00342,
   "Instrumentalness": 0.86,
   "Liveness": 0.0909,
   "Valence": 0.105,
   "Tempo": 126.014,
   "Type": "audio_features",
   "ID": "4R041kRwUVqdunKvrKDr2P",
   "Uri": "spotify:track:4R041kRwUVqdunKvrKDr2P",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4R041kRwUVqdunKvrKDr2P",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4R041kRwUVqdunKvrKDr2P",
   "Duration_ms": 476429,
   "time_signature": 4,
   "Genre": "darktechno"
 },
 {
      "Name": "ParecenViernes",
   "Danceability": 0.658,
   "Energy": 0.863,
   "Key": 7,
   "Loudness": -3.575,
   "Mode": 0,
   "Speechness": 0.0352,
   "Acousticness": 0.287,
   "Instrumentalness": 0.0000153,
   "Liveness": 0.16,
   "Valence": 0.967,
   "Tempo": 96.499,
   "Type": "audio_features",
   "ID": "62E8JJRtwOwU85uup9C5Ox",
   "Uri": "spotify:track:62E8JJRtwOwU85uup9C5Ox",
   "Ref_Track": "https://api.spotify.com/v1/tracks/62E8JJRtwOwU85uup9C5Ox",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/62E8JJRtwOwU85uup9C5Ox",
   "Duration_ms": 268440,
   "time_signature": 4,
   "Genre": "salsa"
 },
 {
      "Name": "Don\\tCallMeUp",
   "Danceability": 0.674,
   "Energy": 0.881,
   "Key": 9,
   "Loudness": -2.853,
   "Mode": 1,
   "Speechness": 0.147,
   "Acousticness": 0.296,
   "Instrumentalness": 0.00000301,
   "Liveness": 0.0793,
   "Valence": 0.234,
   "Tempo": 98.994,
   "Type": "audio_features",
   "ID": "5WHTFyqSii0lmT9R21abT8",
   "Uri": "spotify:track:5WHTFyqSii0lmT9R21abT8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5WHTFyqSii0lmT9R21abT8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5WHTFyqSii0lmT9R21abT8",
   "Duration_ms": 178480,
   "time_signature": 4,
   "Genre": "deepbrazilianpop"
 },
 {
      "Name": "Galaxy(feat.KobTheXFactor)",
   "Danceability": 0.571,
   "Energy": 0.856,
   "Key": 4,
   "Loudness": -2.303,
   "Mode": 0,
   "Speechness": 0.0704,
   "Acousticness": 0.571,
   "Instrumentalness": 0,
   "Liveness": 0.0846,
   "Valence": 0.5,
   "Tempo": 139.972,
   "Type": "audio_features",
   "ID": "0yO5RrszdEpqXhDwyhP6nX",
   "Uri": "spotify:track:0yO5RrszdEpqXhDwyhP6nX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0yO5RrszdEpqXhDwyhP6nX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0yO5RrszdEpqXhDwyhP6nX",
   "Duration_ms": 266754,
   "time_signature": 4,
   "Genre": "thaipop"
 },
 {
      "Name": "WhatYouKnow",
   "Danceability": 0.557,
   "Energy": 0.747,
   "Key": 6,
   "Loudness": -4.007,
   "Mode": 0,
   "Speechness": 0.0418,
   "Acousticness": 0.0008,
   "Instrumentalness": 0.00000982,
   "Liveness": 0.0858,
   "Valence": 0.781,
   "Tempo": 139.006,
   "Type": "audio_features",
   "ID": "7oRgM9AfaDq0rm4ovEVYqG",
   "Uri": "spotify:track:7oRgM9AfaDq0rm4ovEVYqG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7oRgM9AfaDq0rm4ovEVYqG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7oRgM9AfaDq0rm4ovEVYqG",
   "Duration_ms": 189693,
   "time_signature": 4,
   "Genre": "torontoindie"
 },
 {
      "Name": "Sh\\MaYisrael",
   "Danceability": 0.311,
   "Energy": 0.256,
   "Key": 6,
   "Loudness": -10.197,
   "Mode": 1,
   "Speechness": 0.0307,
   "Acousticness": 0.98,
   "Instrumentalness": 0.0000761,
   "Liveness": 0.104,
   "Valence": 0.198,
   "Tempo": 142.554,
   "Type": "audio_features",
   "ID": "1PYXV5dFpj8Qpezw7vabFH",
   "Uri": "spotify:track:1PYXV5dFpj8Qpezw7vabFH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1PYXV5dFpj8Qpezw7vabFH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1PYXV5dFpj8Qpezw7vabFH",
   "Duration_ms": 149253,
   "time_signature": 3,
   "Genre": "messianicpraise"
 },
 {
      "Name": "I\\mGladTroubleDon\\tLastAlways",
   "Danceability": 0.579,
   "Energy": 0.522,
   "Key": 2,
   "Loudness": -7.124,
   "Mode": 1,
   "Speechness": 0.0232,
   "Acousticness": 0.000545,
   "Instrumentalness": 0.00811,
   "Liveness": 0.0914,
   "Valence": 0.286,
   "Tempo": 81.969,
   "Type": "audio_features",
   "ID": "3b9xTm2eiaCRTGqUEWuzxc",
   "Uri": "spotify:track:3b9xTm2eiaCRTGqUEWuzxc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3b9xTm2eiaCRTGqUEWuzxc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3b9xTm2eiaCRTGqUEWuzxc",
   "Duration_ms": 257587,
   "time_signature": 4,
   "Genre": "blues-rock"
 },
 {
      "Name": "FeelsLikeWeOnlyGoBackwards",
   "Danceability": 0.291,
   "Energy": 0.907,
   "Key": 2,
   "Loudness": -2.299,
   "Mode": 0,
   "Speechness": 0.0594,
   "Acousticness": 0.0344,
   "Instrumentalness": 0.74,
   "Liveness": 0.195,
   "Valence": 0.578,
   "Tempo": 149.779,
   "Type": "audio_features",
   "ID": "6SBqfATzBAKqAlvNqsKPGV",
   "Uri": "spotify:track:6SBqfATzBAKqAlvNqsKPGV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6SBqfATzBAKqAlvNqsKPGV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6SBqfATzBAKqAlvNqsKPGV",
   "Duration_ms": 192960,
   "time_signature": 4,
   "Genre": "psychedelicfolk"
 },
 {
      "Name": "HillbillyRock\\n\\Roll",
   "Danceability": 0.383,
   "Energy": 0.941,
   "Key": 2,
   "Loudness": -6.299,
   "Mode": 1,
   "Speechness": 0.102,
   "Acousticness": 0.595,
   "Instrumentalness": 0,
   "Liveness": 0.341,
   "Valence": 0.667,
   "Tempo": 199.564,
   "Type": "audio_features",
   "ID": "6bzf1xi9QFsdMkFLLZCUCO",
   "Uri": "spotify:track:6bzf1xi9QFsdMkFLLZCUCO",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6bzf1xi9QFsdMkFLLZCUCO",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6bzf1xi9QFsdMkFLLZCUCO",
   "Duration_ms": 150720,
   "time_signature": 4,
   "Genre": "deeppsychobilly"
 },
 {
      "Name": "Badfish",
   "Danceability": 0.793,
   "Energy": 0.494,
   "Key": 2,
   "Loudness": -6.235,
   "Mode": 1,
   "Speechness": 0.0573,
   "Acousticness": 0.0241,
   "Instrumentalness": 0.00141,
   "Liveness": 0.388,
   "Valence": 0.561,
   "Tempo": 93.005,
   "Type": "audio_features",
   "ID": "2icFniOYRR5d0W7E9gYHiq",
   "Uri": "spotify:track:2icFniOYRR5d0W7E9gYHiq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2icFniOYRR5d0W7E9gYHiq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2icFniOYRR5d0W7E9gYHiq",
   "Duration_ms": 184427,
   "time_signature": 4,
   "Genre": "reggaerock"
 },
 {
      "Name": "Bottomfeeder",
   "Danceability": 0.747,
   "Energy": 0.429,
   "Key": 4,
   "Loudness": -8.437,
   "Mode": 1,
   "Speechness": 0.0394,
   "Acousticness": 0.078,
   "Instrumentalness": 0.0793,
   "Liveness": 0.0573,
   "Valence": 0.684,
   "Tempo": 119.952,
   "Type": "audio_features",
   "ID": "474XMwhddrNQCn6jIKZEyt",
   "Uri": "spotify:track:474XMwhddrNQCn6jIKZEyt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/474XMwhddrNQCn6jIKZEyt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/474XMwhddrNQCn6jIKZEyt",
   "Duration_ms": 181191,
   "time_signature": 4,
   "Genre": "elpasoindie"
 },
 {
      "Name": "ExplorationofSpace-RadioEdit",
   "Danceability": 0.631,
   "Energy": 0.912,
   "Key": 9,
   "Loudness": -7.591,
   "Mode": 0,
   "Speechness": 0.0361,
   "Acousticness": 0.0346,
   "Instrumentalness": 0.554,
   "Liveness": 0.0729,
   "Valence": 0.329,
   "Tempo": 138.043,
   "Type": "audio_features",
   "ID": "4iLL2yVVG19TAJYssbMeBT",
   "Uri": "spotify:track:4iLL2yVVG19TAJYssbMeBT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4iLL2yVVG19TAJYssbMeBT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4iLL2yVVG19TAJYssbMeBT",
   "Duration_ms": 216360,
   "time_signature": 4,
   "Genre": "germanhardcore"
 },
 {
      "Name": "NegativeOne",
   "Danceability": 0.564,
   "Energy": 0.714,
   "Key": 11,
   "Loudness": -6.05,
   "Mode": 0,
   "Speechness": 0.027,
   "Acousticness": 0.0986,
   "Instrumentalness": 0.141,
   "Liveness": 0.114,
   "Valence": 0.574,
   "Tempo": 97.904,
   "Type": "audio_features",
   "ID": "0mVi88FkjXiY3rW5CQ5Wjv",
   "Uri": "spotify:track:0mVi88FkjXiY3rW5CQ5Wjv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0mVi88FkjXiY3rW5CQ5Wjv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0mVi88FkjXiY3rW5CQ5Wjv",
   "Duration_ms": 162038,
   "time_signature": 4,
   "Genre": "belfastindie"
 },
 {
      "Name": "MyJinji",
   "Danceability": 0.396,
   "Energy": 0.587,
   "Key": 7,
   "Loudness": -8.746,
   "Mode": 1,
   "Speechness": 0.0312,
   "Acousticness": 0.527,
   "Instrumentalness": 0.45,
   "Liveness": 0.144,
   "Valence": 0.519,
   "Tempo": 140.804,
   "Type": "audio_features",
   "ID": "5I8oQkGK1ZFVYJzEv7VQVb",
   "Uri": "spotify:track:5I8oQkGK1ZFVYJzEv7VQVb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5I8oQkGK1ZFVYJzEv7VQVb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5I8oQkGK1ZFVYJzEv7VQVb",
   "Duration_ms": 400560,
   "time_signature": 4,
   "Genre": "hongkongindie"
 },
 {
      "Name": "2014.0",
   "Danceability": 0.763,
   "Energy": 0.77,
   "Key": 7,
   "Loudness": -5.323,
   "Mode": 1,
   "Speechness": 0.275,
   "Acousticness": 0.131,
   "Instrumentalness": 0,
   "Liveness": 0.349,
   "Valence": 0.451,
   "Tempo": 89.99,
   "Type": "audio_features",
   "ID": "2972FVFg6D1XL2iyQfQPWw",
   "Uri": "spotify:track:2972FVFg6D1XL2iyQfQPWw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2972FVFg6D1XL2iyQfQPWw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2972FVFg6D1XL2iyQfQPWw",
   "Duration_ms": 239920,
   "time_signature": 4,
   "Genre": "germanoi"
 },
 {
      "Name": "L.O.V.E.-RadioEdit",
   "Danceability": 0.875,
   "Energy": 0.461,
   "Key": 10,
   "Loudness": -6.015,
   "Mode": 0,
   "Speechness": 0.24,
   "Acousticness": 0.00266,
   "Instrumentalness": 0.000102,
   "Liveness": 0.0518,
   "Valence": 0.802,
   "Tempo": 119.976,
   "Type": "audio_features",
   "ID": "0LQuVyuYMOXnGM3UgLFX37",
   "Uri": "spotify:track:0LQuVyuYMOXnGM3UgLFX37",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0LQuVyuYMOXnGM3UgLFX37",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0LQuVyuYMOXnGM3UgLFX37",
   "Duration_ms": 244033,
   "time_signature": 4,
   "Genre": "organicambient"
 },
 {
      "Name": "HambreDeVictoria",
   "Danceability": 0.611,
   "Energy": 0.909,
   "Key": 11,
   "Loudness": -6.37,
   "Mode": 0,
   "Speechness": 0.282,
   "Acousticness": 0.453,
   "Instrumentalness": 0,
   "Liveness": 0.126,
   "Valence": 0.153,
   "Tempo": 86.755,
   "Type": "audio_features",
   "ID": "1bnj5APlJpy46DDgJD718P",
   "Uri": "spotify:track:1bnj5APlJpy46DDgJD718P",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1bnj5APlJpy46DDgJD718P",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1bnj5APlJpy46DDgJD718P",
   "Duration_ms": 159013,
   "time_signature": 4,
   "Genre": "scratch"
 },
 {
      "Name": "Let\\sRunAwayTogether",
   "Danceability": 0.253,
   "Energy": 0.253,
   "Key": 7,
   "Loudness": -12.686,
   "Mode": 1,
   "Speechness": 0.0341,
   "Acousticness": 0.977,
   "Instrumentalness": 0.852,
   "Liveness": 0.0857,
   "Valence": 0.0694,
   "Tempo": 80.248,
   "Type": "audio_features",
   "ID": "7jxJHRmtMpGNR3EmxnspDB",
   "Uri": "spotify:track:7jxJHRmtMpGNR3EmxnspDB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7jxJHRmtMpGNR3EmxnspDB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7jxJHRmtMpGNR3EmxnspDB",
   "Duration_ms": 177875,
   "time_signature": 4,
   "Genre": "reading"
 },
 {
      "Name": "RememberYou",
   "Danceability": 0.672,
   "Energy": 0.808,
   "Key": 8,
   "Loudness": -5.541,
   "Mode": 1,
   "Speechness": 0.0407,
   "Acousticness": 0.0494,
   "Instrumentalness": 0,
   "Liveness": 0.385,
   "Valence": 0.334,
   "Tempo": 119.935,
   "Type": "audio_features",
   "ID": "20psIOrg7j48rGrlpFXqTI",
   "Uri": "spotify:track:20psIOrg7j48rGrlpFXqTI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/20psIOrg7j48rGrlpFXqTI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/20psIOrg7j48rGrlpFXqTI",
   "Duration_ms": 189000,
   "time_signature": 4,
   "Genre": "beats"
 },
 {
      "Name": "Reflexiones",
   "Danceability": 0.844,
   "Energy": 0.637,
   "Key": 7,
   "Loudness": -6.394,
   "Mode": 1,
   "Speechness": 0.0659,
   "Acousticness": 0.481,
   "Instrumentalness": 0,
   "Liveness": 0.354,
   "Valence": 0.448,
   "Tempo": 119.991,
   "Type": "audio_features",
   "ID": "30U7Hx6g5zYMwm0qvSAZBB",
   "Uri": "spotify:track:30U7Hx6g5zYMwm0qvSAZBB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/30U7Hx6g5zYMwm0qvSAZBB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/30U7Hx6g5zYMwm0qvSAZBB",
   "Duration_ms": 222907,
   "time_signature": 4,
   "Genre": "ecuadorianindie"
 },
 {
      "Name": "TheRhythmOfTheNight",
   "Danceability": 0.69,
   "Energy": 0.805,
   "Key": 5,
   "Loudness": -11.522,
   "Mode": 0,
   "Speechness": 0.0336,
   "Acousticness": 0.000232,
   "Instrumentalness": 0.739,
   "Liveness": 0.095,
   "Valence": 0.799,
   "Tempo": 127.808,
   "Type": "audio_features",
   "ID": "3L9RIFcNF9IDGPRE96EO7N",
   "Uri": "spotify:track:3L9RIFcNF9IDGPRE96EO7N",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3L9RIFcNF9IDGPRE96EO7N",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3L9RIFcNF9IDGPRE96EO7N",
   "Duration_ms": 264280,
   "time_signature": 4,
   "Genre": "v-pop"
 },
 {
      "Name": "IJustCall(ToSayILoveYou)",
   "Danceability": 0.604,
   "Energy": 0.388,
   "Key": 7,
   "Loudness": -8.451,
   "Mode": 1,
   "Speechness": 0.0276,
   "Acousticness": 0.692,
   "Instrumentalness": 0.00522,
   "Liveness": 0.114,
   "Valence": 0.397,
   "Tempo": 99.993,
   "Type": "audio_features",
   "ID": "1UAr44n7gchBBQXlhQ8DY0",
   "Uri": "spotify:track:1UAr44n7gchBBQXlhQ8DY0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1UAr44n7gchBBQXlhQ8DY0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1UAr44n7gchBBQXlhQ8DY0",
   "Duration_ms": 281800,
   "time_signature": 4,
   "Genre": "keroncong"
 },
 {
      "Name": "TommyTheCat",
   "Danceability": 0.526,
   "Energy": 0.985,
   "Key": 1,
   "Loudness": -3.694,
   "Mode": 0,
   "Speechness": 0.135,
   "Acousticness": 0.00187,
   "Instrumentalness": 0.185,
   "Liveness": 0.563,
   "Valence": 0.312,
   "Tempo": 128.86,
   "Type": "audio_features",
   "ID": "1efp2bPw7ssJpCi0Almgsx",
   "Uri": "spotify:track:1efp2bPw7ssJpCi0Almgsx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1efp2bPw7ssJpCi0Almgsx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1efp2bPw7ssJpCi0Almgsx",
   "Duration_ms": 254560,
   "time_signature": 4,
   "Genre": "funkrock"
 },
 {
      "Name": "FunTonight",
   "Danceability": 0.612,
   "Energy": 0.938,
   "Key": 10,
   "Loudness": -7.253,
   "Mode": 0,
   "Speechness": 0.0562,
   "Acousticness": 0.0000251,
   "Instrumentalness": 0.717,
   "Liveness": 0.329,
   "Valence": 0.595,
   "Tempo": 129.994,
   "Type": "audio_features",
   "ID": "4MmO631CdxuFOm18UVbhkp",
   "Uri": "spotify:track:4MmO631CdxuFOm18UVbhkp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4MmO631CdxuFOm18UVbhkp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4MmO631CdxuFOm18UVbhkp",
   "Duration_ms": 162462,
   "time_signature": 4,
   "Genre": "futurefunk"
 },
 {
      "Name": "Tru",
   "Danceability": 0.696,
   "Energy": 0.873,
   "Key": 7,
   "Loudness": -9.029,
   "Mode": 0,
   "Speechness": 0.0553,
   "Acousticness": 0.0115,
   "Instrumentalness": 0.655,
   "Liveness": 0.282,
   "Valence": 0.196,
   "Tempo": 135.994,
   "Type": "audio_features",
   "ID": "1Qukne6RQZb6iXoecwvpmZ",
   "Uri": "spotify:track:1Qukne6RQZb6iXoecwvpmZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Qukne6RQZb6iXoecwvpmZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Qukne6RQZb6iXoecwvpmZ",
   "Duration_ms": 276413,
   "time_signature": 4,
   "Genre": "fluxwork"
 },
 {
      "Name": "YouAreaMemory",
   "Danceability": 0.133,
   "Energy": 0.339,
   "Key": 9,
   "Loudness": -10.315,
   "Mode": 1,
   "Speechness": 0.0339,
   "Acousticness": 0.854,
   "Instrumentalness": 0.0422,
   "Liveness": 0.101,
   "Valence": 0.0291,
   "Tempo": 144.726,
   "Type": "audio_features",
   "ID": "5cWSpmTfItDuppACMrE3I9",
   "Uri": "spotify:track:5cWSpmTfItDuppACMrE3I9",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5cWSpmTfItDuppACMrE3I9",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5cWSpmTfItDuppACMrE3I9",
   "Duration_ms": 221747,
   "time_signature": 5,
   "Genre": "alaskaindie"
 },
 {
      "Name": "Mas",
   "Danceability": 0.746,
   "Energy": 0.857,
   "Key": 7,
   "Loudness": -9.877,
   "Mode": 1,
   "Speechness": 0.0375,
   "Acousticness": 0.0368,
   "Instrumentalness": 0.881,
   "Liveness": 0.1,
   "Valence": 0.239,
   "Tempo": 124.009,
   "Type": "audio_features",
   "ID": "3i1zwjMO1fmW4uI9r7iiJW",
   "Uri": "spotify:track:3i1zwjMO1fmW4uI9r7iiJW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3i1zwjMO1fmW4uI9r7iiJW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3i1zwjMO1fmW4uI9r7iiJW",
   "Duration_ms": 466452,
   "time_signature": 4,
   "Genre": "deepdeephouse"
 },
 {
      "Name": "VirtualMachine",
   "Danceability": 0.611,
   "Energy": 0.669,
   "Key": 2,
   "Loudness": -9.059,
   "Mode": 1,
   "Speechness": 0.0398,
   "Acousticness": 0.156,
   "Instrumentalness": 0.013,
   "Liveness": 0.427,
   "Valence": 0.699,
   "Tempo": 108.013,
   "Type": "audio_features",
   "ID": "3jyjKi3BOgH6F55j918A6K",
   "Uri": "spotify:track:3jyjKi3BOgH6F55j918A6K",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3jyjKi3BOgH6F55j918A6K",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3jyjKi3BOgH6F55j918A6K",
   "Duration_ms": 149055,
   "time_signature": 4,
   "Genre": "essexindie"
 },
 {
      "Name": "EineHerdeweißerSchafe",
   "Danceability": 0.659,
   "Energy": 0.439,
   "Key": 3,
   "Loudness": -11.997,
   "Mode": 1,
   "Speechness": 0.0274,
   "Acousticness": 0.435,
   "Instrumentalness": 0,
   "Liveness": 0.0745,
   "Valence": 0.716,
   "Tempo": 110.862,
   "Type": "audio_features",
   "ID": "3NKn8ElbAFL6G6AR9qKHgK",
   "Uri": "spotify:track:3NKn8ElbAFL6G6AR9qKHgK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3NKn8ElbAFL6G6AR9qKHgK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3NKn8ElbAFL6G6AR9qKHgK",
   "Duration_ms": 187200,
   "time_signature": 4,
   "Genre": "volksmusik"
 },
 {
      "Name": "WhatchaGonnaDo-FatherFunkRemix",
   "Danceability": 0.782,
   "Energy": 0.785,
   "Key": 9,
   "Loudness": -7.106,
   "Mode": 0,
   "Speechness": 0.0911,
   "Acousticness": 0.0188,
   "Instrumentalness": 0.000227,
   "Liveness": 0.346,
   "Valence": 0.629,
   "Tempo": 112.027,
   "Type": "audio_features",
   "ID": "5IDiLGkLBNs0y1SMh2sk3k",
   "Uri": "spotify:track:5IDiLGkLBNs0y1SMh2sk3k",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5IDiLGkLBNs0y1SMh2sk3k",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5IDiLGkLBNs0y1SMh2sk3k",
   "Duration_ms": 240000,
   "time_signature": 4,
   "Genre": "nuelectro"
 },
 {
      "Name": "FarAway-DNARemix",
   "Danceability": 0.695,
   "Energy": 0.925,
   "Key": 6,
   "Loudness": -6.374,
   "Mode": 0,
   "Speechness": 0.0426,
   "Acousticness": 0.00224,
   "Instrumentalness": 0.699,
   "Liveness": 0.18,
   "Valence": 0.369,
   "Tempo": 145.014,
   "Type": "audio_features",
   "ID": "2lft2xJ0EmoAn9DdydctlE",
   "Uri": "spotify:track:2lft2xJ0EmoAn9DdydctlE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2lft2xJ0EmoAn9DdydctlE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2lft2xJ0EmoAn9DdydctlE",
   "Duration_ms": 450707,
   "time_signature": 4,
   "Genre": "psychedelictrance"
 },
 {
      "Name": "FaceFirst",
   "Danceability": 0.566,
   "Energy": 0.887,
   "Key": 7,
   "Loudness": -10.24,
   "Mode": 1,
   "Speechness": 0.0529,
   "Acousticness": 0.0277,
   "Instrumentalness": 0.906,
   "Liveness": 0.127,
   "Valence": 0.527,
   "Tempo": 123.935,
   "Type": "audio_features",
   "ID": "2iuf8q0JzFh6oJdFYXsx1v",
   "Uri": "spotify:track:2iuf8q0JzFh6oJdFYXsx1v",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2iuf8q0JzFh6oJdFYXsx1v",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2iuf8q0JzFh6oJdFYXsx1v",
   "Duration_ms": 424973,
   "time_signature": 4,
   "Genre": "jazzfusion"
 },
 {
      "Name": "Bliss2K",
   "Danceability": 0.518,
   "Energy": 0.99,
   "Key": 8,
   "Loudness": -1.734,
   "Mode": 1,
   "Speechness": 0.107,
   "Acousticness": 0.0167,
   "Instrumentalness": 0.762,
   "Liveness": 0.643,
   "Valence": 0.429,
   "Tempo": 150.022,
   "Type": "audio_features",
   "ID": "1Emp3xfmcBxcFt8n4srZtr",
   "Uri": "spotify:track:1Emp3xfmcBxcFt8n4srZtr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Emp3xfmcBxcFt8n4srZtr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Emp3xfmcBxcFt8n4srZtr",
   "Duration_ms": 207400,
   "time_signature": 4,
   "Genre": "zapstep"
 },
 {
      "Name": "97.0",
   "Danceability": 0.551,
   "Energy": 0.792,
   "Key": 7,
   "Loudness": -6.741,
   "Mode": 1,
   "Speechness": 0.0613,
   "Acousticness": 0.0333,
   "Instrumentalness": 0.719,
   "Liveness": 0.0828,
   "Valence": 0.349,
   "Tempo": 193.985,
   "Type": "audio_features",
   "ID": "0WhBu4zuwXkbL7jgfQznO2",
   "Uri": "spotify:track:0WhBu4zuwXkbL7jgfQznO2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0WhBu4zuwXkbL7jgfQznO2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0WhBu4zuwXkbL7jgfQznO2",
   "Duration_ms": 292000,
   "time_signature": 4,
   "Genre": "vaporpop"
 },
 {
      "Name": "HeyBud",
   "Danceability": 0.827,
   "Energy": 0.749,
   "Key": 4,
   "Loudness": -5.21,
   "Mode": 0,
   "Speechness": 0.263,
   "Acousticness": 0.0019,
   "Instrumentalness": 0.0847,
   "Liveness": 0.665,
   "Valence": 0.603,
   "Tempo": 91.994,
   "Type": "audio_features",
   "ID": "30iGc3gZlptjWNKNZjaEi7",
   "Uri": "spotify:track:30iGc3gZlptjWNKNZjaEi7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/30iGc3gZlptjWNKNZjaEi7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/30iGc3gZlptjWNKNZjaEi7",
   "Duration_ms": 281835,
   "time_signature": 4,
   "Genre": "deepfilthstep"
 },
 {
      "Name": "AThousandNights-OriginalMix",
   "Danceability": 0.688,
   "Energy": 0.534,
   "Key": 9,
   "Loudness": -10.534,
   "Mode": 0,
   "Speechness": 0.0392,
   "Acousticness": 0.0372,
   "Instrumentalness": 0.938,
   "Liveness": 0.119,
   "Valence": 0.642,
   "Tempo": 127.999,
   "Type": "audio_features",
   "ID": "5eB0rqZxYobNIzL4geAqB1",
   "Uri": "spotify:track:5eB0rqZxYobNIzL4geAqB1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5eB0rqZxYobNIzL4geAqB1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5eB0rqZxYobNIzL4geAqB1",
   "Duration_ms": 456701,
   "time_signature": 4,
   "Genre": "minimaltechno"
 },
 {
      "Name": "Flows",
   "Danceability": 0.571,
   "Energy": 0.468,
   "Key": 10,
   "Loudness": -9.739,
   "Mode": 1,
   "Speechness": 0.0317,
   "Acousticness": 0.335,
   "Instrumentalness": 0.789,
   "Liveness": 0.109,
   "Valence": 0.432,
   "Tempo": 84.016,
   "Type": "audio_features",
   "ID": "4h5p6yqJQc7AOChygp1OZE",
   "Uri": "spotify:track:4h5p6yqJQc7AOChygp1OZE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4h5p6yqJQc7AOChygp1OZE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4h5p6yqJQc7AOChygp1OZE",
   "Duration_ms": 181946,
   "time_signature": 1,
   "Genre": "danishpoprock"
 },
 {
      "Name": "IubireaAdancaaTatalui",
   "Danceability": 0.537,
   "Energy": 0.469,
   "Key": 7,
   "Loudness": -8.372,
   "Mode": 1,
   "Speechness": 0.0279,
   "Acousticness": 0.303,
   "Instrumentalness": 0,
   "Liveness": 0.106,
   "Valence": 0.353,
   "Tempo": 127.916,
   "Type": "audio_features",
   "ID": "6We0vDEqzeNq0OBwQAjqfp",
   "Uri": "spotify:track:6We0vDEqzeNq0OBwQAjqfp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6We0vDEqzeNq0OBwQAjqfp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6We0vDEqzeNq0OBwQAjqfp",
   "Duration_ms": 264707,
   "time_signature": 3,
   "Genre": "muzicacrestina"
 },
 {
      "Name": "Kryptonite",
   "Danceability": 0.547,
   "Energy": 0.87,
   "Key": 11,
   "Loudness": -5.098,
   "Mode": 0,
   "Speechness": 0.0286,
   "Acousticness": 0.00494,
   "Instrumentalness": 0.0000348,
   "Liveness": 0.161,
   "Valence": 0.514,
   "Tempo": 99.014,
   "Type": "audio_features",
   "ID": "3bbUkaQYGQHkx1TJi7gPSL",
   "Uri": "spotify:track:3bbUkaQYGQHkx1TJi7gPSL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3bbUkaQYGQHkx1TJi7gPSL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3bbUkaQYGQHkx1TJi7gPSL",
   "Duration_ms": 233827,
   "time_signature": 4,
   "Genre": "metalguitar"
 },
 {
      "Name": "ParadiseCity",
   "Danceability": 0.274,
   "Energy": 0.949,
   "Key": 11,
   "Loudness": -8.642,
   "Mode": 1,
   "Speechness": 0.0896,
   "Acousticness": 0.0214,
   "Instrumentalness": 0.00778,
   "Liveness": 0.218,
   "Valence": 0.497,
   "Tempo": 100.346,
   "Type": "audio_features",
   "ID": "5Q41NLTmGbVPozwHKK7bk2",
   "Uri": "spotify:track:5Q41NLTmGbVPozwHKK7bk2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5Q41NLTmGbVPozwHKK7bk2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5Q41NLTmGbVPozwHKK7bk2",
   "Duration_ms": 406307,
   "time_signature": 4,
   "Genre": "hardglam"
 },
 {
   
   "Name": "MyGodIsGood",
   "Danceability": 0.543,
   "Energy": 0.902,
   "Key": 5,
   "Loudness": -7.92,
   "Mode": 1,
   "Speechness": 0.174,
   "Acousticness": 0.596,
   "Instrumentalness": 0,
   "Liveness": 0.96,
   "Valence": 0.768,
   "Tempo": 126.374,
   "Type": "audio_features",
   "ID": "6cUiRdvcV8PxSRdkEIlKUS",
   "Uri": "spotify:track:6cUiRdvcV8PxSRdkEIlKUS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6cUiRdvcV8PxSRdkEIlKUS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6cUiRdvcV8PxSRdkEIlKUS",
   "Duration_ms": 281040,
   "time_signature": 4,
   "Genre": "africangospel"
 },
 {
   
   "Name": "BlackKkk(feat.21Savage)",
   "Danceability": 0.42,
   "Energy": 0.919,
   "Key": 8,
   "Loudness": -4.737,
   "Mode": 1,
   "Speechness": 0.505,
   "Acousticness": 0.0748,
   "Instrumentalness": 0,
   "Liveness": 0.298,
   "Valence": 0.584,
   "Tempo": 131.147,
   "Type": "audio_features",
   "ID": "2eFL94tC1pKL4d2xTKAeiQ",
   "Uri": "spotify:track:2eFL94tC1pKL4d2xTKAeiQ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2eFL94tC1pKL4d2xTKAeiQ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2eFL94tC1pKL4d2xTKAeiQ",
   "Duration_ms": 168177,
   "time_signature": 4,
   "Genre": "dmvrap"
 },
 {
   
   "Name": "TheThingfromtheSea(1941-11-28)",
   "Danceability": 0.687,
   "Energy": 0.058,
   "Key": 0,
   "Loudness": -23.195,
   "Mode": 1,
   "Speechness": 0.845,
   "Acousticness": 0.986,
   "Instrumentalness": 0.000166,
   "Liveness": 0.113,
   "Valence": 0.182,
   "Tempo": 128.241,
   "Type": "audio_features",
   "ID": "2nj9D8bx7bv8NdHC2gbcF5",
   "Uri": "spotify:track:2nj9D8bx7bv8NdHC2gbcF5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2nj9D8bx7bv8NdHC2gbcF5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2nj9D8bx7bv8NdHC2gbcF5",
   "Duration_ms": 1443213,
   "time_signature": 3,
   "Genre": "vintageradioshow"
 },
 {
   
   "Name": "Piu\\ForteDelleBombe",
   "Danceability": 0.699,
   "Energy": 0.862,
   "Key": 6,
   "Loudness": -6.606,
   "Mode": 1,
   "Speechness": 0.193,
   "Acousticness": 0.00908,
   "Instrumentalness": 0,
   "Liveness": 0.213,
   "Valence": 0.756,
   "Tempo": 101.995,
   "Type": "audio_features",
   "ID": "13Xckcuw0bUlY2skp5uMlJ",
   "Uri": "spotify:track:13Xckcuw0bUlY2skp5uMlJ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/13Xckcuw0bUlY2skp5uMlJ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/13Xckcuw0bUlY2skp5uMlJ",
   "Duration_ms": 258853,
   "time_signature": 4,
   "Genre": "italianundergroundhiphop"
 },
 {
   
   "Name": "CheParaguaype",
   "Danceability": 0.463,
   "Energy": 0.666,
   "Key": 5,
   "Loudness": -8.596,
   "Mode": 1,
   "Speechness": 0.0312,
   "Acousticness": 0.781,
   "Instrumentalness": 0.951,
   "Liveness": 0.117,
   "Valence": 0.853,
   "Tempo": 150.071,
   "Type": "audio_features",
   "ID": "3d5C4Sv9NLx14oo6DUGvCv",
   "Uri": "spotify:track:3d5C4Sv9NLx14oo6DUGvCv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3d5C4Sv9NLx14oo6DUGvCv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3d5C4Sv9NLx14oo6DUGvCv",
   "Duration_ms": 194307,
   "time_signature": 3,
   "Genre": "arpaparaguaya"
 },
 {
   
   "Name": "Jumalanpeili",
   "Danceability": 0.823,
   "Energy": 0.556,
   "Key": 6,
   "Loudness": -7.92,
   "Mode": 0,
   "Speechness": 0.0702,
   "Acousticness": 0.413,
   "Instrumentalness": 0.0153,
   "Liveness": 0.141,
   "Valence": 0.462,
   "Tempo": 117.642,
   "Type": "audio_features",
   "ID": "3iDZgsPo8WwsaSNIWfLQGs",
   "Uri": "spotify:track:3iDZgsPo8WwsaSNIWfLQGs",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3iDZgsPo8WwsaSNIWfLQGs",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3iDZgsPo8WwsaSNIWfLQGs",
   "Duration_ms": 223640,
   "time_signature": 4,
   "Genre": "finnishhiphop"
 },
 {
   
   "Name": "Jagutandig",
   "Danceability": 0.29,
   "Energy": 0.465,
   "Key": 6,
   "Loudness": -10.729,
   "Mode": 1,
   "Speechness": 0.0322,
   "Acousticness": 0.581,
   "Instrumentalness": 0.184,
   "Liveness": 0.258,
   "Valence": 0.412,
   "Tempo": 103.765,
   "Type": "audio_features",
   "ID": "2K6ZdFYngMVzTFiNQhBzM4",
   "Uri": "spotify:track:2K6ZdFYngMVzTFiNQhBzM4",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2K6ZdFYngMVzTFiNQhBzM4",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2K6ZdFYngMVzTFiNQhBzM4",
   "Duration_ms": 244996,
   "time_signature": 4,
   "Genre": "swedishsoul"
 },
 {
   
   "Name": "DiamondsAreForever",
   "Danceability": 0.546,
   "Energy": 0.969,
   "Key": 11,
   "Loudness": -4.68,
   "Mode": 1,
   "Speechness": 0.06,
   "Acousticness": 0.138,
   "Instrumentalness": 0.0000101,
   "Liveness": 0.243,
   "Valence": 0.669,
   "Tempo": 101.004,
   "Type": "audio_features",
   "ID": "4ElblD2CFtOmxFceB7Xoqj",
   "Uri": "spotify:track:4ElblD2CFtOmxFceB7Xoqj",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4ElblD2CFtOmxFceB7Xoqj",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4ElblD2CFtOmxFceB7Xoqj",
   "Duration_ms": 340387,
   "time_signature": 4,
   "Genre": "indonesianpoppunk"
 },
 {
   
   "Name": "FeelingYou",
   "Danceability": 0.644,
   "Energy": 0.502,
   "Key": 1,
   "Loudness": -9.374,
   "Mode": 0,
   "Speechness": 0.0302,
   "Acousticness": 0.665,
   "Instrumentalness": 0.165,
   "Liveness": 0.124,
   "Valence": 0.159,
   "Tempo": 103.987,
   "Type": "audio_features",
   "ID": "03KisebN9LuPAchPJm32M8",
   "Uri": "spotify:track:03KisebN9LuPAchPJm32M8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/03KisebN9LuPAchPJm32M8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/03KisebN9LuPAchPJm32M8",
   "Duration_ms": 201196,
   "time_signature": 4,
   "Genre": "channelpop"
 },
 {
   
   "Name": "K-SwiftIntros1-4",
   "Danceability": 0.824,
   "Energy": 0.924,
   "Key": 8,
   "Loudness": -2.272,
   "Mode": 0,
   "Speechness": 0.214,
   "Acousticness": 0.08,
   "Instrumentalness": 0.00000408,
   "Liveness": 0.446,
   "Valence": 0.697,
   "Tempo": 130.074,
   "Type": "audio_features",
   "ID": "3WB3Gzxd4fbbgHsxoh68tb",
   "Uri": "spotify:track:3WB3Gzxd4fbbgHsxoh68tb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3WB3Gzxd4fbbgHsxoh68tb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3WB3Gzxd4fbbgHsxoh68tb",
   "Duration_ms": 429160,
   "time_signature": 4,
   "Genre": "bmore"
 },
 {
   
   "Name": "November18th",
   "Danceability": 0.749,
   "Energy": 0.476,
   "Key": 11,
   "Loudness": -11.147,
   "Mode": 0,
   "Speechness": 0.507,
   "Acousticness": 0.579,
   "Instrumentalness": 0,
   "Liveness": 0.1,
   "Valence": 0.534,
   "Tempo": 71.937,
   "Type": "audio_features",
   "ID": "0JaVdpmiex2EP7bBzyKVTa",
   "Uri": "spotify:track:0JaVdpmiex2EP7bBzyKVTa",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0JaVdpmiex2EP7bBzyKVTa",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0JaVdpmiex2EP7bBzyKVTa",
   "Duration_ms": 188189,
   "time_signature": 4,
   "Genre": "hiphop"
 },
 {
   
   "Name": "OldTownRoad",
   "Danceability": 0.908,
   "Energy": 0.517,
   "Key": 1,
   "Loudness": -6.063,
   "Mode": 1,
   "Speechness": 0.129,
   "Acousticness": 0.0361,
   "Instrumentalness": 0.00000173,
   "Liveness": 0.0949,
   "Valence": 0.471,
   "Tempo": 136.019,
   "Type": "audio_features",
   "ID": "53CJANUxooaqGOtdsBTh7O",
   "Uri": "spotify:track:53CJANUxooaqGOtdsBTh7O",
   "Ref_Track": "https://api.spotify.com/v1/tracks/53CJANUxooaqGOtdsBTh7O",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/53CJANUxooaqGOtdsBTh7O",
   "Duration_ms": 113013,
   "time_signature": 4,
   "Genre": "ukpop"
 },
 {
   
   "Name": "BailaBailaBaila-Remix",
   "Danceability": 0.785,
   "Energy": 0.572,
   "Key": 2,
   "Loudness": -7.504,
   "Mode": 1,
   "Speechness": 0.123,
   "Acousticness": 0.0598,
   "Instrumentalness": 0,
   "Liveness": 0.218,
   "Valence": 0.49,
   "Tempo": 100.016,
   "Type": "audio_features",
   "ID": "7mWFF4gPADjTQjC97CgFVt",
   "Uri": "spotify:track:7mWFF4gPADjTQjC97CgFVt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7mWFF4gPADjTQjC97CgFVt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7mWFF4gPADjTQjC97CgFVt",
   "Duration_ms": 235284,
   "time_signature": 4,
   "Genre": "electrolatino"
 },
 {
   
   "Name": "Lambreta",
   "Danceability": 0.695,
   "Energy": 0.171,
   "Key": 9,
   "Loudness": -12.284,
   "Mode": 1,
   "Speechness": 0.101,
   "Acousticness": 0.849,
   "Instrumentalness": 0.0349,
   "Liveness": 0.108,
   "Valence": 0.396,
   "Tempo": 132.887,
   "Type": "audio_features",
   "ID": "6OrNf46vJrHqNP3IFpmvhV",
   "Uri": "spotify:track:6OrNf46vJrHqNP3IFpmvhV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6OrNf46vJrHqNP3IFpmvhV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6OrNf46vJrHqNP3IFpmvhV",
   "Duration_ms": 144240,
   "time_signature": 3,
   "Genre": "portugueseindie"
 },
 {
   
   "Name": "Defluxion",
   "Danceability": 0.685,
   "Energy": 0.998,
   "Key": 8,
   "Loudness": -2.325,
   "Mode": 1,
   "Speechness": 0.199,
   "Acousticness": 0.00619,
   "Instrumentalness": 0.401,
   "Liveness": 0.115,
   "Valence": 0.23,
   "Tempo": 95.043,
   "Type": "audio_features",
   "ID": "0uXs2xnOP3yws0Hg7KUdjG",
   "Uri": "spotify:track:0uXs2xnOP3yws0Hg7KUdjG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0uXs2xnOP3yws0Hg7KUdjG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0uXs2xnOP3yws0Hg7KUdjG",
   "Duration_ms": 373333,
   "time_signature": 5,
   "Genre": "breakcore"
 },
 {
   
   "Name": "ItHurts",
   "Danceability": 0.658,
   "Energy": 0.833,
   "Key": 9,
   "Loudness": -4.367,
   "Mode": 1,
   "Speechness": 0.0667,
   "Acousticness": 0.0168,
   "Instrumentalness": 0.221,
   "Liveness": 0.101,
   "Valence": 0.699,
   "Tempo": 149.739,
   "Type": "audio_features",
   "ID": "71N5U2T2S6QT4uCCKa3KLr",
   "Uri": "spotify:track:71N5U2T2S6QT4uCCKa3KLr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/71N5U2T2S6QT4uCCKa3KLr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/71N5U2T2S6QT4uCCKa3KLr",
   "Duration_ms": 137947,
   "time_signature": 4,
   "Genre": "minneapolisindie"
 },
 {
   
   "Name": "WindThatCrackstheLeaves",
   "Danceability": 0.449,
   "Energy": 0.155,
   "Key": 0,
   "Loudness": -19.44,
   "Mode": 0,
   "Speechness": 0.0363,
   "Acousticness": 0.864,
   "Instrumentalness": 0.159,
   "Liveness": 0.121,
   "Valence": 0.146,
   "Tempo": 118.525,
   "Type": "audio_features",
   "ID": "4VjRsyMPWgteehda8ggBhy",
   "Uri": "spotify:track:4VjRsyMPWgteehda8ggBhy",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4VjRsyMPWgteehda8ggBhy",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4VjRsyMPWgteehda8ggBhy",
   "Duration_ms": 378813,
   "time_signature": 4,
   "Genre": "nlfolk"
 },
 {
   
   "Name": "Stronger",
   "Danceability": 0.564,
   "Energy": 0.892,
   "Key": 8,
   "Loudness": -3.653,
   "Mode": 1,
   "Speechness": 0.0401,
   "Acousticness": 0.0473,
   "Instrumentalness": 0.000343,
   "Liveness": 0.412,
   "Valence": 0.679,
   "Tempo": 174.021,
   "Type": "audio_features",
   "ID": "0LjgvrBY5f4QFLvCicT1NJ",
   "Uri": "spotify:track:0LjgvrBY5f4QFLvCicT1NJ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0LjgvrBY5f4QFLvCicT1NJ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0LjgvrBY5f4QFLvCicT1NJ",
   "Duration_ms": 213887,
   "time_signature": 4,
   "Genre": "christianpop"
 },
 {
   
   "Name": "Merlin:II.",
   "Danceability": 0.33,
   "Energy": 0.0869,
   "Key": 9,
   "Loudness": -25.401,
   "Mode": 0,
   "Speechness": 0.0563,
   "Acousticness": 0.979,
   "Instrumentalness": 0.929,
   "Liveness": 0.107,
   "Valence": 0.0399,
   "Tempo": 112.504,
   "Type": "audio_features",
   "ID": "0zRd1hHp8D3PA0Gq8AKE3o",
   "Uri": "spotify:track:0zRd1hHp8D3PA0Gq8AKE3o",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0zRd1hHp8D3PA0Gq8AKE3o",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0zRd1hHp8D3PA0Gq8AKE3o",
   "Duration_ms": 385333,
   "time_signature": 4,
   "Genre": "classicalpercussion"
 },
 {
   
   "Name": "CommitteeCircus",
   "Danceability": 0.486,
   "Energy": 0.969,
   "Key": 1,
   "Loudness": -4.477,
   "Mode": 1,
   "Speechness": 0.149,
   "Acousticness": 0.00077,
   "Instrumentalness": 0.00000383,
   "Liveness": 0.225,
   "Valence": 0.548,
   "Tempo": 92.634,
   "Type": "audio_features",
   "ID": "6KiTZ39ZpPoVjjs9hDXKd2",
   "Uri": "spotify:track:6KiTZ39ZpPoVjjs9hDXKd2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6KiTZ39ZpPoVjjs9hDXKd2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6KiTZ39ZpPoVjjs9hDXKd2",
   "Duration_ms": 195333,
   "time_signature": 4,
   "Genre": "noisepunk"
 },
 {
   
   "Name": "U&ME",
   "Danceability": 0.881,
   "Energy": 0.605,
   "Key": 1,
   "Loudness": -5.392,
   "Mode": 1,
   "Speechness": 0.0417,
   "Acousticness": 0.308,
   "Instrumentalness": 0.742,
   "Liveness": 0.115,
   "Valence": 0.518,
   "Tempo": 132.014,
   "Type": "audio_features",
   "ID": "7qzM2SlRXkHzTvcBG5FrHp",
   "Uri": "spotify:track:7qzM2SlRXkHzTvcBG5FrHp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7qzM2SlRXkHzTvcBG5FrHp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7qzM2SlRXkHzTvcBG5FrHp",
   "Duration_ms": 278750,
   "time_signature": 4,
   "Genre": "experimentalhouse"
 },
 {
   
   "Name": "Allekanprate",
   "Danceability": 0.678,
   "Energy": 0.637,
   "Key": 6,
   "Loudness": -9.462,
   "Mode": 0,
   "Speechness": 0.0376,
   "Acousticness": 0.0826,
   "Instrumentalness": 0.00155,
   "Liveness": 0.0885,
   "Valence": 0.134,
   "Tempo": 107.035,
   "Type": "audio_features",
   "ID": "19mtzdSU5Qc8EwaORz7vu1",
   "Uri": "spotify:track:19mtzdSU5Qc8EwaORz7vu1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/19mtzdSU5Qc8EwaORz7vu1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/19mtzdSU5Qc8EwaORz7vu1",
   "Duration_ms": 198026,
   "time_signature": 4,
   "Genre": "norwegianhiphop"
 },
 {
   
   "Name": "DoMatter",
   "Danceability": 0.521,
   "Energy": 0.289,
   "Key": 8,
   "Loudness": -16.915,
   "Mode": 1,
   "Speechness": 0.0302,
   "Acousticness": 0.54,
   "Instrumentalness": 0.564,
   "Liveness": 0.111,
   "Valence": 0.289,
   "Tempo": 99.997,
   "Type": "audio_features",
   "ID": "6ZQ3XvLBrmwnoNFtU0c2X5",
   "Uri": "spotify:track:6ZQ3XvLBrmwnoNFtU0c2X5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6ZQ3XvLBrmwnoNFtU0c2X5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6ZQ3XvLBrmwnoNFtU0c2X5",
   "Duration_ms": 220920,
   "time_signature": 4,
   "Genre": "glittertrance"
 },
 {
   
   "Name": "I\\mJustAKid",
   "Danceability": 0.527,
   "Energy": 0.834,
   "Key": 1,
   "Loudness": -5.531,
   "Mode": 1,
   "Speechness": 0.0447,
   "Acousticness": 0.00107,
   "Instrumentalness": 0.000102,
   "Liveness": 0.0993,
   "Valence": 0.422,
   "Tempo": 110.065,
   "Type": "audio_features",
   "ID": "1hIupFeRu3nmMcjbjxPnMc",
   "Uri": "spotify:track:1hIupFeRu3nmMcjbjxPnMc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1hIupFeRu3nmMcjbjxPnMc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1hIupFeRu3nmMcjbjxPnMc",
   "Duration_ms": 198333,
   "time_signature": 4,
   "Genre": "deeppoppunk"
 },
 {
   
   "Name": "PuntoG",
   "Danceability": 0.787,
   "Energy": 0.751,
   "Key": 6,
   "Loudness": -4.738,
   "Mode": 0,
   "Speechness": 0.0865,
   "Acousticness": 0.00796,
   "Instrumentalness": 0.000139,
   "Liveness": 0.0857,
   "Valence": 0.926,
   "Tempo": 165.961,
   "Type": "audio_features",
   "ID": "5Lb1pjnll07UQKxNpnnGBy",
   "Uri": "spotify:track:5Lb1pjnll07UQKxNpnnGBy",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5Lb1pjnll07UQKxNpnnGBy",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5Lb1pjnll07UQKxNpnnGBy",
   "Duration_ms": 181587,
   "time_signature": 4,
   "Genre": "reggaeton"
 },
 {
   
   "Name": "ConLaMismaMoneda",
   "Danceability": 0.626,
   "Energy": 0.697,
   "Key": 7,
   "Loudness": -5.819,
   "Mode": 0,
   "Speechness": 0.0292,
   "Acousticness": 0.482,
   "Instrumentalness": 0,
   "Liveness": 0.0982,
   "Valence": 0.757,
   "Tempo": 98.491,
   "Type": "audio_features",
   "ID": "2ALkI7lnCG5p2ZkbKnd5zd",
   "Uri": "spotify:track:2ALkI7lnCG5p2ZkbKnd5zd",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2ALkI7lnCG5p2ZkbKnd5zd",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2ALkI7lnCG5p2ZkbKnd5zd",
   "Duration_ms": 240094,
   "time_signature": 4,
   "Genre": "cumbiaperuana"
 },
 {
   
   "Name": "Slide(feat.Blueface&LilTjay)",
   "Danceability": 0.532,
   "Energy": 0.704,
   "Key": 5,
   "Loudness": -3.895,
   "Mode": 0,
   "Speechness": 0.26,
   "Acousticness": 0.093,
   "Instrumentalness": 0,
   "Liveness": 0.184,
   "Valence": 0.591,
   "Tempo": 96.004,
   "Type": "audio_features",
   "ID": "40Zb4FZ6nS1Hj8RVfaLkCV",
   "Uri": "spotify:track:40Zb4FZ6nS1Hj8RVfaLkCV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/40Zb4FZ6nS1Hj8RVfaLkCV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/40Zb4FZ6nS1Hj8RVfaLkCV",
   "Duration_ms": 186344,
   "time_signature": 4,
   "Genre": "frenchhiphop"
 },
 {
   
   "Name": "U.I.C.",
   "Danceability": 0.581,
   "Energy": 0.95,
   "Key": 9,
   "Loudness": -6.163,
   "Mode": 1,
   "Speechness": 0.111,
   "Acousticness": 0.117,
   "Instrumentalness": 0,
   "Liveness": 0.327,
   "Valence": 0.56,
   "Tempo": 121.133,
   "Type": "audio_features",
   "ID": "2tA0txpNwby68xHvOty7Sw",
   "Uri": "spotify:track:2tA0txpNwby68xHvOty7Sw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2tA0txpNwby68xHvOty7Sw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2tA0txpNwby68xHvOty7Sw",
   "Duration_ms": 135520,
   "time_signature": 4,
   "Genre": "musiqueacadienne"
 },
 {
   
   "Name": "Y\\enamarre",
   "Danceability": 0.401,
   "Energy": 0.887,
   "Key": 9,
   "Loudness": -4.172,
   "Mode": 0,
   "Speechness": 0.106,
   "Acousticness": 0.445,
   "Instrumentalness": 0.00000387,
   "Liveness": 0.252,
   "Valence": 0.782,
   "Tempo": 144.966,
   "Type": "audio_features",
   "ID": "2OdNRuUkRGj4ZpprYSARdo",
   "Uri": "spotify:track:2OdNRuUkRGj4ZpprYSARdo",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2OdNRuUkRGj4ZpprYSARdo",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2OdNRuUkRGj4ZpprYSARdo",
   "Duration_ms": 298284,
   "time_signature": 4,
   "Genre": "deeprai"
 },
 {
   
   "Name": "Yeah3x",
   "Danceability": 0.702,
   "Energy": 0.883,
   "Key": 11,
   "Loudness": -3.239,
   "Mode": 0,
   "Speechness": 0.0437,
   "Acousticness": 0.000407,
   "Instrumentalness": 0.00000127,
   "Liveness": 0.0885,
   "Valence": 0.709,
   "Tempo": 129.999,
   "Type": "audio_features",
   "ID": "0AUIjHlr9KfbVoemhhxHS6",
   "Uri": "spotify:track:0AUIjHlr9KfbVoemhhxHS6",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0AUIjHlr9KfbVoemhhxHS6",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0AUIjHlr9KfbVoemhhxHS6",
   "Duration_ms": 241093,
   "time_signature": 4,
   "Genre": "americanchoir"
 },
 {
   
   "Name": "WindyCity",
   "Danceability": 0.475,
   "Energy": 0.43,
   "Key": 2,
   "Loudness": -6.752,
   "Mode": 1,
   "Speechness": 0.0256,
   "Acousticness": 0.559,
   "Instrumentalness": 0.00000125,
   "Liveness": 0.0984,
   "Valence": 0.304,
   "Tempo": 98.9,
   "Type": "audio_features",
   "ID": "4yrgkvL2T7VMYjUTwUi9pa",
   "Uri": "spotify:track:4yrgkvL2T7VMYjUTwUi9pa",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4yrgkvL2T7VMYjUTwUi9pa",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4yrgkvL2T7VMYjUTwUi9pa",
   "Duration_ms": 195973,
   "time_signature": 4,
   "Genre": "ukamericana"
 },
 {
   
   "Name": "SemVocê",
   "Danceability": 0.401,
   "Energy": 0.583,
   "Key": 10,
   "Loudness": -6.478,
   "Mode": 1,
   "Speechness": 0.0314,
   "Acousticness": 0.41,
   "Instrumentalness": 0,
   "Liveness": 0.207,
   "Valence": 0.669,
   "Tempo": 200.328,
   "Type": "audio_features",
   "ID": "4MEF6IiIiDOD23VYFgJOoG",
   "Uri": "spotify:track:4MEF6IiIiDOD23VYFgJOoG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4MEF6IiIiDOD23VYFgJOoG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4MEF6IiIiDOD23VYFgJOoG",
   "Duration_ms": 231573,
   "time_signature": 3,
   "Genre": "chamame"
 },
 {
   
   "Name": "WaitingInVain",
   "Danceability": 0.838,
   "Energy": 0.453,
   "Key": 8,
   "Loudness": -11.536,
   "Mode": 1,
   "Speechness": 0.31,
   "Acousticness": 0.025,
   "Instrumentalness": 0.0000242,
   "Liveness": 0.116,
   "Valence": 0.815,
   "Tempo": 78.837,
   "Type": "audio_features",
   "ID": "7FILn9Akg2468HPNsRZCkq",
   "Uri": "spotify:track:7FILn9Akg2468HPNsRZCkq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7FILn9Akg2468HPNsRZCkq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7FILn9Akg2468HPNsRZCkq",
   "Duration_ms": 256493,
   "time_signature": 4,
   "Genre": "reggae"
 },
 {
   
   "Name": "BreatheonUs",
   "Danceability": 0.238,
   "Energy": 0.4,
   "Key": 4,
   "Loudness": -8.338,
   "Mode": 1,
   "Speechness": 0.0329,
   "Acousticness": 0.209,
   "Instrumentalness": 0.00000326,
   "Liveness": 0.113,
   "Valence": 0.0825,
   "Tempo": 147.598,
   "Type": "audio_features",
   "ID": "4N2yp7olhde2viZAxvqhbV",
   "Uri": "spotify:track:4N2yp7olhde2viZAxvqhbV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4N2yp7olhde2viZAxvqhbV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4N2yp7olhde2viZAxvqhbV",
   "Duration_ms": 368811,
   "time_signature": 4,
   "Genre": "deepccm"
 },
 {
   
   "Name": "Dilema",
   "Danceability": 0.691,
   "Energy": 0.576,
   "Key": 5,
   "Loudness": -6.539,
   "Mode": 0,
   "Speechness": 0.115,
   "Acousticness": 0.166,
   "Instrumentalness": 0,
   "Liveness": 0.0986,
   "Valence": 0.456,
   "Tempo": 97.91,
   "Type": "audio_features",
   "ID": "7n4jbgtbZ36s1z9AOCBz2t",
   "Uri": "spotify:track:7n4jbgtbZ36s1z9AOCBz2t",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7n4jbgtbZ36s1z9AOCBz2t",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7n4jbgtbZ36s1z9AOCBz2t",
   "Duration_ms": 186155,
   "time_signature": 4,
   "Genre": "r&bbrasileiro"
 },
 {
   
   "Name": "SopadeCaracol",
   "Danceability": 0.927,
   "Energy": 0.544,
   "Key": 3,
   "Loudness": -14.621,
   "Mode": 1,
   "Speechness": 0.0769,
   "Acousticness": 0.308,
   "Instrumentalness": 0.0000103,
   "Liveness": 0.312,
   "Valence": 0.961,
   "Tempo": 124.283,
   "Type": "audio_features",
   "ID": "4V8uHuLaBRxQ02H4YNCOO7",
   "Uri": "spotify:track:4V8uHuLaBRxQ02H4YNCOO7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4V8uHuLaBRxQ02H4YNCOO7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4V8uHuLaBRxQ02H4YNCOO7",
   "Duration_ms": 293907,
   "time_signature": 4,
   "Genre": "punta"
 },
 {
   
   "Name": "TheNoiseofOcean\\sLastWhale",
   "Danceability": 0.351,
   "Energy": 0.153,
   "Key": 0,
   "Loudness": -14.604,
   "Mode": 1,
   "Speechness": 0.0312,
   "Acousticness": 0.0663,
   "Instrumentalness": 0.939,
   "Liveness": 0.404,
   "Valence": 0.0395,
   "Tempo": 75.008,
   "Type": "audio_features",
   "ID": "66wjPLeKLF4KObobc3lBg8",
   "Uri": "spotify:track:66wjPLeKLF4KObobc3lBg8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/66wjPLeKLF4KObobc3lBg8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/66wjPLeKLF4KObobc3lBg8",
   "Duration_ms": 351400,
   "time_signature": 4,
   "Genre": "italianpost-rock"
 },
 {
   
   "Name": "MistakesLikeFractures",
   "Danceability": 0.28,
   "Energy": 0.935,
   "Key": 9,
   "Loudness": -3.565,
   "Mode": 1,
   "Speechness": 0.12,
   "Acousticness": 0.0000428,
   "Instrumentalness": 0.000004,
   "Liveness": 0.331,
   "Valence": 0.195,
   "Tempo": 142.973,
   "Type": "audio_features",
   "ID": "57Eqt2WEeSfi9Pg9dQhnPT",
   "Uri": "spotify:track:57Eqt2WEeSfi9Pg9dQhnPT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/57Eqt2WEeSfi9Pg9dQhnPT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/57Eqt2WEeSfi9Pg9dQhnPT",
   "Duration_ms": 221852,
   "time_signature": 4,
   "Genre": "hardcorepunk"
 },
 {
   
   "Name": "PreSego-OriginalMix",
   "Danceability": 0.809,
   "Energy": 0.974,
   "Key": 4,
   "Loudness": -11.158,
   "Mode": 0,
   "Speechness": 0.0685,
   "Acousticness": 0.000183,
   "Instrumentalness": 0.931,
   "Liveness": 0.0695,
   "Valence": 0.498,
   "Tempo": 122.992,
   "Type": "audio_features",
   "ID": "28yQYEPNspcR4h7dR3UV30",
   "Uri": "spotify:track:28yQYEPNspcR4h7dR3UV30",
   "Ref_Track": "https://api.spotify.com/v1/tracks/28yQYEPNspcR4h7dR3UV30",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/28yQYEPNspcR4h7dR3UV30",
   "Duration_ms": 452750,
   "time_signature": 4,
   "Genre": "microhouse"
 },
 {
   
   "Name": "MeanMachine",
   "Danceability": 0.467,
   "Energy": 0.97,
   "Key": 5,
   "Loudness": -4.894,
   "Mode": 0,
   "Speechness": 0.0811,
   "Acousticness": 0.00000651,
   "Instrumentalness": 0.0396,
   "Liveness": 0.0751,
   "Valence": 0.408,
   "Tempo": 75.997,
   "Type": "audio_features",
   "ID": "5xkziBu4gybsgYaTGNUJvf",
   "Uri": "spotify:track:5xkziBu4gybsgYaTGNUJvf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5xkziBu4gybsgYaTGNUJvf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5xkziBu4gybsgYaTGNUJvf",
   "Duration_ms": 225080,
   "time_signature": 4,
   "Genre": "neo-tradmetal"
 },
 {
   
   "Name": "Inertia",
   "Danceability": 0.425,
   "Energy": 0.799,
   "Key": 9,
   "Loudness": -7.745,
   "Mode": 0,
   "Speechness": 0.045,
   "Acousticness": 0.00284,
   "Instrumentalness": 0.727,
   "Liveness": 0.453,
   "Valence": 0.0478,
   "Tempo": 116.983,
   "Type": "audio_features",
   "ID": "3wLRcgbtuNhM7F4D9szv2T",
   "Uri": "spotify:track:3wLRcgbtuNhM7F4D9szv2T",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3wLRcgbtuNhM7F4D9szv2T",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3wLRcgbtuNhM7F4D9szv2T",
   "Duration_ms": 223027,
   "time_signature": 4,
   "Genre": "melodicdeathmetal"
 },
 {
   
   "Name": "DefendersoftheGrave",
   "Danceability": 0.263,
   "Energy": 0.971,
   "Key": 1,
   "Loudness": -6.812,
   "Mode": 1,
   "Speechness": 0.254,
   "Acousticness": 0.0000147,
   "Instrumentalness": 0.0000992,
   "Liveness": 0.382,
   "Valence": 0.175,
   "Tempo": 110.168,
   "Type": "audio_features",
   "ID": "7EIa00uDUWSwXTHUFhfMWx",
   "Uri": "spotify:track:7EIa00uDUWSwXTHUFhfMWx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7EIa00uDUWSwXTHUFhfMWx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7EIa00uDUWSwXTHUFhfMWx",
   "Duration_ms": 231360,
   "time_signature": 3,
   "Genre": "deathgrind"
 },
 {
   
   "Name": "TheNexus",
   "Danceability": 0.514,
   "Energy": 0.965,
   "Key": 6,
   "Loudness": -4.989,
   "Mode": 1,
   "Speechness": 0.112,
   "Acousticness": 0.00013,
   "Instrumentalness": 0,
   "Liveness": 0.0829,
   "Valence": 0.615,
   "Tempo": 105.014,
   "Type": "audio_features",
   "ID": "02zLvie0t2VVz6vB0fgGSW",
   "Uri": "spotify:track:02zLvie0t2VVz6vB0fgGSW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/02zLvie0t2VVz6vB0fgGSW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/02zLvie0t2VVz6vB0fgGSW",
   "Duration_ms": 198173,
   "time_signature": 4,
   "Genre": "melodicmetalcore"
 },
 {
   
   "Name": "GurenNoYumiya",
   "Danceability": 0.325,
   "Energy": 0.99,
   "Key": 1,
   "Loudness": -3.884,
   "Mode": 0,
   "Speechness": 0.248,
   "Acousticness": 0.0689,
   "Instrumentalness": 0.0000043,
   "Liveness": 0.585,
   "Valence": 0.0841,
   "Tempo": 180.677,
   "Type": "audio_features",
   "ID": "0b7b3OR4cKHo08rdpLHofM",
   "Uri": "spotify:track:0b7b3OR4cKHo08rdpLHofM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0b7b3OR4cKHo08rdpLHofM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0b7b3OR4cKHo08rdpLHofM",
   "Duration_ms": 316933,
   "time_signature": 4,
   "Genre": "animescore"
 },
 {
   
   "Name": "Power",
   "Danceability": 0.937,
   "Energy": 0.558,
   "Key": 6,
   "Loudness": -6.911,
   "Mode": 1,
   "Speechness": 0.275,
   "Acousticness": 0.0163,
   "Instrumentalness": 0,
   "Liveness": 0.157,
   "Valence": 0.497,
   "Tempo": 96.006,
   "Type": "audio_features",
   "ID": "2cn6dv12KLXErgdcSbsdRU",
   "Uri": "spotify:track:2cn6dv12KLXErgdcSbsdRU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2cn6dv12KLXErgdcSbsdRU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2cn6dv12KLXErgdcSbsdRU",
   "Duration_ms": 231293,
   "time_signature": 4,
   "Genre": "detroitindie"
 },
 {
   
   "Name": "Nomeimporta",
   "Danceability": 0.663,
   "Energy": 0.896,
   "Key": 2,
   "Loudness": -4.94,
   "Mode": 1,
   "Speechness": 0.0708,
   "Acousticness": 0.0145,
   "Instrumentalness": 0.0281,
   "Liveness": 0.124,
   "Valence": 0.955,
   "Tempo": 164.054,
   "Type": "audio_features",
   "ID": "2EjY6PVCynZEVdwJYJb0ri",
   "Uri": "spotify:track:2EjY6PVCynZEVdwJYJb0ri",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2EjY6PVCynZEVdwJYJb0ri",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2EjY6PVCynZEVdwJYJb0ri",
   "Duration_ms": 153760,
   "time_signature": 4,
   "Genre": "colombianrock"
 },
 {
   
   "Name": "\\TheWizardAndI-FromWickedOriginalBroadwayCastRecording/2003\\",
   "Danceability": 0.379,
   "Energy": 0.377,
   "Key": 0,
   "Loudness": -7.972,
   "Mode": 1,
   "Speechness": 0.0357,
   "Acousticness": 0.832,
   "Instrumentalness": 0,
   "Liveness": 0.409,
   "Valence": 0.326,
   "Tempo": 137.021,
   "Type": "audio_features",
   "ID": "3TJQRDc5qot9GJb6T0Pdh2",
   "Uri": "spotify:track:3TJQRDc5qot9GJb6T0Pdh2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3TJQRDc5qot9GJb6T0Pdh2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3TJQRDc5qot9GJb6T0Pdh2",
   "Duration_ms": 309520,
   "time_signature": 4,
   "Genre": "showtunes"
 },
 {
   
   "Name": "DikWork(feat.DJFunk)",
   "Danceability": 0.73,
   "Energy": 0.999,
   "Key": 11,
   "Loudness": -3.721,
   "Mode": 1,
   "Speechness": 0.059,
   "Acousticness": 0.00444,
   "Instrumentalness": 0.519,
   "Liveness": 0.0812,
   "Valence": 0.607,
   "Tempo": 130.015,
   "Type": "audio_features",
   "ID": "7Jfs0R28Rb4FX8QkgIjCy8",
   "Uri": "spotify:track:7Jfs0R28Rb4FX8QkgIjCy8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7Jfs0R28Rb4FX8QkgIjCy8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7Jfs0R28Rb4FX8QkgIjCy8",
   "Duration_ms": 254769,
   "time_signature": 4,
   "Genre": "ghettotech"
 },
 {
   
   "Name": "Herecomesthesun",
   "Danceability": 0.73,
   "Energy": 0.253,
   "Key": 9,
   "Loudness": -17.084,
   "Mode": 1,
   "Speechness": 0.0658,
   "Acousticness": 0.657,
   "Instrumentalness": 0.94,
   "Liveness": 0.0749,
   "Valence": 0.708,
   "Tempo": 109.89,
   "Type": "audio_features",
   "ID": "4pizFjwJsU41FLkbwtJluM",
   "Uri": "spotify:track:4pizFjwJsU41FLkbwtJluM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4pizFjwJsU41FLkbwtJluM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4pizFjwJsU41FLkbwtJluM",
   "Duration_ms": 170646,
   "time_signature": 4,
   "Genre": "musicbox"
 },
 {
   
   "Name": "Flashlight-OriginalMix",
   "Danceability": 0.705,
   "Energy": 0.949,
   "Key": 10,
   "Loudness": -3.575,
   "Mode": 1,
   "Speechness": 0.0454,
   "Acousticness": 0.0128,
   "Instrumentalness": 0.6,
   "Liveness": 0.27,
   "Valence": 0.274,
   "Tempo": 128.011,
   "Type": "audio_features",
   "ID": "0WeF2Avp91o78EiEfxHPrw",
   "Uri": "spotify:track:0WeF2Avp91o78EiEfxHPrw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0WeF2Avp91o78EiEfxHPrw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0WeF2Avp91o78EiEfxHPrw",
   "Duration_ms": 232500,
   "time_signature": 4,
   "Genre": "dubstep"
 },
 {
   
   "Name": "MyFirstAnal",
   "Danceability": 0.287,
   "Energy": 0.793,
   "Key": 7,
   "Loudness": -12.985,
   "Mode": 1,
   "Speechness": 0.888,
   "Acousticness": 0.922,
   "Instrumentalness": 0.0102,
   "Liveness": 0.953,
   "Valence": 0.144,
   "Tempo": 67.695,
   "Type": "audio_features",
   "ID": "0TiNh7Y5XOcU0I0EtR6yOh",
   "Uri": "spotify:track:0TiNh7Y5XOcU0I0EtR6yOh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0TiNh7Y5XOcU0I0EtR6yOh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0TiNh7Y5XOcU0I0EtR6yOh",
   "Duration_ms": 387205,
   "time_signature": 4,
   "Genre": "turkishexperimental"
 },
 {
   
   "Name": "StillDoin\\Time",
   "Danceability": 0.633,
   "Energy": 0.368,
   "Key": 3,
   "Loudness": -11.086,
   "Mode": 1,
   "Speechness": 0.0376,
   "Acousticness": 0.753,
   "Instrumentalness": 0.0000757,
   "Liveness": 0.1,
   "Valence": 0.275,
   "Tempo": 123.883,
   "Type": "audio_features",
   "ID": "1PUrH3l6rfsuZAQdsM4LGY",
   "Uri": "spotify:track:1PUrH3l6rfsuZAQdsM4LGY",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1PUrH3l6rfsuZAQdsM4LGY",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1PUrH3l6rfsuZAQdsM4LGY",
   "Duration_ms": 169240,
   "time_signature": 3,
   "Genre": "steelguitar"
 },
 {
   
   "Name": "HawaiianSurf",
   "Danceability": 0.573,
   "Energy": 0.304,
   "Key": 7,
   "Loudness": -12.174,
   "Mode": 1,
   "Speechness": 0.029,
   "Acousticness": 0.851,
   "Instrumentalness": 0.853,
   "Liveness": 0.916,
   "Valence": 0.542,
   "Tempo": 109.791,
   "Type": "audio_features",
   "ID": "67AvDsRL2bgDBovv7eeFXL",
   "Uri": "spotify:track:67AvDsRL2bgDBovv7eeFXL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/67AvDsRL2bgDBovv7eeFXL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/67AvDsRL2bgDBovv7eeFXL",
   "Duration_ms": 174586,
   "time_signature": 4,
   "Genre": "vintagehawaiian"
 },
 {
   
   "Name": "GoldenTeacher",
   "Danceability": 0.531,
   "Energy": 0.428,
   "Key": 4,
   "Loudness": -13.916,
   "Mode": 1,
   "Speechness": 0.0481,
   "Acousticness": 0.481,
   "Instrumentalness": 0.00000822,
   "Liveness": 0.14,
   "Valence": 0.406,
   "Tempo": 138.138,
   "Type": "audio_features",
   "ID": "68vCu2CJ4KzLACnvYs7pxB",
   "Uri": "spotify:track:68vCu2CJ4KzLACnvYs7pxB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/68vCu2CJ4KzLACnvYs7pxB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/68vCu2CJ4KzLACnvYs7pxB",
   "Duration_ms": 219472,
   "time_signature": 4,
   "Genre": "experimentalpsych"
 },
 {
   
   "Name": "LaDiluvienne",
   "Danceability": 0.702,
   "Energy": 0.485,
   "Key": 1,
   "Loudness": -9.413,
   "Mode": 1,
   "Speechness": 0.0441,
   "Acousticness": 0.635,
   "Instrumentalness": 0.0000887,
   "Liveness": 0.141,
   "Valence": 0.339,
   "Tempo": 80.051,
   "Type": "audio_features",
   "ID": "5OeiPamijUlt8UNsF3jjxi",
   "Uri": "spotify:track:5OeiPamijUlt8UNsF3jjxi",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5OeiPamijUlt8UNsF3jjxi",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5OeiPamijUlt8UNsF3jjxi",
   "Duration_ms": 206253,
   "time_signature": 4,
   "Genre": "frenchfolk"
 },
 {
   
   "Name": "Hobâb",
   "Danceability": 0.507,
   "Energy": 0.19,
   "Key": 8,
   "Loudness": -18.877,
   "Mode": 0,
   "Speechness": 0.0346,
   "Acousticness": 0.912,
   "Instrumentalness": 0.676,
   "Liveness": 0.0993,
   "Valence": 0.279,
   "Tempo": 110.205,
   "Type": "audio_features",
   "ID": "5JfJrjh3nd5eOjFjPfV0c4",
   "Uri": "spotify:track:5JfJrjh3nd5eOjFjPfV0c4",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5JfJrjh3nd5eOjFjPfV0c4",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5JfJrjh3nd5eOjFjPfV0c4",
   "Duration_ms": 224360,
   "time_signature": 3,
   "Genre": "persianneo-traditional"
 },
 {
   
   "Name": "99Luftballons",
   "Danceability": 0.621,
   "Energy": 0.636,
   "Key": 4,
   "Loudness": -5.383,
   "Mode": 1,
   "Speechness": 0.0456,
   "Acousticness": 0.0754,
   "Instrumentalness": 0,
   "Liveness": 0.112,
   "Valence": 0.406,
   "Tempo": 96.8,
   "Type": "audio_features",
   "ID": "4WrzovqrEyQ3FVthDEqoEz",
   "Uri": "spotify:track:4WrzovqrEyQ3FVthDEqoEz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4WrzovqrEyQ3FVthDEqoEz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4WrzovqrEyQ3FVthDEqoEz",
   "Duration_ms": 231653,
   "time_signature": 4,
   "Genre": "neuedeutschewelle"
 },
 {
   
   "Name": "Vöggukvæði",
   "Danceability": 0.28,
   "Energy": 0.0106,
   "Key": 4,
   "Loudness": -29.188,
   "Mode": 1,
   "Speechness": 0.0458,
   "Acousticness": 0.993,
   "Instrumentalness": 0.0000508,
   "Liveness": 0.0767,
   "Valence": 0.0976,
   "Tempo": 129.082,
   "Type": "audio_features",
   "ID": "5O9a4hrONcdm0g0x8Dw6JX",
   "Uri": "spotify:track:5O9a4hrONcdm0g0x8Dw6JX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5O9a4hrONcdm0g0x8Dw6JX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5O9a4hrONcdm0g0x8Dw6JX",
   "Duration_ms": 195976,
   "time_signature": 3,
   "Genre": "icelandicpop"
 },
 {
   
   "Name": "Girls",
   "Danceability": 0.681,
   "Energy": 0.657,
   "Key": 1,
   "Loudness": -6.385,
   "Mode": 0,
   "Speechness": 0.0728,
   "Acousticness": 0.222,
   "Instrumentalness": 0,
   "Liveness": 0.135,
   "Valence": 0.353,
   "Tempo": 101.012,
   "Type": "audio_features",
   "ID": "0TaLEGNb6f3nL2VME9SxAR",
   "Uri": "spotify:track:0TaLEGNb6f3nL2VME9SxAR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0TaLEGNb6f3nL2VME9SxAR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0TaLEGNb6f3nL2VME9SxAR",
   "Duration_ms": 271003,
   "time_signature": 4,
   "Genre": "gauzepop"
 },
 {
   
   "Name": "RunningDowntoCuba",
   "Danceability": 0.858,
   "Energy": 0.394,
   "Key": 4,
   "Loudness": -4.705,
   "Mode": 1,
   "Speechness": 0.0737,
   "Acousticness": 0.955,
   "Instrumentalness": 0,
   "Liveness": 0.405,
   "Valence": 0.678,
   "Tempo": 83.063,
   "Type": "audio_features",
   "ID": "3nUgmDWwwmHAbGXZoaeZdz",
   "Uri": "spotify:track:3nUgmDWwwmHAbGXZoaeZdz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3nUgmDWwwmHAbGXZoaeZdz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3nUgmDWwwmHAbGXZoaeZdz",
   "Duration_ms": 89880,
   "time_signature": 4,
   "Genre": "shanty"
 },
 {
   
   "Name": "Rockin\\AroundTheChristmasTree",
   "Danceability": 0.679,
   "Energy": 0.554,
   "Key": 8,
   "Loudness": -6.413,
   "Mode": 1,
   "Speechness": 0.0518,
   "Acousticness": 0.653,
   "Instrumentalness": 0,
   "Liveness": 0.509,
   "Valence": 0.871,
   "Tempo": 141.264,
   "Type": "audio_features",
   "ID": "28fuXrmmF9dYWx25dMW9dP",
   "Uri": "spotify:track:28fuXrmmF9dYWx25dMW9dP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/28fuXrmmF9dYWx25dMW9dP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/28fuXrmmF9dYWx25dMW9dP",
   "Duration_ms": 124520,
   "time_signature": 4,
   "Genre": "christmas"
 },
 {
   
   "Name": "SaviersRoad",
   "Danceability": 0.539,
   "Energy": 0.631,
   "Key": 10,
   "Loudness": -7.673,
   "Mode": 1,
   "Speechness": 0.393,
   "Acousticness": 0.00899,
   "Instrumentalness": 0,
   "Liveness": 0.132,
   "Valence": 0.139,
   "Tempo": 88.426,
   "Type": "audio_features",
   "ID": "3LfnrqODEqXpp7s974cT4z",
   "Uri": "spotify:track:3LfnrqODEqXpp7s974cT4z",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3LfnrqODEqXpp7s974cT4z",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3LfnrqODEqXpp7s974cT4z",
   "Duration_ms": 144667,
   "time_signature": 4,
   "Genre": "chiphop"
 },
 {
   
   "Name": "\\BecauseYouLovedMe(ThemefromUpCloseandPersonal)\\",
   "Danceability": 0.614,
   "Energy": 0.466,
   "Key": 1,
   "Loudness": -9.881,
   "Mode": 1,
   "Speechness": 0.0327,
   "Acousticness": 0.314,
   "Instrumentalness": 0,
   "Liveness": 0.099,
   "Valence": 0.178,
   "Tempo": 119.916,
   "Type": "audio_features",
   "ID": "1NOeZ7ZIVKMebuza26rofd",
   "Uri": "spotify:track:1NOeZ7ZIVKMebuza26rofd",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1NOeZ7ZIVKMebuza26rofd",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1NOeZ7ZIVKMebuza26rofd",
   "Duration_ms": 273667,
   "time_signature": 4,
   "Genre": "musikanak-anak"
 },
 {
   
   "Name": "Utopia",
   "Danceability": 0.535,
   "Energy": 0.706,
   "Key": 0,
   "Loudness": -7.014,
   "Mode": 0,
   "Speechness": 0.0363,
   "Acousticness": 0.0964,
   "Instrumentalness": 0.000116,
   "Liveness": 0.073,
   "Valence": 0.627,
   "Tempo": 179.96,
   "Type": "audio_features",
   "ID": "4wA5QCifsllCrkw6SwNzkm",
   "Uri": "spotify:track:4wA5QCifsllCrkw6SwNzkm",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4wA5QCifsllCrkw6SwNzkm",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4wA5QCifsllCrkw6SwNzkm",
   "Duration_ms": 289640,
   "time_signature": 4,
   "Genre": "swedishsynthpop"
 },
 {
   
   "Name": "BrokenDawn",
   "Danceability": 0.711,
   "Energy": 0.645,
   "Key": 8,
   "Loudness": -7.993,
   "Mode": 0,
   "Speechness": 0.0421,
   "Acousticness": 0.00138,
   "Instrumentalness": 0.825,
   "Liveness": 0.154,
   "Valence": 0.167,
   "Tempo": 139.966,
   "Type": "audio_features",
   "ID": "5GZoKQ8DZXIaK8LIpiTa8K",
   "Uri": "spotify:track:5GZoKQ8DZXIaK8LIpiTa8K",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5GZoKQ8DZXIaK8LIpiTa8K",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5GZoKQ8DZXIaK8LIpiTa8K",
   "Duration_ms": 334286,
   "time_signature": 4,
   "Genre": "minimaldubstep"
 },
 {
   
   "Name": "TheBluePlanet",
   "Danceability": 0.163,
   "Energy": 0.41,
   "Key": 4,
   "Loudness": -16.699,
   "Mode": 0,
   "Speechness": 0.0695,
   "Acousticness": 0.419,
   "Instrumentalness": 0.964,
   "Liveness": 0.0853,
   "Valence": 0.0369,
   "Tempo": 130.045,
   "Type": "audio_features",
   "ID": "1CCq5q1Bv4NLktpSCIr4Yj",
   "Uri": "spotify:track:1CCq5q1Bv4NLktpSCIr4Yj",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1CCq5q1Bv4NLktpSCIr4Yj",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1CCq5q1Bv4NLktpSCIr4Yj",
   "Duration_ms": 197358,
   "time_signature": 4,
   "Genre": "scorecore"
 },
 {
   
   "Name": "FoundLove",
   "Danceability": 0.442,
   "Energy": 0.63,
   "Key": 0,
   "Loudness": -4.961,
   "Mode": 1,
   "Speechness": 0.0367,
   "Acousticness": 0.579,
   "Instrumentalness": 0.000139,
   "Liveness": 0.333,
   "Valence": 0.373,
   "Tempo": 173.936,
   "Type": "audio_features",
   "ID": "7t2ke6xDg4cShdocIVQXfd",
   "Uri": "spotify:track:7t2ke6xDg4cShdocIVQXfd",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7t2ke6xDg4cShdocIVQXfd",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7t2ke6xDg4cShdocIVQXfd",
   "Duration_ms": 196333,
   "time_signature": 4,
   "Genre": "peruvianindie"
 },
 {
   
   "Name": "PostAcid",
   "Danceability": 0.314,
   "Energy": 0.953,
   "Key": 11,
   "Loudness": -2.385,
   "Mode": 0,
   "Speechness": 0.132,
   "Acousticness": 0.000361,
   "Instrumentalness": 0.00000356,
   "Liveness": 0.068,
   "Valence": 0.413,
   "Tempo": 122.982,
   "Type": "audio_features",
   "ID": "4vzOMLsOzZIGZb6MdnmhUV",
   "Uri": "spotify:track:4vzOMLsOzZIGZb6MdnmhUV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4vzOMLsOzZIGZb6MdnmhUV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4vzOMLsOzZIGZb6MdnmhUV",
   "Duration_ms": 130520,
   "time_signature": 4,
   "Genre": "geekrock"
 },
 {
   
   "Name": "Drugs",
   "Danceability": 0.577,
   "Energy": 0.845,
   "Key": 10,
   "Loudness": -7.606,
   "Mode": 0,
   "Speechness": 0.0351,
   "Acousticness": 0.0355,
   "Instrumentalness": 0.0000277,
   "Liveness": 0.0814,
   "Valence": 0.692,
   "Tempo": 115.088,
   "Type": "audio_features",
   "ID": "7j0EnXOIyq4qedtko87r6f",
   "Uri": "spotify:track:7j0EnXOIyq4qedtko87r6f",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7j0EnXOIyq4qedtko87r6f",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7j0EnXOIyq4qedtko87r6f",
   "Duration_ms": 134900,
   "time_signature": 4,
   "Genre": "buffalonyindie"
 },
 {
   
   "Name": "TheBeginningoftheEnd",
   "Danceability": 0.803,
   "Energy": 0.461,
   "Key": 2,
   "Loudness": -8.658,
   "Mode": 0,
   "Speechness": 0.0714,
   "Acousticness": 0.202,
   "Instrumentalness": 0.952,
   "Liveness": 0.137,
   "Valence": 0.528,
   "Tempo": 146.018,
   "Type": "audio_features",
   "ID": "3i2Yw419Kx3cO0elhP4pdl",
   "Uri": "spotify:track:3i2Yw419Kx3cO0elhP4pdl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3i2Yw419Kx3cO0elhP4pdl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3i2Yw419Kx3cO0elhP4pdl",
   "Duration_ms": 131515,
   "time_signature": 4,
   "Genre": "ambeat"
 },
 {
   
   "Name": "TheWoodmans-MusicfromtheFilm:titles",
   "Danceability": 0.309,
   "Energy": 0.0558,
   "Key": 5,
   "Loudness": -19.068,
   "Mode": 0,
   "Speechness": 0.0369,
   "Acousticness": 0.995,
   "Instrumentalness": 0.918,
   "Liveness": 0.111,
   "Valence": 0.0398,
   "Tempo": 71.953,
   "Type": "audio_features",
   "ID": "7IXN40EHOThZ351NDGqLS9",
   "Uri": "spotify:track:7IXN40EHOThZ351NDGqLS9",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7IXN40EHOThZ351NDGqLS9",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7IXN40EHOThZ351NDGqLS9",
   "Duration_ms": 426587,
   "time_signature": 3,
   "Genre": "mallet"
 },
 {
   
   "Name": "Steentje",
   "Danceability": 0.682,
   "Energy": 0.455,
   "Key": 7,
   "Loudness": -9.738,
   "Mode": 0,
   "Speechness": 0.0902,
   "Acousticness": 0.663,
   "Instrumentalness": 0.0602,
   "Liveness": 0.12,
   "Valence": 0.424,
   "Tempo": 71.976,
   "Type": "audio_features",
   "ID": "2j4sbzmSxCjlZJzBQ5OpUC",
   "Uri": "spotify:track:2j4sbzmSxCjlZJzBQ5OpUC",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2j4sbzmSxCjlZJzBQ5OpUC",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2j4sbzmSxCjlZJzBQ5OpUC",
   "Duration_ms": 216347,
   "time_signature": 4,
   "Genre": "belgianindierock"
 },
 {
   
   "Name": "SmokeandMirrors",
   "Danceability": 0.6,
   "Energy": 0.579,
   "Key": 2,
   "Loudness": -7.46,
   "Mode": 0,
   "Speechness": 0.0266,
   "Acousticness": 0.0933,
   "Instrumentalness": 0.00076,
   "Liveness": 0.108,
   "Valence": 0.266,
   "Tempo": 99.745,
   "Type": "audio_features",
   "ID": "1XSoEETVRA7mteA8lA2ozh",
   "Uri": "spotify:track:1XSoEETVRA7mteA8lA2ozh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1XSoEETVRA7mteA8lA2ozh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1XSoEETVRA7mteA8lA2ozh",
   "Duration_ms": 281283,
   "time_signature": 4,
   "Genre": "otacore"
 },
 {
   
   "Name": "InYourArms",
   "Danceability": 0.3,
   "Energy": 0.849,
   "Key": 9,
   "Loudness": -2.908,
   "Mode": 1,
   "Speechness": 0.0535,
   "Acousticness": 0.159,
   "Instrumentalness": 0.0091,
   "Liveness": 0.0764,
   "Valence": 0.0556,
   "Tempo": 87.002,
   "Type": "audio_features",
   "ID": "7oW2II81S5jF0VaULnfKTR",
   "Uri": "spotify:track:7oW2II81S5jF0VaULnfKTR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7oW2II81S5jF0VaULnfKTR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7oW2II81S5jF0VaULnfKTR",
   "Duration_ms": 252414,
   "time_signature": 4,
   "Genre": "drumandbass"
 },
 {
   
   "Name": "Yui",
   "Danceability": 0.614,
   "Energy": 0.709,
   "Key": 5,
   "Loudness": -9.043,
   "Mode": 0,
   "Speechness": 0.042,
   "Acousticness": 0.416,
   "Instrumentalness": 0.797,
   "Liveness": 0.359,
   "Valence": 0.216,
   "Tempo": 114.997,
   "Type": "audio_features",
   "ID": "1AzhY8vtvWWZwSZwH0g4AN",
   "Uri": "spotify:track:1AzhY8vtvWWZwSZwH0g4AN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1AzhY8vtvWWZwSZwH0g4AN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1AzhY8vtvWWZwSZwH0g4AN",
   "Duration_ms": 181565,
   "time_signature": 4,
   "Genre": "chillstep"
 },
 {
   
   "Name": "Sunshine",
   "Danceability": 0.852,
   "Energy": 0.572,
   "Key": 1,
   "Loudness": -5.086,
   "Mode": 1,
   "Speechness": 0.149,
   "Acousticness": 0.147,
   "Instrumentalness": 0.00000262,
   "Liveness": 0.186,
   "Valence": 0.569,
   "Tempo": 90.939,
   "Type": "audio_features",
   "ID": "5OmcnFH77xm4IETrbEvhlq",
   "Uri": "spotify:track:5OmcnFH77xm4IETrbEvhlq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5OmcnFH77xm4IETrbEvhlq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5OmcnFH77xm4IETrbEvhlq",
   "Duration_ms": 216547,
   "time_signature": 4,
   "Genre": "atmosphere"
 },
 {
   
   "Name": "SattaMassaGana",
   "Danceability": 0.564,
   "Energy": 0.705,
   "Key": 6,
   "Loudness": -5.938,
   "Mode": 0,
   "Speechness": 0.0543,
   "Acousticness": 0.294,
   "Instrumentalness": 0,
   "Liveness": 0.425,
   "Valence": 0.701,
   "Tempo": 75.102,
   "Type": "audio_features",
   "ID": "27adNyPtau6RYDGsUbXEo4",
   "Uri": "spotify:track:27adNyPtau6RYDGsUbXEo4",
   "Ref_Track": "https://api.spotify.com/v1/tracks/27adNyPtau6RYDGsUbXEo4",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/27adNyPtau6RYDGsUbXEo4",
   "Duration_ms": 217573,
   "time_signature": 4,
   "Genre": "rootsreggae"
 },
 {
   
   "Name": "OriginalNuttah",
   "Danceability": 0.778,
   "Energy": 0.772,
   "Key": 6,
   "Loudness": -11.286,
   "Mode": 1,
   "Speechness": 0.099,
   "Acousticness": 0.0229,
   "Instrumentalness": 0.0000417,
   "Liveness": 0.104,
   "Valence": 0.71,
   "Tempo": 113.375,
   "Type": "audio_features",
   "ID": "53mh7POQqTXj2Cfh7phP5b",
   "Uri": "spotify:track:53mh7POQqTXj2Cfh7phP5b",
   "Ref_Track": "https://api.spotify.com/v1/tracks/53mh7POQqTXj2Cfh7phP5b",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/53mh7POQqTXj2Cfh7phP5b",
   "Duration_ms": 312000,
   "time_signature": 5,
   "Genre": "deepragga"
 },
 {
   
   "Name": "BitByDeadBeeptI",
   "Danceability": 0.47,
   "Energy": 0.663,
   "Key": 0,
   "Loudness": -5.493,
   "Mode": 1,
   "Speechness": 0.0347,
   "Acousticness": 0.0465,
   "Instrumentalness": 0.0508,
   "Liveness": 0.143,
   "Valence": 0.264,
   "Tempo": 81.903,
   "Type": "audio_features",
   "ID": "7DbwhXVx7Zb24pVyRGtxyp",
   "Uri": "spotify:track:7DbwhXVx7Zb24pVyRGtxyp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7DbwhXVx7Zb24pVyRGtxyp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7DbwhXVx7Zb24pVyRGtxyp",
   "Duration_ms": 209787,
   "time_signature": 4,
   "Genre": "midwestemo"
 },
 {
   
   "Name": "Watashihaame",
   "Danceability": 0.604,
   "Energy": 0.63,
   "Key": 4,
   "Loudness": -6.322,
   "Mode": 0,
   "Speechness": 0.0682,
   "Acousticness": 0.62,
   "Instrumentalness": 0,
   "Liveness": 0.101,
   "Valence": 0.546,
   "Tempo": 136.904,
   "Type": "audio_features",
   "ID": "4qyPvIwZ2ZFB6yGEDPS8cR",
   "Uri": "spotify:track:4qyPvIwZ2ZFB6yGEDPS8cR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4qyPvIwZ2ZFB6yGEDPS8cR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4qyPvIwZ2ZFB6yGEDPS8cR",
   "Duration_ms": 272907,
   "time_signature": 4,
   "Genre": "visualkei"
 },
 {
   
   "Name": "LosFariseos",
   "Danceability": 0.577,
   "Energy": 0.509,
   "Key": 2,
   "Loudness": -10.375,
   "Mode": 0,
   "Speechness": 0.0454,
   "Acousticness": 0.714,
   "Instrumentalness": 0.00141,
   "Liveness": 0.314,
   "Valence": 0.911,
   "Tempo": 173.771,
   "Type": "audio_features",
   "ID": "0C4tbDyUetYF4GuhaaWCqt",
   "Uri": "spotify:track:0C4tbDyUetYF4GuhaaWCqt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0C4tbDyUetYF4GuhaaWCqt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0C4tbDyUetYF4GuhaaWCqt",
   "Duration_ms": 294067,
   "time_signature": 4,
   "Genre": "salsainternational"
 },
 {
   
   "Name": "(NoTitle)",
   "Danceability": 0,
   "Energy": 0.252,
   "Key": 11,
   "Loudness": -16.794,
   "Mode": 1,
   "Speechness": 0,
   "Acousticness": 0.625,
   "Instrumentalness": 0,
   "Liveness": 0,
   "Valence": 0,
   "Tempo": 0,
   "Type": "audio_features",
   "ID": "2Cj7vUuJeYZ2yblMUqUKLt",
   "Uri": "spotify:track:2Cj7vUuJeYZ2yblMUqUKLt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Cj7vUuJeYZ2yblMUqUKLt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Cj7vUuJeYZ2yblMUqUKLt",
   "Duration_ms": 7133,
   "time_signature": 0,
   "Genre": "chicagopunk"
 },
 {
   
   "Name": "Oceans(WhereFeetMayFail)/YouMakeMeBrave",
   "Danceability": 0.367,
   "Energy": 0.233,
   "Key": 2,
   "Loudness": -8.776,
   "Mode": 1,
   "Speechness": 0.0347,
   "Acousticness": 0.861,
   "Instrumentalness": 0,
   "Liveness": 0.103,
   "Valence": 0.32,
   "Tempo": 90.903,
   "Type": "audio_features",
   "ID": "1v65fu6TbC5Do7nxlQVRWL",
   "Uri": "spotify:track:1v65fu6TbC5Do7nxlQVRWL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1v65fu6TbC5Do7nxlQVRWL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1v65fu6TbC5Do7nxlQVRWL",
   "Duration_ms": 210419,
   "time_signature": 4,
   "Genre": "anthemworship"
 },
 {
   
   "Name": "Smokahontas",
   "Danceability": 0.523,
   "Energy": 0.924,
   "Key": 7,
   "Loudness": -4.03,
   "Mode": 1,
   "Speechness": 0.112,
   "Acousticness": 0.00113,
   "Instrumentalness": 0,
   "Liveness": 0.125,
   "Valence": 0.306,
   "Tempo": 134.984,
   "Type": "audio_features",
   "ID": "4tXdTwla80gq4CgnkB4vwe",
   "Uri": "spotify:track:4tXdTwla80gq4CgnkB4vwe",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4tXdTwla80gq4CgnkB4vwe",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4tXdTwla80gq4CgnkB4vwe",
   "Duration_ms": 234493,
   "time_signature": 4,
   "Genre": "electronicore"
 },
 {
   
   "Name": "ConAltura",
   "Danceability": 0.882,
   "Energy": 0.689,
   "Key": 6,
   "Loudness": -4.027,
   "Mode": 1,
   "Speechness": 0.124,
   "Acousticness": 0.39,
   "Instrumentalness": 0.00325,
   "Liveness": 0.0501,
   "Valence": 0.746,
   "Tempo": 97.963,
   "Type": "audio_features",
   "ID": "2qG5sZ7Si6sdK74qLxedYM",
   "Uri": "spotify:track:2qG5sZ7Si6sdK74qLxedYM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2qG5sZ7Si6sdK74qLxedYM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2qG5sZ7Si6sdK74qLxedYM",
   "Duration_ms": 161627,
   "time_signature": 4,
   "Genre": "canteflamenco"
 },
 {
   
   "Name": "BloodandThunder",
   "Danceability": 0.364,
   "Energy": 0.935,
   "Key": 2,
   "Loudness": -6.548,
   "Mode": 1,
   "Speechness": 0.0724,
   "Acousticness": 0.00000858,
   "Instrumentalness": 0.729,
   "Liveness": 0.0317,
   "Valence": 0.478,
   "Tempo": 92.717,
   "Type": "audio_features",
   "ID": "3jagGO7eHHuaD53ibehkux",
   "Uri": "spotify:track:3jagGO7eHHuaD53ibehkux",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3jagGO7eHHuaD53ibehkux",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3jagGO7eHHuaD53ibehkux",
   "Duration_ms": 228587,
   "time_signature": 4,
   "Genre": "sludgemetal"
 },
 {
   
   "Name": "CalonLan",
   "Danceability": 0.148,
   "Energy": 0.173,
   "Key": 8,
   "Loudness": -16.908,
   "Mode": 1,
   "Speechness": 0.0337,
   "Acousticness": 0.967,
   "Instrumentalness": 0.00000132,
   "Liveness": 0.142,
   "Valence": 0.17,
   "Tempo": 170.589,
   "Type": "audio_features",
   "ID": "4018M1GQWCpjdHOwdFmVgU",
   "Uri": "spotify:track:4018M1GQWCpjdHOwdFmVgU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4018M1GQWCpjdHOwdFmVgU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4018M1GQWCpjdHOwdFmVgU",
   "Duration_ms": 209583,
   "time_signature": 4,
   "Genre": "welshchoir"
 },
 {
   
   "Name": "EbbandFlow",
   "Danceability": 0.426,
   "Energy": 0.521,
   "Key": 5,
   "Loudness": -6.288,
   "Mode": 1,
   "Speechness": 0.0256,
   "Acousticness": 0.0107,
   "Instrumentalness": 0.0000587,
   "Liveness": 0.0937,
   "Valence": 0.443,
   "Tempo": 165.091,
   "Type": "audio_features",
   "ID": "1o8MaDqJF3J2DRWuyNiDFl",
   "Uri": "spotify:track:1o8MaDqJF3J2DRWuyNiDFl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1o8MaDqJF3J2DRWuyNiDFl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1o8MaDqJF3J2DRWuyNiDFl",
   "Duration_ms": 197560,
   "time_signature": 3,
   "Genre": "southernamericana"
 },
 {
   
   "Name": "MinhaCidade-MeninadosOlhosdoMar",
   "Danceability": 0.634,
   "Energy": 0.702,
   "Key": 2,
   "Loudness": -9.661,
   "Mode": 1,
   "Speechness": 0.185,
   "Acousticness": 0.299,
   "Instrumentalness": 0,
   "Liveness": 0.0933,
   "Valence": 0.699,
   "Tempo": 88.056,
   "Type": "audio_features",
   "ID": "2njZpcHVbvp7eI905DfXNx",
   "Uri": "spotify:track:2njZpcHVbvp7eI905DfXNx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2njZpcHVbvp7eI905DfXNx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2njZpcHVbvp7eI905DfXNx",
   "Duration_ms": 202360,
   "time_signature": 4,
   "Genre": "musicadepernambuco"
 },
 {
   
   "Name": "AllAboutTonight",
   "Danceability": 0.637,
   "Energy": 0.804,
   "Key": 2,
   "Loudness": -6.141,
   "Mode": 1,
   "Speechness": 0.0448,
   "Acousticness": 0.207,
   "Instrumentalness": 0,
   "Liveness": 0.115,
   "Valence": 0.732,
   "Tempo": 129.261,
   "Type": "audio_features",
   "ID": "1Fx9aiORwv0cx5mFEBasHo",
   "Uri": "spotify:track:1Fx9aiORwv0cx5mFEBasHo",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Fx9aiORwv0cx5mFEBasHo",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Fx9aiORwv0cx5mFEBasHo",
   "Duration_ms": 186173,
   "time_signature": 3,
   "Genre": "pixie"
 },
 {
   
   "Name": "YazGazeteciYaz",
   "Danceability": 0.739,
   "Energy": 0.748,
   "Key": 4,
   "Loudness": -8.568,
   "Mode": 0,
   "Speechness": 0.171,
   "Acousticness": 0.682,
   "Instrumentalness": 0,
   "Liveness": 0.0457,
   "Valence": 0.568,
   "Tempo": 93.825,
   "Type": "audio_features",
   "ID": "2x6nt60ec2EOwB09UbcfgE",
   "Uri": "spotify:track:2x6nt60ec2EOwB09UbcfgE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2x6nt60ec2EOwB09UbcfgE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2x6nt60ec2EOwB09UbcfgE",
   "Duration_ms": 165320,
   "time_signature": 4,
   "Genre": "turkishfolk"
 },
 {
   
   "Name": "Påskemorgenslukkersorgen",
   "Danceability": 0.124,
   "Energy": 0.202,
   "Key": 6,
   "Loudness": -14.464,
   "Mode": 1,
   "Speechness": 0.0396,
   "Acousticness": 0.949,
   "Instrumentalness": 0.664,
   "Liveness": 0.0957,
   "Valence": 0.0683,
   "Tempo": 70.35,
   "Type": "audio_features",
   "ID": "11uj8AKspd2wvYGhZBERCl",
   "Uri": "spotify:track:11uj8AKspd2wvYGhZBERCl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/11uj8AKspd2wvYGhZBERCl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/11uj8AKspd2wvYGhZBERCl",
   "Duration_ms": 305827,
   "time_signature": 4,
   "Genre": "norwegianchoir"
 },
 {
   
   "Name": "DieYoung(Acoustic)",
   "Danceability": 0.403,
   "Energy": 0.503,
   "Key": 1,
   "Loudness": -6.963,
   "Mode": 0,
   "Speechness": 0.0287,
   "Acousticness": 0.335,
   "Instrumentalness": 0.0013,
   "Liveness": 0.122,
   "Valence": 0.331,
   "Tempo": 140.121,
   "Type": "audio_features",
   "ID": "1YmDXTV2VyDo72p7iJeKfb",
   "Uri": "spotify:track:1YmDXTV2VyDo72p7iJeKfb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1YmDXTV2VyDo72p7iJeKfb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1YmDXTV2VyDo72p7iJeKfb",
   "Duration_ms": 297399,
   "time_signature": 4,
   "Genre": "technicalblackmetal"
 },
 {
   
   "Name": "Pulkun",
   "Danceability": 0.229,
   "Energy": 0.43,
   "Key": 0,
   "Loudness": -8.007,
   "Mode": 1,
   "Speechness": 0.0313,
   "Acousticness": 0.912,
   "Instrumentalness": 0.00167,
   "Liveness": 0.123,
   "Valence": 0.489,
   "Tempo": 185.705,
   "Type": "audio_features",
   "ID": "05mIasXWm4B7hIYfleudGF",
   "Uri": "spotify:track:05mIasXWm4B7hIYfleudGF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/05mIasXWm4B7hIYfleudGF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/05mIasXWm4B7hIYfleudGF",
   "Duration_ms": 129968,
   "time_signature": 4,
   "Genre": "balticfolk"
 },
 {
   
   "Name": "GuayaquilCity",
   "Danceability": 0.708,
   "Energy": 0.572,
   "Key": 4,
   "Loudness": -5.22,
   "Mode": 0,
   "Speechness": 0.0361,
   "Acousticness": 0.476,
   "Instrumentalness": 0,
   "Liveness": 0.242,
   "Valence": 0.386,
   "Tempo": 103.933,
   "Type": "audio_features",
   "ID": "4dKCmonYWqjAxuV8Ydu4Iv",
   "Uri": "spotify:track:4dKCmonYWqjAxuV8Ydu4Iv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4dKCmonYWqjAxuV8Ydu4Iv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4dKCmonYWqjAxuV8Ydu4Iv",
   "Duration_ms": 248653,
   "time_signature": 4,
   "Genre": "ecuadoria"
 },
 {
   
   "Name": "MeGustas",
   "Danceability": 0.608,
   "Energy": 0.546,
   "Key": 9,
   "Loudness": -8.626,
   "Mode": 0,
   "Speechness": 0.0488,
   "Acousticness": 0.173,
   "Instrumentalness": 0.0354,
   "Liveness": 0.244,
   "Valence": 0.828,
   "Tempo": 87.956,
   "Type": "audio_features",
   "ID": "0JfsIu62NVXNQl2s7ATN37",
   "Uri": "spotify:track:0JfsIu62NVXNQl2s7ATN37",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0JfsIu62NVXNQl2s7ATN37",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0JfsIu62NVXNQl2s7ATN37",
   "Duration_ms": 202670,
   "time_signature": 4,
   "Genre": "monterreyindie"
 },
 {
   
   "Name": "PrimaTecata",
   "Danceability": 0.81,
   "Energy": 0.612,
   "Key": 1,
   "Loudness": -11.27,
   "Mode": 0,
   "Speechness": 0.0375,
   "Acousticness": 0.295,
   "Instrumentalness": 0,
   "Liveness": 0.0616,
   "Valence": 0.951,
   "Tempo": 125.974,
   "Type": "audio_features",
   "ID": "1iNd1ZK5BDamlhOF25fPbX",
   "Uri": "spotify:track:1iNd1ZK5BDamlhOF25fPbX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1iNd1ZK5BDamlhOF25fPbX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1iNd1ZK5BDamlhOF25fPbX",
   "Duration_ms": 237750,
   "time_signature": 4,
   "Genre": "dominicanindie"
 },
 {
   
   "Name": "AllWorksOut",
   "Danceability": 0.529,
   "Energy": 0.955,
   "Key": 0,
   "Loudness": -3.842,
   "Mode": 1,
   "Speechness": 0.0374,
   "Acousticness": 0.023,
   "Instrumentalness": 0.00000976,
   "Liveness": 0.0982,
   "Valence": 0.598,
   "Tempo": 129.056,
   "Type": "audio_features",
   "ID": "2yp2Xgm3ishQn9KzPCnoYP",
   "Uri": "spotify:track:2yp2Xgm3ishQn9KzPCnoYP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2yp2Xgm3ishQn9KzPCnoYP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2yp2Xgm3ishQn9KzPCnoYP",
   "Duration_ms": 234293,
   "time_signature": 4,
   "Genre": "indietico"
 },
 {
   
   "Name": "TheVictors",
   "Danceability": 0.546,
   "Energy": 0.679,
   "Key": 8,
   "Loudness": -12.044,
   "Mode": 1,
   "Speechness": 0.0679,
   "Acousticness": 0.656,
   "Instrumentalness": 0.966,
   "Liveness": 0.269,
   "Valence": 0.325,
   "Tempo": 83.091,
   "Type": "audio_features",
   "ID": "6wVbHLCBOCqp6052WcWXLG",
   "Uri": "spotify:track:6wVbHLCBOCqp6052WcWXLG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6wVbHLCBOCqp6052WcWXLG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6wVbHLCBOCqp6052WcWXLG",
   "Duration_ms": 122968,
   "time_signature": 4,
   "Genre": "collegemarchingband"
 },
 {
   
   "Name": "Undead",
   "Danceability": 0.511,
   "Energy": 0.937,
   "Key": 2,
   "Loudness": -5.116,
   "Mode": 0,
   "Speechness": 0.115,
   "Acousticness": 0.0146,
   "Instrumentalness": 0,
   "Liveness": 0.304,
   "Valence": 0.484,
   "Tempo": 163.141,
   "Type": "audio_features",
   "ID": "5wBLDkxVvclanSitx5jq8e",
   "Uri": "spotify:track:5wBLDkxVvclanSitx5jq8e",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5wBLDkxVvclanSitx5jq8e",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5wBLDkxVvclanSitx5jq8e",
   "Duration_ms": 265053,
   "time_signature": 4,
   "Genre": "hollywood"
 },
 {
   
   "Name": "Vivaldi/Thilde:TrumpetConcertoinB-FlatMinor:I.Allegro",
   "Danceability": 0.551,
   "Energy": 0.528,
   "Key": 3,
   "Loudness": -9.827,
   "Mode": 1,
   "Speechness": 0.0429,
   "Acousticness": 0.904,
   "Instrumentalness": 0.91,
   "Liveness": 0.137,
   "Valence": 0.737,
   "Tempo": 123.355,
   "Type": "audio_features",
   "ID": "3IABdrbxaos4lUkXJO49dz",
   "Uri": "spotify:track:3IABdrbxaos4lUkXJO49dz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3IABdrbxaos4lUkXJO49dz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3IABdrbxaos4lUkXJO49dz",
   "Duration_ms": 74227,
   "time_signature": 4,
   "Genre": "classicaltrumpet"
 },
 {
   
   "Name": "Spikeroog",
   "Danceability": 0.151,
   "Energy": 0.168,
   "Key": 2,
   "Loudness": -14.513,
   "Mode": 0,
   "Speechness": 0.0363,
   "Acousticness": 0.969,
   "Instrumentalness": 0.849,
   "Liveness": 0.0824,
   "Valence": 0.054,
   "Tempo": 148.828,
   "Type": "audio_features",
   "ID": "149g1z4mDkQsNG8ZB0xbev",
   "Uri": "spotify:track:149g1z4mDkQsNG8ZB0xbev",
   "Ref_Track": "https://api.spotify.com/v1/tracks/149g1z4mDkQsNG8ZB0xbev",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/149g1z4mDkQsNG8ZB0xbev",
   "Duration_ms": 185699,
   "time_signature": 4,
   "Genre": "medieval"
 },
 {
   
   "Name": "TrueTonight",
   "Danceability": 0.586,
   "Energy": 0.738,
   "Key": 2,
   "Loudness": -6.732,
   "Mode": 1,
   "Speechness": 0.0304,
   "Acousticness": 0.00204,
   "Instrumentalness": 0.59,
   "Liveness": 0.144,
   "Valence": 0.22,
   "Tempo": 118.117,
   "Type": "audio_features",
   "ID": "0kfVCZ0L1Y07NT144vRZjw",
   "Uri": "spotify:track:0kfVCZ0L1Y07NT144vRZjw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0kfVCZ0L1Y07NT144vRZjw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0kfVCZ0L1Y07NT144vRZjw",
   "Duration_ms": 300347,
   "time_signature": 4,
   "Genre": "albuquerqueindie"
 },
 {
   
   "Name": "Intwenjani",
   "Danceability": 0.792,
   "Energy": 0.443,
   "Key": 3,
   "Loudness": -18.005,
   "Mode": 0,
   "Speechness": 0.0514,
   "Acousticness": 0.0165,
   "Instrumentalness": 0.0268,
   "Liveness": 0.032,
   "Valence": 0.972,
   "Tempo": 103.999,
   "Type": "audio_features",
   "ID": "0eotNIGKUHo9XGsUlToDIh",
   "Uri": "spotify:track:0eotNIGKUHo9XGsUlToDIh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0eotNIGKUHo9XGsUlToDIh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0eotNIGKUHo9XGsUlToDIh",
   "Duration_ms": 333760,
   "time_signature": 4,
   "Genre": "kwaito"
 },
 {
   
   "Name": "Genesis",
   "Danceability": 0.611,
   "Energy": 0.677,
   "Key": 10,
   "Loudness": -6.745,
   "Mode": 0,
   "Speechness": 0.034,
   "Acousticness": 0.0764,
   "Instrumentalness": 0.0698,
   "Liveness": 0.241,
   "Valence": 0.233,
   "Tempo": 166.04,
   "Type": "audio_features",
   "ID": "4sCYKMatyhazyy6r2N7Hp2",
   "Uri": "spotify:track:4sCYKMatyhazyy6r2N7Hp2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4sCYKMatyhazyy6r2N7Hp2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4sCYKMatyhazyy6r2N7Hp2",
   "Duration_ms": 255320,
   "time_signature": 4,
   "Genre": "canadianelectropop"
 },
 {
   
   "Name": "LastKiss",
   "Danceability": 0.62,
   "Energy": 0.725,
   "Key": 7,
   "Loudness": -6.437,
   "Mode": 1,
   "Speechness": 0.0273,
   "Acousticness": 0.363,
   "Instrumentalness": 0.000207,
   "Liveness": 0.192,
   "Valence": 0.768,
   "Tempo": 112.062,
   "Type": "audio_features",
   "ID": "7uA5bDs7bcvciXM2DwwCgp",
   "Uri": "spotify:track:7uA5bDs7bcvciXM2DwwCgp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7uA5bDs7bcvciXM2DwwCgp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7uA5bDs7bcvciXM2DwwCgp",
   "Duration_ms": 196400,
   "time_signature": 4,
   "Genre": "grungepop"
 },
 {
   
   "Name": "SwimmingBackwards",
   "Danceability": 0.68,
   "Energy": 0.596,
   "Key": 5,
   "Loudness": -8.342,
   "Mode": 1,
   "Speechness": 0.031,
   "Acousticness": 0.522,
   "Instrumentalness": 0.889,
   "Liveness": 0.111,
   "Valence": 0.124,
   "Tempo": 120.953,
   "Type": "audio_features",
   "ID": "6gdXKvWTGKYDOsC1Rj3Q3d",
   "Uri": "spotify:track:6gdXKvWTGKYDOsC1Rj3Q3d",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6gdXKvWTGKYDOsC1Rj3Q3d",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6gdXKvWTGKYDOsC1Rj3Q3d",
   "Duration_ms": 222378,
   "time_signature": 4,
   "Genre": "israeliindie"
 },
 {
   
   "Name": "Mäenpelkää",
   "Danceability": 0.59,
   "Energy": 0.824,
   "Key": 1,
   "Loudness": -6.449,
   "Mode": 1,
   "Speechness": 0.0509,
   "Acousticness": 0.00517,
   "Instrumentalness": 0,
   "Liveness": 0.121,
   "Valence": 0.471,
   "Tempo": 124.032,
   "Type": "audio_features",
   "ID": "5o5QFuPYIiJ0XGNt1H70Hz",
   "Uri": "spotify:track:5o5QFuPYIiJ0XGNt1H70Hz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5o5QFuPYIiJ0XGNt1H70Hz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5o5QFuPYIiJ0XGNt1H70Hz",
   "Duration_ms": 217116,
   "time_signature": 4,
   "Genre": "finnishedm"
 },
 {
   
   "Name": "Georgia",
   "Danceability": 0.664,
   "Energy": 0.522,
   "Key": 8,
   "Loudness": -9.677,
   "Mode": 1,
   "Speechness": 0.11,
   "Acousticness": 0.729,
   "Instrumentalness": 0.000126,
   "Liveness": 0.0935,
   "Valence": 0.289,
   "Tempo": 134.047,
   "Type": "audio_features",
   "ID": "2B15MgKTaavdlKdlwd4W0R",
   "Uri": "spotify:track:2B15MgKTaavdlKdlwd4W0R",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2B15MgKTaavdlKdlwd4W0R",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2B15MgKTaavdlKdlwd4W0R",
   "Duration_ms": 219467,
   "time_signature": 4,
   "Genre": "experimentalhiphop"
 },
 {
   
   "Name": "SearchingforPath",
   "Danceability": 0.382,
   "Energy": 0.361,
   "Key": 2,
   "Loudness": -16.304,
   "Mode": 0,
   "Speechness": 0.0327,
   "Acousticness": 0.619,
   "Instrumentalness": 0.827,
   "Liveness": 0.0729,
   "Valence": 0.285,
   "Tempo": 125.555,
   "Type": "audio_features",
   "ID": "11tmTijOeNTPIzQPlFbiwh",
   "Uri": "spotify:track:11tmTijOeNTPIzQPlFbiwh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/11tmTijOeNTPIzQPlFbiwh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/11tmTijOeNTPIzQPlFbiwh",
   "Duration_ms": 421920,
   "time_signature": 5,
   "Genre": "russianjazz"
 },
 {
   
   "Name": "MierdaDeCiudad",
   "Danceability": 0.522,
   "Energy": 0.644,
   "Key": 2,
   "Loudness": -11.385,
   "Mode": 1,
   "Speechness": 0.0534,
   "Acousticness": 0.223,
   "Instrumentalness": 0,
   "Liveness": 0.75,
   "Valence": 0.914,
   "Tempo": 154.978,
   "Type": "audio_features",
   "ID": "6lSJZiZqWU8Qt1fJVeFZEv",
   "Uri": "spotify:track:6lSJZiZqWU8Qt1fJVeFZEv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6lSJZiZqWU8Qt1fJVeFZEv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6lSJZiZqWU8Qt1fJVeFZEv",
   "Duration_ms": 197480,
   "time_signature": 4,
   "Genre": "basquerock"
 },
 {
   
   "Name": "Can\\tGetEnough",
   "Danceability": 0.732,
   "Energy": 0.817,
   "Key": 2,
   "Loudness": -4.979,
   "Mode": 1,
   "Speechness": 0.147,
   "Acousticness": 0.018,
   "Instrumentalness": 0.000766,
   "Liveness": 0.478,
   "Valence": 0.332,
   "Tempo": 126.064,
   "Type": "audio_features",
   "ID": "5TkfpxFkwl8MU8WvsqkyxJ",
   "Uri": "spotify:track:5TkfpxFkwl8MU8WvsqkyxJ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5TkfpxFkwl8MU8WvsqkyxJ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5TkfpxFkwl8MU8WvsqkyxJ",
   "Duration_ms": 166487,
   "time_signature": 4,
   "Genre": "edm"
 },
 {
   
   "Name": "DespacitoxShapeOfYou",
   "Danceability": 0.691,
   "Energy": 0.631,
   "Key": 5,
   "Loudness": -7.239,
   "Mode": 1,
   "Speechness": 0.0377,
   "Acousticness": 0.0582,
   "Instrumentalness": 0,
   "Liveness": 0.169,
   "Valence": 0.577,
   "Tempo": 93.984,
   "Type": "audio_features",
   "ID": "5cj54CVe4pQZ9cUKgbsZrG",
   "Uri": "spotify:track:5cj54CVe4pQZ9cUKgbsZrG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5cj54CVe4pQZ9cUKgbsZrG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5cj54CVe4pQZ9cUKgbsZrG",
   "Duration_ms": 198947,
   "time_signature": 4,
   "Genre": "skyroom"
 },
 {
   
   "Name": "Freibad",
   "Danceability": 0.901,
   "Energy": 0.609,
   "Key": 6,
   "Loudness": -4.897,
   "Mode": 1,
   "Speechness": 0.285,
   "Acousticness": 0.354,
   "Instrumentalness": 0.00000158,
   "Liveness": 0.109,
   "Valence": 0.77,
   "Tempo": 92.012,
   "Type": "audio_features",
   "ID": "1kdRNX3azy9bxgm23o19jE",
   "Uri": "spotify:track:1kdRNX3azy9bxgm23o19jE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1kdRNX3azy9bxgm23o19jE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1kdRNX3azy9bxgm23o19jE",
   "Duration_ms": 221680,
   "time_signature": 4,
   "Genre": "austrianhiphop"
 },
 {
   
   "Name": "HowtoMakeGravy(TripleJLikeaVersion)[Live]",
   "Danceability": 0.245,
   "Energy": 0.746,
   "Key": 8,
   "Loudness": -6.551,
   "Mode": 0,
   "Speechness": 0.0617,
   "Acousticness": 0.000816,
   "Instrumentalness": 0.0000223,
   "Liveness": 0.0806,
   "Valence": 0.208,
   "Tempo": 144.721,
   "Type": "audio_features",
   "ID": "1Xb8vdZG9b0Z6fs2XMPIot",
   "Uri": "spotify:track:1Xb8vdZG9b0Z6fs2XMPIot",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Xb8vdZG9b0Z6fs2XMPIot",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Xb8vdZG9b0Z6fs2XMPIot",
   "Duration_ms": 263788,
   "time_signature": 3,
   "Genre": "tassieindie"
 },
 {
   
   "Name": "RiverBoatSong-2018LiveVer.",
   "Danceability": 0.381,
   "Energy": 0.574,
   "Key": 2,
   "Loudness": -7.983,
   "Mode": 0,
   "Speechness": 0.0275,
   "Acousticness": 0.0206,
   "Instrumentalness": 0.000867,
   "Liveness": 0.664,
   "Valence": 0.238,
   "Tempo": 96.016,
   "Type": "audio_features",
   "ID": "7FUaexUiZnWQytntCvpShq",
   "Uri": "spotify:track:7FUaexUiZnWQytntCvpShq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7FUaexUiZnWQytntCvpShq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7FUaexUiZnWQytntCvpShq",
   "Duration_ms": 230471,
   "time_signature": 4,
   "Genre": "modernperformance"
 },
 {
   
   "Name": "DreamAngus",
   "Danceability": 0.38,
   "Energy": 0.0718,
   "Key": 1,
   "Loudness": -13.267,
   "Mode": 1,
   "Speechness": 0.0339,
   "Acousticness": 0.967,
   "Instrumentalness": 0.00000388,
   "Liveness": 0.0952,
   "Valence": 0.304,
   "Tempo": 77.617,
   "Type": "audio_features",
   "ID": "4ZNYarBwGOvqqt65fPqYwW",
   "Uri": "spotify:track:4ZNYarBwGOvqqt65fPqYwW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4ZNYarBwGOvqqt65fPqYwW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4ZNYarBwGOvqqt65fPqYwW",
   "Duration_ms": 277587,
   "time_signature": 4,
   "Genre": "traditionalbritishfolk"
 },
 {
   
   "Name": "Pathfinder",
   "Danceability": 0.337,
   "Energy": 0.38,
   "Key": 4,
   "Loudness": -10.456,
   "Mode": 0,
   "Speechness": 0.0314,
   "Acousticness": 0.133,
   "Instrumentalness": 0.922,
   "Liveness": 0.129,
   "Valence": 0.0397,
   "Tempo": 96.983,
   "Type": "audio_features",
   "ID": "3s4QJmPBzx0qLyf6Dl9wcH",
   "Uri": "spotify:track:3s4QJmPBzx0qLyf6Dl9wcH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3s4QJmPBzx0qLyf6Dl9wcH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3s4QJmPBzx0qLyf6Dl9wcH",
   "Duration_ms": 322151,
   "time_signature": 4,
   "Genre": "demoscene"
 },
 {
   
   "Name": "LightBlack",
   "Danceability": 0.741,
   "Energy": 0.485,
   "Key": 7,
   "Loudness": -13.507,
   "Mode": 0,
   "Speechness": 0.0742,
   "Acousticness": 0.489,
   "Instrumentalness": 0.94,
   "Liveness": 0.688,
   "Valence": 0.106,
   "Tempo": 124.044,
   "Type": "audio_features",
   "ID": "0jeLaY24Q00HXE7viksiL8",
   "Uri": "spotify:track:0jeLaY24Q00HXE7viksiL8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0jeLaY24Q00HXE7viksiL8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0jeLaY24Q00HXE7viksiL8",
   "Duration_ms": 432773,
   "time_signature": 4,
   "Genre": "deepdubtechno"
 },
 {
   
   "Name": "TheRoadtoLife",
   "Danceability": 0.469,
   "Energy": 0.583,
   "Key": 0,
   "Loudness": -8.943,
   "Mode": 1,
   "Speechness": 0.0268,
   "Acousticness": 0.0235,
   "Instrumentalness": 0.918,
   "Liveness": 0.121,
   "Valence": 0.075,
   "Tempo": 66.004,
   "Type": "audio_features",
   "ID": "5IQzw8udPzrhEA5FPB0MaU",
   "Uri": "spotify:track:5IQzw8udPzrhEA5FPB0MaU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5IQzw8udPzrhEA5FPB0MaU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5IQzw8udPzrhEA5FPB0MaU",
   "Duration_ms": 229244,
   "time_signature": 4,
   "Genre": "focus"
 },
 {
   
   "Name": "GuardiansAttheGate",
   "Danceability": 0.475,
   "Energy": 0.789,
   "Key": 5,
   "Loudness": -8.893,
   "Mode": 0,
   "Speechness": 0.0578,
   "Acousticness": 0.313,
   "Instrumentalness": 0.965,
   "Liveness": 0.104,
   "Valence": 0.63,
   "Tempo": 137.984,
   "Type": "audio_features",
   "ID": "4MUN6PQPplQDajjx7NCcdr",
   "Uri": "spotify:track:4MUN6PQPplQDajjx7NCcdr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4MUN6PQPplQDajjx7NCcdr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4MUN6PQPplQDajjx7NCcdr",
   "Duration_ms": 128413,
   "time_signature": 4,
   "Genre": "epicore"
 },
 {
   
   "Name": "Casadas",
   "Danceability": 0.673,
   "Energy": 0.788,
   "Key": 10,
   "Loudness": -4.606,
   "Mode": 0,
   "Speechness": 0.102,
   "Acousticness": 0.156,
   "Instrumentalness": 0,
   "Liveness": 0.0885,
   "Valence": 0.494,
   "Tempo": 94.976,
   "Type": "audio_features",
   "ID": "2ESTB7UxMMlSsOilH4XFxK",
   "Uri": "spotify:track:2ESTB7UxMMlSsOilH4XFxK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2ESTB7UxMMlSsOilH4XFxK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2ESTB7UxMMlSsOilH4XFxK",
   "Duration_ms": 162004,
   "time_signature": 4,
   "Genre": "cumbiapop"
 },
 {
   
   "Name": "ThisIsTheWay-RadioEdit",
   "Danceability": 0.593,
   "Energy": 0.926,
   "Key": 0,
   "Loudness": -5.189,
   "Mode": 1,
   "Speechness": 0.0312,
   "Acousticness": 0.00664,
   "Instrumentalness": 0.00372,
   "Liveness": 0.296,
   "Valence": 0.71,
   "Tempo": 141.426,
   "Type": "audio_features",
   "ID": "1BBIW3lDfwK9PXOFOedZmo",
   "Uri": "spotify:track:1BBIW3lDfwK9PXOFOedZmo",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1BBIW3lDfwK9PXOFOedZmo",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1BBIW3lDfwK9PXOFOedZmo",
   "Duration_ms": 235293,
   "time_signature": 4,
   "Genre": "deepeurodance"
 },
 {
   
   "Name": "Ayla-RadioEdit",
   "Danceability": 0.753,
   "Energy": 0.891,
   "Key": 0,
   "Loudness": -8.056,
   "Mode": 0,
   "Speechness": 0.0368,
   "Acousticness": 0.00444,
   "Instrumentalness": 0.842,
   "Liveness": 0.079,
   "Valence": 0.196,
   "Tempo": 137.013,
   "Type": "audio_features",
   "ID": "1wZf98VPIr7oAU7FQG11eF",
   "Uri": "spotify:track:1wZf98VPIr7oAU7FQG11eF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1wZf98VPIr7oAU7FQG11eF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1wZf98VPIr7oAU7FQG11eF",
   "Duration_ms": 428313,
   "time_signature": 4,
   "Genre": "bubbletrance"
 },
 {
   
   "Name": "PlayGod",
   "Danceability": 0.7,
   "Energy": 0.677,
   "Key": 10,
   "Loudness": -7.206,
   "Mode": 0,
   "Speechness": 0.0458,
   "Acousticness": 0.131,
   "Instrumentalness": 0.0491,
   "Liveness": 0.121,
   "Valence": 0.614,
   "Tempo": 94.388,
   "Type": "audio_features",
   "ID": "022k1qYIMWV20yW7tjiBv5",
   "Uri": "spotify:track:022k1qYIMWV20yW7tjiBv5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/022k1qYIMWV20yW7tjiBv5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/022k1qYIMWV20yW7tjiBv5",
   "Duration_ms": 226967,
   "time_signature": 4,
   "Genre": "northeastenglandindie"
 },
 {
   
   "Name": "ScaredtoBeLonely",
   "Danceability": 0.584,
   "Energy": 0.54,
   "Key": 1,
   "Loudness": -7.786,
   "Mode": 0,
   "Speechness": 0.0576,
   "Acousticness": 0.0895,
   "Instrumentalness": 0,
   "Liveness": 0.261,
   "Valence": 0.195,
   "Tempo": 137.972,
   "Type": "audio_features",
   "ID": "3ebXMykcMXOcLeJ9xZ17XH",
   "Uri": "spotify:track:3ebXMykcMXOcLeJ9xZ17XH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3ebXMykcMXOcLeJ9xZ17XH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3ebXMykcMXOcLeJ9xZ17XH",
   "Duration_ms": 220883,
   "time_signature": 4,
   "Genre": "popedm"
 },
 {
   
   "Name": "Don\\tGoToStrangers",
   "Danceability": 0.368,
   "Energy": 0.12,
   "Key": 0,
   "Loudness": -15.88,
   "Mode": 1,
   "Speechness": 0.0757,
   "Acousticness": 0.795,
   "Instrumentalness": 0.0000191,
   "Liveness": 0.106,
   "Valence": 0.125,
   "Tempo": 78.724,
   "Type": "audio_features",
   "ID": "7eiaz0FB3nJMfauMtGukfO",
   "Uri": "spotify:track:7eiaz0FB3nJMfauMtGukfO",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7eiaz0FB3nJMfauMtGukfO",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7eiaz0FB3nJMfauMtGukfO",
   "Duration_ms": 320640,
   "time_signature": 3,
   "Genre": "vocaljazz"
 },
 {
   
   "Name": "ToughYoungGuys",
   "Danceability": 0.823,
   "Energy": 0.329,
   "Key": 7,
   "Loudness": -13.446,
   "Mode": 1,
   "Speechness": 0.0942,
   "Acousticness": 0.0799,
   "Instrumentalness": 0.806,
   "Liveness": 0.0832,
   "Valence": 0.285,
   "Tempo": 114.993,
   "Type": "audio_features",
   "ID": "24Gqky0CeaQsn3CQoP29UH",
   "Uri": "spotify:track:24Gqky0CeaQsn3CQoP29UH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/24Gqky0CeaQsn3CQoP29UH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/24Gqky0CeaQsn3CQoP29UH",
   "Duration_ms": 387375,
   "time_signature": 4,
   "Genre": "greekhouse"
 },
 {
   
   "Name": "Fingerpaint-OriginalMix",
   "Danceability": 0.718,
   "Energy": 0.752,
   "Key": 6,
   "Loudness": -8.744,
   "Mode": 0,
   "Speechness": 0.0385,
   "Acousticness": 0.0451,
   "Instrumentalness": 0.869,
   "Liveness": 0.1,
   "Valence": 0.32,
   "Tempo": 127.006,
   "Type": "audio_features",
   "ID": "1e206MrcRVKbAJj2Z1vVrn",
   "Uri": "spotify:track:1e206MrcRVKbAJj2Z1vVrn",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1e206MrcRVKbAJj2Z1vVrn",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1e206MrcRVKbAJj2Z1vVrn",
   "Duration_ms": 628518,
   "time_signature": 4,
   "Genre": "progressivebreaks"
 },
 {
   
   "Name": "InbetweenDays",
   "Danceability": 0.546,
   "Energy": 0.836,
   "Key": 9,
   "Loudness": -6.321,
   "Mode": 1,
   "Speechness": 0.0317,
   "Acousticness": 0.107,
   "Instrumentalness": 0.583,
   "Liveness": 0.166,
   "Valence": 0.735,
   "Tempo": 142.605,
   "Type": "audio_features",
   "ID": "4CRpOsjhvgxjF7rQufmyZ1",
   "Uri": "spotify:track:4CRpOsjhvgxjF7rQufmyZ1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4CRpOsjhvgxjF7rQufmyZ1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4CRpOsjhvgxjF7rQufmyZ1",
   "Duration_ms": 177958,
   "time_signature": 4,
   "Genre": "ukpost-punk"
 },
 {
   
   "Name": "TooDoggoneFunky",
   "Danceability": 0.347,
   "Energy": 0.914,
   "Key": 6,
   "Loudness": -6.797,
   "Mode": 1,
   "Speechness": 0.0655,
   "Acousticness": 0.000503,
   "Instrumentalness": 0.866,
   "Liveness": 0.081,
   "Valence": 0.236,
   "Tempo": 169.262,
   "Type": "audio_features",
   "ID": "6oHxuRyYYl8LFclX5yJKv2",
   "Uri": "spotify:track:6oHxuRyYYl8LFclX5yJKv2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6oHxuRyYYl8LFclX5yJKv2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6oHxuRyYYl8LFclX5yJKv2",
   "Duration_ms": 419500,
   "time_signature": 4,
   "Genre": "drumfunk"
 },
 {
   
   "Name": "Minoan",
   "Danceability": 0.543,
   "Energy": 0.995,
   "Key": 0,
   "Loudness": -3.328,
   "Mode": 1,
   "Speechness": 0.134,
   "Acousticness": 0.000117,
   "Instrumentalness": 0.834,
   "Liveness": 0.121,
   "Valence": 0.314,
   "Tempo": 172.007,
   "Type": "audio_features",
   "ID": "7FVOl2uBv87Uba5jd16vlT",
   "Uri": "spotify:track:7FVOl2uBv87Uba5jd16vlT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7FVOl2uBv87Uba5jd16vlT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7FVOl2uBv87Uba5jd16vlT",
   "Duration_ms": 362893,
   "time_signature": 4,
   "Genre": "neurostep"
 },
 {
   
   "Name": "AnuNobu",
   "Danceability": 0.628,
   "Energy": 0.868,
   "Key": 11,
   "Loudness": -5.552,
   "Mode": 0,
   "Speechness": 0.205,
   "Acousticness": 0.11,
   "Instrumentalness": 0,
   "Liveness": 0.344,
   "Valence": 0.716,
   "Tempo": 142.056,
   "Type": "audio_features",
   "ID": "37yfmJSIXizdyeJRhMKKsR",
   "Uri": "spotify:track:37yfmJSIXizdyeJRhMKKsR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/37yfmJSIXizdyeJRhMKKsR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/37yfmJSIXizdyeJRhMKKsR",
   "Duration_ms": 221054,
   "time_signature": 4,
   "Genre": "portugueseearlymusic"
 },
 {
   
   "Name": "Wahnfried1883",
   "Danceability": 0.0834,
   "Energy": 0.474,
   "Key": 10,
   "Loudness": -15.364,
   "Mode": 0,
   "Speechness": 0.0877,
   "Acousticness": 0.409,
   "Instrumentalness": 0.829,
   "Liveness": 0.357,
   "Valence": 0.0321,
   "Tempo": 168.058,
   "Type": "audio_features",
   "ID": "7nLd2aoEhCRTLcIbQHBvjn",
   "Uri": "spotify:track:7nLd2aoEhCRTLcIbQHBvjn",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7nLd2aoEhCRTLcIbQHBvjn",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7nLd2aoEhCRTLcIbQHBvjn",
   "Duration_ms": 1709573,
   "time_signature": 4,
   "Genre": "earlyavantgarde"
 },
 {
   
   "Name": "EllaQuiereBeber-Remix",
   "Danceability": 0.751,
   "Energy": 0.665,
   "Key": 8,
   "Loudness": -3.083,
   "Mode": 1,
   "Speechness": 0.124,
   "Acousticness": 0.265,
   "Instrumentalness": 0,
   "Liveness": 0.0515,
   "Valence": 0.698,
   "Tempo": 95.239,
   "Type": "audio_features",
   "ID": "2cYnZNzFRFK0H7vSNxPsUq",
   "Uri": "spotify:track:2cYnZNzFRFK0H7vSNxPsUq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2cYnZNzFRFK0H7vSNxPsUq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2cYnZNzFRFK0H7vSNxPsUq",
   "Duration_ms": 219357,
   "time_signature": 4,
   "Genre": "classicsoundtrack"
 },
 {
   
   "Name": "BreakMyFall",
   "Danceability": 0.534,
   "Energy": 0.419,
   "Key": 0,
   "Loudness": -10.103,
   "Mode": 1,
   "Speechness": 0.0259,
   "Acousticness": 0.55,
   "Instrumentalness": 0.166,
   "Liveness": 0.223,
   "Valence": 0.397,
   "Tempo": 76.514,
   "Type": "audio_features",
   "ID": "652zwAiP1Wdy39NY8DSMu5",
   "Uri": "spotify:track:652zwAiP1Wdy39NY8DSMu5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/652zwAiP1Wdy39NY8DSMu5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/652zwAiP1Wdy39NY8DSMu5",
   "Duration_ms": 288093,
   "time_signature": 4,
   "Genre": "columbusohioindie"
 },
 {
   
   "Name": "TheFieldsOfAthenry",
   "Danceability": 0.414,
   "Energy": 0.249,
   "Key": 4,
   "Loudness": -13.351,
   "Mode": 1,
   "Speechness": 0.0323,
   "Acousticness": 0.744,
   "Instrumentalness": 0.0016,
   "Liveness": 0.0972,
   "Valence": 0.229,
   "Tempo": 113.012,
   "Type": "audio_features",
   "ID": "3BPcgBQKNJnwLjcwXNPyx0",
   "Uri": "spotify:track:3BPcgBQKNJnwLjcwXNPyx0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3BPcgBQKNJnwLjcwXNPyx0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3BPcgBQKNJnwLjcwXNPyx0",
   "Duration_ms": 280333,
   "time_signature": 4,
   "Genre": "irishfolk"
 },
 {
   
   "Name": "UUUUU",
   "Danceability": 0.585,
   "Energy": 0.791,
   "Key": 7,
   "Loudness": -8.833,
   "Mode": 1,
   "Speechness": 0.196,
   "Acousticness": 0.0000207,
   "Instrumentalness": 0.121,
   "Liveness": 0.0959,
   "Valence": 0.477,
   "Tempo": 94.962,
   "Type": "audio_features",
   "ID": "54CaCWgjd1Hv7LG5ozTbS0",
   "Uri": "spotify:track:54CaCWgjd1Hv7LG5ozTbS0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/54CaCWgjd1Hv7LG5ozTbS0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/54CaCWgjd1Hv7LG5ozTbS0",
   "Duration_ms": 212468,
   "time_signature": 4,
   "Genre": "sanantonioindie"
 },
 {
   
   "Name": "Bailar",
   "Danceability": 0.75,
   "Energy": 0.891,
   "Key": 9,
   "Loudness": -3.738,
   "Mode": 1,
   "Speechness": 0.227,
   "Acousticness": 0.0249,
   "Instrumentalness": 0.00000648,
   "Liveness": 0.0569,
   "Valence": 0.553,
   "Tempo": 128.065,
   "Type": "audio_features",
   "ID": "1A5yplwEk6cJbAL63L6bkp",
   "Uri": "spotify:track:1A5yplwEk6cJbAL63L6bkp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1A5yplwEk6cJbAL63L6bkp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1A5yplwEk6cJbAL63L6bkp",
   "Duration_ms": 160305,
   "time_signature": 4,
   "Genre": "mexicanedm"
 },
 {
   
   "Name": "KainCintaPutih",
   "Danceability": 0.619,
   "Energy": 0.556,
   "Key": 3,
   "Loudness": -3.954,
   "Mode": 0,
   "Speechness": 0.0259,
   "Acousticness": 0.189,
   "Instrumentalness": 0,
   "Liveness": 0.154,
   "Valence": 0.418,
   "Tempo": 106.997,
   "Type": "audio_features",
   "ID": "11fsBPqmGvygROhCaVNIqE",
   "Uri": "spotify:track:11fsBPqmGvygROhCaVNIqE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/11fsBPqmGvygROhCaVNIqE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/11fsBPqmGvygROhCaVNIqE",
   "Duration_ms": 333333,
   "time_signature": 4,
   "Genre": "rockkapak"
 },
 {
   
   "Name": "PlanetEarthIISuite",
   "Danceability": 0.16,
   "Energy": 0.184,
   "Key": 10,
   "Loudness": -18.507,
   "Mode": 1,
   "Speechness": 0.0465,
   "Acousticness": 0.216,
   "Instrumentalness": 0.966,
   "Liveness": 0.0709,
   "Valence": 0.0327,
   "Tempo": 108.368,
   "Type": "audio_features",
   "ID": "4QlFVqAbmWsDyDyaufOGA3",
   "Uri": "spotify:track:4QlFVqAbmWsDyDyaufOGA3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4QlFVqAbmWsDyDyaufOGA3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4QlFVqAbmWsDyDyaufOGA3",
   "Duration_ms": 271267,
   "time_signature": 4,
   "Genre": "deepsoundtrack"
 },
 {
   
   "Name": "Loophead",
   "Danceability": 0.532,
   "Energy": 0.624,
   "Key": 2,
   "Loudness": -8.472,
   "Mode": 1,
   "Speechness": 0.0345,
   "Acousticness": 0.0853,
   "Instrumentalness": 0,
   "Liveness": 0.319,
   "Valence": 0.813,
   "Tempo": 118.026,
   "Type": "audio_features",
   "ID": "6cteteV5fgPcynxDAaHWpk",
   "Uri": "spotify:track:6cteteV5fgPcynxDAaHWpk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6cteteV5fgPcynxDAaHWpk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6cteteV5fgPcynxDAaHWpk",
   "Duration_ms": 204480,
   "time_signature": 4,
   "Genre": "bretonfolk"
 },
 {
   
   "Name": "Ute",
   "Danceability": 0.674,
   "Energy": 0.736,
   "Key": 5,
   "Loudness": -8.66,
   "Mode": 1,
   "Speechness": 0.0332,
   "Acousticness": 0.844,
   "Instrumentalness": 0,
   "Liveness": 0.171,
   "Valence": 0.947,
   "Tempo": 118.201,
   "Type": "audio_features",
   "ID": "3gMOq3gMgmWcRXOKfT7B0P",
   "Uri": "spotify:track:3gMOq3gMgmWcRXOKfT7B0P",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3gMOq3gMgmWcRXOKfT7B0P",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3gMOq3gMgmWcRXOKfT7B0P",
   "Duration_ms": 177894,
   "time_signature": 4,
   "Genre": "tahitian"
 },
 {
   
   "Name": "SmellsLikeTeenSpirit",
   "Danceability": 0.516,
   "Energy": 0.906,
   "Key": 1,
   "Loudness": -4.525,
   "Mode": 1,
   "Speechness": 0.0658,
   "Acousticness": 0.0000286,
   "Instrumentalness": 0.000101,
   "Liveness": 0.105,
   "Valence": 0.728,
   "Tempo": 116.775,
   "Type": "audio_features",
   "ID": "5ghIJDpPoe3CfHMGu71E6T",
   "Uri": "spotify:track:5ghIJDpPoe3CfHMGu71E6T",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5ghIJDpPoe3CfHMGu71E6T",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5ghIJDpPoe3CfHMGu71E6T",
   "Duration_ms": 301920,
   "time_signature": 4,
   "Genre": "renaissance"
 },
 {
   
   "Name": "Lyckost",
   "Danceability": 0.371,
   "Energy": 0.909,
   "Key": 9,
   "Loudness": -5.573,
   "Mode": 1,
   "Speechness": 0.0598,
   "Acousticness": 0.715,
   "Instrumentalness": 0.00000144,
   "Liveness": 0.304,
   "Valence": 0.869,
   "Tempo": 182.788,
   "Type": "audio_features",
   "ID": "6TOEGwm3rdNPV0rTQW21A8",
   "Uri": "spotify:track:6TOEGwm3rdNPV0rTQW21A8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6TOEGwm3rdNPV0rTQW21A8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6TOEGwm3rdNPV0rTQW21A8",
   "Duration_ms": 150316,
   "time_signature": 4,
   "Genre": "swedishrockabilly"
 },
 {
   
   "Name": "ARoomBetweentheRooms",
   "Danceability": 0.163,
   "Energy": 0.228,
   "Key": 6,
   "Loudness": -22.692,
   "Mode": 1,
   "Speechness": 0.0444,
   "Acousticness": 0.488,
   "Instrumentalness": 0.905,
   "Liveness": 0.097,
   "Valence": 0.0269,
   "Tempo": 136.933,
   "Type": "audio_features",
   "ID": "6aAfkcsiO7rerTy6kHJ6V4",
   "Uri": "spotify:track:6aAfkcsiO7rerTy6kHJ6V4",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6aAfkcsiO7rerTy6kHJ6V4",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6aAfkcsiO7rerTy6kHJ6V4",
   "Duration_ms": 393440,
   "time_signature": 4,
   "Genre": "dronescape"
 },
 {
   
   "Name": "Unwanted",
   "Danceability": 0.355,
   "Energy": 0.963,
   "Key": 5,
   "Loudness": -4.467,
   "Mode": 1,
   "Speechness": 0.171,
   "Acousticness": 0.0000416,
   "Instrumentalness": 0.0195,
   "Liveness": 0.228,
   "Valence": 0.157,
   "Tempo": 77.417,
   "Type": "audio_features",
   "ID": "5GemDONmUrZSEobC36nG93",
   "Uri": "spotify:track:5GemDONmUrZSEobC36nG93",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5GemDONmUrZSEobC36nG93",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5GemDONmUrZSEobC36nG93",
   "Duration_ms": 259995,
   "time_signature": 4,
   "Genre": "austrianmetal"
 },
 {
   
   "Name": "Don\\tGo",
   "Danceability": 0.371,
   "Energy": 0.92,
   "Key": 11,
   "Loudness": -5.793,
   "Mode": 1,
   "Speechness": 0.0439,
   "Acousticness": 0.00115,
   "Instrumentalness": 0,
   "Liveness": 0.426,
   "Valence": 0.585,
   "Tempo": 161.936,
   "Type": "audio_features",
   "ID": "5DA5TYUrasRZ3oMzxr1nj0",
   "Uri": "spotify:track:5DA5TYUrasRZ3oMzxr1nj0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5DA5TYUrasRZ3oMzxr1nj0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5DA5TYUrasRZ3oMzxr1nj0",
   "Duration_ms": 148742,
   "time_signature": 4,
   "Genre": "deeppower-poppunk"
 },
 {
   
   "Name": "Macadam",
   "Danceability": 0.538,
   "Energy": 0.551,
   "Key": 4,
   "Loudness": -9.817,
   "Mode": 0,
   "Speechness": 0.357,
   "Acousticness": 0.746,
   "Instrumentalness": 0,
   "Liveness": 0.109,
   "Valence": 0.63,
   "Tempo": 73.006,
   "Type": "audio_features",
   "ID": "0xYf16JCb4Mv0WhFGL6wvT",
   "Uri": "spotify:track:0xYf16JCb4Mv0WhFGL6wvT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0xYf16JCb4Mv0WhFGL6wvT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0xYf16JCb4Mv0WhFGL6wvT",
   "Duration_ms": 116800,
   "time_signature": 4,
   "Genre": "trapfrancais"
 },
 {
   
   "Name": "MeanttoBe(feat.FloridaGeorgiaLine)",
   "Danceability": 0.643,
   "Energy": 0.783,
   "Key": 10,
   "Loudness": -6.458,
   "Mode": 1,
   "Speechness": 0.0856,
   "Acousticness": 0.047,
   "Instrumentalness": 0,
   "Liveness": 0.083,
   "Valence": 0.579,
   "Tempo": 154.084,
   "Type": "audio_features",
   "ID": "7iDa6hUg2VgEL1o1HjmfBn",
   "Uri": "spotify:track:7iDa6hUg2VgEL1o1HjmfBn",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7iDa6hUg2VgEL1o1HjmfBn",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7iDa6hUg2VgEL1o1HjmfBn",
   "Duration_ms": 163870,
   "time_signature": 4,
   "Genre": "countrydawn"
 },
 {
   
   "Name": "SugarShack",
   "Danceability": 0.757,
   "Energy": 0.564,
   "Key": 9,
   "Loudness": -8.067,
   "Mode": 1,
   "Speechness": 0.0606,
   "Acousticness": 0.363,
   "Instrumentalness": 0.0153,
   "Liveness": 0.113,
   "Valence": 0.782,
   "Tempo": 129.283,
   "Type": "audio_features",
   "ID": "50LSh0CKule183lEw3HzQg",
   "Uri": "spotify:track:50LSh0CKule183lEw3HzQg",
   "Ref_Track": "https://api.spotify.com/v1/tracks/50LSh0CKule183lEw3HzQg",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/50LSh0CKule183lEw3HzQg",
   "Duration_ms": 276187,
   "time_signature": 4,
   "Genre": "moderncountryrock"
 },
 {
   
   "Name": "SameOl\\River-Live",
   "Danceability": 0.48,
   "Energy": 0.718,
   "Key": 0,
   "Loudness": -7.558,
   "Mode": 1,
   "Speechness": 0.0319,
   "Acousticness": 0.388,
   "Instrumentalness": 0.0227,
   "Liveness": 0.963,
   "Valence": 0.67,
   "Tempo": 120.663,
   "Type": "audio_features",
   "ID": "1tlINlCiIrAkxoKR2tEAzm",
   "Uri": "spotify:track:1tlINlCiIrAkxoKR2tEAzm",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1tlINlCiIrAkxoKR2tEAzm",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1tlINlCiIrAkxoKR2tEAzm",
   "Duration_ms": 539400,
   "time_signature": 4,
   "Genre": "progressivebluegrass"
 },
 {
   
   "Name": "GoodbyeInHerEyes",
   "Danceability": 0.4,
   "Energy": 0.558,
   "Key": 3,
   "Loudness": -7.393,
   "Mode": 1,
   "Speechness": 0.038,
   "Acousticness": 0.163,
   "Instrumentalness": 0.00000376,
   "Liveness": 0.0879,
   "Valence": 0.376,
   "Tempo": 81.271,
   "Type": "audio_features",
   "ID": "3yM53DMMIioxVy7Pha1hD0",
   "Uri": "spotify:track:3yM53DMMIioxVy7Pha1hD0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3yM53DMMIioxVy7Pha1hD0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3yM53DMMIioxVy7Pha1hD0",
   "Duration_ms": 324267,
   "time_signature": 4,
   "Genre": "albertacountry"
 },
 {
   
   "Name": "EsÉpico",
   "Danceability": 0.665,
   "Energy": 0.816,
   "Key": 0,
   "Loudness": -6.753,
   "Mode": 1,
   "Speechness": 0.266,
   "Acousticness": 0.448,
   "Instrumentalness": 0,
   "Liveness": 0.297,
   "Valence": 0.745,
   "Tempo": 93.37,
   "Type": "audio_features",
   "ID": "2kd0T6zgABT8P0s2h9QU5O",
   "Uri": "spotify:track:2kd0T6zgABT8P0s2h9QU5O",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2kd0T6zgABT8P0s2h9QU5O",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2kd0T6zgABT8P0s2h9QU5O",
   "Duration_ms": 361979,
   "time_signature": 4,
   "Genre": "venezuelanhiphop"
 },
 {
   
   "Name": "AsTraditionDiesSlowly",
   "Danceability": 0.192,
   "Energy": 0.945,
   "Key": 9,
   "Loudness": -6.499,
   "Mode": 1,
   "Speechness": 0.153,
   "Acousticness": 0.000075,
   "Instrumentalness": 0.143,
   "Liveness": 0.296,
   "Valence": 0.2,
   "Tempo": 86.515,
   "Type": "audio_features",
   "ID": "4hjDgv58TbRgCisdScGknT",
   "Uri": "spotify:track:4hjDgv58TbRgCisdScGknT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4hjDgv58TbRgCisdScGknT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4hjDgv58TbRgCisdScGknT",
   "Duration_ms": 184987,
   "time_signature": 4,
   "Genre": "metallichardcore"
 },
 {
   
   "Name": "Otherside",
   "Danceability": 0.458,
   "Energy": 0.795,
   "Key": 0,
   "Loudness": -3.265,
   "Mode": 1,
   "Speechness": 0.0574,
   "Acousticness": 0.00316,
   "Instrumentalness": 0.000202,
   "Liveness": 0.0756,
   "Valence": 0.513,
   "Tempo": 123.229,
   "Type": "audio_features",
   "ID": "64BbK9SFKH2jk86U3dGj2P",
   "Uri": "spotify:track:64BbK9SFKH2jk86U3dGj2P",
   "Ref_Track": "https://api.spotify.com/v1/tracks/64BbK9SFKH2jk86U3dGj2P",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/64BbK9SFKH2jk86U3dGj2P",
   "Duration_ms": 255373,
   "time_signature": 4,
   "Genre": "latinmetal"
 },
 {
   
   "Name": "SaveMe",
   "Danceability": 0.697,
   "Energy": 0.78,
   "Key": 6,
   "Loudness": -6.798,
   "Mode": 0,
   "Speechness": 0.0379,
   "Acousticness": 0.0824,
   "Instrumentalness": 0.121,
   "Liveness": 0.348,
   "Valence": 0.695,
   "Tempo": 123.994,
   "Type": "audio_features",
   "ID": "5ZRcp3KMbqF3KXIEJ7Pg6K",
   "Uri": "spotify:track:5ZRcp3KMbqF3KXIEJ7Pg6K",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5ZRcp3KMbqF3KXIEJ7Pg6K",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5ZRcp3KMbqF3KXIEJ7Pg6K",
   "Duration_ms": 171691,
   "time_signature": 4,
   "Genre": "turkishelectronic"
 },
 {
   
   "Name": "Uitzicht",
   "Danceability": 0.807,
   "Energy": 0.425,
   "Key": 7,
   "Loudness": -8.452,
   "Mode": 1,
   "Speechness": 0.0656,
   "Acousticness": 0.0169,
   "Instrumentalness": 0.891,
   "Liveness": 0.0614,
   "Valence": 0.66,
   "Tempo": 125.987,
   "Type": "audio_features",
   "ID": "4OuuTwky6Lupc7zDJNtig6",
   "Uri": "spotify:track:4OuuTwky6Lupc7zDJNtig6",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4OuuTwky6Lupc7zDJNtig6",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4OuuTwky6Lupc7zDJNtig6",
   "Duration_ms": 308929,
   "time_signature": 4,
   "Genre": "glitchbeats"
 },
 {
   
   "Name": "PrivateEyes",
   "Danceability": 0.823,
   "Energy": 0.778,
   "Key": 2,
   "Loudness": -12.313,
   "Mode": 0,
   "Speechness": 0.0475,
   "Acousticness": 0.331,
   "Instrumentalness": 0,
   "Liveness": 0.0799,
   "Valence": 0.862,
   "Tempo": 121.033,
   "Type": "audio_features",
   "ID": "098DRq2EpYSun5kAj7NfWa",
   "Uri": "spotify:track:098DRq2EpYSun5kAj7NfWa",
   "Ref_Track": "https://api.spotify.com/v1/tracks/098DRq2EpYSun5kAj7NfWa",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/098DRq2EpYSun5kAj7NfWa",
   "Duration_ms": 208173,
   "time_signature": 4,
   "Genre": "norwegiandeathmetal"
 },
 {
   
   "Name": "CryoutforaHero",
   "Danceability": 0.443,
   "Energy": 0.972,
   "Key": 10,
   "Loudness": -5.367,
   "Mode": 0,
   "Speechness": 0.0715,
   "Acousticness": 0.0000177,
   "Instrumentalness": 0.318,
   "Liveness": 0.334,
   "Valence": 0.408,
   "Tempo": 91.074,
   "Type": "audio_features",
   "ID": "41P2FpxK9DruCmAUcy35UD",
   "Uri": "spotify:track:41P2FpxK9DruCmAUcy35UD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/41P2FpxK9DruCmAUcy35UD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/41P2FpxK9DruCmAUcy35UD",
   "Duration_ms": 207965,
   "time_signature": 4,
   "Genre": "finnishblackmetal"
 },
 {
   
   "Name": "Psy",
   "Danceability": 0.0995,
   "Energy": 0.872,
   "Key": 6,
   "Loudness": -3.329,
   "Mode": 1,
   "Speechness": 0.0614,
   "Acousticness": 0.0000029,
   "Instrumentalness": 0.959,
   "Liveness": 0.255,
   "Valence": 0.438,
   "Tempo": 159.503,
   "Type": "audio_features",
   "ID": "0PAKbQarxkuGIetlUz5Mnf",
   "Uri": "spotify:track:0PAKbQarxkuGIetlUz5Mnf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0PAKbQarxkuGIetlUz5Mnf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0PAKbQarxkuGIetlUz5Mnf",
   "Duration_ms": 143000,
   "time_signature": 3,
   "Genre": "polishblackmetal"
 },
 {
   
   "Name": "TheLegendofLoFi",
   "Danceability": 0.755,
   "Energy": 0.316,
   "Key": 6,
   "Loudness": -9.385,
   "Mode": 0,
   "Speechness": 0.0835,
   "Acousticness": 0.602,
   "Instrumentalness": 0.935,
   "Liveness": 0.108,
   "Valence": 0.37,
   "Tempo": 80.015,
   "Type": "audio_features",
   "ID": "2m7Y68bhEEAzRDARRzbdDt",
   "Uri": "spotify:track:2m7Y68bhEEAzRDARRzbdDt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2m7Y68bhEEAzRDARRzbdDt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2m7Y68bhEEAzRDARRzbdDt",
   "Duration_ms": 145219,
   "time_signature": 4,
   "Genre": "videogamemusic"
 },
 {
   
   "Name": "Transmission-2010RemasteredVersion",
   "Danceability": 0.497,
   "Energy": 0.808,
   "Key": 7,
   "Loudness": -8.088,
   "Mode": 1,
   "Speechness": 0.0388,
   "Acousticness": 0.0355,
   "Instrumentalness": 0.437,
   "Liveness": 0.0966,
   "Valence": 0.683,
   "Tempo": 153.561,
   "Type": "audio_features",
   "ID": "5EclH1u6hKzOV3m1I3LAc3",
   "Uri": "spotify:track:5EclH1u6hKzOV3m1I3LAc3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5EclH1u6hKzOV3m1I3LAc3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5EclH1u6hKzOV3m1I3LAc3",
   "Duration_ms": 215148,
   "time_signature": 4,
   "Genre": "darkpost-punk"
 },
 {
   
   "Name": "Intro",
   "Danceability": 0.396,
   "Energy": 0.605,
   "Key": 7,
   "Loudness": -19.471,
   "Mode": 1,
   "Speechness": 0.322,
   "Acousticness": 0.262,
   "Instrumentalness": 0,
   "Liveness": 0.835,
   "Valence": 0.197,
   "Tempo": 126.388,
   "Type": "audio_features",
   "ID": "0ZnH5ym1uMtngTa5Qjq61K",
   "Uri": "spotify:track:0ZnH5ym1uMtngTa5Qjq61K",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0ZnH5ym1uMtngTa5Qjq61K",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0ZnH5ym1uMtngTa5Qjq61K",
   "Duration_ms": 61947,
   "time_signature": 5,
   "Genre": "cyberpunk"
 },
 {
   
   "Name": "ElVerano",
   "Danceability": 0.322,
   "Energy": 0.55,
   "Key": 6,
   "Loudness": -8.482,
   "Mode": 1,
   "Speechness": 0.0381,
   "Acousticness": 0.0838,
   "Instrumentalness": 0,
   "Liveness": 0.0583,
   "Valence": 0.48,
   "Tempo": 164.065,
   "Type": "audio_features",
   "ID": "6ArUa9CVR9nb2whVFc0i4V",
   "Uri": "spotify:track:6ArUa9CVR9nb2whVFc0i4V",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6ArUa9CVR9nb2whVFc0i4V",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6ArUa9CVR9nb2whVFc0i4V",
   "Duration_ms": 328795,
   "time_signature": 3,
   "Genre": "colombianindie"
 },
 {
   
   "Name": "LivetoTell-EditVersion",
   "Danceability": 0.627,
   "Energy": 0.363,
   "Key": 5,
   "Loudness": -12.368,
   "Mode": 1,
   "Speechness": 0.026,
   "Acousticness": 0.104,
   "Instrumentalness": 0.00000352,
   "Liveness": 0.127,
   "Valence": 0.259,
   "Tempo": 110.07,
   "Type": "audio_features",
   "ID": "4osrEm2iY3QcTUcQuFUtfW",
   "Uri": "spotify:track:4osrEm2iY3QcTUcQuFUtfW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4osrEm2iY3QcTUcQuFUtfW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4osrEm2iY3QcTUcQuFUtfW",
   "Duration_ms": 318773,
   "time_signature": 4,
   "Genre": "wrock"
 },
 {
   
   "Name": "NeverGonnaGetAway",
   "Danceability": 0.743,
   "Energy": 0.849,
   "Key": 6,
   "Loudness": -5.138,
   "Mode": 1,
   "Speechness": 0.0917,
   "Acousticness": 0.47,
   "Instrumentalness": 0.0000674,
   "Liveness": 0.0985,
   "Valence": 0.91,
   "Tempo": 120.015,
   "Type": "audio_features",
   "ID": "0JsTbSZcZQewHgHaVjZ14T",
   "Uri": "spotify:track:0JsTbSZcZQewHgHaVjZ14T",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0JsTbSZcZQewHgHaVjZ14T",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0JsTbSZcZQewHgHaVjZ14T",
   "Duration_ms": 188630,
   "time_signature": 4,
   "Genre": "steampunk"
 },
 {
   
   "Name": "FairRosamund",
   "Danceability": 0.335,
   "Energy": 0.222,
   "Key": 10,
   "Loudness": -16.48,
   "Mode": 0,
   "Speechness": 0.0362,
   "Acousticness": 0.915,
   "Instrumentalness": 0.199,
   "Liveness": 0.0914,
   "Valence": 0.185,
   "Tempo": 109.665,
   "Type": "audio_features",
   "ID": "2hCRQALSANEOVh72FSgMIn",
   "Uri": "spotify:track:2hCRQALSANEOVh72FSgMIn",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2hCRQALSANEOVh72FSgMIn",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2hCRQALSANEOVh72FSgMIn",
   "Duration_ms": 323880,
   "time_signature": 4,
   "Genre": "traditionalenglishfolk"
 },
 {
   
   "Name": "SurahYa-Seen",
   "Danceability": 0.383,
   "Energy": 0.265,
   "Key": 8,
   "Loudness": -6.301,
   "Mode": 1,
   "Speechness": 0.0305,
   "Acousticness": 0.925,
   "Instrumentalness": 0,
   "Liveness": 0.23,
   "Valence": 0.35,
   "Tempo": 142.198,
   "Type": "audio_features",
   "ID": "0PSXctwBNDb8TdAAJDDML8",
   "Uri": "spotify:track:0PSXctwBNDb8TdAAJDDML8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0PSXctwBNDb8TdAAJDDML8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0PSXctwBNDb8TdAAJDDML8",
   "Duration_ms": 1059788,
   "time_signature": 4,
   "Genre": "vintagechanson"
 },
 {
   
   "Name": "SongForYou",
   "Danceability": 0.838,
   "Energy": 0.369,
   "Key": 2,
   "Loudness": -10.388,
   "Mode": 1,
   "Speechness": 0.0357,
   "Acousticness": 0.616,
   "Instrumentalness": 0.666,
   "Liveness": 0.109,
   "Valence": 0.224,
   "Tempo": 115.99,
   "Type": "audio_features",
   "ID": "0BfLvshnvJldGROufmYCrv",
   "Uri": "spotify:track:0BfLvshnvJldGROufmYCrv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0BfLvshnvJldGROufmYCrv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0BfLvshnvJldGROufmYCrv",
   "Duration_ms": 238667,
   "time_signature": 4,
   "Genre": "brazilianelectronica"
 },
 {
   
   "Name": "Branches",
   "Danceability": 0.637,
   "Energy": 0.051,
   "Key": 2,
   "Loudness": -16.595,
   "Mode": 1,
   "Speechness": 0.0434,
   "Acousticness": 0.961,
   "Instrumentalness": 0.0000191,
   "Liveness": 0.0815,
   "Valence": 0.0848,
   "Tempo": 135.551,
   "Type": "audio_features",
   "ID": "3Fgxrn0SYk2ueNiYEGAMH7",
   "Uri": "spotify:track:3Fgxrn0SYk2ueNiYEGAMH7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3Fgxrn0SYk2ueNiYEGAMH7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3Fgxrn0SYk2ueNiYEGAMH7",
   "Duration_ms": 207693,
   "time_signature": 4,
   "Genre": "icelandicrock"
 },
 {
   
   "Name": "\\HeMeleNoLilo(FromLilo&Stitch)\\",
   "Danceability": 0.337,
   "Energy": 0.252,
   "Key": 5,
   "Loudness": -14.375,
   "Mode": 1,
   "Speechness": 0.0386,
   "Acousticness": 0.944,
   "Instrumentalness": 0.624,
   "Liveness": 0.0606,
   "Valence": 0.417,
   "Tempo": 141.272,
   "Type": "audio_features",
   "ID": "4lhSRK6MTgBfBRAKLlOUW9",
   "Uri": "spotify:track:4lhSRK6MTgBfBRAKLlOUW9",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4lhSRK6MTgBfBRAKLlOUW9",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4lhSRK6MTgBfBRAKLlOUW9",
   "Duration_ms": 152053,
   "time_signature": 4,
   "Genre": "britishbrassband"
 },
 {
   
   "Name": "SpareMe(feat.Clara)",
   "Danceability": 0.697,
   "Energy": 0.775,
   "Key": 5,
   "Loudness": -5.803,
   "Mode": 0,
   "Speechness": 0.0545,
   "Acousticness": 0.0175,
   "Instrumentalness": 0,
   "Liveness": 0.271,
   "Valence": 0.291,
   "Tempo": 89.985,
   "Type": "audio_features",
   "ID": "37w4bHQH4LBNokl7j2ENT5",
   "Uri": "spotify:track:37w4bHQH4LBNokl7j2ENT5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/37w4bHQH4LBNokl7j2ENT5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/37w4bHQH4LBNokl7j2ENT5",
   "Duration_ms": 164560,
   "time_signature": 4,
   "Genre": "swissindie"
 },
 {
   
   "Name": "SoothingPianoforPleasure",
   "Danceability": 0.467,
   "Energy": 0.0274,
   "Key": 0,
   "Loudness": -26.328,
   "Mode": 1,
   "Speechness": 0.0477,
   "Acousticness": 0.995,
   "Instrumentalness": 0.938,
   "Liveness": 0.0767,
   "Valence": 0.143,
   "Tempo": 127.451,
   "Type": "audio_features",
   "ID": "0JMgxT0GfIIMn3ARQD1CEJ",
   "Uri": "spotify:track:0JMgxT0GfIIMn3ARQD1CEJ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0JMgxT0GfIIMn3ARQD1CEJ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0JMgxT0GfIIMn3ARQD1CEJ",
   "Duration_ms": 211851,
   "time_signature": 4,
   "Genre": "petcalming"
 },
 {
   
   "Name": "IslandInTheSun",
   "Danceability": 0.615,
   "Energy": 0.237,
   "Key": 9,
   "Loudness": -14.453,
   "Mode": 1,
   "Speechness": 0.0325,
   "Acousticness": 0.853,
   "Instrumentalness": 0.965,
   "Liveness": 0.0944,
   "Valence": 0.221,
   "Tempo": 83.998,
   "Type": "audio_features",
   "ID": "62BfIDR2RU3N6aENEyVWMR",
   "Uri": "spotify:track:62BfIDR2RU3N6aENEyVWMR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/62BfIDR2RU3N6aENEyVWMR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/62BfIDR2RU3N6aENEyVWMR",
   "Duration_ms": 194400,
   "time_signature": 4,
   "Genre": "panpipe"
 },
 {
   
   "Name": "CanYou-OriginalMix",
   "Danceability": 0.576,
   "Energy": 0.927,
   "Key": 10,
   "Loudness": -3.627,
   "Mode": 0,
   "Speechness": 0.145,
   "Acousticness": 0.00597,
   "Instrumentalness": 0.554,
   "Liveness": 0.11,
   "Valence": 0.649,
   "Tempo": 175.026,
   "Type": "audio_features",
   "ID": "6yyCN75IbbjlD3IMMvlV0z",
   "Uri": "spotify:track:6yyCN75IbbjlD3IMMvlV0z",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6yyCN75IbbjlD3IMMvlV0z",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6yyCN75IbbjlD3IMMvlV0z",
   "Duration_ms": 310629,
   "time_signature": 4,
   "Genre": "j-core"
 },
 {
   
   "Name": "LabourlikeIDo",
   "Danceability": 0.579,
   "Energy": 0.805,
   "Key": 2,
   "Loudness": -6.345,
   "Mode": 1,
   "Speechness": 0.0366,
   "Acousticness": 0.0372,
   "Instrumentalness": 0.000111,
   "Liveness": 0.0945,
   "Valence": 0.78,
   "Tempo": 113.886,
   "Type": "audio_features",
   "ID": "53XXjlb6TMb3NAxtQh5jb2",
   "Uri": "spotify:track:53XXjlb6TMb3NAxtQh5jb2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/53XXjlb6TMb3NAxtQh5jb2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/53XXjlb6TMb3NAxtQh5jb2",
   "Duration_ms": 220080,
   "time_signature": 4,
   "Genre": "brightonindie"
 },
 {
   
   "Name": "KännikalajaSelväpyy-Lastenmusiikkia",
   "Danceability": 0.752,
   "Energy": 0.7,
   "Key": 4,
   "Loudness": -9.136,
   "Mode": 0,
   "Speechness": 0.144,
   "Acousticness": 0.152,
   "Instrumentalness": 0,
   "Liveness": 0.258,
   "Valence": 0.606,
   "Tempo": 91.751,
   "Type": "audio_features",
   "ID": "1ZMBLis8fb0VWf0W1bbCUB",
   "Uri": "spotify:track:1ZMBLis8fb0VWf0W1bbCUB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1ZMBLis8fb0VWf0W1bbCUB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1ZMBLis8fb0VWf0W1bbCUB",
   "Duration_ms": 170000,
   "time_signature": 4,
   "Genre": "musiikkialapsille"
 },
 {
   
   "Name": "LosingMyself",
   "Danceability": 0.714,
   "Energy": 0.618,
   "Key": 1,
   "Loudness": -10.02,
   "Mode": 1,
   "Speechness": 0.053,
   "Acousticness": 0.319,
   "Instrumentalness": 0.733,
   "Liveness": 0.113,
   "Valence": 0.593,
   "Tempo": 110.018,
   "Type": "audio_features",
   "ID": "4dKmwwCVuUtf9wvz94U7Fx",
   "Uri": "spotify:track:4dKmwwCVuUtf9wvz94U7Fx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4dKmwwCVuUtf9wvz94U7Fx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4dKmwwCVuUtf9wvz94U7Fx",
   "Duration_ms": 233465,
   "time_signature": 4,
   "Genre": "icelandicindie"
 },
 {
   
   "Name": "Needin\\USo-TocadiscoRemix",
   "Danceability": 0.7,
   "Energy": 0.886,
   "Key": 8,
   "Loudness": -5.111,
   "Mode": 1,
   "Speechness": 0.0836,
   "Acousticness": 0.216,
   "Instrumentalness": 0.0137,
   "Liveness": 0.122,
   "Valence": 0.512,
   "Tempo": 124.975,
   "Type": "audio_features",
   "ID": "2uajcqd3uQ9uRvlYmj7Uf3",
   "Uri": "spotify:track:2uajcqd3uQ9uRvlYmj7Uf3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2uajcqd3uQ9uRvlYmj7Uf3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2uajcqd3uQ9uRvlYmj7Uf3",
   "Duration_ms": 174620,
   "time_signature": 4,
   "Genre": "bouncyhouse"
 },
 {
   
   "Name": "WalmartKid",
   "Danceability": 0.837,
   "Energy": 0.336,
   "Key": 5,
   "Loudness": -9.711,
   "Mode": 1,
   "Speechness": 0.0784,
   "Acousticness": 0.216,
   "Instrumentalness": 0.00407,
   "Liveness": 0.376,
   "Valence": 0.127,
   "Tempo": 126.999,
   "Type": "audio_features",
   "ID": "74fg6xkCQ6JP1F3dF6RIgp",
   "Uri": "spotify:track:74fg6xkCQ6JP1F3dF6RIgp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/74fg6xkCQ6JP1F3dF6RIgp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/74fg6xkCQ6JP1F3dF6RIgp",
   "Duration_ms": 89288,
   "time_signature": 4,
   "Genre": "lowercase"
 },
 {
   
   "Name": "TijuanaMakesMeHappy",
   "Danceability": 0.88,
   "Energy": 0.458,
   "Key": 10,
   "Loudness": -7.26,
   "Mode": 0,
   "Speechness": 0.0313,
   "Acousticness": 0.101,
   "Instrumentalness": 0.82,
   "Liveness": 0.0951,
   "Valence": 0.861,
   "Tempo": 120.026,
   "Type": "audio_features",
   "ID": "00o5WpvMHT7bhDZGOlolSU",
   "Uri": "spotify:track:00o5WpvMHT7bhDZGOlolSU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/00o5WpvMHT7bhDZGOlolSU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/00o5WpvMHT7bhDZGOlolSU",
   "Duration_ms": 247107,
   "time_signature": 4,
   "Genre": "tijuanaelectronic"
 },
 {
   
   "Name": "On",
   "Danceability": 0.6,
   "Energy": 0.93,
   "Key": 6,
   "Loudness": -13.986,
   "Mode": 1,
   "Speechness": 0.0456,
   "Acousticness": 0.0184,
   "Instrumentalness": 0.923,
   "Liveness": 0.0829,
   "Valence": 0.372,
   "Tempo": 134.976,
   "Type": "audio_features",
   "ID": "4bqKYnULuraOQzUEpAZArn",
   "Uri": "spotify:track:4bqKYnULuraOQzUEpAZArn",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4bqKYnULuraOQzUEpAZArn",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4bqKYnULuraOQzUEpAZArn",
   "Duration_ms": 412267,
   "time_signature": 4,
   "Genre": "intelligentdancemusic"
 },
 {
   
   "Name": "Disco2000",
   "Danceability": 0.567,
   "Energy": 0.932,
   "Key": 7,
   "Loudness": -5.888,
   "Mode": 0,
   "Speechness": 0.0759,
   "Acousticness": 0.0147,
   "Instrumentalness": 0,
   "Liveness": 0.0484,
   "Valence": 0.55,
   "Tempo": 133.074,
   "Type": "audio_features",
   "ID": "7ec55GDkRIBmsI8XKrG1lu",
   "Uri": "spotify:track:7ec55GDkRIBmsI8XKrG1lu",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7ec55GDkRIBmsI8XKrG1lu",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7ec55GDkRIBmsI8XKrG1lu",
   "Duration_ms": 273733,
   "time_signature": 4,
   "Genre": "dancerock"
 },
 {
   
   "Name": "Flows",
   "Danceability": 0.571,
   "Energy": 0.468,
   "Key": 10,
   "Loudness": -9.739,
   "Mode": 1,
   "Speechness": 0.0317,
   "Acousticness": 0.335,
   "Instrumentalness": 0.789,
   "Liveness": 0.109,
   "Valence": 0.432,
   "Tempo": 84.016,
   "Type": "audio_features",
   "ID": "4h5p6yqJQc7AOChygp1OZE",
   "Uri": "spotify:track:4h5p6yqJQc7AOChygp1OZE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4h5p6yqJQc7AOChygp1OZE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4h5p6yqJQc7AOChygp1OZE",
   "Duration_ms": 181946,
   "time_signature": 1,
   "Genre": "danishindiepop"
 },
 {
   
   "Name": "Soilborn-Remaster",
   "Danceability": 0.424,
   "Energy": 0.962,
   "Key": 7,
   "Loudness": -5.661,
   "Mode": 1,
   "Speechness": 0.0807,
   "Acousticness": 0.00000869,
   "Instrumentalness": 0.000221,
   "Liveness": 0.0518,
   "Valence": 0.308,
   "Tempo": 90.485,
   "Type": "audio_features",
   "ID": "5sJjsBGS8MEWDHq5cFPyAf",
   "Uri": "spotify:track:5sJjsBGS8MEWDHq5cFPyAf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5sJjsBGS8MEWDHq5cFPyAf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5sJjsBGS8MEWDHq5cFPyAf",
   "Duration_ms": 209973,
   "time_signature": 4,
   "Genre": "rapmetalcore"
 },
 {
   
   "Name": "Febbraio",
   "Danceability": 0.566,
   "Energy": 0.661,
   "Key": 2,
   "Loudness": -5.661,
   "Mode": 1,
   "Speechness": 0.14,
   "Acousticness": 0.46,
   "Instrumentalness": 0.000151,
   "Liveness": 0.118,
   "Valence": 0.619,
   "Tempo": 78.932,
   "Type": "audio_features",
   "ID": "6rBDKhngfXnDTacixhwd5c",
   "Uri": "spotify:track:6rBDKhngfXnDTacixhwd5c",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6rBDKhngfXnDTacixhwd5c",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6rBDKhngfXnDTacixhwd5c",
   "Duration_ms": 194750,
   "time_signature": 4,
   "Genre": "okindie"
 },
 {
   
   "Name": "Stay-SneijderRemix",
   "Danceability": 0.521,
   "Energy": 0.952,
   "Key": 0,
   "Loudness": -5.564,
   "Mode": 0,
   "Speechness": 0.0661,
   "Acousticness": 0.0473,
   "Instrumentalness": 0.00233,
   "Liveness": 0.306,
   "Valence": 0.134,
   "Tempo": 137.976,
   "Type": "audio_features",
   "ID": "4wmDScqiSAfRwuenaf7oe8",
   "Uri": "spotify:track:4wmDScqiSAfRwuenaf7oe8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4wmDScqiSAfRwuenaf7oe8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4wmDScqiSAfRwuenaf7oe8",
   "Duration_ms": 213913,
   "time_signature": 4,
   "Genre": "trance"
 },
 {
   
   "Name": "Stay-SneijderRemix",
   "Danceability": 0.521,
   "Energy": 0.952,
   "Key": 0,
   "Loudness": -5.564,
   "Mode": 0,
   "Speechness": 0.0661,
   "Acousticness": 0.0473,
   "Instrumentalness": 0.00233,
   "Liveness": 0.306,
   "Valence": 0.134,
   "Tempo": 137.976,
   "Type": "audio_features",
   "ID": "4wmDScqiSAfRwuenaf7oe8",
   "Uri": "spotify:track:4wmDScqiSAfRwuenaf7oe8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4wmDScqiSAfRwuenaf7oe8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4wmDScqiSAfRwuenaf7oe8",
   "Duration_ms": 213913,
   "time_signature": 4,
   "Genre": "progressivetrance"
 },
 {
   
   "Name": "Bonetrousle",
   "Danceability": 0.571,
   "Energy": 0.523,
   "Key": 0,
   "Loudness": -13.245,
   "Mode": 0,
   "Speechness": 0.0364,
   "Acousticness": 0.87,
   "Instrumentalness": 0.656,
   "Liveness": 0.131,
   "Valence": 0.558,
   "Tempo": 150.055,
   "Type": "audio_features",
   "ID": "14P8huCHOcdBsgUafA65CR",
   "Uri": "spotify:track:14P8huCHOcdBsgUafA65CR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/14P8huCHOcdBsgUafA65CR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/14P8huCHOcdBsgUafA65CR",
   "Duration_ms": 122000,
   "time_signature": 4,
   "Genre": "orchestralperformance"
 },
 {
   
   "Name": "WorkthatMotherfucker-OriginalMix",
   "Danceability": 0.804,
   "Energy": 0.751,
   "Key": 8,
   "Loudness": -14.446,
   "Mode": 0,
   "Speechness": 0.0921,
   "Acousticness": 0.0217,
   "Instrumentalness": 0.895,
   "Liveness": 0.0869,
   "Valence": 0.354,
   "Tempo": 130.509,
   "Type": "audio_features",
   "ID": "3nRjs6KIJ5bz7S0U4Fk5xz",
   "Uri": "spotify:track:3nRjs6KIJ5bz7S0U4Fk5xz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3nRjs6KIJ5bz7S0U4Fk5xz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3nRjs6KIJ5bz7S0U4Fk5xz",
   "Duration_ms": 296008,
   "time_signature": 4,
   "Genre": "chicagohouse"
 },
 {
   
   "Name": "StealHerManChallenge(JerseyClubRemix)",
   "Danceability": 0.85,
   "Energy": 0.647,
   "Key": 1,
   "Loudness": -8.097,
   "Mode": 1,
   "Speechness": 0.378,
   "Acousticness": 0.00782,
   "Instrumentalness": 0.0294,
   "Liveness": 0.0592,
   "Valence": 0.586,
   "Tempo": 164.93,
   "Type": "audio_features",
   "ID": "7kfh2iyJlRgONMJgyhZEPf",
   "Uri": "spotify:track:7kfh2iyJlRgONMJgyhZEPf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7kfh2iyJlRgONMJgyhZEPf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7kfh2iyJlRgONMJgyhZEPf",
   "Duration_ms": 104727,
   "time_signature": 4,
   "Genre": "jerseyclub"
 },
 {
   
   "Name": "WeWon\\tBeAlone(feat.LauraBrehm)",
   "Danceability": 0.377,
   "Energy": 0.858,
   "Key": 11,
   "Loudness": -4.9,
   "Mode": 0,
   "Speechness": 0.148,
   "Acousticness": 0.134,
   "Instrumentalness": 0.00185,
   "Liveness": 0.0985,
   "Valence": 0.117,
   "Tempo": 174.751,
   "Type": "audio_features",
   "ID": "5qsKdwDWbhNTygUO4mGpix",
   "Uri": "spotify:track:5qsKdwDWbhNTygUO4mGpix",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5qsKdwDWbhNTygUO4mGpix",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5qsKdwDWbhNTygUO4mGpix",
   "Duration_ms": 234475,
   "time_signature": 4,
   "Genre": "dubsteppe"
 },
 {
   
   "Name": "AguaMarfil",
   "Danceability": 0.494,
   "Energy": 0.274,
   "Key": 1,
   "Loudness": -10.156,
   "Mode": 0,
   "Speechness": 0.029,
   "Acousticness": 0.898,
   "Instrumentalness": 0.000235,
   "Liveness": 0.107,
   "Valence": 0.0835,
   "Tempo": 134.293,
   "Type": "audio_features",
   "ID": "6mYdnKt43uGw3gmtOz4yQi",
   "Uri": "spotify:track:6mYdnKt43uGw3gmtOz4yQi",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6mYdnKt43uGw3gmtOz4yQi",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6mYdnKt43uGw3gmtOz4yQi",
   "Duration_ms": 251853,
   "time_signature": 4,
   "Genre": "argentineindie"
 },
 {
   
   "Name": "EntranceOfTheGladiator",
   "Danceability": 0.526,
   "Energy": 0.216,
   "Key": 2,
   "Loudness": -15.18,
   "Mode": 1,
   "Speechness": 0.0372,
   "Acousticness": 0.995,
   "Instrumentalness": 0.95,
   "Liveness": 0.102,
   "Valence": 0.27,
   "Tempo": 112.197,
   "Type": "audio_features",
   "ID": "7ddsj11lqfybNzxQccPau3",
   "Uri": "spotify:track:7ddsj11lqfybNzxQccPau3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7ddsj11lqfybNzxQccPau3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7ddsj11lqfybNzxQccPau3",
   "Duration_ms": 132733,
   "time_signature": 4,
   "Genre": "darkcabaret"
 },
 {
   
   "Name": "You(Piano&StringsSessionsVersion)[Instrumental]",
   "Danceability": 0.382,
   "Energy": 0.29,
   "Key": 2,
   "Loudness": -8.67,
   "Mode": 1,
   "Speechness": 0.0333,
   "Acousticness": 0.289,
   "Instrumentalness": 0.846,
   "Liveness": 0.126,
   "Valence": 0.17,
   "Tempo": 171.833,
   "Type": "audio_features",
   "ID": "0kxiRfn9KcOSTccXgsXS8A",
   "Uri": "spotify:track:0kxiRfn9KcOSTccXgsXS8A",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0kxiRfn9KcOSTccXgsXS8A",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0kxiRfn9KcOSTccXgsXS8A",
   "Duration_ms": 265991,
   "time_signature": 4,
   "Genre": "classify"
 },
 {
   
   "Name": "BackinTime",
   "Danceability": 0.87,
   "Energy": 0.792,
   "Key": 6,
   "Loudness": -5.327,
   "Mode": 0,
   "Speechness": 0.047,
   "Acousticness": 0.0166,
   "Instrumentalness": 0.123,
   "Liveness": 0.178,
   "Valence": 0.645,
   "Tempo": 117.983,
   "Type": "audio_features",
   "ID": "7pstX01u6qbKF0tWsTa2Lz",
   "Uri": "spotify:track:7pstX01u6qbKF0tWsTa2Lz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7pstX01u6qbKF0tWsTa2Lz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7pstX01u6qbKF0tWsTa2Lz",
   "Duration_ms": 198667,
   "time_signature": 4,
   "Genre": "swing"
 },
 {
   
   "Name": "öölaps!",
   "Danceability": 0.937,
   "Energy": 0.486,
   "Key": 2,
   "Loudness": -8.6,
   "Mode": 0,
   "Speechness": 0.161,
   "Acousticness": 0.162,
   "Instrumentalness": 0.599,
   "Liveness": 0.1,
   "Valence": 0.644,
   "Tempo": 121.036,
   "Type": "audio_features",
   "ID": "70qZhu8T6VHpeugYFZCnVk",
   "Uri": "spotify:track:70qZhu8T6VHpeugYFZCnVk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/70qZhu8T6VHpeugYFZCnVk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/70qZhu8T6VHpeugYFZCnVk",
   "Duration_ms": 192982,
   "time_signature": 4,
   "Genre": "estonianhiphop"
 },
 {
   
   "Name": "Nefarius",
   "Danceability": 0.313,
   "Energy": 0.961,
   "Key": 0,
   "Loudness": -6.335,
   "Mode": 0,
   "Speechness": 0.106,
   "Acousticness": 0.00000911,
   "Instrumentalness": 0.91,
   "Liveness": 0.746,
   "Valence": 0.0423,
   "Tempo": 160.037,
   "Type": "audio_features",
   "ID": "2caomeBQtYroBZ198ZIpAF",
   "Uri": "spotify:track:2caomeBQtYroBZ198ZIpAF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2caomeBQtYroBZ198ZIpAF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2caomeBQtYroBZ198ZIpAF",
   "Duration_ms": 267160,
   "time_signature": 4,
   "Genre": "chaoticblackmetal"
 },
 {
   
   "Name": "Comatose",
   "Danceability": 0.476,
   "Energy": 0.949,
   "Key": 11,
   "Loudness": -2.098,
   "Mode": 0,
   "Speechness": 0.0777,
   "Acousticness": 0.00000905,
   "Instrumentalness": 0.00162,
   "Liveness": 0.0677,
   "Valence": 0.475,
   "Tempo": 85.981,
   "Type": "audio_features",
   "ID": "4yr6szTi931ZysFOHSqMpp",
   "Uri": "spotify:track:4yr6szTi931ZysFOHSqMpp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4yr6szTi931ZysFOHSqMpp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4yr6szTi931ZysFOHSqMpp",
   "Duration_ms": 307827,
   "time_signature": 4,
   "Genre": "turkishmetal"
 },
 {
   
   "Name": "Homeless",
   "Danceability": 0.49,
   "Energy": 0.992,
   "Key": 4,
   "Loudness": -6.613,
   "Mode": 0,
   "Speechness": 0.0646,
   "Acousticness": 0.000967,
   "Instrumentalness": 0.906,
   "Liveness": 0.806,
   "Valence": 0.12,
   "Tempo": 127.018,
   "Type": "audio_features",
   "ID": "6EWrE0pebhbkoUZnFiUEvN",
   "Uri": "spotify:track:6EWrE0pebhbkoUZnFiUEvN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6EWrE0pebhbkoUZnFiUEvN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6EWrE0pebhbkoUZnFiUEvN",
   "Duration_ms": 438425,
   "time_signature": 4,
   "Genre": "necrogrind"
 },
 {
   
   "Name": "DiGolgota",
   "Danceability": 0.455,
   "Energy": 0.365,
   "Key": 0,
   "Loudness": -8.857,
   "Mode": 1,
   "Speechness": 0.0266,
   "Acousticness": 0.252,
   "Instrumentalness": 0,
   "Liveness": 0.37,
   "Valence": 0.22,
   "Tempo": 132.054,
   "Type": "audio_features",
   "ID": "0BS5DHnAugONMzaQsEDYEA",
   "Uri": "spotify:track:0BS5DHnAugONMzaQsEDYEA",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0BS5DHnAugONMzaQsEDYEA",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0BS5DHnAugONMzaQsEDYEA",
   "Duration_ms": 258467,
   "time_signature": 4,
   "Genre": "indonesianworship"
 },
 {
   
   "Name": "Attention",
   "Danceability": 0.533,
   "Energy": 0.61,
   "Key": 7,
   "Loudness": -7.037,
   "Mode": 1,
   "Speechness": 0.108,
   "Acousticness": 0.0661,
   "Instrumentalness": 0,
   "Liveness": 0.225,
   "Valence": 0.734,
   "Tempo": 204.308,
   "Type": "audio_features",
   "ID": "5P40YyCrdZRsoj2vTbSyVI",
   "Uri": "spotify:track:5P40YyCrdZRsoj2vTbSyVI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5P40YyCrdZRsoj2vTbSyVI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5P40YyCrdZRsoj2vTbSyVI",
   "Duration_ms": 171520,
   "time_signature": 4,
   "Genre": "acappella"
 },
 {
   
   "Name": "Don\\tAskMeQuestions",
   "Danceability": 0.562,
   "Energy": 0.568,
   "Key": 9,
   "Loudness": -10.634,
   "Mode": 0,
   "Speechness": 0.0848,
   "Acousticness": 0.14,
   "Instrumentalness": 0.0115,
   "Liveness": 0.145,
   "Valence": 0.152,
   "Tempo": 87.097,
   "Type": "audio_features",
   "ID": "1lKHTSLeTPfNbYio8dB3Xj",
   "Uri": "spotify:track:1lKHTSLeTPfNbYio8dB3Xj",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1lKHTSLeTPfNbYio8dB3Xj",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1lKHTSLeTPfNbYio8dB3Xj",
   "Duration_ms": 216720,
   "time_signature": 4,
   "Genre": "polishclassical"
 },
 {
   
   "Name": "WarinYourHead",
   "Danceability": 0.379,
   "Energy": 0.97,
   "Key": 9,
   "Loudness": -4.468,
   "Mode": 0,
   "Speechness": 0.0787,
   "Acousticness": 0.0000139,
   "Instrumentalness": 0.58,
   "Liveness": 0.444,
   "Valence": 0.526,
   "Tempo": 105.332,
   "Type": "audio_features",
   "ID": "5zROqptJq2EoIOzV5v2qso",
   "Uri": "spotify:track:5zROqptJq2EoIOzV5v2qso",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5zROqptJq2EoIOzV5v2qso",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5zROqptJq2EoIOzV5v2qso",
   "Duration_ms": 89165,
   "time_signature": 4,
   "Genre": "ukdiypunk"
 },
 {
   
   "Name": "LosingSleep",
   "Danceability": 0.587,
   "Energy": 0.628,
   "Key": 1,
   "Loudness": -5.703,
   "Mode": 1,
   "Speechness": 0.0431,
   "Acousticness": 0.0677,
   "Instrumentalness": 0.00000188,
   "Liveness": 0.122,
   "Valence": 0.649,
   "Tempo": 92.003,
   "Type": "audio_features",
   "ID": "5Feu0AyHLrW0mCRAyUnZ6W",
   "Uri": "spotify:track:5Feu0AyHLrW0mCRAyUnZ6W",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5Feu0AyHLrW0mCRAyUnZ6W",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5Feu0AyHLrW0mCRAyUnZ6W",
   "Duration_ms": 180252,
   "time_signature": 4,
   "Genre": "swisscountry"
 },
 {
   
   "Name": "MastersOfDestiny",
   "Danceability": 0.454,
   "Energy": 0.809,
   "Key": 11,
   "Loudness": -6.886,
   "Mode": 0,
   "Speechness": 0.0654,
   "Acousticness": 0.000341,
   "Instrumentalness": 0.00563,
   "Liveness": 0.0864,
   "Valence": 0.236,
   "Tempo": 113.219,
   "Type": "audio_features",
   "ID": "3Z7w8vnhfAsOIrzLLHmEDf",
   "Uri": "spotify:track:3Z7w8vnhfAsOIrzLLHmEDf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3Z7w8vnhfAsOIrzLLHmEDf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3Z7w8vnhfAsOIrzLLHmEDf",
   "Duration_ms": 294646,
   "time_signature": 4,
   "Genre": "gothicsymphonicmetal"
 },
 {
   
   "Name": "WelcometotheBlackParade",
   "Danceability": 0.217,
   "Energy": 0.905,
   "Key": 2,
   "Loudness": -4.103,
   "Mode": 1,
   "Speechness": 0.0752,
   "Acousticness": 0.000289,
   "Instrumentalness": 0.00011,
   "Liveness": 0.222,
   "Valence": 0.236,
   "Tempo": 96.95,
   "Type": "audio_features",
   "ID": "5wQnmLuC1W7ATsArWACrgW",
   "Uri": "spotify:track:5wQnmLuC1W7ATsArWACrgW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5wQnmLuC1W7ATsArWACrgW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5wQnmLuC1W7ATsArWACrgW",
   "Duration_ms": 311107,
   "time_signature": 4,
   "Genre": "popemo"
 },
 {
   
   "Name": "Enslemmigtorsk",
   "Danceability": 0.325,
   "Energy": 0.722,
   "Key": 10,
   "Loudness": -13.386,
   "Mode": 1,
   "Speechness": 0.0985,
   "Acousticness": 0.000339,
   "Instrumentalness": 0.0000359,
   "Liveness": 0.116,
   "Valence": 0.644,
   "Tempo": 95.521,
   "Type": "audio_features",
   "ID": "0lHqNKA2IX8MzQwLNPbbY8",
   "Uri": "spotify:track:0lHqNKA2IX8MzQwLNPbbY8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0lHqNKA2IX8MzQwLNPbbY8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0lHqNKA2IX8MzQwLNPbbY8",
   "Duration_ms": 109800,
   "time_signature": 4,
   "Genre": "welshmetal"
 },
 {
   
   "Name": "Gloryhammer",
   "Danceability": 0.517,
   "Energy": 0.916,
   "Key": 0,
   "Loudness": -4.933,
   "Mode": 1,
   "Speechness": 0.0559,
   "Acousticness": 0.000182,
   "Instrumentalness": 0.00191,
   "Liveness": 0.306,
   "Valence": 0.444,
   "Tempo": 135.996,
   "Type": "audio_features",
   "ID": "4HA34COgxgVJ6zK88UN4Ik",
   "Uri": "spotify:track:4HA34COgxgVJ6zK88UN4Ik",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4HA34COgxgVJ6zK88UN4Ik",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4HA34COgxgVJ6zK88UN4Ik",
   "Duration_ms": 300320,
   "time_signature": 4,
   "Genre": "vikingmetal"
 },
 {
   
   "Name": "ExtrañandoCasa",
   "Danceability": 0.334,
   "Energy": 0.896,
   "Key": 2,
   "Loudness": -7.368,
   "Mode": 1,
   "Speechness": 0.0417,
   "Acousticness": 0.000743,
   "Instrumentalness": 0,
   "Liveness": 0.268,
   "Valence": 0.496,
   "Tempo": 118.28,
   "Type": "audio_features",
   "ID": "7xjHy5BTZy1JQGBq6eeqT0",
   "Uri": "spotify:track:7xjHy5BTZy1JQGBq6eeqT0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7xjHy5BTZy1JQGBq6eeqT0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7xjHy5BTZy1JQGBq6eeqT0",
   "Duration_ms": 156907,
   "time_signature": 4,
   "Genre": "mexicanpoppunk"
 },
 {
   
   "Name": "That\\sWhatYouGet",
   "Danceability": 0.528,
   "Energy": 0.831,
   "Key": 8,
   "Loudness": -3.607,
   "Mode": 1,
   "Speechness": 0.0429,
   "Acousticness": 0.0000943,
   "Instrumentalness": 0,
   "Liveness": 0.141,
   "Valence": 0.632,
   "Tempo": 131.094,
   "Type": "audio_features",
   "ID": "0UY4FvG4f9JI6kBR1BlWrZ",
   "Uri": "spotify:track:0UY4FvG4f9JI6kBR1BlWrZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0UY4FvG4f9JI6kBR1BlWrZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0UY4FvG4f9JI6kBR1BlWrZ",
   "Duration_ms": 220480,
   "time_signature": 3,
   "Genre": "alternativeemo"
 },
 {
   
   "Name": "SadisticMagician",
   "Danceability": 0.26,
   "Energy": 0.998,
   "Key": 4,
   "Loudness": -2.844,
   "Mode": 1,
   "Speechness": 0.16,
   "Acousticness": 0.000728,
   "Instrumentalness": 0.0187,
   "Liveness": 0.141,
   "Valence": 0.447,
   "Tempo": 194.788,
   "Type": "audio_features",
   "ID": "5szz2njh6khJU22vh4dAz0",
   "Uri": "spotify:track:5szz2njh6khJU22vh4dAz0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5szz2njh6khJU22vh4dAz0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5szz2njh6khJU22vh4dAz0",
   "Duration_ms": 129387,
   "time_signature": 4,
   "Genre": "crossoverthrash"
 },
 {
   
   "Name": "Shinkansen",
   "Danceability": 0.646,
   "Energy": 0.37,
   "Key": 6,
   "Loudness": -16.315,
   "Mode": 0,
   "Speechness": 0.0793,
   "Acousticness": 0.0728,
   "Instrumentalness": 0.905,
   "Liveness": 0.0869,
   "Valence": 0.0311,
   "Tempo": 151.945,
   "Type": "audio_features",
   "ID": "4YoejEllMJllmDEDwYNOto",
   "Uri": "spotify:track:4YoejEllMJllmDEDwYNOto",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4YoejEllMJllmDEDwYNOto",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4YoejEllMJllmDEDwYNOto",
   "Duration_ms": 391960,
   "time_signature": 4,
   "Genre": "futureambient"
 },
 {
   
   "Name": "KlabbV2",
   "Danceability": 0.381,
   "Energy": 0.57,
   "Key": 4,
   "Loudness": -8.71,
   "Mode": 1,
   "Speechness": 0.0422,
   "Acousticness": 0.0171,
   "Instrumentalness": 0.874,
   "Liveness": 0.199,
   "Valence": 0.138,
   "Tempo": 110.012,
   "Type": "audio_features",
   "ID": "4T337xtWmPVGzV1XP8fAog",
   "Uri": "spotify:track:4T337xtWmPVGzV1XP8fAog",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4T337xtWmPVGzV1XP8fAog",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4T337xtWmPVGzV1XP8fAog",
   "Duration_ms": 388156,
   "time_signature": 4,
   "Genre": "chineseexperimental"
 },
 {
   
   "Name": "TheFalloftheFirstPillar",
   "Danceability": 0.0699,
   "Energy": 0.894,
   "Key": 7,
   "Loudness": -4.982,
   "Mode": 1,
   "Speechness": 0.0782,
   "Acousticness": 0.00000205,
   "Instrumentalness": 0.183,
   "Liveness": 0.109,
   "Valence": 0.0673,
   "Tempo": 178.957,
   "Type": "audio_features",
   "ID": "4ttUcxbYpcZEZTKoe3iSpE",
   "Uri": "spotify:track:4ttUcxbYpcZEZTKoe3iSpE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4ttUcxbYpcZEZTKoe3iSpE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4ttUcxbYpcZEZTKoe3iSpE",
   "Duration_ms": 346989,
   "time_signature": 4,
   "Genre": "greekblackmetal"
 },
 {
   
   "Name": "We\\llLiveandDieinTheseTowns",
   "Danceability": 0.469,
   "Energy": 0.678,
   "Key": 4,
   "Loudness": -6.197,
   "Mode": 1,
   "Speechness": 0.0358,
   "Acousticness": 0.234,
   "Instrumentalness": 0,
   "Liveness": 0.343,
   "Valence": 0.287,
   "Tempo": 150.169,
   "Type": "audio_features",
   "ID": "2XWAPRiW50qgKBU1T7MfN7",
   "Uri": "spotify:track:2XWAPRiW50qgKBU1T7MfN7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2XWAPRiW50qgKBU1T7MfN7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2XWAPRiW50qgKBU1T7MfN7",
   "Duration_ms": 235040,
   "time_signature": 4,
   "Genre": "coventryindie"
 },
 {
   
   "Name": "Lambreta",
   "Danceability": 0.695,
   "Energy": 0.171,
   "Key": 9,
   "Loudness": -12.284,
   "Mode": 1,
   "Speechness": 0.101,
   "Acousticness": 0.849,
   "Instrumentalness": 0.0349,
   "Liveness": 0.108,
   "Valence": 0.396,
   "Tempo": 132.887,
   "Type": "audio_features",
   "ID": "6OrNf46vJrHqNP3IFpmvhV",
   "Uri": "spotify:track:6OrNf46vJrHqNP3IFpmvhV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6OrNf46vJrHqNP3IFpmvhV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6OrNf46vJrHqNP3IFpmvhV",
   "Duration_ms": 144240,
   "time_signature": 3,
   "Genre": "portuguesepop"
 },
 {
   
   "Name": "BetterDay",
   "Danceability": 0.492,
   "Energy": 0.567,
   "Key": 10,
   "Loudness": -5.984,
   "Mode": 1,
   "Speechness": 0.0239,
   "Acousticness": 0.0378,
   "Instrumentalness": 0,
   "Liveness": 0.173,
   "Valence": 0.328,
   "Tempo": 79.374,
   "Type": "audio_features",
   "ID": "0k7AYarupFQ2RHN1niWSAD",
   "Uri": "spotify:track:0k7AYarupFQ2RHN1niWSAD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0k7AYarupFQ2RHN1niWSAD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0k7AYarupFQ2RHN1niWSAD",
   "Duration_ms": 225067,
   "time_signature": 4,
   "Genre": "leedsindie"
 },
 {
   
   "Name": "LaLola",
   "Danceability": 0.725,
   "Energy": 0.79,
   "Key": 9,
   "Loudness": -4.393,
   "Mode": 0,
   "Speechness": 0.102,
   "Acousticness": 0.0646,
   "Instrumentalness": 0.00883,
   "Liveness": 0.121,
   "Valence": 0.867,
   "Tempo": 151.985,
   "Type": "audio_features",
   "ID": "01OAJcBZVjwAGvKLyJsqWM",
   "Uri": "spotify:track:01OAJcBZVjwAGvKLyJsqWM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/01OAJcBZVjwAGvKLyJsqWM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/01OAJcBZVjwAGvKLyJsqWM",
   "Duration_ms": 197320,
   "time_signature": 4,
   "Genre": "trikiti"
 },
 {
   
   "Name": "Génovýininier",
   "Danceability": 0.262,
   "Energy": 0.745,
   "Key": 11,
   "Loudness": -5.917,
   "Mode": 1,
   "Speechness": 0.0666,
   "Acousticness": 0.0103,
   "Instrumentalness": 0.00347,
   "Liveness": 0.117,
   "Valence": 0.132,
   "Tempo": 142.835,
   "Type": "audio_features",
   "ID": "0yozeL7FDKn4Jvk6tAUZbK",
   "Uri": "spotify:track:0yozeL7FDKn4Jvk6tAUZbK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0yozeL7FDKn4Jvk6tAUZbK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0yozeL7FDKn4Jvk6tAUZbK",
   "Duration_ms": 249960,
   "time_signature": 4,
   "Genre": "czechindie"
 },
 {
   
   "Name": "Dearmyblue",
   "Danceability": 0.528,
   "Energy": 0.105,
   "Key": 9,
   "Loudness": -14.107,
   "Mode": 0,
   "Speechness": 0.339,
   "Acousticness": 0.896,
   "Instrumentalness": 0,
   "Liveness": 0.364,
   "Valence": 0.258,
   "Tempo": 170.347,
   "Type": "audio_features",
   "ID": "2l2AUzq4ERp5prZ0vf8EPH",
   "Uri": "spotify:track:2l2AUzq4ERp5prZ0vf8EPH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2l2AUzq4ERp5prZ0vf8EPH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2l2AUzq4ERp5prZ0vf8EPH",
   "Duration_ms": 138390,
   "time_signature": 3,
   "Genre": "vaporsoul"
 },
 {
   
   "Name": "Lucky",
   "Danceability": 0.623,
   "Energy": 0.417,
   "Key": 0,
   "Loudness": -8.699,
   "Mode": 1,
   "Speechness": 0.0354,
   "Acousticness": 0.296,
   "Instrumentalness": 0,
   "Liveness": 0.135,
   "Valence": 0.721,
   "Tempo": 130.032,
   "Type": "audio_features",
   "ID": "0IktbUcnAGrvD03AWnz3Q8",
   "Uri": "spotify:track:0IktbUcnAGrvD03AWnz3Q8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0IktbUcnAGrvD03AWnz3Q8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0IktbUcnAGrvD03AWnz3Q8",
   "Duration_ms": 191360,
   "time_signature": 4,
   "Genre": "guitarcase"
 },
 {
   
   "Name": "TwistMeUp-OriginalMix",
   "Danceability": 0.667,
   "Energy": 0.77,
   "Key": 11,
   "Loudness": -8.335,
   "Mode": 0,
   "Speechness": 0.0442,
   "Acousticness": 0.000234,
   "Instrumentalness": 0.753,
   "Liveness": 0.112,
   "Valence": 0.0994,
   "Tempo": 135.012,
   "Type": "audio_features",
   "ID": "1WyWDZI8savcEdeINqBLjC",
   "Uri": "spotify:track:1WyWDZI8savcEdeINqBLjC",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1WyWDZI8savcEdeINqBLjC",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1WyWDZI8savcEdeINqBLjC",
   "Duration_ms": 492444,
   "time_signature": 4,
   "Genre": "goatrance"
 },
 {
   
   "Name": "AstheDeer",
   "Danceability": 0.514,
   "Energy": 0.0349,
   "Key": 2,
   "Loudness": -20.247,
   "Mode": 1,
   "Speechness": 0.0464,
   "Acousticness": 0.994,
   "Instrumentalness": 0.926,
   "Liveness": 0.102,
   "Valence": 0.226,
   "Tempo": 113.978,
   "Type": "audio_features",
   "ID": "7jZ8JuODxdSJcpex05ilZw",
   "Uri": "spotify:track:7jZ8JuODxdSJcpex05ilZw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7jZ8JuODxdSJcpex05ilZw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7jZ8JuODxdSJcpex05ilZw",
   "Duration_ms": 144533,
   "time_signature": 4,
   "Genre": "christianrelaxative"
 },
 {
   
   "Name": "SereDuNokeTeLitleGråGeita",
   "Danceability": 0.575,
   "Energy": 0.022,
   "Key": 1,
   "Loudness": -23.604,
   "Mode": 1,
   "Speechness": 0.225,
   "Acousticness": 0.983,
   "Instrumentalness": 0,
   "Liveness": 0.123,
   "Valence": 0.633,
   "Tempo": 99.412,
   "Type": "audio_features",
   "ID": "5y9QZI0EeWoOR2bziUD5kP",
   "Uri": "spotify:track:5y9QZI0EeWoOR2bziUD5kP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5y9QZI0EeWoOR2bziUD5kP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5y9QZI0EeWoOR2bziUD5kP",
   "Duration_ms": 19587,
   "time_signature": 3,
   "Genre": "norwegianfolk"
 },
 {
   
   "Name": "Galaxy",
   "Danceability": 0.659,
   "Energy": 0.561,
   "Key": 11,
   "Loudness": -9.383,
   "Mode": 0,
   "Speechness": 0.325,
   "Acousticness": 0.0185,
   "Instrumentalness": 0.0000131,
   "Liveness": 0.52,
   "Valence": 0.664,
   "Tempo": 91.021,
   "Type": "audio_features",
   "ID": "5KT2p82cl3RQTerBbIApCO",
   "Uri": "spotify:track:5KT2p82cl3RQTerBbIApCO",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5KT2p82cl3RQTerBbIApCO",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5KT2p82cl3RQTerBbIApCO",
   "Duration_ms": 258462,
   "time_signature": 4,
   "Genre": "outerhiphop"
 },
 {
   
   "Name": "Redbone",
   "Danceability": 0.745,
   "Energy": 0.359,
   "Key": 1,
   "Loudness": -10.429,
   "Mode": 1,
   "Speechness": 0.112,
   "Acousticness": 0.192,
   "Instrumentalness": 0.00628,
   "Liveness": 0.138,
   "Valence": 0.55,
   "Tempo": 160.123,
   "Type": "audio_features",
   "ID": "2Uvy6SkNqxvnH1W68dymxG",
   "Uri": "spotify:track:2Uvy6SkNqxvnH1W68dymxG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Uvy6SkNqxvnH1W68dymxG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Uvy6SkNqxvnH1W68dymxG",
   "Duration_ms": 326933,
   "time_signature": 4,
   "Genre": "neosoul-jazz"
 },
 {
   
   "Name": "IFeelItAll",
   "Danceability": 0.3,
   "Energy": 0.834,
   "Key": 9,
   "Loudness": -10.984,
   "Mode": 0,
   "Speechness": 0.0521,
   "Acousticness": 0.000132,
   "Instrumentalness": 0.111,
   "Liveness": 0.0445,
   "Valence": 0.426,
   "Tempo": 175.086,
   "Type": "audio_features",
   "ID": "1meMTA0WnLa2UCEs746xac",
   "Uri": "spotify:track:1meMTA0WnLa2UCEs746xac",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1meMTA0WnLa2UCEs746xac",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1meMTA0WnLa2UCEs746xac",
   "Duration_ms": 203094,
   "time_signature": 4,
   "Genre": "malmoindie"
 },
 {
   
   "Name": "JimmySetsOutTheGroundRulesForTheShow",
   "Danceability": 0.455,
   "Energy": 0.933,
   "Key": 1,
   "Loudness": -13.901,
   "Mode": 1,
   "Speechness": 0.942,
   "Acousticness": 0.767,
   "Instrumentalness": 0,
   "Liveness": 0.407,
   "Valence": 0.079,
   "Tempo": 77.896,
   "Type": "audio_features",
   "ID": "0xZwriIAl9tEmACBOzEOk0",
   "Uri": "spotify:track:0xZwriIAl9tEmACBOzEOk0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0xZwriIAl9tEmACBOzEOk0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0xZwriIAl9tEmACBOzEOk0",
   "Duration_ms": 455320,
   "time_signature": 4,
   "Genre": "britishcomedy"
 },
 {
   
   "Name": "Dorian",
   "Danceability": 0.658,
   "Energy": 0.576,
   "Key": 11,
   "Loudness": -7.491,
   "Mode": 0,
   "Speechness": 0.037,
   "Acousticness": 0.502,
   "Instrumentalness": 0.000021,
   "Liveness": 0.131,
   "Valence": 0.263,
   "Tempo": 127.992,
   "Type": "audio_features",
   "ID": "6DYjp49kj5vFDsuVhcCafX",
   "Uri": "spotify:track:6DYjp49kj5vFDsuVhcCafX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6DYjp49kj5vFDsuVhcCafX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6DYjp49kj5vFDsuVhcCafX",
   "Duration_ms": 230363,
   "time_signature": 4,
   "Genre": "etherpop"
 },
 {
   
   "Name": "Dormancy",
   "Danceability": 0.371,
   "Energy": 0.888,
   "Key": 0,
   "Loudness": -5.84,
   "Mode": 0,
   "Speechness": 0.0682,
   "Acousticness": 0.0000118,
   "Instrumentalness": 0.904,
   "Liveness": 0.222,
   "Valence": 0.358,
   "Tempo": 117.685,
   "Type": "audio_features",
   "ID": "2qSgx2UbAaQj0nKjTgebmk",
   "Uri": "spotify:track:2qSgx2UbAaQj0nKjTgebmk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2qSgx2UbAaQj0nKjTgebmk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2qSgx2UbAaQj0nKjTgebmk",
   "Duration_ms": 89933,
   "time_signature": 4,
   "Genre": "koreanmetal"
 },
 {
   
   "Name": "WalktotheOneYouLove",
   "Danceability": 0.523,
   "Energy": 0.898,
   "Key": 2,
   "Loudness": -4.464,
   "Mode": 1,
   "Speechness": 0.0549,
   "Acousticness": 0.0129,
   "Instrumentalness": 0.0484,
   "Liveness": 0.273,
   "Valence": 0.723,
   "Tempo": 128.101,
   "Type": "audio_features",
   "ID": "3LkgNmES1jJhFh3TILdNJS",
   "Uri": "spotify:track:3LkgNmES1jJhFh3TILdNJS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3LkgNmES1jJhFh3TILdNJS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3LkgNmES1jJhFh3TILdNJS",
   "Duration_ms": 213427,
   "time_signature": 4,
   "Genre": "chicagoindie"
 },
 {
   
   "Name": "1537.0",
   "Danceability": 0.697,
   "Energy": 0.245,
   "Key": 4,
   "Loudness": -11.056,
   "Mode": 0,
   "Speechness": 0.036,
   "Acousticness": 0.914,
   "Instrumentalness": 0,
   "Liveness": 0.0986,
   "Valence": 0.281,
   "Tempo": 133.925,
   "Type": "audio_features",
   "ID": "7msOGQhkexWYDyUuzeiddi",
   "Uri": "spotify:track:7msOGQhkexWYDyUuzeiddi",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7msOGQhkexWYDyUuzeiddi",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7msOGQhkexWYDyUuzeiddi",
   "Duration_ms": 224107,
   "time_signature": 3,
   "Genre": "ecuadorianalternativerock"
 },
 {
   
   "Name": "Louise",
   "Danceability": 0.618,
   "Energy": 0.739,
   "Key": 4,
   "Loudness": -7.467,
   "Mode": 0,
   "Speechness": 0.0264,
   "Acousticness": 0.0348,
   "Instrumentalness": 0.00000222,
   "Liveness": 0.045,
   "Valence": 0.873,
   "Tempo": 96.012,
   "Type": "audio_features",
   "ID": "0U1XjTvG2xzaWNBJii1mqx",
   "Uri": "spotify:track:0U1XjTvG2xzaWNBJii1mqx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0U1XjTvG2xzaWNBJii1mqx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0U1XjTvG2xzaWNBJii1mqx",
   "Duration_ms": 199400,
   "time_signature": 4,
   "Genre": "flemishfolk"
 },
 {
   
   "Name": "TeoKajAmo",
   "Danceability": 0.651,
   "Energy": 0.609,
   "Key": 0,
   "Loudness": -7.145,
   "Mode": 1,
   "Speechness": 0.0273,
   "Acousticness": 0.14,
   "Instrumentalness": 0.0000736,
   "Liveness": 0.162,
   "Valence": 0.517,
   "Tempo": 135.109,
   "Type": "audio_features",
   "ID": "0mTuZSxKg8stTE0zZ8SIQb",
   "Uri": "spotify:track:0mTuZSxKg8stTE0zZ8SIQb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0mTuZSxKg8stTE0zZ8SIQb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0mTuZSxKg8stTE0zZ8SIQb",
   "Duration_ms": 196076,
   "time_signature": 4,
   "Genre": "esperanto"
 },
 {
   
   "Name": "Accireme",
   "Danceability": 0.715,
   "Energy": 0.649,
   "Key": 7,
   "Loudness": -7.15,
   "Mode": 1,
   "Speechness": 0.0316,
   "Acousticness": 0.293,
   "Instrumentalness": 0.000419,
   "Liveness": 0.175,
   "Valence": 0.626,
   "Tempo": 122.133,
   "Type": "audio_features",
   "ID": "37vI6YBjnBO91AIaIOd6w3",
   "Uri": "spotify:track:37vI6YBjnBO91AIaIOd6w3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/37vI6YBjnBO91AIaIOd6w3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/37vI6YBjnBO91AIaIOd6w3",
   "Duration_ms": 157053,
   "time_signature": 4,
   "Genre": "indienapoletano"
 },
 {
   
   "Name": "TheTraveller",
   "Danceability": 0.208,
   "Energy": 0.956,
   "Key": 7,
   "Loudness": -4.414,
   "Mode": 0,
   "Speechness": 0.334,
   "Acousticness": 0.0000235,
   "Instrumentalness": 0.00000224,
   "Liveness": 0.0921,
   "Valence": 0.138,
   "Tempo": 167.086,
   "Type": "audio_features",
   "ID": "1ve6zyHYoviIDoHSNiTUTK",
   "Uri": "spotify:track:1ve6zyHYoviIDoHSNiTUTK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1ve6zyHYoviIDoHSNiTUTK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1ve6zyHYoviIDoHSNiTUTK",
   "Duration_ms": 325058,
   "time_signature": 4,
   "Genre": "peruvianmetal"
 },
 {
   
   "Name": "L\\étéindien",
   "Danceability": 0.476,
   "Energy": 0.602,
   "Key": 7,
   "Loudness": -8.929,
   "Mode": 0,
   "Speechness": 0.0371,
   "Acousticness": 0.167,
   "Instrumentalness": 0.000706,
   "Liveness": 0.168,
   "Valence": 0.62,
   "Tempo": 121.608,
   "Type": "audio_features",
   "ID": "7BNeFchpHDCWYSUV4hfU89",
   "Uri": "spotify:track:7BNeFchpHDCWYSUV4hfU89",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7BNeFchpHDCWYSUV4hfU89",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7BNeFchpHDCWYSUV4hfU89",
   "Duration_ms": 269320,
   "time_signature": 4,
   "Genre": "chanson"
 },
 {
   
   "Name": "AltoSaxophoneConcerto:I.Andanteappassionato",
   "Danceability": 0.282,
   "Energy": 0.0865,
   "Key": 0,
   "Loudness": -20.054,
   "Mode": 0,
   "Speechness": 0.0432,
   "Acousticness": 0.968,
   "Instrumentalness": 0.874,
   "Liveness": 0.117,
   "Valence": 0.0519,
   "Tempo": 106.72,
   "Type": "audio_features",
   "ID": "7s8ooQrxEhhke0v2TsPZKf",
   "Uri": "spotify:track:7s8ooQrxEhhke0v2TsPZKf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7s8ooQrxEhhke0v2TsPZKf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7s8ooQrxEhhke0v2TsPZKf",
   "Duration_ms": 548240,
   "time_signature": 4,
   "Genre": "classicalsaxophone"
 },
 {
   
   "Name": "TheYellowCakeRevue:FarewelltoStromness",
   "Danceability": 0.408,
   "Energy": 0.00657,
   "Key": 2,
   "Loudness": -31.186,
   "Mode": 1,
   "Speechness": 0.0636,
   "Acousticness": 0.995,
   "Instrumentalness": 0.936,
   "Liveness": 0.0792,
   "Valence": 0.0613,
   "Tempo": 73.224,
   "Type": "audio_features",
   "ID": "6yOhU3jq4WrW5grIlRYOId",
   "Uri": "spotify:track:6yOhU3jq4WrW5grIlRYOId",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6yOhU3jq4WrW5grIlRYOId",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6yOhU3jq4WrW5grIlRYOId",
   "Duration_ms": 336973,
   "time_signature": 4,
   "Genre": "irishclassical"
 },
 {
   
   "Name": "Noble",
   "Danceability": 0.586,
   "Energy": 0.128,
   "Key": 7,
   "Loudness": -14.199,
   "Mode": 1,
   "Speechness": 0.0328,
   "Acousticness": 0.902,
   "Instrumentalness": 0.000261,
   "Liveness": 0.0952,
   "Valence": 0.299,
   "Tempo": 116.759,
   "Type": "audio_features",
   "ID": "4mTpQExVe2MCa9gLqvrlmZ",
   "Uri": "spotify:track:4mTpQExVe2MCa9gLqvrlmZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4mTpQExVe2MCa9gLqvrlmZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4mTpQExVe2MCa9gLqvrlmZ",
   "Duration_ms": 177390,
   "time_signature": 3,
   "Genre": "bahai"
 },
 {
   
   "Name": "NudaperSatana",
   "Danceability": 0.239,
   "Energy": 0.42,
   "Key": 2,
   "Loudness": -15.397,
   "Mode": 1,
   "Speechness": 0.0415,
   "Acousticness": 0.541,
   "Instrumentalness": 0.921,
   "Liveness": 0.103,
   "Valence": 0.113,
   "Tempo": 135.913,
   "Type": "audio_features",
   "ID": "6kjUbMgWCvoGOIj3vRHMYy",
   "Uri": "spotify:track:6kjUbMgWCvoGOIj3vRHMYy",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6kjUbMgWCvoGOIj3vRHMYy",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6kjUbMgWCvoGOIj3vRHMYy",
   "Duration_ms": 416507,
   "time_signature": 4,
   "Genre": "italianoccultpsychedelia"
 },
 {
   
   "Name": "VenturaHighway",
   "Danceability": 0.673,
   "Energy": 0.581,
   "Key": 2,
   "Loudness": -10.205,
   "Mode": 1,
   "Speechness": 0.029,
   "Acousticness": 0.223,
   "Instrumentalness": 0.000206,
   "Liveness": 0.063,
   "Valence": 0.818,
   "Tempo": 130.771,
   "Type": "audio_features",
   "ID": "4IU1RL4BKvFyXtbTwaHAvW",
   "Uri": "spotify:track:4IU1RL4BKvFyXtbTwaHAvW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4IU1RL4BKvFyXtbTwaHAvW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4IU1RL4BKvFyXtbTwaHAvW",
   "Duration_ms": 211387,
   "time_signature": 4,
   "Genre": "deepsoftrock"
 },
 {
   
   "Name": "ManusiaBodoh",
   "Danceability": 0.519,
   "Energy": 0.634,
   "Key": 4,
   "Loudness": -6.61,
   "Mode": 1,
   "Speechness": 0.0398,
   "Acousticness": 0.37,
   "Instrumentalness": 0,
   "Liveness": 0.302,
   "Valence": 0.273,
   "Tempo": 159.869,
   "Type": "audio_features",
   "ID": "408TyH9YoTkH9J0Da9Ue8C",
   "Uri": "spotify:track:408TyH9YoTkH9J0Da9Ue8C",
   "Ref_Track": "https://api.spotify.com/v1/tracks/408TyH9YoTkH9J0Da9Ue8C",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/408TyH9YoTkH9J0Da9Ue8C",
   "Duration_ms": 257927,
   "time_signature": 4,
   "Genre": "indonesianpop"
 },
 {
   
   "Name": "ModernLove-1999Remaster",
   "Danceability": 0.315,
   "Energy": 0.889,
   "Key": 0,
   "Loudness": -8.192,
   "Mode": 1,
   "Speechness": 0.041,
   "Acousticness": 0.000376,
   "Instrumentalness": 0.00241,
   "Liveness": 0.133,
   "Valence": 0.961,
   "Tempo": 181.329,
   "Type": "audio_features",
   "ID": "7LyIoUsiMtelB1I0I4drEF",
   "Uri": "spotify:track:7LyIoUsiMtelB1I0I4drEF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7LyIoUsiMtelB1I0I4drEF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7LyIoUsiMtelB1I0I4drEF",
   "Duration_ms": 288467,
   "time_signature": 4,
   "Genre": "newromantic"
 },
 {
   
   "Name": "FantasyGirl",
   "Danceability": 0.728,
   "Energy": 0.661,
   "Key": 9,
   "Loudness": -8.293,
   "Mode": 0,
   "Speechness": 0.0362,
   "Acousticness": 0.0182,
   "Instrumentalness": 0.0702,
   "Liveness": 0.133,
   "Valence": 0.525,
   "Tempo": 127.239,
   "Type": "audio_features",
   "ID": "0wit7noNUZyrLYfzJegwaE",
   "Uri": "spotify:track:0wit7noNUZyrLYfzJegwaE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0wit7noNUZyrLYfzJegwaE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0wit7noNUZyrLYfzJegwaE",
   "Duration_ms": 239573,
   "time_signature": 4,
   "Genre": "freestyle"
 },
 {
   
   "Name": "FallingDown-BonusTrack",
   "Danceability": 0.669,
   "Energy": 0.574,
   "Key": 4,
   "Loudness": -6.442,
   "Mode": 0,
   "Speechness": 0.0286,
   "Acousticness": 0.0175,
   "Instrumentalness": 0.00294,
   "Liveness": 0.146,
   "Valence": 0.273,
   "Tempo": 120.013,
   "Type": "audio_features",
   "ID": "4jvjzW7Hm0yK4LvvE0Paz9",
   "Uri": "spotify:track:4jvjzW7Hm0yK4LvvE0Paz9",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4jvjzW7Hm0yK4LvvE0Paz9",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4jvjzW7Hm0yK4LvvE0Paz9",
   "Duration_ms": 196400,
   "time_signature": 4,
   "Genre": "emorap"
 },
 {
   
   "Name": "HazardProfilePart1",
   "Danceability": 0.278,
   "Energy": 0.744,
   "Key": 10,
   "Loudness": -10.128,
   "Mode": 1,
   "Speechness": 0.0676,
   "Acousticness": 0.0101,
   "Instrumentalness": 0.816,
   "Liveness": 0.114,
   "Valence": 0.496,
   "Tempo": 105.466,
   "Type": "audio_features",
   "ID": "7J2kYMUtOIzKU9Tpd6YDYX",
   "Uri": "spotify:track:7J2kYMUtOIzKU9Tpd6YDYX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7J2kYMUtOIzKU9Tpd6YDYX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7J2kYMUtOIzKU9Tpd6YDYX",
   "Duration_ms": 559520,
   "time_signature": 4,
   "Genre": "canterburyscene"
 },
 {
   
   "Name": "Gloomsville",
   "Danceability": 0.28,
   "Energy": 0.315,
   "Key": 3,
   "Loudness": -14.228,
   "Mode": 1,
   "Speechness": 0.028,
   "Acousticness": 0.845,
   "Instrumentalness": 0.0364,
   "Liveness": 0.11,
   "Valence": 0.0962,
   "Tempo": 95.207,
   "Type": "audio_features",
   "ID": "4WXhra3KcWZfgkC4nxUJ40",
   "Uri": "spotify:track:4WXhra3KcWZfgkC4nxUJ40",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4WXhra3KcWZfgkC4nxUJ40",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4WXhra3KcWZfgkC4nxUJ40",
   "Duration_ms": 193560,
   "time_signature": 4,
   "Genre": "norwegianindie"
 },
 {
   
   "Name": "Catena",
   "Danceability": 0.301,
   "Energy": 0.374,
   "Key": 7,
   "Loudness": -12.325,
   "Mode": 1,
   "Speechness": 0.0339,
   "Acousticness": 0.848,
   "Instrumentalness": 0,
   "Liveness": 0.0876,
   "Valence": 0.648,
   "Tempo": 73.207,
   "Type": "audio_features",
   "ID": "55RbX93B5aabqvjkyizybg",
   "Uri": "spotify:track:55RbX93B5aabqvjkyizybg",
   "Ref_Track": "https://api.spotify.com/v1/tracks/55RbX93B5aabqvjkyizybg",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/55RbX93B5aabqvjkyizybg",
   "Duration_ms": 260293,
   "time_signature": 4,
   "Genre": "corsicanfolk"
 },
 {
   
   "Name": "Sverigesstyvbarn2",
   "Danceability": 0.591,
   "Energy": 0.525,
   "Key": 2,
   "Loudness": -6.508,
   "Mode": 1,
   "Speechness": 0.0942,
   "Acousticness": 0.121,
   "Instrumentalness": 0.00000124,
   "Liveness": 0.172,
   "Valence": 0.57,
   "Tempo": 105.417,
   "Type": "audio_features",
   "ID": "6hCKJQbn1FgejgEmLMDxOi",
   "Uri": "spotify:track:6hCKJQbn1FgejgEmLMDxOi",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6hCKJQbn1FgejgEmLMDxOi",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6hCKJQbn1FgejgEmLMDxOi",
   "Duration_ms": 241160,
   "time_signature": 4,
   "Genre": "swedishprog"
 },
 {
   
   "Name": "CryingatDaybreak",
   "Danceability": 0.846,
   "Energy": 0.684,
   "Key": 11,
   "Loudness": -7.265,
   "Mode": 0,
   "Speechness": 0.0423,
   "Acousticness": 0.426,
   "Instrumentalness": 0.0966,
   "Liveness": 0.142,
   "Valence": 0.785,
   "Tempo": 89.984,
   "Type": "audio_features",
   "ID": "65HFbR2SvowCFJ4XyTeO5u",
   "Uri": "spotify:track:65HFbR2SvowCFJ4XyTeO5u",
   "Ref_Track": "https://api.spotify.com/v1/tracks/65HFbR2SvowCFJ4XyTeO5u",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/65HFbR2SvowCFJ4XyTeO5u",
   "Duration_ms": 225243,
   "time_signature": 4,
   "Genre": "vintagegospel"
 },
 {
   
   "Name": "Intro",
   "Danceability": 0.441,
   "Energy": 0.443,
   "Key": 4,
   "Loudness": -14.885,
   "Mode": 1,
   "Speechness": 0.0332,
   "Acousticness": 0.947,
   "Instrumentalness": 0.99,
   "Liveness": 0.196,
   "Valence": 0.036,
   "Tempo": 129.996,
   "Type": "audio_features",
   "ID": "3umPB0mGGOTDD8DD4KZRfj",
   "Uri": "spotify:track:3umPB0mGGOTDD8DD4KZRfj",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3umPB0mGGOTDD8DD4KZRfj",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3umPB0mGGOTDD8DD4KZRfj",
   "Duration_ms": 67173,
   "time_signature": 4,
   "Genre": "germanworship"
 },
 {
   
   "Name": "TheMomentBeforeYouFallAsleep",
   "Danceability": 0.143,
   "Energy": 0.51,
   "Key": 7,
   "Loudness": -16.237,
   "Mode": 1,
   "Speechness": 0.0547,
   "Acousticness": 0.439,
   "Instrumentalness": 0.952,
   "Liveness": 0.0923,
   "Valence": 0.0787,
   "Tempo": 72.598,
   "Type": "audio_features",
   "ID": "0C4oku99XL2QifSsSJ6cz1",
   "Uri": "spotify:track:0C4oku99XL2QifSsSJ6cz1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0C4oku99XL2QifSsSJ6cz1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0C4oku99XL2QifSsSJ6cz1",
   "Duration_ms": 508630,
   "time_signature": 4,
   "Genre": "darkambient"
 },
 {
   
   "Name": "Hentai",
   "Danceability": 0.496,
   "Energy": 0.76,
   "Key": 4,
   "Loudness": -4.281,
   "Mode": 1,
   "Speechness": 0.393,
   "Acousticness": 0.000799,
   "Instrumentalness": 0.00285,
   "Liveness": 0.368,
   "Valence": 0.422,
   "Tempo": 174.944,
   "Type": "audio_features",
   "ID": "6RvTtRyn7zVayLUWAJxd5Z",
   "Uri": "spotify:track:6RvTtRyn7zVayLUWAJxd5Z",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6RvTtRyn7zVayLUWAJxd5Z",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6RvTtRyn7zVayLUWAJxd5Z",
   "Duration_ms": 185831,
   "time_signature": 4,
   "Genre": "hardvapour"
 },
 {
   
   "Name": "N\\ImporteQuoi",
   "Danceability": 0.747,
   "Energy": 0.614,
   "Key": 2,
   "Loudness": -13.109,
   "Mode": 1,
   "Speechness": 0.191,
   "Acousticness": 0.0674,
   "Instrumentalness": 0.814,
   "Liveness": 0.0629,
   "Valence": 0.306,
   "Tempo": 107.012,
   "Type": "audio_features",
   "ID": "41bjqQmc0T5VssrktDQI1r",
   "Uri": "spotify:track:41bjqQmc0T5VssrktDQI1r",
   "Ref_Track": "https://api.spotify.com/v1/tracks/41bjqQmc0T5VssrktDQI1r",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/41bjqQmc0T5VssrktDQI1r",
   "Duration_ms": 448670,
   "time_signature": 4,
   "Genre": "deepidm"
 },
 {
   
   "Name": "NightForce",
   "Danceability": 0.531,
   "Energy": 0.711,
   "Key": 10,
   "Loudness": -9.412,
   "Mode": 0,
   "Speechness": 0.0386,
   "Acousticness": 0.00132,
   "Instrumentalness": 0.795,
   "Liveness": 0.273,
   "Valence": 0.24,
   "Tempo": 94.003,
   "Type": "audio_features",
   "ID": "09qzYWDA5M0Baw5Psi9fT0",
   "Uri": "spotify:track:09qzYWDA5M0Baw5Psi9fT0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/09qzYWDA5M0Baw5Psi9fT0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/09qzYWDA5M0Baw5Psi9fT0",
   "Duration_ms": 255319,
   "time_signature": 4,
   "Genre": "darkwave"
 },
 {
   
   "Name": "ThisIsHowItFeels",
   "Danceability": 0.465,
   "Energy": 0.863,
   "Key": 11,
   "Loudness": -5.85,
   "Mode": 1,
   "Speechness": 0.0445,
   "Acousticness": 0.00831,
   "Instrumentalness": 0.0000911,
   "Liveness": 0.199,
   "Valence": 0.342,
   "Tempo": 119.366,
   "Type": "audio_features",
   "ID": "7pulrplMgu0lEI4BBwXIdG",
   "Uri": "spotify:track:7pulrplMgu0lEI4BBwXIdG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7pulrplMgu0lEI4BBwXIdG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7pulrplMgu0lEI4BBwXIdG",
   "Duration_ms": 193333,
   "time_signature": 4,
   "Genre": "madchester"
 },
 {
   
   "Name": "SixSpeed",
   "Danceability": 0.51,
   "Energy": 0.327,
   "Key": 7,
   "Loudness": -6.154,
   "Mode": 1,
   "Speechness": 0.504,
   "Acousticness": 0.335,
   "Instrumentalness": 0,
   "Liveness": 0.119,
   "Valence": 0.523,
   "Tempo": 37.399,
   "Type": "audio_features",
   "ID": "38loOBAgDgCW4pFWyH9cey",
   "Uri": "spotify:track:38loOBAgDgCW4pFWyH9cey",
   "Ref_Track": "https://api.spotify.com/v1/tracks/38loOBAgDgCW4pFWyH9cey",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/38loOBAgDgCW4pFWyH9cey",
   "Duration_ms": 120000,
   "time_signature": 4,
   "Genre": "bedroompop"
 },
 {
   
   "Name": "MistaDegIgjen",
   "Danceability": 0.482,
   "Energy": 0.973,
   "Key": 9,
   "Loudness": -5.339,
   "Mode": 1,
   "Speechness": 0.0699,
   "Acousticness": 0.0000279,
   "Instrumentalness": 0,
   "Liveness": 0.241,
   "Valence": 0.485,
   "Tempo": 122.09,
   "Type": "audio_features",
   "ID": "01qjPA2X43WiOFDkRrr5WB",
   "Uri": "spotify:track:01qjPA2X43WiOFDkRrr5WB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/01qjPA2X43WiOFDkRrr5WB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/01qjPA2X43WiOFDkRrr5WB",
   "Duration_ms": 173176,
   "time_signature": 4,
   "Genre": "norwegianpunk"
 },
 {
   
   "Name": "ReunitedintheGrave",
   "Danceability": 0.39,
   "Energy": 0.61,
   "Key": 2,
   "Loudness": -7.622,
   "Mode": 0,
   "Speechness": 0.0324,
   "Acousticness": 0.0258,
   "Instrumentalness": 0.779,
   "Liveness": 0.382,
   "Valence": 0.0729,
   "Tempo": 99.823,
   "Type": "audio_features",
   "ID": "7ABSXwifPYaITe7cbAHOpV",
   "Uri": "spotify:track:7ABSXwifPYaITe7cbAHOpV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7ABSXwifPYaITe7cbAHOpV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7ABSXwifPYaITe7cbAHOpV",
   "Duration_ms": 653263,
   "time_signature": 4,
   "Genre": "funeraldoom"
 },
 {
   
   "Name": "JustALilBit",
   "Danceability": 0.489,
   "Energy": 0.692,
   "Key": 1,
   "Loudness": -6.672,
   "Mode": 1,
   "Speechness": 0.41,
   "Acousticness": 0.0322,
   "Instrumentalness": 0.00608,
   "Liveness": 0.315,
   "Valence": 0.527,
   "Tempo": 96.946,
   "Type": "audio_features",
   "ID": "0x7U32vZzq7e1qVpA0MBwK",
   "Uri": "spotify:track:0x7U32vZzq7e1qVpA0MBwK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0x7U32vZzq7e1qVpA0MBwK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0x7U32vZzq7e1qVpA0MBwK",
   "Duration_ms": 237707,
   "time_signature": 4,
   "Genre": "hiphouse"
 },
 {
   
   "Name": "HemdausHawaii",
   "Danceability": 0.481,
   "Energy": 0.882,
   "Key": 2,
   "Loudness": -3.803,
   "Mode": 1,
   "Speechness": 0.0661,
   "Acousticness": 0.0224,
   "Instrumentalness": 0,
   "Liveness": 0.238,
   "Valence": 0.6,
   "Tempo": 152.899,
   "Type": "audio_features",
   "ID": "69MCgtnZKlZdEvJNumrtui",
   "Uri": "spotify:track:69MCgtnZKlZdEvJNumrtui",
   "Ref_Track": "https://api.spotify.com/v1/tracks/69MCgtnZKlZdEvJNumrtui",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/69MCgtnZKlZdEvJNumrtui",
   "Duration_ms": 204806,
   "time_signature": 4,
   "Genre": "germanpop"
 },
 {
   
   "Name": "AnotherDay",
   "Danceability": 0.354,
   "Energy": 0.353,
   "Key": 8,
   "Loudness": -9.475,
   "Mode": 0,
   "Speechness": 0.0318,
   "Acousticness": 0.838,
   "Instrumentalness": 0.933,
   "Liveness": 0.117,
   "Valence": 0.326,
   "Tempo": 140.393,
   "Type": "audio_features",
   "ID": "0xKy7WHdqw3X3iG9T87c3X",
   "Uri": "spotify:track:0xKy7WHdqw3X3iG9T87c3X",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0xKy7WHdqw3X3iG9T87c3X",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0xKy7WHdqw3X3iG9T87c3X",
   "Duration_ms": 352613,
   "time_signature": 5,
   "Genre": "finnishjazz"
 },
 {
   
   "Name": "MyQueenIsAdaEastman",
   "Danceability": 0.658,
   "Energy": 0.835,
   "Key": 6,
   "Loudness": -6.315,
   "Mode": 1,
   "Speechness": 0.113,
   "Acousticness": 0.65,
   "Instrumentalness": 0.0222,
   "Liveness": 0.0995,
   "Valence": 0.734,
   "Tempo": 72.972,
   "Type": "audio_features",
   "ID": "1GeEoY31g28aDRzJ3sLLN9",
   "Uri": "spotify:track:1GeEoY31g28aDRzJ3sLLN9",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1GeEoY31g28aDRzJ3sLLN9",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1GeEoY31g28aDRzJ3sLLN9",
   "Duration_ms": 399760,
   "time_signature": 4,
   "Genre": "britishjazz"
 },
 {
   
   "Name": "RunningWater",
   "Danceability": 0.435,
   "Energy": 0.281,
   "Key": 9,
   "Loudness": -14.766,
   "Mode": 0,
   "Speechness": 0.0423,
   "Acousticness": 0.974,
   "Instrumentalness": 0.682,
   "Liveness": 0.0829,
   "Valence": 0.265,
   "Tempo": 71.96,
   "Type": "audio_features",
   "ID": "7EZEs8MEPOs0Ze5qzt036f",
   "Uri": "spotify:track:7EZEs8MEPOs0Ze5qzt036f",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7EZEs8MEPOs0Ze5qzt036f",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7EZEs8MEPOs0Ze5qzt036f",
   "Duration_ms": 446893,
   "time_signature": 4,
   "Genre": "chineseguzheng"
 },
 {
   
   "Name": "Obsessed",
   "Danceability": 0.582,
   "Energy": 0.826,
   "Key": 11,
   "Loudness": -4.599,
   "Mode": 0,
   "Speechness": 0.0612,
   "Acousticness": 0.0614,
   "Instrumentalness": 0.0000027,
   "Liveness": 0.108,
   "Valence": 0.201,
   "Tempo": 117.948,
   "Type": "audio_features",
   "ID": "7p4tetW3qNwSCz92PLGJg5",
   "Uri": "spotify:track:7p4tetW3qNwSCz92PLGJg5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7p4tetW3qNwSCz92PLGJg5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7p4tetW3qNwSCz92PLGJg5",
   "Duration_ms": 209933,
   "time_signature": 4,
   "Genre": "deepgroovehouse"
 },
 {
   
   "Name": "WorthDyingFor",
   "Danceability": 0.212,
   "Energy": 0.986,
   "Key": 1,
   "Loudness": -3.788,
   "Mode": 0,
   "Speechness": 0.226,
   "Acousticness": 0.000129,
   "Instrumentalness": 0.0000262,
   "Liveness": 0.343,
   "Valence": 0.357,
   "Tempo": 172.295,
   "Type": "audio_features",
   "ID": "2cb4GyN7uKLMOezKYREPMT",
   "Uri": "spotify:track:2cb4GyN7uKLMOezKYREPMT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2cb4GyN7uKLMOezKYREPMT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2cb4GyN7uKLMOezKYREPMT",
   "Duration_ms": 200000,
   "time_signature": 4,
   "Genre": "indiegaragerock"
 },
 {
   
   "Name": "CountYourBlessing",
   "Danceability": 0.527,
   "Energy": 0.826,
   "Key": 1,
   "Loudness": -3.994,
   "Mode": 0,
   "Speechness": 0.61,
   "Acousticness": 0.547,
   "Instrumentalness": 0.00000205,
   "Liveness": 0.739,
   "Valence": 0.875,
   "Tempo": 180.077,
   "Type": "audio_features",
   "ID": "19qwZ5gdugFmfnAMf5cNEp",
   "Uri": "spotify:track:19qwZ5gdugFmfnAMf5cNEp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/19qwZ5gdugFmfnAMf5cNEp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/19qwZ5gdugFmfnAMf5cNEp",
   "Duration_ms": 178462,
   "time_signature": 4,
   "Genre": "indonesianhiphop"
 },
 {
   
   "Name": "MyFantasy(PartDeux)",
   "Danceability": 0.828,
   "Energy": 0.824,
   "Key": 1,
   "Loudness": -5.613,
   "Mode": 0,
   "Speechness": 0.0523,
   "Acousticness": 0.0553,
   "Instrumentalness": 0.385,
   "Liveness": 0.0685,
   "Valence": 0.965,
   "Tempo": 128.003,
   "Type": "audio_features",
   "ID": "6xxXp7YylWQY8mc3CwRSp3",
   "Uri": "spotify:track:6xxXp7YylWQY8mc3CwRSp3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6xxXp7YylWQY8mc3CwRSp3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6xxXp7YylWQY8mc3CwRSp3",
   "Duration_ms": 307953,
   "time_signature": 4,
   "Genre": "vegasindie"
 },
 {
   
   "Name": "OneMoreTime",
   "Danceability": 0.611,
   "Energy": 0.697,
   "Key": 2,
   "Loudness": -8.618,
   "Mode": 1,
   "Speechness": 0.133,
   "Acousticness": 0.0193,
   "Instrumentalness": 0,
   "Liveness": 0.332,
   "Valence": 0.476,
   "Tempo": 122.752,
   "Type": "audio_features",
   "ID": "0DiWol3AO6WpXZgp0goxAV",
   "Uri": "spotify:track:0DiWol3AO6WpXZgp0goxAV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0DiWol3AO6WpXZgp0goxAV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0DiWol3AO6WpXZgp0goxAV",
   "Duration_ms": 320357,
   "time_signature": 4,
   "Genre": "frenchpunk"
 },
 {
   
   "Name": "You\\reSomebodyElse",
   "Danceability": 0.713,
   "Energy": 0.451,
   "Key": 1,
   "Loudness": -9.64,
   "Mode": 1,
   "Speechness": 0.0294,
   "Acousticness": 0.844,
   "Instrumentalness": 0.00317,
   "Liveness": 0.105,
   "Valence": 0.238,
   "Tempo": 102.972,
   "Type": "audio_features",
   "ID": "1tweNeMlwxfeoOXklVibnf",
   "Uri": "spotify:track:1tweNeMlwxfeoOXklVibnf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1tweNeMlwxfeoOXklVibnf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1tweNeMlwxfeoOXklVibnf",
   "Duration_ms": 218883,
   "time_signature": 4,
   "Genre": "deepindierock"
 },
 {
   
   "Name": "YouAreHoly(PrinceofPeace)",
   "Danceability": 0.579,
   "Energy": 0.3,
   "Key": 5,
   "Loudness": -8.223,
   "Mode": 1,
   "Speechness": 0.0293,
   "Acousticness": 0.806,
   "Instrumentalness": 0,
   "Liveness": 0.117,
   "Valence": 0.653,
   "Tempo": 71.969,
   "Type": "audio_features",
   "ID": "0OfvvG92RcjFnYPqYo3yIz",
   "Uri": "spotify:track:0OfvvG92RcjFnYPqYo3yIz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0OfvvG92RcjFnYPqYo3yIz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0OfvvG92RcjFnYPqYo3yIz",
   "Duration_ms": 207280,
   "time_signature": 5,
   "Genre": "christianacappella"
 },
 {
   
   "Name": "WilliamTell(GuillaumeTell)Overture:Finale[Arr.forEuphoniumbyJorijnVanHese]",
   "Danceability": 0.561,
   "Energy": 0.236,
   "Key": 0,
   "Loudness": -27.926,
   "Mode": 1,
   "Speechness": 0.0491,
   "Acousticness": 0.995,
   "Instrumentalness": 0.934,
   "Liveness": 0.121,
   "Valence": 0.964,
   "Tempo": 102.216,
   "Type": "audio_features",
   "ID": "1I5L8EAVFpTnSAYptTJVrU",
   "Uri": "spotify:track:1I5L8EAVFpTnSAYptTJVrU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1I5L8EAVFpTnSAYptTJVrU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1I5L8EAVFpTnSAYptTJVrU",
   "Duration_ms": 120080,
   "time_signature": 4,
   "Genre": "classicalbaritone"
 },
 {
   
   "Name": "Pavanaallavenetiana",
   "Danceability": 0.422,
   "Energy": 0.083,
   "Key": 2,
   "Loudness": -27.478,
   "Mode": 1,
   "Speechness": 0.0519,
   "Acousticness": 0.995,
   "Instrumentalness": 0.876,
   "Liveness": 0.123,
   "Valence": 0.496,
   "Tempo": 146.543,
   "Type": "audio_features",
   "ID": "3bt86zHn4Ac5AH121ZU7YO",
   "Uri": "spotify:track:3bt86zHn4Ac5AH121ZU7YO",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3bt86zHn4Ac5AH121ZU7YO",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3bt86zHn4Ac5AH121ZU7YO",
   "Duration_ms": 206533,
   "time_signature": 4,
   "Genre": "italianrenaissance"
 },
 {
   
   "Name": "B2B",
   "Danceability": 0.661,
   "Energy": 0.978,
   "Key": 11,
   "Loudness": -4.328,
   "Mode": 0,
   "Speechness": 0.0629,
   "Acousticness": 0.000345,
   "Instrumentalness": 0.894,
   "Liveness": 0.0438,
   "Valence": 0.148,
   "Tempo": 127.966,
   "Type": "audio_features",
   "ID": "4xXMhdoD5UrDTjs2mbdbjQ",
   "Uri": "spotify:track:4xXMhdoD5UrDTjs2mbdbjQ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4xXMhdoD5UrDTjs2mbdbjQ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4xXMhdoD5UrDTjs2mbdbjQ",
   "Duration_ms": 395791,
   "time_signature": 4,
   "Genre": "darkprogressivehouse"
 },
 {
   
   "Name": "Yarilo",
   "Danceability": 0.512,
   "Energy": 0.943,
   "Key": 1,
   "Loudness": -3.612,
   "Mode": 0,
   "Speechness": 0.036,
   "Acousticness": 0.0103,
   "Instrumentalness": 0.00000832,
   "Liveness": 0.116,
   "Valence": 0.83,
   "Tempo": 150.078,
   "Type": "audio_features",
   "ID": "4yGUqYYQiNAdUJXeSMbjCL",
   "Uri": "spotify:track:4yGUqYYQiNAdUJXeSMbjCL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4yGUqYYQiNAdUJXeSMbjCL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4yGUqYYQiNAdUJXeSMbjCL",
   "Duration_ms": 151040,
   "time_signature": 4,
   "Genre": "slavicmetal"
 },
 {
   
   "Name": "Loomer-RemasteredVersion",
   "Danceability": 0.21,
   "Energy": 0.518,
   "Key": 3,
   "Loudness": -12.591,
   "Mode": 1,
   "Speechness": 0.0362,
   "Acousticness": 0.00000175,
   "Instrumentalness": 0.874,
   "Liveness": 0.133,
   "Valence": 0.375,
   "Tempo": 152.294,
   "Type": "audio_features",
   "ID": "4z8GgIwK12UE8tZd2E4myL",
   "Uri": "spotify:track:4z8GgIwK12UE8tZd2E4myL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4z8GgIwK12UE8tZd2E4myL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4z8GgIwK12UE8tZd2E4myL",
   "Duration_ms": 158240,
   "time_signature": 3,
   "Genre": "uknoiserock"
 },
 {
   
   "Name": "Carrollton",
   "Danceability": 0.844,
   "Energy": 0.52,
   "Key": 5,
   "Loudness": -10.626,
   "Mode": 0,
   "Speechness": 0.533,
   "Acousticness": 0.00221,
   "Instrumentalness": 0.00122,
   "Liveness": 0.7,
   "Valence": 0.289,
   "Tempo": 149.995,
   "Type": "audio_features",
   "ID": "1T3cZ3XAnIjc9M91bhshcu",
   "Uri": "spotify:track:1T3cZ3XAnIjc9M91bhshcu",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1T3cZ3XAnIjc9M91bhshcu",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1T3cZ3XAnIjc9M91bhshcu",
   "Duration_ms": 203897,
   "time_signature": 4,
   "Genre": "darktrap"
 },
 {
   
   "Name": "Ilcoccodrillocomefa?",
   "Danceability": 0.907,
   "Energy": 0.761,
   "Key": 2,
   "Loudness": -4.749,
   "Mode": 1,
   "Speechness": 0.0395,
   "Acousticness": 0.283,
   "Instrumentalness": 0.000626,
   "Liveness": 0.0734,
   "Valence": 0.947,
   "Tempo": 114.948,
   "Type": "audio_features",
   "ID": "1dDdFKGtWXd0nOlzBTQqK3",
   "Uri": "spotify:track:1dDdFKGtWXd0nOlzBTQqK3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1dDdFKGtWXd0nOlzBTQqK3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1dDdFKGtWXd0nOlzBTQqK3",
   "Duration_ms": 195773,
   "time_signature": 4,
   "Genre": "musicaperbambini"
 },
 {
   
   "Name": "SmoothOperator",
   "Danceability": 0.891,
   "Energy": 0.319,
   "Key": 4,
   "Loudness": -16.099,
   "Mode": 0,
   "Speechness": 0.333,
   "Acousticness": 0.0933,
   "Instrumentalness": 0.000104,
   "Liveness": 0.0482,
   "Valence": 0.687,
   "Tempo": 92.649,
   "Type": "audio_features",
   "ID": "1Z4mVNtYGnpjHUoZVo3IMU",
   "Uri": "spotify:track:1Z4mVNtYGnpjHUoZVo3IMU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Z4mVNtYGnpjHUoZVo3IMU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Z4mVNtYGnpjHUoZVo3IMU",
   "Duration_ms": 284467,
   "time_signature": 4,
   "Genre": "earlymusic"
 },
 {
   
   "Name": "0.0",
   "Danceability": 0.208,
   "Energy": 0.347,
   "Key": 11,
   "Loudness": -15.558,
   "Mode": 0,
   "Speechness": 0.0357,
   "Acousticness": 0.605,
   "Instrumentalness": 0.951,
   "Liveness": 0.105,
   "Valence": 0.039,
   "Tempo": 92.177,
   "Type": "audio_features",
   "ID": "6Q3Li9g6IuVSrE1IM8L2gn",
   "Uri": "spotify:track:6Q3Li9g6IuVSrE1IM8L2gn",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6Q3Li9g6IuVSrE1IM8L2gn",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6Q3Li9g6IuVSrE1IM8L2gn",
   "Duration_ms": 74644,
   "time_signature": 4,
   "Genre": "atmosphericpost-metal"
 },
 {
   
   "Name": "Dead-EndedLives",
   "Danceability": 0.321,
   "Energy": 0.9,
   "Key": 11,
   "Loudness": -8.197,
   "Mode": 0,
   "Speechness": 0.0446,
   "Acousticness": 0.0000251,
   "Instrumentalness": 0.425,
   "Liveness": 0.264,
   "Valence": 0.548,
   "Tempo": 154.882,
   "Type": "audio_features",
   "ID": "42jsn7AqtJXj7VFiiYxOEA",
   "Uri": "spotify:track:42jsn7AqtJXj7VFiiYxOEA",
   "Ref_Track": "https://api.spotify.com/v1/tracks/42jsn7AqtJXj7VFiiYxOEA",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/42jsn7AqtJXj7VFiiYxOEA",
   "Duration_ms": 197634,
   "time_signature": 4,
   "Genre": "rvaindie"
 },
 {
   
   "Name": "BarbieGirl",
   "Danceability": 0.814,
   "Energy": 0.955,
   "Key": 1,
   "Loudness": -5.905,
   "Mode": 0,
   "Speechness": 0.0377,
   "Acousticness": 0.0146,
   "Instrumentalness": 0.283,
   "Liveness": 0.218,
   "Valence": 0.963,
   "Tempo": 129.992,
   "Type": "audio_features",
   "ID": "2RSOzvKUnfDDrb2nQPfpQU",
   "Uri": "spotify:track:2RSOzvKUnfDDrb2nQPfpQU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2RSOzvKUnfDDrb2nQPfpQU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2RSOzvKUnfDDrb2nQPfpQU",
   "Duration_ms": 197773,
   "time_signature": 4,
   "Genre": "danishpop"
 },
 {
   
   "Name": "OuviDizer",
   "Danceability": 0.526,
   "Energy": 0.54,
   "Key": 4,
   "Loudness": -6.587,
   "Mode": 1,
   "Speechness": 0.0261,
   "Acousticness": 0.485,
   "Instrumentalness": 0,
   "Liveness": 0.0962,
   "Valence": 0.384,
   "Tempo": 82.021,
   "Type": "audio_features",
   "ID": "73nNXl2PZ1Z6j2pbfl8N8R",
   "Uri": "spotify:track:73nNXl2PZ1Z6j2pbfl8N8R",
   "Ref_Track": "https://api.spotify.com/v1/tracks/73nNXl2PZ1Z6j2pbfl8N8R",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/73nNXl2PZ1Z6j2pbfl8N8R",
   "Duration_ms": 230907,
   "time_signature": 4,
   "Genre": "portugueserock"
 },
 {
   
   "Name": "Hello",
   "Danceability": 0.712,
   "Energy": 0.565,
   "Key": 2,
   "Loudness": -7.404,
   "Mode": 1,
   "Speechness": 0.0313,
   "Acousticness": 0.401,
   "Instrumentalness": 0.000322,
   "Liveness": 0.0792,
   "Valence": 0.679,
   "Tempo": 120.042,
   "Type": "audio_features",
   "ID": "7kr1ixLomPOwbQAAHaetXw",
   "Uri": "spotify:track:7kr1ixLomPOwbQAAHaetXw",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7kr1ixLomPOwbQAAHaetXw",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7kr1ixLomPOwbQAAHaetXw",
   "Duration_ms": 144707,
   "time_signature": 4,
   "Genre": "indianindie"
 },
 {
   
   "Name": "FadeIntoYou",
   "Danceability": 0.42,
   "Energy": 0.33,
   "Key": 9,
   "Loudness": -13.925,
   "Mode": 1,
   "Speechness": 0.0275,
   "Acousticness": 0.245,
   "Instrumentalness": 0.000679,
   "Liveness": 0.0677,
   "Valence": 0.175,
   "Tempo": 157.143,
   "Type": "audio_features",
   "ID": "1LzNfuep1bnAUR9skqdHCK",
   "Uri": "spotify:track:1LzNfuep1bnAUR9skqdHCK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1LzNfuep1bnAUR9skqdHCK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1LzNfuep1bnAUR9skqdHCK",
   "Duration_ms": 295600,
   "time_signature": 3,
   "Genre": "milanindie"
 },
 {
   
   "Name": "It\\sNotEasy",
   "Danceability": 0.569,
   "Energy": 0.696,
   "Key": 2,
   "Loudness": -9.304,
   "Mode": 1,
   "Speechness": 0.041,
   "Acousticness": 0.392,
   "Instrumentalness": 0.000038,
   "Liveness": 0.115,
   "Valence": 0.537,
   "Tempo": 80.324,
   "Type": "audio_features",
   "ID": "4rrvdFAql8jw5BgLB8qBJM",
   "Uri": "spotify:track:4rrvdFAql8jw5BgLB8qBJM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4rrvdFAql8jw5BgLB8qBJM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4rrvdFAql8jw5BgLB8qBJM",
   "Duration_ms": 265493,
   "time_signature": 4,
   "Genre": "afropsych"
 },
 {
   
   "Name": "Chip",
   "Danceability": 0.426,
   "Energy": 0.888,
   "Key": 5,
   "Loudness": -5.639,
   "Mode": 1,
   "Speechness": 0.0421,
   "Acousticness": 0.00311,
   "Instrumentalness": 0,
   "Liveness": 0.0768,
   "Valence": 0.903,
   "Tempo": 159.972,
   "Type": "audio_features",
   "ID": "2SnZayZg4eTZ4592TmK6CN",
   "Uri": "spotify:track:2SnZayZg4eTZ4592TmK6CN",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2SnZayZg4eTZ4592TmK6CN",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2SnZayZg4eTZ4592TmK6CN",
   "Duration_ms": 194453,
   "time_signature": 4,
   "Genre": "celtic"
 },
 {
   
   "Name": "RannaI",
   "Danceability": 0.28,
   "Energy": 0.0123,
   "Key": 7,
   "Loudness": -30.466,
   "Mode": 0,
   "Speechness": 0.0345,
   "Acousticness": 0.992,
   "Instrumentalness": 0.936,
   "Liveness": 0.0978,
   "Valence": 0.0337,
   "Tempo": 82.206,
   "Type": "audio_features",
   "ID": "0srnfIuDWbYSJqIWjYXtmQ",
   "Uri": "spotify:track:0srnfIuDWbYSJqIWjYXtmQ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0srnfIuDWbYSJqIWjYXtmQ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0srnfIuDWbYSJqIWjYXtmQ",
   "Duration_ms": 180333,
   "time_signature": 4,
   "Genre": "estonianjazz"
 },
 {
   
   "Name": "LaCumparsita",
   "Danceability": 0.525,
   "Energy": 0.577,
   "Key": 7,
   "Loudness": -5.76,
   "Mode": 0,
   "Speechness": 0.0423,
   "Acousticness": 0.685,
   "Instrumentalness": 0.298,
   "Liveness": 0.316,
   "Valence": 0.671,
   "Tempo": 143.424,
   "Type": "audio_features",
   "ID": "1E5GuOBWrG2h10lyl4RthU",
   "Uri": "spotify:track:1E5GuOBWrG2h10lyl4RthU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1E5GuOBWrG2h10lyl4RthU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1E5GuOBWrG2h10lyl4RthU",
   "Duration_ms": 131893,
   "time_signature": 3,
   "Genre": "tango"
 },
 {
   
   "Name": "VivirBailando",
   "Danceability": 0.846,
   "Energy": 0.848,
   "Key": 5,
   "Loudness": -4.752,
   "Mode": 1,
   "Speechness": 0.121,
   "Acousticness": 0.104,
   "Instrumentalness": 0,
   "Liveness": 0.0837,
   "Valence": 0.553,
   "Tempo": 91.971,
   "Type": "audio_features",
   "ID": "7gL0eIncXB5ELO8BFMR3Uv",
   "Uri": "spotify:track:7gL0eIncXB5ELO8BFMR3Uv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7gL0eIncXB5ELO8BFMR3Uv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7gL0eIncXB5ELO8BFMR3Uv",
   "Duration_ms": 214413,
   "time_signature": 4,
   "Genre": "nuevacancion"
 },
 {
   
   "Name": "PalomoEnLata(feat.LapizConciente&MonkeyBlack)",
   "Danceability": 0.723,
   "Energy": 0.88,
   "Key": 7,
   "Loudness": -5.589,
   "Mode": 1,
   "Speechness": 0.31,
   "Acousticness": 0.0638,
   "Instrumentalness": 0,
   "Liveness": 0.228,
   "Valence": 0.803,
   "Tempo": 93.798,
   "Type": "audio_features",
   "ID": "6Y2TrEFWvCRWCZo3g93N7T",
   "Uri": "spotify:track:6Y2TrEFWvCRWCZo3g93N7T",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6Y2TrEFWvCRWCZo3g93N7T",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6Y2TrEFWvCRWCZo3g93N7T",
   "Duration_ms": 328147,
   "time_signature": 4,
   "Genre": "rapdominicano"
 },
 {
   
   "Name": "Faceswap",
   "Danceability": 0.646,
   "Energy": 0.862,
   "Key": 1,
   "Loudness": -2.09,
   "Mode": 0,
   "Speechness": 0.36,
   "Acousticness": 0.0268,
   "Instrumentalness": 0.0033,
   "Liveness": 0.113,
   "Valence": 0.425,
   "Tempo": 143.425,
   "Type": "audio_features",
   "ID": "102axnvJyoQo7pKiFcwKqX",
   "Uri": "spotify:track:102axnvJyoQo7pKiFcwKqX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/102axnvJyoQo7pKiFcwKqX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/102axnvJyoQo7pKiFcwKqX",
   "Duration_ms": 198662,
   "time_signature": 4,
   "Genre": "riddim"
 },
 {
   
   "Name": "WhiletheFurnaceBurns",
   "Danceability": 0.424,
   "Energy": 0.972,
   "Key": 10,
   "Loudness": -3.42,
   "Mode": 1,
   "Speechness": 0.0791,
   "Acousticness": 0.0000194,
   "Instrumentalness": 0.437,
   "Liveness": 0.0486,
   "Valence": 0.0586,
   "Tempo": 110.15,
   "Type": "audio_features",
   "ID": "25UER7vBSYvDJ4hinkGaJv",
   "Uri": "spotify:track:25UER7vBSYvDJ4hinkGaJv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/25UER7vBSYvDJ4hinkGaJv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/25UER7vBSYvDJ4hinkGaJv",
   "Duration_ms": 222500,
   "time_signature": 4,
   "Genre": "swedishdeathmetal"
 },
 {
   
   "Name": "DialecticChaos",
   "Danceability": 0.16,
   "Energy": 0.982,
   "Key": 0,
   "Loudness": -2.715,
   "Mode": 1,
   "Speechness": 0.0761,
   "Acousticness": 0.0000028,
   "Instrumentalness": 0.847,
   "Liveness": 0.0996,
   "Valence": 0.216,
   "Tempo": 83.458,
   "Type": "audio_features",
   "ID": "2Sl9U6mLbNeaE9lT9C32Td",
   "Uri": "spotify:track:2Sl9U6mLbNeaE9lT9C32Td",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Sl9U6mLbNeaE9lT9C32Td",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Sl9U6mLbNeaE9lT9C32Td",
   "Duration_ms": 145813,
   "time_signature": 4,
   "Genre": "instrumentalprogressivemetal"
 },
 {
   
   "Name": "TheMotorcycleDiaries:DeUsuahiaalaQuiaca(arr.V.Bessasforguitarquartet)",
   "Danceability": 0.5,
   "Energy": 0.146,
   "Key": 7,
   "Loudness": -23.401,
   "Mode": 0,
   "Speechness": 0.0552,
   "Acousticness": 0.978,
   "Instrumentalness": 0.873,
   "Liveness": 0.106,
   "Valence": 0.296,
   "Tempo": 150.587,
   "Type": "audio_features",
   "ID": "73m96RXitMHNbS76gtxONY",
   "Uri": "spotify:track:73m96RXitMHNbS76gtxONY",
   "Ref_Track": "https://api.spotify.com/v1/tracks/73m96RXitMHNbS76gtxONY",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/73m96RXitMHNbS76gtxONY",
   "Duration_ms": 170000,
   "time_signature": 4,
   "Genre": "classicalguitarquartet"
 },
 {
   
   "Name": "MuaDemNgoaiO",
   "Danceability": 0.477,
   "Energy": 0.471,
   "Key": 9,
   "Loudness": -5.774,
   "Mode": 0,
   "Speechness": 0.0317,
   "Acousticness": 0.495,
   "Instrumentalness": 0,
   "Liveness": 0.0825,
   "Valence": 0.294,
   "Tempo": 81.924,
   "Type": "audio_features",
   "ID": "5PT2zOxWA2incgqW3sJ6n0",
   "Uri": "spotify:track:5PT2zOxWA2incgqW3sJ6n0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5PT2zOxWA2incgqW3sJ6n0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5PT2zOxWA2incgqW3sJ6n0",
   "Duration_ms": 368067,
   "time_signature": 4,
   "Genre": "vietnamesebolero"
 },
 {
   
   "Name": "NoBailesDeCaballito",
   "Danceability": 0.892,
   "Energy": 0.768,
   "Key": 5,
   "Loudness": -6.011,
   "Mode": 1,
   "Speechness": 0.131,
   "Acousticness": 0.147,
   "Instrumentalness": 0,
   "Liveness": 0.282,
   "Valence": 0.906,
   "Tempo": 135.091,
   "Type": "audio_features",
   "ID": "3PTfu2zsB5IH0nTu9vP8iR",
   "Uri": "spotify:track:3PTfu2zsB5IH0nTu9vP8iR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3PTfu2zsB5IH0nTu9vP8iR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3PTfu2zsB5IH0nTu9vP8iR",
   "Duration_ms": 241453,
   "time_signature": 4,
   "Genre": "deepnorteno"
 },
 {
   
   "Name": "TheGivingTree",
   "Danceability": 0.222,
   "Energy": 0.857,
   "Key": 9,
   "Loudness": -5.085,
   "Mode": 0,
   "Speechness": 0.0457,
   "Acousticness": 0.0000998,
   "Instrumentalness": 0.613,
   "Liveness": 0.11,
   "Valence": 0.0699,
   "Tempo": 100.013,
   "Type": "audio_features",
   "ID": "238fv8we4yuwuw71KLgcpQ",
   "Uri": "spotify:track:238fv8we4yuwuw71KLgcpQ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/238fv8we4yuwuw71KLgcpQ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/238fv8we4yuwuw71KLgcpQ",
   "Duration_ms": 363280,
   "time_signature": 4,
   "Genre": "post-metal"
 },
 {
   
   "Name": "Clockworks",
   "Danceability": 0.228,
   "Energy": 0.98,
   "Key": 1,
   "Loudness": -5.313,
   "Mode": 1,
   "Speechness": 0.11,
   "Acousticness": 0.00000201,
   "Instrumentalness": 0.833,
   "Liveness": 0.289,
   "Valence": 0.364,
   "Tempo": 129.939,
   "Type": "audio_features",
   "ID": "5Q5JuwRUZQVNXTCoAkjgQf",
   "Uri": "spotify:track:5Q5JuwRUZQVNXTCoAkjgQf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5Q5JuwRUZQVNXTCoAkjgQf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5Q5JuwRUZQVNXTCoAkjgQf",
   "Duration_ms": 435040,
   "time_signature": 1,
   "Genre": "mathcore"
 },
 {
   
   "Name": "ActIII",
   "Danceability": 0.425,
   "Energy": 0.38,
   "Key": 7,
   "Loudness": -11.536,
   "Mode": 1,
   "Speechness": 0.0565,
   "Acousticness": 0.757,
   "Instrumentalness": 0,
   "Liveness": 0.221,
   "Valence": 0.475,
   "Tempo": 114.147,
   "Type": "audio_features",
   "ID": "3CEf0o1RxlL8gQXxVtNOGW",
   "Uri": "spotify:track:3CEf0o1RxlL8gQXxVtNOGW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3CEf0o1RxlL8gQXxVtNOGW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3CEf0o1RxlL8gQXxVtNOGW",
   "Duration_ms": 1310933,
   "time_signature": 4,
   "Genre": "chineseopera"
 },
 {
   
   "Name": "PONPONPON",
   "Danceability": 0.776,
   "Energy": 0.949,
   "Key": 4,
   "Loudness": -1.754,
   "Mode": 1,
   "Speechness": 0.0541,
   "Acousticness": 0.018,
   "Instrumentalness": 0.0000149,
   "Liveness": 0.0733,
   "Valence": 0.955,
   "Tempo": 130.009,
   "Type": "audio_features",
   "ID": "5HIAwcfisXSHCoVpSwAPz1",
   "Uri": "spotify:track:5HIAwcfisXSHCoVpSwAPz1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5HIAwcfisXSHCoVpSwAPz1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5HIAwcfisXSHCoVpSwAPz1",
   "Duration_ms": 126231,
   "time_signature": 4,
   "Genre": "chiptune"
 },
 {
   
   "Name": "MusicIsMath",
   "Danceability": 0.542,
   "Energy": 0.799,
   "Key": 2,
   "Loudness": -11.021,
   "Mode": 1,
   "Speechness": 0.0414,
   "Acousticness": 0.0682,
   "Instrumentalness": 0.932,
   "Liveness": 0.461,
   "Valence": 0.116,
   "Tempo": 99.976,
   "Type": "audio_features",
   "ID": "3vBJYnujT3yxLjLEG1jtDS",
   "Uri": "spotify:track:3vBJYnujT3yxLjLEG1jtDS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3vBJYnujT3yxLjLEG1jtDS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3vBJYnujT3yxLjLEG1jtDS",
   "Duration_ms": 321453,
   "time_signature": 4,
   "Genre": "abstractidm"
 },
 {
   
   "Name": "ElOcasodelosDioses:MarchaFunebre",
   "Danceability": 0.065,
   "Energy": 0.0338,
   "Key": 5,
   "Loudness": -19.016,
   "Mode": 0,
   "Speechness": 0.037,
   "Acousticness": 0.955,
   "Instrumentalness": 0.932,
   "Liveness": 0.083,
   "Valence": 0.036,
   "Tempo": 64.713,
   "Type": "audio_features",
   "ID": "03MuaTeGqu2svkbJ3xWOJK",
   "Uri": "spotify:track:03MuaTeGqu2svkbJ3xWOJK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/03MuaTeGqu2svkbJ3xWOJK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/03MuaTeGqu2svkbJ3xWOJK",
   "Duration_ms": 463747,
   "time_signature": 3,
   "Genre": "marchafunebre"
 },
 {
   
   "Name": "TheHardshipoftheScots",
   "Danceability": 0.156,
   "Energy": 0.886,
   "Key": 0,
   "Loudness": -8.091,
   "Mode": 1,
   "Speechness": 0.0598,
   "Acousticness": 0.00000367,
   "Instrumentalness": 0.789,
   "Liveness": 0.283,
   "Valence": 0.122,
   "Tempo": 106.934,
   "Type": "audio_features",
   "ID": "16Pxep5FcmK6YTm3gOPo3n",
   "Uri": "spotify:track:16Pxep5FcmK6YTm3gOPo3n",
   "Ref_Track": "https://api.spotify.com/v1/tracks/16Pxep5FcmK6YTm3gOPo3n",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/16Pxep5FcmK6YTm3gOPo3n",
   "Duration_ms": 455500,
   "time_signature": 4,
   "Genre": "darkblackmetal"
 },
 {
   
   "Name": "Hypnotize",
   "Danceability": 0.695,
   "Energy": 0.715,
   "Key": 7,
   "Loudness": -12.992,
   "Mode": 1,
   "Speechness": 0.0471,
   "Acousticness": 0.0643,
   "Instrumentalness": 0.845,
   "Liveness": 0.276,
   "Valence": 0.0285,
   "Tempo": 128.012,
   "Type": "audio_features",
   "ID": "3NPaD6SlCVvjMJE46I7KoS",
   "Uri": "spotify:track:3NPaD6SlCVvjMJE46I7KoS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3NPaD6SlCVvjMJE46I7KoS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3NPaD6SlCVvjMJE46I7KoS",
   "Duration_ms": 396276,
   "time_signature": 4,
   "Genre": "hardminimaltechno"
 },
 {
   
   "Name": "ElectricPowWowDrum",
   "Danceability": 0.658,
   "Energy": 0.573,
   "Key": 3,
   "Loudness": -5.408,
   "Mode": 0,
   "Speechness": 0.107,
   "Acousticness": 0.023,
   "Instrumentalness": 0.0613,
   "Liveness": 0.0981,
   "Valence": 0.583,
   "Tempo": 133.442,
   "Type": "audio_features",
   "ID": "5e8v4ibmsMHxHLALe5KaiZ",
   "Uri": "spotify:track:5e8v4ibmsMHxHLALe5KaiZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5e8v4ibmsMHxHLALe5KaiZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5e8v4ibmsMHxHLALe5KaiZ",
   "Duration_ms": 219853,
   "time_signature": 4,
   "Genre": "nativeamericanhiphop"
 },
 {
   
   "Name": "SweetDarlin",
   "Danceability": 0.7,
   "Energy": 0.62,
   "Key": 0,
   "Loudness": -5.822,
   "Mode": 1,
   "Speechness": 0.0264,
   "Acousticness": 0.00242,
   "Instrumentalness": 0,
   "Liveness": 0.111,
   "Valence": 0.767,
   "Tempo": 80.095,
   "Type": "audio_features",
   "ID": "3dEiAE9GQ4Go6LbOWCm5r5",
   "Uri": "spotify:track:3dEiAE9GQ4Go6LbOWCm5r5",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3dEiAE9GQ4Go6LbOWCm5r5",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3dEiAE9GQ4Go6LbOWCm5r5",
   "Duration_ms": 272280,
   "time_signature": 4,
   "Genre": "polynesianpop"
 },
 {
   
   "Name": "CommitteeCircus",
   "Danceability": 0.486,
   "Energy": 0.969,
   "Key": 1,
   "Loudness": -4.477,
   "Mode": 1,
   "Speechness": 0.149,
   "Acousticness": 0.00077,
   "Instrumentalness": 0.00000383,
   "Liveness": 0.225,
   "Valence": 0.548,
   "Tempo": 92.634,
   "Type": "audio_features",
   "ID": "6KiTZ39ZpPoVjjs9hDXKd2",
   "Uri": "spotify:track:6KiTZ39ZpPoVjjs9hDXKd2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6KiTZ39ZpPoVjjs9hDXKd2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6KiTZ39ZpPoVjjs9hDXKd2",
   "Duration_ms": 195333,
   "time_signature": 4,
   "Genre": "noisepop"
 },
 {
   
   "Name": "EbbandFlow",
   "Danceability": 0.426,
   "Energy": 0.521,
   "Key": 5,
   "Loudness": -6.288,
   "Mode": 1,
   "Speechness": 0.0256,
   "Acousticness": 0.0107,
   "Instrumentalness": 0.0000587,
   "Liveness": 0.0937,
   "Valence": 0.443,
   "Tempo": 165.091,
   "Type": "audio_features",
   "ID": "1o8MaDqJF3J2DRWuyNiDFl",
   "Uri": "spotify:track:1o8MaDqJF3J2DRWuyNiDFl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1o8MaDqJF3J2DRWuyNiDFl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1o8MaDqJF3J2DRWuyNiDFl",
   "Duration_ms": 197560,
   "time_signature": 3,
   "Genre": "gothicrock"
 },
 {
   
   "Name": "KanLakMa\\aya(Feat.UmmKulthum)",
   "Danceability": 0.499,
   "Energy": 0.504,
   "Key": 1,
   "Loudness": -6.995,
   "Mode": 0,
   "Speechness": 0.0593,
   "Acousticness": 0.482,
   "Instrumentalness": 0.00000611,
   "Liveness": 0.123,
   "Valence": 0.399,
   "Tempo": 79.832,
   "Type": "audio_features",
   "ID": "6EVt050wg9TQv9HpSn0Ke3",
   "Uri": "spotify:track:6EVt050wg9TQv9HpSn0Ke3",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6EVt050wg9TQv9HpSn0Ke3",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6EVt050wg9TQv9HpSn0Ke3",
   "Duration_ms": 225344,
   "time_signature": 4,
   "Genre": "arabalternative"
 },
 {
   
   "Name": "Ádzseszkó",
   "Danceability": 0.513,
   "Energy": 0.951,
   "Key": 9,
   "Loudness": -5.404,
   "Mode": 1,
   "Speechness": 0.0587,
   "Acousticness": 0.00823,
   "Instrumentalness": 0.000299,
   "Liveness": 0.0401,
   "Valence": 0.922,
   "Tempo": 180.339,
   "Type": "audio_features",
   "ID": "5lJoOwXyrae5daN9ckgKXs",
   "Uri": "spotify:track:5lJoOwXyrae5daN9ckgKXs",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5lJoOwXyrae5daN9ckgKXs",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5lJoOwXyrae5daN9ckgKXs",
   "Duration_ms": 154867,
   "time_signature": 4,
   "Genre": "hungarianpunk"
 },
 {
   
   "Name": "Norgaard",
   "Danceability": 0.323,
   "Energy": 0.847,
   "Key": 11,
   "Loudness": -4.716,
   "Mode": 1,
   "Speechness": 0.0348,
   "Acousticness": 0.00000512,
   "Instrumentalness": 0.0208,
   "Liveness": 0.25,
   "Valence": 0.859,
   "Tempo": 173.914,
   "Type": "audio_features",
   "ID": "1Q8reqCOXg2yqNr47HGo9X",
   "Uri": "spotify:track:1Q8reqCOXg2yqNr47HGo9X",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Q8reqCOXg2yqNr47HGo9X",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Q8reqCOXg2yqNr47HGo9X",
   "Duration_ms": 98400,
   "time_signature": 4,
   "Genre": "ukalternativepop"
 },
 {
   
   "Name": "Ciaoamore",
   "Danceability": 0.516,
   "Energy": 0.828,
   "Key": 7,
   "Loudness": -5.607,
   "Mode": 0,
   "Speechness": 0.16,
   "Acousticness": 0.459,
   "Instrumentalness": 0,
   "Liveness": 0.231,
   "Valence": 0.667,
   "Tempo": 155.843,
   "Type": "audio_features",
   "ID": "4CNypjmhtXyQmLVweupMYb",
   "Uri": "spotify:track:4CNypjmhtXyQmLVweupMYb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4CNypjmhtXyQmLVweupMYb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4CNypjmhtXyQmLVweupMYb",
   "Duration_ms": 221973,
   "time_signature": 4,
   "Genre": "polishfolk"
 },
 {
   
   "Name": "AveMaria/OpeningPrayers",
   "Danceability": 0.282,
   "Energy": 0.241,
   "Key": 5,
   "Loudness": -14.172,
   "Mode": 1,
   "Speechness": 0.0408,
   "Acousticness": 0.893,
   "Instrumentalness": 0.192,
   "Liveness": 0.109,
   "Valence": 0.245,
   "Tempo": 90.798,
   "Type": "audio_features",
   "ID": "4T4jI32SMjy6PhSJGxgFKk",
   "Uri": "spotify:track:4T4jI32SMjy6PhSJGxgFKk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4T4jI32SMjy6PhSJGxgFKk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4T4jI32SMjy6PhSJGxgFKk",
   "Duration_ms": 213213,
   "time_signature": 3,
   "Genre": "rosary"
 },
 {
   
   "Name": "Yesterday",
   "Danceability": 0.474,
   "Energy": 0.964,
   "Key": 9,
   "Loudness": -2.671,
   "Mode": 1,
   "Speechness": 0.253,
   "Acousticness": 0.0366,
   "Instrumentalness": 0.000346,
   "Liveness": 0.311,
   "Valence": 0.309,
   "Tempo": 74.931,
   "Type": "audio_features",
   "ID": "0FEppyOToPmaQ7XDtat2HI",
   "Uri": "spotify:track:0FEppyOToPmaQ7XDtat2HI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0FEppyOToPmaQ7XDtat2HI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0FEppyOToPmaQ7XDtat2HI",
   "Duration_ms": 218502,
   "time_signature": 4,
   "Genre": "hardstyle"
 },
 {
   
   "Name": "Gatrumberu",
   "Danceability": 0.654,
   "Energy": 0.903,
   "Key": 11,
   "Loudness": -3.241,
   "Mode": 0,
   "Speechness": 0.12,
   "Acousticness": 0.165,
   "Instrumentalness": 0,
   "Liveness": 0.249,
   "Valence": 0.941,
   "Tempo": 124.802,
   "Type": "audio_features",
   "ID": "67gRrJD0CjBdcYZwsNUmsE",
   "Uri": "spotify:track:67gRrJD0CjBdcYZwsNUmsE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/67gRrJD0CjBdcYZwsNUmsE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/67gRrJD0CjBdcYZwsNUmsE",
   "Duration_ms": 155240,
   "time_signature": 4,
   "Genre": "catalanfolk"
 },
 {
   
   "Name": "MakeThatCall",
   "Danceability": 0.787,
   "Energy": 0.67,
   "Key": 6,
   "Loudness": -5.484,
   "Mode": 1,
   "Speechness": 0.0369,
   "Acousticness": 0.208,
   "Instrumentalness": 0.0000183,
   "Liveness": 0.0465,
   "Valence": 0.58,
   "Tempo": 118.064,
   "Type": "audio_features",
   "ID": "5hB4uV5XGpTE5pnxHv36EF",
   "Uri": "spotify:track:5hB4uV5XGpTE5pnxHv36EF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5hB4uV5XGpTE5pnxHv36EF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5hB4uV5XGpTE5pnxHv36EF",
   "Duration_ms": 187119,
   "time_signature": 4,
   "Genre": "sunsetlounge"
 },
 {
   
   "Name": "California",
   "Danceability": 0.427,
   "Energy": 0.798,
   "Key": 11,
   "Loudness": -7.538,
   "Mode": 1,
   "Speechness": 0.0449,
   "Acousticness": 0.222,
   "Instrumentalness": 0.393,
   "Liveness": 0.134,
   "Valence": 0.646,
   "Tempo": 162.01,
   "Type": "audio_features",
   "ID": "4Y3gLYlV5rD3fhirhWKtei",
   "Uri": "spotify:track:4Y3gLYlV5rD3fhirhWKtei",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4Y3gLYlV5rD3fhirhWKtei",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4Y3gLYlV5rD3fhirhWKtei",
   "Duration_ms": 219520,
   "time_signature": 4,
   "Genre": "dallasindie"
 },
 {
   
   "Name": "FortunateSon",
   "Danceability": 0.643,
   "Energy": 0.669,
   "Key": 0,
   "Loudness": -7.485,
   "Mode": 1,
   "Speechness": 0.0398,
   "Acousticness": 0.208,
   "Instrumentalness": 0.00664,
   "Liveness": 0.151,
   "Valence": 0.609,
   "Tempo": 132.709,
   "Type": "audio_features",
   "ID": "3yI282DoIJyERd0vGukMoB",
   "Uri": "spotify:track:3yI282DoIJyERd0vGukMoB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3yI282DoIJyERd0vGukMoB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3yI282DoIJyERd0vGukMoB",
   "Duration_ms": 140773,
   "time_signature": 4,
   "Genre": "psychedelicblues-rock"
 },
 {
   
   "Name": "BodyOnMy",
   "Danceability": 0.744,
   "Energy": 0.726,
   "Key": 1,
   "Loudness": -4.675,
   "Mode": 1,
   "Speechness": 0.0463,
   "Acousticness": 0.0399,
   "Instrumentalness": 0,
   "Liveness": 0.374,
   "Valence": 0.687,
   "Tempo": 121.985,
   "Type": "audio_features",
   "ID": "6e0CvGZf7CouOpYF8toXHC",
   "Uri": "spotify:track:6e0CvGZf7CouOpYF8toXHC",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6e0CvGZf7CouOpYF8toXHC",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6e0CvGZf7CouOpYF8toXHC",
   "Duration_ms": 192507,
   "time_signature": 4,
   "Genre": "dancepop"
 },
 {
   
   "Name": "LifeonTick",
   "Danceability": 0.564,
   "Energy": 0.746,
   "Key": 5,
   "Loudness": -5.937,
   "Mode": 0,
   "Speechness": 0.322,
   "Acousticness": 0.263,
   "Instrumentalness": 0,
   "Liveness": 0.183,
   "Valence": 0.876,
   "Tempo": 172.222,
   "Type": "audio_features",
   "ID": "7DEZJX5KEkph40ZvAlsJOk",
   "Uri": "spotify:track:7DEZJX5KEkph40ZvAlsJOk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7DEZJX5KEkph40ZvAlsJOk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7DEZJX5KEkph40ZvAlsJOk",
   "Duration_ms": 227399,
   "time_signature": 4,
   "Genre": "scottishhiphop"
 },
 {
   
   "Name": "Quandohoincontratote",
   "Danceability": 0.885,
   "Energy": 0.583,
   "Key": 10,
   "Loudness": -6.795,
   "Mode": 1,
   "Speechness": 0.0391,
   "Acousticness": 0.0581,
   "Instrumentalness": 0.0000224,
   "Liveness": 0.312,
   "Valence": 0.704,
   "Tempo": 119.994,
   "Type": "audio_features",
   "ID": "40ZQz5OjyeqmreeRmD3ctu",
   "Uri": "spotify:track:40ZQz5OjyeqmreeRmD3ctu",
   "Ref_Track": "https://api.spotify.com/v1/tracks/40ZQz5OjyeqmreeRmD3ctu",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/40ZQz5OjyeqmreeRmD3ctu",
   "Duration_ms": 242253,
   "time_signature": 4,
   "Genre": "italianindiepop"
 },
 {
   
   "Name": "Dimequepuedohacersintí",
   "Danceability": 0.558,
   "Energy": 0.532,
   "Key": 2,
   "Loudness": -6.607,
   "Mode": 1,
   "Speechness": 0.024,
   "Acousticness": 0.396,
   "Instrumentalness": 0.0027,
   "Liveness": 0.0655,
   "Valence": 0.423,
   "Tempo": 88.844,
   "Type": "audio_features",
   "ID": "4IcI2RwHHTz6EiVW5B1VJe",
   "Uri": "spotify:track:4IcI2RwHHTz6EiVW5B1VJe",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4IcI2RwHHTz6EiVW5B1VJe",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4IcI2RwHHTz6EiVW5B1VJe",
   "Duration_ms": 206067,
   "time_signature": 4,
   "Genre": "rocktico"
 },
 {
   
   "Name": "Remolineando",
   "Danceability": 0.767,
   "Energy": 0.752,
   "Key": 8,
   "Loudness": -11.28,
   "Mode": 1,
   "Speechness": 0.092,
   "Acousticness": 0.217,
   "Instrumentalness": 0.446,
   "Liveness": 0.0878,
   "Valence": 0.881,
   "Tempo": 157.177,
   "Type": "audio_features",
   "ID": "6b1vMfKjvWaLBnaPANN2JD",
   "Uri": "spotify:track:6b1vMfKjvWaLBnaPANN2JD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6b1vMfKjvWaLBnaPANN2JD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6b1vMfKjvWaLBnaPANN2JD",
   "Duration_ms": 244135,
   "time_signature": 4,
   "Genre": "latinchristian"
 },
 {
   
   "Name": "QueChova!!",
   "Danceability": 0.445,
   "Energy": 0.631,
   "Key": 5,
   "Loudness": -5.435,
   "Mode": 1,
   "Speechness": 0.0331,
   "Acousticness": 0.636,
   "Instrumentalness": 0.0000758,
   "Liveness": 0.121,
   "Valence": 0.932,
   "Tempo": 150.645,
   "Type": "audio_features",
   "ID": "62QyJMpglmzckIKqO3lt9E",
   "Uri": "spotify:track:62QyJMpglmzckIKqO3lt9E",
   "Ref_Track": "https://api.spotify.com/v1/tracks/62QyJMpglmzckIKqO3lt9E",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/62QyJMpglmzckIKqO3lt9E",
   "Duration_ms": 242547,
   "time_signature": 4,
   "Genre": "galicianfolk"
 },
 {
   
   "Name": "Victory(BonusTrack)",
   "Danceability": 0.844,
   "Energy": 0.539,
   "Key": 3,
   "Loudness": -9.445,
   "Mode": 0,
   "Speechness": 0.162,
   "Acousticness": 0.537,
   "Instrumentalness": 0.00000165,
   "Liveness": 0.0914,
   "Valence": 0.748,
   "Tempo": 103.048,
   "Type": "audio_features",
   "ID": "5qwb7vkBOakwA9DxH9wpVZ",
   "Uri": "spotify:track:5qwb7vkBOakwA9DxH9wpVZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5qwb7vkBOakwA9DxH9wpVZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5qwb7vkBOakwA9DxH9wpVZ",
   "Duration_ms": 209537,
   "time_signature": 4,
   "Genre": "christianafrobeat"
 },
 {
   
   "Name": "Sofia...",
   "Danceability": 0.585,
   "Energy": 0.747,
   "Key": 9,
   "Loudness": -5.326,
   "Mode": 1,
   "Speechness": 0.0431,
   "Acousticness": 0.063,
   "Instrumentalness": 0.000566,
   "Liveness": 0.0827,
   "Valence": 0.445,
   "Tempo": 124.116,
   "Type": "audio_features",
   "ID": "3mVvHX2unymAji6lBRuzBg",
   "Uri": "spotify:track:3mVvHX2unymAji6lBRuzBg",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3mVvHX2unymAji6lBRuzBg",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3mVvHX2unymAji6lBRuzBg",
   "Duration_ms": 312000,
   "time_signature": 4,
   "Genre": "michiganindie"
 },
 {
   
   "Name": "HolyGround",
   "Danceability": 0.484,
   "Energy": 0.958,
   "Key": 9,
   "Loudness": -5.836,
   "Mode": 0,
   "Speechness": 0.0487,
   "Acousticness": 0.00283,
   "Instrumentalness": 0.00284,
   "Liveness": 0.335,
   "Valence": 0.238,
   "Tempo": 137.95,
   "Type": "audio_features",
   "ID": "26xQNN438FGePK2UnlCGdg",
   "Uri": "spotify:track:26xQNN438FGePK2UnlCGdg",
   "Ref_Track": "https://api.spotify.com/v1/tracks/26xQNN438FGePK2UnlCGdg",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/26xQNN438FGePK2UnlCGdg",
   "Duration_ms": 223716,
   "time_signature": 4,
   "Genre": "vocaltrance"
 },
 {
   
   "Name": "Suede",
   "Danceability": 0.741,
   "Energy": 0.588,
   "Key": 9,
   "Loudness": -7.676,
   "Mode": 0,
   "Speechness": 0.0302,
   "Acousticness": 0.356,
   "Instrumentalness": 0.0144,
   "Liveness": 0.12,
   "Valence": 0.609,
   "Tempo": 99.985,
   "Type": "audio_features",
   "ID": "5jmb1MEFD9GjRfy3E2MhEl",
   "Uri": "spotify:track:5jmb1MEFD9GjRfy3E2MhEl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5jmb1MEFD9GjRfy3E2MhEl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5jmb1MEFD9GjRfy3E2MhEl",
   "Duration_ms": 256227,
   "time_signature": 4,
   "Genre": "smoothjazz"
 },
 {
   
   "Name": "SankiBuz",
   "Danceability": 0.674,
   "Energy": 0.569,
   "Key": 2,
   "Loudness": -5.502,
   "Mode": 0,
   "Speechness": 0.0689,
   "Acousticness": 0.917,
   "Instrumentalness": 0,
   "Liveness": 0.327,
   "Valence": 0.341,
   "Tempo": 93.447,
   "Type": "audio_features",
   "ID": "7LYTnWWTcc62tJ0nMvHcE6",
   "Uri": "spotify:track:7LYTnWWTcc62tJ0nMvHcE6",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7LYTnWWTcc62tJ0nMvHcE6",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7LYTnWWTcc62tJ0nMvHcE6",
   "Duration_ms": 144000,
   "time_signature": 5,
   "Genre": "azeripop"
 },
 {
   
   "Name": "Virgenes",
   "Danceability": 0.584,
   "Energy": 0.778,
   "Key": 9,
   "Loudness": -7.749,
   "Mode": 0,
   "Speechness": 0.0394,
   "Acousticness": 0.00212,
   "Instrumentalness": 0.255,
   "Liveness": 0.18,
   "Valence": 0.662,
   "Tempo": 94.996,
   "Type": "audio_features",
   "ID": "6pC43SDOrTogVzj9ej2FjM",
   "Uri": "spotify:track:6pC43SDOrTogVzj9ej2FjM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6pC43SDOrTogVzj9ej2FjM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6pC43SDOrTogVzj9ej2FjM",
   "Duration_ms": 232827,
   "time_signature": 4,
   "Genre": "panamanianrock"
 },
 {
   
   "Name": "ColdtotheTouch",
   "Danceability": 0.723,
   "Energy": 0.67,
   "Key": 0,
   "Loudness": -8.113,
   "Mode": 1,
   "Speechness": 0.0434,
   "Acousticness": 0.013,
   "Instrumentalness": 0.00000138,
   "Liveness": 0.0938,
   "Valence": 0.527,
   "Tempo": 106.011,
   "Type": "audio_features",
   "ID": "3moDgeKCXv4LKXpFxYlGR7",
   "Uri": "spotify:track:3moDgeKCXv4LKXpFxYlGR7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3moDgeKCXv4LKXpFxYlGR7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3moDgeKCXv4LKXpFxYlGR7",
   "Duration_ms": 205472,
   "time_signature": 4,
   "Genre": "canadiansoundtrack"
 },
 {
   
   "Name": "ViMalerByenRød",
   "Danceability": 0.594,
   "Energy": 0.871,
   "Key": 5,
   "Loudness": -3.507,
   "Mode": 1,
   "Speechness": 0.0403,
   "Acousticness": 0.486,
   "Instrumentalness": 0,
   "Liveness": 0.343,
   "Valence": 0.761,
   "Tempo": 92.402,
   "Type": "audio_features",
   "ID": "5R7qlPnCh9qVEtNaHIyPvh",
   "Uri": "spotify:track:5R7qlPnCh9qVEtNaHIyPvh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5R7qlPnCh9qVEtNaHIyPvh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5R7qlPnCh9qVEtNaHIyPvh",
   "Duration_ms": 176333,
   "time_signature": 4,
   "Genre": "classicdanishpop"
 },
 {
   
   "Name": "Liebemachtblind",
   "Danceability": 0.576,
   "Energy": 0.816,
   "Key": 11,
   "Loudness": -5.602,
   "Mode": 1,
   "Speechness": 0.0449,
   "Acousticness": 0.0277,
   "Instrumentalness": 0.0000708,
   "Liveness": 0.101,
   "Valence": 0.847,
   "Tempo": 98.82,
   "Type": "audio_features",
   "ID": "2hLYDmpTpVkfW44TEMrFvH",
   "Uri": "spotify:track:2hLYDmpTpVkfW44TEMrFvH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2hLYDmpTpVkfW44TEMrFvH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2hLYDmpTpVkfW44TEMrFvH",
   "Duration_ms": 192400,
   "time_signature": 4,
   "Genre": "euroska"
 },
 {
   
   "Name": "Adele",
   "Danceability": 0.485,
   "Energy": 0.18,
   "Key": 2,
   "Loudness": -18.588,
   "Mode": 1,
   "Speechness": 0.0419,
   "Acousticness": 0.892,
   "Instrumentalness": 0.0982,
   "Liveness": 0.111,
   "Valence": 0.138,
   "Tempo": 136.159,
   "Type": "audio_features",
   "ID": "41GmtZAyb2t1diD2da8IBD",
   "Uri": "spotify:track:41GmtZAyb2t1diD2da8IBD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/41GmtZAyb2t1diD2da8IBD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/41GmtZAyb2t1diD2da8IBD",
   "Duration_ms": 203076,
   "time_signature": 4,
   "Genre": "cornwallindie"
 },
 {
   
   "Name": "MANTRA",
   "Danceability": 0.502,
   "Energy": 0.817,
   "Key": 0,
   "Loudness": -3.508,
   "Mode": 1,
   "Speechness": 0.0447,
   "Acousticness": 0.000477,
   "Instrumentalness": 0,
   "Liveness": 0.153,
   "Valence": 0.617,
   "Tempo": 90.024,
   "Type": "audio_features",
   "ID": "7dRj3sTBYkNbEx5kdNHriv",
   "Uri": "spotify:track:7dRj3sTBYkNbEx5kdNHriv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7dRj3sTBYkNbEx5kdNHriv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7dRj3sTBYkNbEx5kdNHriv",
   "Duration_ms": 233298,
   "time_signature": 4,
   "Genre": "czechrock"
 },
 {
   
   "Name": "ItRunsThroughMe",
   "Danceability": 0.802,
   "Energy": 0.607,
   "Key": 11,
   "Loudness": -11.028,
   "Mode": 0,
   "Speechness": 0.289,
   "Acousticness": 0.205,
   "Instrumentalness": 0.000748,
   "Liveness": 0.246,
   "Valence": 0.274,
   "Tempo": 96.916,
   "Type": "audio_features",
   "ID": "02CygBCQOIyEuhNZqHHcNx",
   "Uri": "spotify:track:02CygBCQOIyEuhNZqHHcNx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/02CygBCQOIyEuhNZqHHcNx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/02CygBCQOIyEuhNZqHHcNx",
   "Duration_ms": 261881,
   "time_signature": 4,
   "Genre": "soul"
 },
 {
   
   "Name": "HurradieWeltgehtunter",
   "Danceability": 0.615,
   "Energy": 0.598,
   "Key": 4,
   "Loudness": -4.967,
   "Mode": 0,
   "Speechness": 0.207,
   "Acousticness": 0.0259,
   "Instrumentalness": 0,
   "Liveness": 0.136,
   "Valence": 0.653,
   "Tempo": 80.293,
   "Type": "audio_features",
   "ID": "3NIDOSThELMihLSOMZcL4k",
   "Uri": "spotify:track:3NIDOSThELMihLSOMZcL4k",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3NIDOSThELMihLSOMZcL4k",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3NIDOSThELMihLSOMZcL4k",
   "Duration_ms": 284693,
   "time_signature": 4,
   "Genre": "germanpunk"
 },
 {
   
   "Name": "SérénadeetDanse",
   "Danceability": 0.17,
   "Energy": 0.0623,
   "Key": 4,
   "Loudness": -21.681,
   "Mode": 1,
   "Speechness": 0.0584,
   "Acousticness": 0.988,
   "Instrumentalness": 0.615,
   "Liveness": 0.21,
   "Valence": 0.0738,
   "Tempo": 65.76,
   "Type": "audio_features",
   "ID": "3aPzRHLZybzw014Pnnl8u2",
   "Uri": "spotify:track:3aPzRHLZybzw014Pnnl8u2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3aPzRHLZybzw014Pnnl8u2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3aPzRHLZybzw014Pnnl8u2",
   "Duration_ms": 371027,
   "time_signature": 4,
   "Genre": "canadianclassical"
 },
 {
   
   "Name": "AltoSaxophoneSonata:I.Allegro",
   "Danceability": 0.276,
   "Energy": 0.103,
   "Key": 5,
   "Loudness": -16.602,
   "Mode": 0,
   "Speechness": 0.0419,
   "Acousticness": 0.992,
   "Instrumentalness": 0.885,
   "Liveness": 0.09,
   "Valence": 0.147,
   "Tempo": 72.134,
   "Type": "audio_features",
   "ID": "3I6nsnbk1v8lHwX4VdvkaK",
   "Uri": "spotify:track:3I6nsnbk1v8lHwX4VdvkaK",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3I6nsnbk1v8lHwX4VdvkaK",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3I6nsnbk1v8lHwX4VdvkaK",
   "Duration_ms": 380147,
   "time_signature": 4,
   "Genre": "classicalsaxophonequartet"
 },
 {
   
   "Name": "BlackPaperPlanes",
   "Danceability": 0.446,
   "Energy": 0.862,
   "Key": 7,
   "Loudness": -6.732,
   "Mode": 1,
   "Speechness": 0.0409,
   "Acousticness": 0.000013,
   "Instrumentalness": 0.791,
   "Liveness": 0.0667,
   "Valence": 0.155,
   "Tempo": 133.524,
   "Type": "audio_features",
   "ID": "6ZvmAXqrALWGr0sytv66NO",
   "Uri": "spotify:track:6ZvmAXqrALWGr0sytv66NO",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6ZvmAXqrALWGr0sytv66NO",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6ZvmAXqrALWGr0sytv66NO",
   "Duration_ms": 437120,
   "time_signature": 4,
   "Genre": "germanpost-rock"
 },
 {
   
   "Name": "Paused",
   "Danceability": 0.761,
   "Energy": 0.713,
   "Key": 10,
   "Loudness": -8.521,
   "Mode": 0,
   "Speechness": 0.192,
   "Acousticness": 0.474,
   "Instrumentalness": 0.918,
   "Liveness": 0.0979,
   "Valence": 0.343,
   "Tempo": 150.194,
   "Type": "audio_features",
   "ID": "1B0w0D7qTjvGinWYZYuL7a",
   "Uri": "spotify:track:1B0w0D7qTjvGinWYZYuL7a",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1B0w0D7qTjvGinWYZYuL7a",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1B0w0D7qTjvGinWYZYuL7a",
   "Duration_ms": 267634,
   "time_signature": 4,
   "Genre": "skweee"
 },
 {
   
   "Name": "Zweiundneunzig-Fürpure",
   "Danceability": 0.209,
   "Energy": 0.65,
   "Key": 5,
   "Loudness": -14.097,
   "Mode": 0,
   "Speechness": 0.116,
   "Acousticness": 0.00258,
   "Instrumentalness": 0.936,
   "Liveness": 0.0793,
   "Valence": 0.0834,
   "Tempo": 175.094,
   "Type": "audio_features",
   "ID": "2XrxRchzTV7ed4XBaIRqmk",
   "Uri": "spotify:track:2XrxRchzTV7ed4XBaIRqmk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2XrxRchzTV7ed4XBaIRqmk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2XrxRchzTV7ed4XBaIRqmk",
   "Duration_ms": 516404,
   "time_signature": 5,
   "Genre": "belgianexperimental"
 },
 {
   
   "Name": "IWantYou-Remix-Main",
   "Danceability": 0.536,
   "Energy": 0.669,
   "Key": 8,
   "Loudness": -7.532,
   "Mode": 1,
   "Speechness": 0.371,
   "Acousticness": 0.121,
   "Instrumentalness": 0,
   "Liveness": 0.337,
   "Valence": 0.59,
   "Tempo": 98.03,
   "Type": "audio_features",
   "ID": "1w6MVKsMS7hsN7eaKPBTjE",
   "Uri": "spotify:track:1w6MVKsMS7hsN7eaKPBTjE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1w6MVKsMS7hsN7eaKPBTjE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1w6MVKsMS7hsN7eaKPBTjE",
   "Duration_ms": 266250,
   "time_signature": 4,
   "Genre": "quietstorm"
 },
 {
   
   "Name": "FluorescentAdolescent",
   "Danceability": 0.646,
   "Energy": 0.813,
   "Key": 6,
   "Loudness": -5.29,
   "Mode": 0,
   "Speechness": 0.0288,
   "Acousticness": 0.00178,
   "Instrumentalness": 0.0000226,
   "Liveness": 0.144,
   "Valence": 0.821,
   "Tempo": 112.115,
   "Type": "audio_features",
   "ID": "7e8utCy2JlSB8dRHKi49xM",
   "Uri": "spotify:track:7e8utCy2JlSB8dRHKi49xM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7e8utCy2JlSB8dRHKi49xM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7e8utCy2JlSB8dRHKi49xM",
   "Duration_ms": 173493,
   "time_signature": 4,
   "Genre": "garagerock"
 },
 {
   
   "Name": "WhatYouKnow",
   "Danceability": 0.557,
   "Energy": 0.747,
   "Key": 6,
   "Loudness": -4.007,
   "Mode": 0,
   "Speechness": 0.0418,
   "Acousticness": 0.0008,
   "Instrumentalness": 0.00000982,
   "Liveness": 0.0858,
   "Valence": 0.781,
   "Tempo": 139.006,
   "Type": "audio_features",
   "ID": "7oRgM9AfaDq0rm4ovEVYqG",
   "Uri": "spotify:track:7oRgM9AfaDq0rm4ovEVYqG",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7oRgM9AfaDq0rm4ovEVYqG",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7oRgM9AfaDq0rm4ovEVYqG",
   "Duration_ms": 189693,
   "time_signature": 4,
   "Genre": "seattleindie"
 },
 {
   
   "Name": "PumpedUpKicks",
   "Danceability": 0.733,
   "Energy": 0.71,
   "Key": 5,
   "Loudness": -5.849,
   "Mode": 0,
   "Speechness": 0.0292,
   "Acousticness": 0.145,
   "Instrumentalness": 0.115,
   "Liveness": 0.0956,
   "Valence": 0.965,
   "Tempo": 127.975,
   "Type": "audio_features",
   "ID": "7w87IxuO7BDcJ3YUqCyMTT",
   "Uri": "spotify:track:7w87IxuO7BDcJ3YUqCyMTT",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7w87IxuO7BDcJ3YUqCyMTT",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7w87IxuO7BDcJ3YUqCyMTT",
   "Duration_ms": 239600,
   "time_signature": 4,
   "Genre": "phoenixindie"
 },
 {
   
   "Name": "MissaBell\\Amfitrit\\altera:Kyrie",
   "Danceability": 0.0779,
   "Energy": 0.117,
   "Key": 9,
   "Loudness": -21.713,
   "Mode": 1,
   "Speechness": 0.0437,
   "Acousticness": 0.992,
   "Instrumentalness": 0.915,
   "Liveness": 0.0702,
   "Valence": 0.0395,
   "Tempo": 67.417,
   "Type": "audio_features",
   "ID": "0RxzkTojBbkVRolZHRfQvt",
   "Uri": "spotify:track:0RxzkTojBbkVRolZHRfQvt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0RxzkTojBbkVRolZHRfQvt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0RxzkTojBbkVRolZHRfQvt",
   "Duration_ms": 193893,
   "time_signature": 3,
   "Genre": "polyphony"
 },
 {
   
   "Name": "WhiteRabbit",
   "Danceability": 0.551,
   "Energy": 0.293,
   "Key": 2,
   "Loudness": -12.503,
   "Mode": 1,
   "Speechness": 0.0272,
   "Acousticness": 0.486,
   "Instrumentalness": 0.000273,
   "Liveness": 0.0864,
   "Valence": 0.322,
   "Tempo": 106.798,
   "Type": "audio_features",
   "ID": "4vpeKl0vMGdAXpZiQB2Dtd",
   "Uri": "spotify:track:4vpeKl0vMGdAXpZiQB2Dtd",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4vpeKl0vMGdAXpZiQB2Dtd",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4vpeKl0vMGdAXpZiQB2Dtd",
   "Duration_ms": 150640,
   "time_signature": 4,
   "Genre": "psychedelicrock"
 },
 {
   
   "Name": "Afterlife",
   "Danceability": 0.487,
   "Energy": 0.949,
   "Key": 2,
   "Loudness": -4.217,
   "Mode": 0,
   "Speechness": 0.0798,
   "Acousticness": 0.000429,
   "Instrumentalness": 0.0000291,
   "Liveness": 0.231,
   "Valence": 0.406,
   "Tempo": 110.02,
   "Type": "audio_features",
   "ID": "7zAt4tdL44D3VuzsvM0N8n",
   "Uri": "spotify:track:7zAt4tdL44D3VuzsvM0N8n",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7zAt4tdL44D3VuzsvM0N8n",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7zAt4tdL44D3VuzsvM0N8n",
   "Duration_ms": 352427,
   "time_signature": 4,
   "Genre": "classicswedishpop"
 },
 {
   
   "Name": "WhiteSedan",
   "Danceability": 0.61,
   "Energy": 0.452,
   "Key": 1,
   "Loudness": -14.695,
   "Mode": 0,
   "Speechness": 0.045,
   "Acousticness": 0.163,
   "Instrumentalness": 0.894,
   "Liveness": 0.111,
   "Valence": 0.385,
   "Tempo": 123.923,
   "Type": "audio_features",
   "ID": "6Fvi4W50kum9MfkZF0ypZh",
   "Uri": "spotify:track:6Fvi4W50kum9MfkZF0ypZh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6Fvi4W50kum9MfkZF0ypZh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6Fvi4W50kum9MfkZF0ypZh",
   "Duration_ms": 420200,
   "time_signature": 4,
   "Genre": "germanjazz"
 },
 {
   
   "Name": "Ingerlaliinnaleqaagut",
   "Danceability": 0.5,
   "Energy": 0.645,
   "Key": 0,
   "Loudness": -7.5,
   "Mode": 1,
   "Speechness": 0.0261,
   "Acousticness": 0.0985,
   "Instrumentalness": 0.000162,
   "Liveness": 0.145,
   "Valence": 0.563,
   "Tempo": 79.013,
   "Type": "audio_features",
   "ID": "0ZaWKNIfU5rZjMgSucCAX0",
   "Uri": "spotify:track:0ZaWKNIfU5rZjMgSucCAX0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0ZaWKNIfU5rZjMgSucCAX0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0ZaWKNIfU5rZjMgSucCAX0",
   "Duration_ms": 232080,
   "time_signature": 4,
   "Genre": "greenlandicpop"
 },
 {
   
   "Name": "AngelZoo",
   "Danceability": 0.669,
   "Energy": 0.683,
   "Key": 0,
   "Loudness": -5.214,
   "Mode": 1,
   "Speechness": 0.173,
   "Acousticness": 0.207,
   "Instrumentalness": 0.00000399,
   "Liveness": 0.171,
   "Valence": 0.452,
   "Tempo": 80.022,
   "Type": "audio_features",
   "ID": "672amoeenDyj593OhDRgak",
   "Uri": "spotify:track:672amoeenDyj593OhDRgak",
   "Ref_Track": "https://api.spotify.com/v1/tracks/672amoeenDyj593OhDRgak",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/672amoeenDyj593OhDRgak",
   "Duration_ms": 159720,
   "time_signature": 4,
   "Genre": "scandinavianr&b"
 },
 {
   
   "Name": "GlassHouse",
   "Danceability": 0.608,
   "Energy": 0.655,
   "Key": 6,
   "Loudness": -5.841,
   "Mode": 0,
   "Speechness": 0.0955,
   "Acousticness": 0.447,
   "Instrumentalness": 0.000035,
   "Liveness": 0.558,
   "Valence": 0.564,
   "Tempo": 72.882,
   "Type": "audio_features",
   "ID": "2dLUKfYXEeiNxRsvJfPZQD",
   "Uri": "spotify:track:2dLUKfYXEeiNxRsvJfPZQD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2dLUKfYXEeiNxRsvJfPZQD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2dLUKfYXEeiNxRsvJfPZQD",
   "Duration_ms": 214143,
   "time_signature": 4,
   "Genre": "alternativer&b"
 },
 {
   
   "Name": "Process",
   "Danceability": 0.172,
   "Energy": 0.993,
   "Key": 5,
   "Loudness": -3.689,
   "Mode": 0,
   "Speechness": 0.149,
   "Acousticness": 0.00000141,
   "Instrumentalness": 0.848,
   "Liveness": 0.335,
   "Valence": 0.0283,
   "Tempo": 116.672,
   "Type": "audio_features",
   "ID": "0PamwfSDmQlOzu725iTI8M",
   "Uri": "spotify:track:0PamwfSDmQlOzu725iTI8M",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0PamwfSDmQlOzu725iTI8M",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0PamwfSDmQlOzu725iTI8M",
   "Duration_ms": 124173,
   "time_signature": 4,
   "Genre": "crustpunk"
 },
 {
   
   "Name": "Lavieenrose",
   "Danceability": 0.38,
   "Energy": 0.277,
   "Key": 8,
   "Loudness": -10.897,
   "Mode": 1,
   "Speechness": 0.0315,
   "Acousticness": 0.977,
   "Instrumentalness": 0,
   "Liveness": 0.158,
   "Valence": 0.489,
   "Tempo": 113.107,
   "Type": "audio_features",
   "ID": "6By5EZtl0GKQuRZBZbk1LU",
   "Uri": "spotify:track:6By5EZtl0GKQuRZBZbk1LU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6By5EZtl0GKQuRZBZbk1LU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6By5EZtl0GKQuRZBZbk1LU",
   "Duration_ms": 187667,
   "time_signature": 5,
   "Genre": "frenchfolkpop"
 },
 {
   
   "Name": "ViacrucisdeSalud",
   "Danceability": 0.274,
   "Energy": 0.514,
   "Key": 1,
   "Loudness": -3.975,
   "Mode": 0,
   "Speechness": 0.047,
   "Acousticness": 0.79,
   "Instrumentalness": 0.928,
   "Liveness": 0.0653,
   "Valence": 0.57,
   "Tempo": 73.961,
   "Type": "audio_features",
   "ID": "5chaCvvB7BUJEpUHMdAn6t",
   "Uri": "spotify:track:5chaCvvB7BUJEpUHMdAn6t",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5chaCvvB7BUJEpUHMdAn6t",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5chaCvvB7BUJEpUHMdAn6t",
   "Duration_ms": 199400,
   "time_signature": 4,
   "Genre": "cornetasytambores"
 },
 {
   
   "Name": "RequiemForATower",
   "Danceability": 0.432,
   "Energy": 0.743,
   "Key": 7,
   "Loudness": -6.561,
   "Mode": 0,
   "Speechness": 0.0436,
   "Acousticness": 0.205,
   "Instrumentalness": 0.783,
   "Liveness": 0.0599,
   "Valence": 0.39,
   "Tempo": 79.016,
   "Type": "audio_features",
   "ID": "1xB7YdTKvUzO4bOjN6QAW8",
   "Uri": "spotify:track:1xB7YdTKvUzO4bOjN6QAW8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1xB7YdTKvUzO4bOjN6QAW8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1xB7YdTKvUzO4bOjN6QAW8",
   "Duration_ms": 119000,
   "time_signature": 4,
   "Genre": "germanrenaissance"
 },
 {
   
   "Name": "Puente",
   "Danceability": 0.444,
   "Energy": 0.471,
   "Key": 10,
   "Loudness": -9.107,
   "Mode": 1,
   "Speechness": 0.0322,
   "Acousticness": 0.00161,
   "Instrumentalness": 0.0017,
   "Liveness": 0.14,
   "Valence": 0.205,
   "Tempo": 76.335,
   "Type": "audio_features",
   "ID": "6gwaa6ElIixNTvu6RwkMyo",
   "Uri": "spotify:track:6gwaa6ElIixNTvu6RwkMyo",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6gwaa6ElIixNTvu6RwkMyo",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6gwaa6ElIixNTvu6RwkMyo",
   "Duration_ms": 273800,
   "time_signature": 4,
   "Genre": "rocknacional"
 },
 {
   
   "Name": "JohntheRevelator",
   "Danceability": 0.738,
   "Energy": 0.334,
   "Key": 9,
   "Loudness": -12.972,
   "Mode": 0,
   "Speechness": 0.27,
   "Acousticness": 0.995,
   "Instrumentalness": 0.0675,
   "Liveness": 0.564,
   "Valence": 0.503,
   "Tempo": 125.6,
   "Type": "audio_features",
   "ID": "3MCRz5li4Sp6SKfz2tqxn0",
   "Uri": "spotify:track:3MCRz5li4Sp6SKfz2tqxn0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3MCRz5li4Sp6SKfz2tqxn0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3MCRz5li4Sp6SKfz2tqxn0",
   "Duration_ms": 196533,
   "time_signature": 4,
   "Genre": "gospelblues"
 },
 {
   
   "Name": "InBalance",
   "Danceability": 0.326,
   "Energy": 0.0108,
   "Key": 1,
   "Loudness": -29.982,
   "Mode": 0,
   "Speechness": 0.0442,
   "Acousticness": 0.93,
   "Instrumentalness": 0.383,
   "Liveness": 0.0733,
   "Valence": 0.0392,
   "Tempo": 100.948,
   "Type": "audio_features",
   "ID": "7zhbnL5v6qXvzUgp9eE285",
   "Uri": "spotify:track:7zhbnL5v6qXvzUgp9eE285",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7zhbnL5v6qXvzUgp9eE285",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7zhbnL5v6qXvzUgp9eE285",
   "Duration_ms": 693707,
   "time_signature": 3,
   "Genre": "nordiccontemporaryclassical"
 },
 {
   
   "Name": "Sensitivity",
   "Danceability": 0.688,
   "Energy": 0.789,
   "Key": 1,
   "Loudness": -9.261,
   "Mode": 1,
   "Speechness": 0.0438,
   "Acousticness": 0.145,
   "Instrumentalness": 0.43,
   "Liveness": 0.0775,
   "Valence": 0.719,
   "Tempo": 96.955,
   "Type": "audio_features",
   "ID": "6yz8tJF1yWkRtDAvjh2SWU",
   "Uri": "spotify:track:6yz8tJF1yWkRtDAvjh2SWU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6yz8tJF1yWkRtDAvjh2SWU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6yz8tJF1yWkRtDAvjh2SWU",
   "Duration_ms": 280026,
   "time_signature": 4,
   "Genre": "newjackswing"
 },
 {
   
   "Name": "HearThis",
   "Danceability": 0.561,
   "Energy": 0.744,
   "Key": 5,
   "Loudness": -6.571,
   "Mode": 0,
   "Speechness": 0.0547,
   "Acousticness": 0.0823,
   "Instrumentalness": 0,
   "Liveness": 0.325,
   "Valence": 0.531,
   "Tempo": 131.862,
   "Type": "audio_features",
   "ID": "2dc3f9srVqYCpOYXExQrcj",
   "Uri": "spotify:track:2dc3f9srVqYCpOYXExQrcj",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2dc3f9srVqYCpOYXExQrcj",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2dc3f9srVqYCpOYXExQrcj",
   "Duration_ms": 289070,
   "time_signature": 4,
   "Genre": "gospelr&b"
 },
 {
   
   "Name": "LovingIsEasy",
   "Danceability": 0.756,
   "Energy": 0.609,
   "Key": 3,
   "Loudness": -7.927,
   "Mode": 1,
   "Speechness": 0.0544,
   "Acousticness": 0.217,
   "Instrumentalness": 0.00474,
   "Liveness": 0.096,
   "Valence": 0.537,
   "Tempo": 117.023,
   "Type": "audio_features",
   "ID": "5EYi2rH4LYs6M21ZLOyQTx",
   "Uri": "spotify:track:5EYi2rH4LYs6M21ZLOyQTx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5EYi2rH4LYs6M21ZLOyQTx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5EYi2rH4LYs6M21ZLOyQTx",
   "Duration_ms": 155720,
   "time_signature": 4,
   "Genre": "idahoindie"
 },
 {
   
   "Name": "UnderPressure-Remastered",
   "Danceability": 0.663,
   "Energy": 0.712,
   "Key": 2,
   "Loudness": -7.268,
   "Mode": 1,
   "Speechness": 0.0479,
   "Acousticness": 0.524,
   "Instrumentalness": 0,
   "Liveness": 0.0804,
   "Valence": 0.527,
   "Tempo": 113.439,
   "Type": "audio_features",
   "ID": "2aSFLiDPreOVP6KHiWk4lF",
   "Uri": "spotify:track:2aSFLiDPreOVP6KHiWk4lF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2aSFLiDPreOVP6KHiWk4lF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2aSFLiDPreOVP6KHiWk4lF",
   "Duration_ms": 236520,
   "time_signature": 4,
   "Genre": "rock"
 },
 {
   
   "Name": "TheGreenSuperintendent",
   "Danceability": 0.703,
   "Energy": 0.745,
   "Key": 6,
   "Loudness": -5.498,
   "Mode": 0,
   "Speechness": 0.0619,
   "Acousticness": 0.557,
   "Instrumentalness": 0,
   "Liveness": 0.239,
   "Valence": 0.786,
   "Tempo": 152.006,
   "Type": "audio_features",
   "ID": "2Qxn4coed4Rrk98dyHtgds",
   "Uri": "spotify:track:2Qxn4coed4Rrk98dyHtgds",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Qxn4coed4Rrk98dyHtgds",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Qxn4coed4Rrk98dyHtgds",
   "Duration_ms": 183073,
   "time_signature": 4,
   "Genre": "dunedinindie"
 },
 {
   
   "Name": "BadBoys",
   "Danceability": 0.469,
   "Energy": 0.825,
   "Key": 9,
   "Loudness": -6.564,
   "Mode": 1,
   "Speechness": 0.0555,
   "Acousticness": 0.0357,
   "Instrumentalness": 0.146,
   "Liveness": 0.191,
   "Valence": 0.646,
   "Tempo": 154.014,
   "Type": "audio_features",
   "ID": "56NZkBzHCQK5JjntJgvKqS",
   "Uri": "spotify:track:56NZkBzHCQK5JjntJgvKqS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/56NZkBzHCQK5JjntJgvKqS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/56NZkBzHCQK5JjntJgvKqS",
   "Duration_ms": 187077,
   "time_signature": 4,
   "Genre": "dublinindie"
 },
 {
   
   "Name": "Cocola",
   "Danceability": 0.805,
   "Energy": 0.513,
   "Key": 7,
   "Loudness": -10.751,
   "Mode": 1,
   "Speechness": 0.165,
   "Acousticness": 0.456,
   "Instrumentalness": 0.921,
   "Liveness": 0.111,
   "Valence": 0.471,
   "Tempo": 124.019,
   "Type": "audio_features",
   "ID": "7zWXlhm8cIODIUqr99DRe6",
   "Uri": "spotify:track:7zWXlhm8cIODIUqr99DRe6",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7zWXlhm8cIODIUqr99DRe6",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7zWXlhm8cIODIUqr99DRe6",
   "Duration_ms": 326960,
   "time_signature": 4,
   "Genre": "deepfunk"
 },
 {
   
   "Name": "KapionAllonFilises-Live",
   "Danceability": 0.601,
   "Energy": 0.768,
   "Key": 0,
   "Loudness": -3.501,
   "Mode": 0,
   "Speechness": 0.0542,
   "Acousticness": 0.41,
   "Instrumentalness": 0,
   "Liveness": 0.461,
   "Valence": 0.576,
   "Tempo": 109.13,
   "Type": "audio_features",
   "ID": "4H1jVDiDBytX1wyBv6Nkqq",
   "Uri": "spotify:track:4H1jVDiDBytX1wyBv6Nkqq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4H1jVDiDBytX1wyBv6Nkqq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4H1jVDiDBytX1wyBv6Nkqq",
   "Duration_ms": 214467,
   "time_signature": 4,
   "Genre": "rebetiko"
 },
 {
   
   "Name": "Distancia",
   "Danceability": 0.288,
   "Energy": 0.637,
   "Key": 4,
   "Loudness": -9.008,
   "Mode": 0,
   "Speechness": 0.0356,
   "Acousticness": 0.0649,
   "Instrumentalness": 0.897,
   "Liveness": 0.138,
   "Valence": 0.037,
   "Tempo": 110.567,
   "Type": "audio_features",
   "ID": "3bqb5xdBPoFBv0PnIjL7PX",
   "Uri": "spotify:track:3bqb5xdBPoFBv0PnIjL7PX",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3bqb5xdBPoFBv0PnIjL7PX",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3bqb5xdBPoFBv0PnIjL7PX",
   "Duration_ms": 413367,
   "time_signature": 4,
   "Genre": "post-rocklatinoamericano"
 },
 {
   
   "Name": "NovelaDeAmor",
   "Danceability": 0.713,
   "Energy": 0.872,
   "Key": 3,
   "Loudness": -3.157,
   "Mode": 0,
   "Speechness": 0.0512,
   "Acousticness": 0.121,
   "Instrumentalness": 0,
   "Liveness": 0.292,
   "Valence": 0.916,
   "Tempo": 104.98,
   "Type": "audio_features",
   "ID": "5Qzjw9Fqck164Z9covgsdu",
   "Uri": "spotify:track:5Qzjw9Fqck164Z9covgsdu",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5Qzjw9Fqck164Z9covgsdu",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5Qzjw9Fqck164Z9covgsdu",
   "Duration_ms": 210286,
   "time_signature": 4,
   "Genre": "cubaton"
 },
 {
   
   "Name": "PrendeunPorro",
   "Danceability": 0.818,
   "Energy": 0.919,
   "Key": 5,
   "Loudness": -1.816,
   "Mode": 1,
   "Speechness": 0.246,
   "Acousticness": 0.0245,
   "Instrumentalness": 0.00616,
   "Liveness": 0.192,
   "Valence": 0.797,
   "Tempo": 110.048,
   "Type": "audio_features",
   "ID": "5cP7ftiSJpLRBnap7S6ilE",
   "Uri": "spotify:track:5cP7ftiSJpLRBnap7S6ilE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5cP7ftiSJpLRBnap7S6ilE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5cP7ftiSJpLRBnap7S6ilE",
   "Duration_ms": 193672,
   "time_signature": 4,
   "Genre": "porro"
 },
 {
   
   "Name": "TheGivingTree",
   "Danceability": 0.222,
   "Energy": 0.857,
   "Key": 9,
   "Loudness": -5.085,
   "Mode": 0,
   "Speechness": 0.0457,
   "Acousticness": 0.0000998,
   "Instrumentalness": 0.613,
   "Liveness": 0.11,
   "Valence": 0.0699,
   "Tempo": 100.013,
   "Type": "audio_features",
   "ID": "238fv8we4yuwuw71KLgcpQ",
   "Uri": "spotify:track:238fv8we4yuwuw71KLgcpQ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/238fv8we4yuwuw71KLgcpQ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/238fv8we4yuwuw71KLgcpQ",
   "Duration_ms": 363280,
   "time_signature": 4,
   "Genre": "post-blackmetal"
 },
 {
   
   "Name": "NuestroFinal(VersiónSalsa)",
   "Danceability": 0.668,
   "Energy": 0.707,
   "Key": 10,
   "Loudness": -8.479,
   "Mode": 1,
   "Speechness": 0.0365,
   "Acousticness": 0.321,
   "Instrumentalness": 0,
   "Liveness": 0.429,
   "Valence": 0.918,
   "Tempo": 93.965,
   "Type": "audio_features",
   "ID": "7wZ7N1ovMboxdcPfHDzsTa",
   "Uri": "spotify:track:7wZ7N1ovMboxdcPfHDzsTa",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7wZ7N1ovMboxdcPfHDzsTa",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7wZ7N1ovMboxdcPfHDzsTa",
   "Duration_ms": 286330,
   "time_signature": 4,
   "Genre": "peruvianhiphop"
 },
 {
   
   "Name": "VinoTinto",
   "Danceability": 0.694,
   "Energy": 0.935,
   "Key": 7,
   "Loudness": -3.215,
   "Mode": 1,
   "Speechness": 0.105,
   "Acousticness": 0.359,
   "Instrumentalness": 0,
   "Liveness": 0.0324,
   "Valence": 0.797,
   "Tempo": 92.478,
   "Type": "audio_features",
   "ID": "15m2Op4d1ZtX0ScPaDNKcd",
   "Uri": "spotify:track:15m2Op4d1ZtX0ScPaDNKcd",
   "Ref_Track": "https://api.spotify.com/v1/tracks/15m2Op4d1ZtX0ScPaDNKcd",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/15m2Op4d1ZtX0ScPaDNKcd",
   "Duration_ms": 198560,
   "time_signature": 4,
   "Genre": "rumbacatalana"
 },
 {
   
   "Name": "Suchmichfindmich",
   "Danceability": 0.676,
   "Energy": 0.885,
   "Key": 6,
   "Loudness": -4.211,
   "Mode": 0,
   "Speechness": 0.0579,
   "Acousticness": 0.00263,
   "Instrumentalness": 0.0000267,
   "Liveness": 0.0947,
   "Valence": 0.618,
   "Tempo": 127.023,
   "Type": "audio_features",
   "ID": "78cQDh4thpWSE4DeTCBeDE",
   "Uri": "spotify:track:78cQDh4thpWSE4DeTCBeDE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/78cQDh4thpWSE4DeTCBeDE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/78cQDh4thpWSE4DeTCBeDE",
   "Duration_ms": 210013,
   "time_signature": 4,
   "Genre": "germanhardrock"
 },
 {
   
   "Name": "CuatroRosas",
   "Danceability": 0.773,
   "Energy": 0.585,
   "Key": 11,
   "Loudness": -5.728,
   "Mode": 1,
   "Speechness": 0.0899,
   "Acousticness": 0.476,
   "Instrumentalness": 0,
   "Liveness": 0.089,
   "Valence": 0.784,
   "Tempo": 148.077,
   "Type": "audio_features",
   "ID": "39pCrC5AA7xhJb98tqWDgb",
   "Uri": "spotify:track:39pCrC5AA7xhJb98tqWDgb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/39pCrC5AA7xhJb98tqWDgb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/39pCrC5AA7xhJb98tqWDgb",
   "Duration_ms": 276360,
   "time_signature": 4,
   "Genre": "vallenato"
 },
 {
   
   "Name": "Dendödavinkeln",
   "Danceability": 0.488,
   "Energy": 0.643,
   "Key": 0,
   "Loudness": -5.869,
   "Mode": 0,
   "Speechness": 0.029,
   "Acousticness": 0.00131,
   "Instrumentalness": 0.000311,
   "Liveness": 0.0794,
   "Valence": 0.276,
   "Tempo": 135.019,
   "Type": "audio_features",
   "ID": "3ZupiEZdTEA0m62uzvgfpy",
   "Uri": "spotify:track:3ZupiEZdTEA0m62uzvgfpy",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3ZupiEZdTEA0m62uzvgfpy",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3ZupiEZdTEA0m62uzvgfpy",
   "Duration_ms": 259493,
   "time_signature": 4,
   "Genre": "swedishpoppunk"
 },
 {
   
   "Name": "IfYouCan\\tHang",
   "Danceability": 0.397,
   "Energy": 0.975,
   "Key": 2,
   "Loudness": -3.532,
   "Mode": 0,
   "Speechness": 0.365,
   "Acousticness": 0.00152,
   "Instrumentalness": 0,
   "Liveness": 0.118,
   "Valence": 0.451,
   "Tempo": 192.021,
   "Type": "audio_features",
   "ID": "3ouugfdFz6exFXUxu7wRvD",
   "Uri": "spotify:track:3ouugfdFz6exFXUxu7wRvD",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3ouugfdFz6exFXUxu7wRvD",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3ouugfdFz6exFXUxu7wRvD",
   "Duration_ms": 250240,
   "time_signature": 4,
   "Genre": "aussieemo"
 },
 {
   
   "Name": "ComeOnMySelector",
   "Danceability": 0.58,
   "Energy": 0.902,
   "Key": 6,
   "Loudness": -8.699,
   "Mode": 0,
   "Speechness": 0.0948,
   "Acousticness": 0.00965,
   "Instrumentalness": 0.852,
   "Liveness": 0.111,
   "Valence": 0.833,
   "Tempo": 95.024,
   "Type": "audio_features",
   "ID": "6lUoKi6r3AY4ECxPOqVs7F",
   "Uri": "spotify:track:6lUoKi6r3AY4ECxPOqVs7F",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6lUoKi6r3AY4ECxPOqVs7F",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6lUoKi6r3AY4ECxPOqVs7F",
   "Duration_ms": 204800,
   "time_signature": 4,
   "Genre": "drillandbass"
 },
 {
   
   "Name": "Mammagamma",
   "Danceability": 0.686,
   "Energy": 0.453,
   "Key": 2,
   "Loudness": -12.588,
   "Mode": 1,
   "Speechness": 0.0323,
   "Acousticness": 0.473,
   "Instrumentalness": 0.895,
   "Liveness": 0.121,
   "Valence": 0.901,
   "Tempo": 103.616,
   "Type": "audio_features",
   "ID": "0PDERhRxsTjly6dN7Brr88",
   "Uri": "spotify:track:0PDERhRxsTjly6dN7Brr88",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0PDERhRxsTjly6dN7Brr88",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0PDERhRxsTjly6dN7Brr88",
   "Duration_ms": 214320,
   "time_signature": 4,
   "Genre": "moog"
 },
 {
   
   "Name": "Stat",
   "Danceability": 0.659,
   "Energy": 0.727,
   "Key": 8,
   "Loudness": -9.6,
   "Mode": 0,
   "Speechness": 0.0561,
   "Acousticness": 0.0198,
   "Instrumentalness": 0.0138,
   "Liveness": 0.106,
   "Valence": 0.52,
   "Tempo": 135.028,
   "Type": "audio_features",
   "ID": "44NZiw9KKebxmFtbv7OGdL",
   "Uri": "spotify:track:44NZiw9KKebxmFtbv7OGdL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/44NZiw9KKebxmFtbv7OGdL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/44NZiw9KKebxmFtbv7OGdL",
   "Duration_ms": 267260,
   "time_signature": 3,
   "Genre": "czechelectronic"
 },
 {
   
   "Name": "Komodo",
   "Danceability": 0.435,
   "Energy": 0.83,
   "Key": 11,
   "Loudness": -6.694,
   "Mode": 0,
   "Speechness": 0.038,
   "Acousticness": 0.108,
   "Instrumentalness": 0.56,
   "Liveness": 0.314,
   "Valence": 0.319,
   "Tempo": 137.706,
   "Type": "audio_features",
   "ID": "0KeUidAZVdvTbM553K7809",
   "Uri": "spotify:track:0KeUidAZVdvTbM553K7809",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0KeUidAZVdvTbM553K7809",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0KeUidAZVdvTbM553K7809",
   "Duration_ms": 204147,
   "time_signature": 4,
   "Genre": "electronica"
 },
 {
   
   "Name": "Jakhochutantsevat\\",
   "Danceability": 0.61,
   "Energy": 0.974,
   "Key": 4,
   "Loudness": -3.902,
   "Mode": 0,
   "Speechness": 0.171,
   "Acousticness": 0.255,
   "Instrumentalness": 0,
   "Liveness": 0.151,
   "Valence": 0.276,
   "Tempo": 128.071,
   "Type": "audio_features",
   "ID": "3qmd6jznB7HxGBVUYtJAWz",
   "Uri": "spotify:track:3qmd6jznB7HxGBVUYtJAWz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3qmd6jznB7HxGBVUYtJAWz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3qmd6jznB7HxGBVUYtJAWz",
   "Duration_ms": 188436,
   "time_signature": 4,
   "Genre": "russianelectronic"
 },
 {
   
   "Name": "Psalm1vers1en4",
   "Danceability": 0.15,
   "Energy": 0.343,
   "Key": 2,
   "Loudness": -16.695,
   "Mode": 1,
   "Speechness": 0.0333,
   "Acousticness": 0.648,
   "Instrumentalness": 0.941,
   "Liveness": 0.0981,
   "Valence": 0.0878,
   "Tempo": 136.636,
   "Type": "audio_features",
   "ID": "3Mv60YbsKZuevEjkoTD9p1",
   "Uri": "spotify:track:3Mv60YbsKZuevEjkoTD9p1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3Mv60YbsKZuevEjkoTD9p1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3Mv60YbsKZuevEjkoTD9p1",
   "Duration_ms": 201227,
   "time_signature": 3,
   "Genre": "psalmen"
 },
 {
   
   "Name": "DialecticChaos",
   "Danceability": 0.16,
   "Energy": 0.982,
   "Key": 0,
   "Loudness": -2.715,
   "Mode": 1,
   "Speechness": 0.0761,
   "Acousticness": 0.0000028,
   "Instrumentalness": 0.847,
   "Liveness": 0.0996,
   "Valence": 0.216,
   "Tempo": 83.458,
   "Type": "audio_features",
   "ID": "2Sl9U6mLbNeaE9lT9C32Td",
   "Uri": "spotify:track:2Sl9U6mLbNeaE9lT9C32Td",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Sl9U6mLbNeaE9lT9C32Td",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Sl9U6mLbNeaE9lT9C32Td",
   "Duration_ms": 145813,
   "time_signature": 4,
   "Genre": "symphonicpowermetal"
 },
 {
   
   "Name": "DancewithYou",
   "Danceability": 0.355,
   "Energy": 0.384,
   "Key": 1,
   "Loudness": -7.27,
   "Mode": 1,
   "Speechness": 0.0462,
   "Acousticness": 0.773,
   "Instrumentalness": 0,
   "Liveness": 0.0808,
   "Valence": 0.385,
   "Tempo": 83.625,
   "Type": "audio_features",
   "ID": "04zipeUI1GQjypWxPfFL8t",
   "Uri": "spotify:track:04zipeUI1GQjypWxPfFL8t",
   "Ref_Track": "https://api.spotify.com/v1/tracks/04zipeUI1GQjypWxPfFL8t",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/04zipeUI1GQjypWxPfFL8t",
   "Duration_ms": 187440,
   "time_signature": 4,
   "Genre": "schoolensemble"
 },
 {
   
   "Name": "Tundra",
   "Danceability": 0.166,
   "Energy": 0.107,
   "Key": 10,
   "Loudness": -18.633,
   "Mode": 1,
   "Speechness": 0.0364,
   "Acousticness": 0.983,
   "Instrumentalness": 0.85,
   "Liveness": 0.0977,
   "Valence": 0.0366,
   "Tempo": 70.962,
   "Type": "audio_features",
   "ID": "23pA44aBQ9IOcZuXPUxJIA",
   "Uri": "spotify:track:23pA44aBQ9IOcZuXPUxJIA",
   "Ref_Track": "https://api.spotify.com/v1/tracks/23pA44aBQ9IOcZuXPUxJIA",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/23pA44aBQ9IOcZuXPUxJIA",
   "Duration_ms": 215773,
   "time_signature": 4,
   "Genre": "norwegianclassical"
 },
 {
   
   "Name": "CirandaCirandinha(feat.aRainhaDeCantigasDeRoda)",
   "Danceability": 0.972,
   "Energy": 0.329,
   "Key": 5,
   "Loudness": -12.487,
   "Mode": 1,
   "Speechness": 0.083,
   "Acousticness": 0.62,
   "Instrumentalness": 0,
   "Liveness": 0.0744,
   "Valence": 0.97,
   "Tempo": 120.091,
   "Type": "audio_features",
   "ID": "4nVZaGrzoj6b07O5TIoewk",
   "Uri": "spotify:track:4nVZaGrzoj6b07O5TIoewk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4nVZaGrzoj6b07O5TIoewk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4nVZaGrzoj6b07O5TIoewk",
   "Duration_ms": 94615,
   "time_signature": 4,
   "Genre": "cancoesinfantis"
 },
 {
   
   "Name": "TheFinalComedown",
   "Danceability": 0.75,
   "Energy": 0.955,
   "Key": 1,
   "Loudness": -8.074,
   "Mode": 1,
   "Speechness": 0.0459,
   "Acousticness": 0.16,
   "Instrumentalness": 0.482,
   "Liveness": 0.0888,
   "Valence": 0.923,
   "Tempo": 105.638,
   "Type": "audio_features",
   "ID": "4rIXPKi6nsXrGAueC0fNgh",
   "Uri": "spotify:track:4rIXPKi6nsXrGAueC0fNgh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4rIXPKi6nsXrGAueC0fNgh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4rIXPKi6nsXrGAueC0fNgh",
   "Duration_ms": 207867,
   "time_signature": 4,
   "Genre": "latinfunk"
 },
 {
   
   "Name": "Slide(feat.Blueface&LilTjay)",
   "Danceability": 0.532,
   "Energy": 0.704,
   "Key": 5,
   "Loudness": -3.895,
   "Mode": 0,
   "Speechness": 0.26,
   "Acousticness": 0.093,
   "Instrumentalness": 0,
   "Liveness": 0.184,
   "Valence": 0.591,
   "Tempo": 96.004,
   "Type": "audio_features",
   "ID": "40Zb4FZ6nS1Hj8RVfaLkCV",
   "Uri": "spotify:track:40Zb4FZ6nS1Hj8RVfaLkCV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/40Zb4FZ6nS1Hj8RVfaLkCV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/40Zb4FZ6nS1Hj8RVfaLkCV",
   "Duration_ms": 186344,
   "time_signature": 4,
   "Genre": "urbancontemporary"
 },
 {
   
   "Name": "(YourLoveKeepsLiftingMe)Higher&Higher",
   "Danceability": 0.631,
   "Energy": 0.69,
   "Key": 2,
   "Loudness": -6.676,
   "Mode": 1,
   "Speechness": 0.0531,
   "Acousticness": 0.176,
   "Instrumentalness": 0,
   "Liveness": 0.121,
   "Valence": 0.938,
   "Tempo": 94.574,
   "Type": "audio_features",
   "ID": "4TBBPZks71c60whhq0PgdP",
   "Uri": "spotify:track:4TBBPZks71c60whhq0PgdP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4TBBPZks71c60whhq0PgdP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4TBBPZks71c60whhq0PgdP",
   "Duration_ms": 181067,
   "time_signature": 4,
   "Genre": "classicsoul"
 },
 {
   
   "Name": "WeightyGhost",
   "Danceability": 0.44,
   "Energy": 0.723,
   "Key": 9,
   "Loudness": -5.489,
   "Mode": 1,
   "Speechness": 0.0345,
   "Acousticness": 0.131,
   "Instrumentalness": 0.0000593,
   "Liveness": 0.134,
   "Valence": 0.196,
   "Tempo": 84.951,
   "Type": "audio_features",
   "ID": "1kVEX9FBvKC8531ALTrNfl",
   "Uri": "spotify:track:1kVEX9FBvKC8531ALTrNfl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1kVEX9FBvKC8531ALTrNfl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1kVEX9FBvKC8531ALTrNfl",
   "Duration_ms": 218973,
   "time_signature": 4,
   "Genre": "halifaxindie"
 },
 {
   
   "Name": "VivreSurVideo",
   "Danceability": 0.708,
   "Energy": 0.61,
   "Key": 7,
   "Loudness": -9.947,
   "Mode": 0,
   "Speechness": 0.0332,
   "Acousticness": 0.000246,
   "Instrumentalness": 0.369,
   "Liveness": 0.0769,
   "Valence": 0.964,
   "Tempo": 131.006,
   "Type": "audio_features",
   "ID": "3OsBTsc9xA9uRklB7lxYRt",
   "Uri": "spotify:track:3OsBTsc9xA9uRklB7lxYRt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3OsBTsc9xA9uRklB7lxYRt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3OsBTsc9xA9uRklB7lxYRt",
   "Duration_ms": 372173,
   "time_signature": 4,
   "Genre": "hi-nrg"
 },
 {
   
   "Name": "Drugs",
   "Danceability": 0.577,
   "Energy": 0.845,
   "Key": 10,
   "Loudness": -7.606,
   "Mode": 0,
   "Speechness": 0.0351,
   "Acousticness": 0.0355,
   "Instrumentalness": 0.0000277,
   "Liveness": 0.0814,
   "Valence": 0.692,
   "Tempo": 115.088,
   "Type": "audio_features",
   "ID": "7j0EnXOIyq4qedtko87r6f",
   "Uri": "spotify:track:7j0EnXOIyq4qedtko87r6f",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7j0EnXOIyq4qedtko87r6f",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7j0EnXOIyq4qedtko87r6f",
   "Duration_ms": 134900,
   "time_signature": 4,
   "Genre": "westernmassindie"
 },
 {
   
   "Name": "SuiteNo.3inCDurBWV1009:V.Bourrée1&2",
   "Danceability": 0.29,
   "Energy": 0.0401,
   "Key": 6,
   "Loudness": -25.373,
   "Mode": 1,
   "Speechness": 0.0556,
   "Acousticness": 0.97,
   "Instrumentalness": 0.932,
   "Liveness": 0.109,
   "Valence": 0.5,
   "Tempo": 84.804,
   "Type": "audio_features",
   "ID": "7fBhShZA5DxPRlkwT7f3wM",
   "Uri": "spotify:track:7fBhShZA5DxPRlkwT7f3wM",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7fBhShZA5DxPRlkwT7f3wM",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7fBhShZA5DxPRlkwT7f3wM",
   "Duration_ms": 221067,
   "time_signature": 4,
   "Genre": "historicallyinformedperformance"
 },
 {
   
   "Name": "SlowDeath",
   "Danceability": 0.459,
   "Energy": 0.829,
   "Key": 2,
   "Loudness": -9.974,
   "Mode": 1,
   "Speechness": 0.0662,
   "Acousticness": 0.00376,
   "Instrumentalness": 0.00000249,
   "Liveness": 0.11,
   "Valence": 0.404,
   "Tempo": 146.843,
   "Type": "audio_features",
   "ID": "44JvhqeLaMatXiA2VAtw25",
   "Uri": "spotify:track:44JvhqeLaMatXiA2VAtw25",
   "Ref_Track": "https://api.spotify.com/v1/tracks/44JvhqeLaMatXiA2VAtw25",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/44JvhqeLaMatXiA2VAtw25",
   "Duration_ms": 263733,
   "time_signature": 4,
   "Genre": "protopunk"
 },
 {
   
   "Name": "YoungandAble",
   "Danceability": 0.671,
   "Energy": 0.504,
   "Key": 5,
   "Loudness": -10.827,
   "Mode": 1,
   "Speechness": 0.0383,
   "Acousticness": 0.788,
   "Instrumentalness": 0,
   "Liveness": 0.11,
   "Valence": 0.671,
   "Tempo": 144.215,
   "Type": "audio_features",
   "ID": "5yQWk2KWtPa4p7p4rCMr2A",
   "Uri": "spotify:track:5yQWk2KWtPa4p7p4rCMr2A",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5yQWk2KWtPa4p7p4rCMr2A",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5yQWk2KWtPa4p7p4rCMr2A",
   "Duration_ms": 246933,
   "time_signature": 4,
   "Genre": "victoriabcindie"
 },
 {
   
   "Name": "RiversofBabylon-LongVersion",
   "Danceability": 0.794,
   "Energy": 0.369,
   "Key": 7,
   "Loudness": -14.082,
   "Mode": 1,
   "Speechness": 0.0684,
   "Acousticness": 0.685,
   "Instrumentalness": 0.342,
   "Liveness": 0.0973,
   "Valence": 0.791,
   "Tempo": 106.884,
   "Type": "audio_features",
   "ID": "3Q6QQMARzPG55AeV62WQ6S",
   "Uri": "spotify:track:3Q6QQMARzPG55AeV62WQ6S",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3Q6QQMARzPG55AeV62WQ6S",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3Q6QQMARzPG55AeV62WQ6S",
   "Duration_ms": 257267,
   "time_signature": 4,
   "Genre": "brazilianska"
 },
 {
   
   "Name": "OneDance",
   "Danceability": 0.777,
   "Energy": 0.613,
   "Key": 1,
   "Loudness": -5.83,
   "Mode": 1,
   "Speechness": 0.0503,
   "Acousticness": 0.0105,
   "Instrumentalness": 0.00164,
   "Liveness": 0.329,
   "Valence": 0.436,
   "Tempo": 103.98,
   "Type": "audio_features",
   "ID": "5ZKG94fnjiuMH5yrC5S9lS",
   "Uri": "spotify:track:5ZKG94fnjiuMH5yrC5S9lS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5ZKG94fnjiuMH5yrC5S9lS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5ZKG94fnjiuMH5yrC5S9lS",
   "Duration_ms": 173973,
   "time_signature": 4,
   "Genre": "j-dance"
 },
 {
   
   "Name": "Lavieenrose",
   "Danceability": 0.38,
   "Energy": 0.277,
   "Key": 8,
   "Loudness": -10.897,
   "Mode": 1,
   "Speechness": 0.0315,
   "Acousticness": 0.977,
   "Instrumentalness": 0,
   "Liveness": 0.158,
   "Valence": 0.489,
   "Tempo": 113.107,
   "Type": "audio_features",
   "ID": "6By5EZtl0GKQuRZBZbk1LU",
   "Uri": "spotify:track:6By5EZtl0GKQuRZBZbk1LU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6By5EZtl0GKQuRZBZbk1LU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6By5EZtl0GKQuRZBZbk1LU",
   "Duration_ms": 187667,
   "time_signature": 5,
   "Genre": "frenchopera"
 },
 {
   
   "Name": "ICanMakeYa",
   "Danceability": 0.714,
   "Energy": 0.531,
   "Key": 2,
   "Loudness": -5.255,
   "Mode": 0,
   "Speechness": 0.126,
   "Acousticness": 0.205,
   "Instrumentalness": 0,
   "Liveness": 0.118,
   "Valence": 0.371,
   "Tempo": 57.49,
   "Type": "audio_features",
   "ID": "75D2N8X59LA1WfcXQEV6CH",
   "Uri": "spotify:track:75D2N8X59LA1WfcXQEV6CH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/75D2N8X59LA1WfcXQEV6CH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/75D2N8X59LA1WfcXQEV6CH",
   "Duration_ms": 152216,
   "time_signature": 4,
   "Genre": "popping"
 },
 {
   
   "Name": "Ruoska",
   "Danceability": 0.328,
   "Energy": 0.764,
   "Key": 2,
   "Loudness": -5.054,
   "Mode": 0,
   "Speechness": 0.078,
   "Acousticness": 0.0000173,
   "Instrumentalness": 0.734,
   "Liveness": 0.188,
   "Valence": 0.0386,
   "Tempo": 119.797,
   "Type": "audio_features",
   "ID": "3yx1BDkbzVkqt0YQli2KGH",
   "Uri": "spotify:track:3yx1BDkbzVkqt0YQli2KGH",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3yx1BDkbzVkqt0YQli2KGH",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3yx1BDkbzVkqt0YQli2KGH",
   "Duration_ms": 363373,
   "time_signature": 4,
   "Genre": "depressiveblackmetal"
 },
 {
   
   "Name": "MeinMädelausKrain",
   "Danceability": 0.582,
   "Energy": 0.691,
   "Key": 10,
   "Loudness": -6.079,
   "Mode": 1,
   "Speechness": 0.0315,
   "Acousticness": 0.754,
   "Instrumentalness": 0.000156,
   "Liveness": 0.321,
   "Valence": 0.964,
   "Tempo": 137.425,
   "Type": "audio_features",
   "ID": "0hqK7GNkVcqQVKlusFO86D",
   "Uri": "spotify:track:0hqK7GNkVcqQVKlusFO86D",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0hqK7GNkVcqQVKlusFO86D",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0hqK7GNkVcqQVKlusFO86D",
   "Duration_ms": 149800,
   "time_signature": 4,
   "Genre": "oberkrainer"
 },
 {
   
   "Name": "FluorescentAdolescent",
   "Danceability": 0.647,
   "Energy": 0.818,
   "Key": 6,
   "Loudness": -5.222,
   "Mode": 0,
   "Speechness": 0.0291,
   "Acousticness": 0.00196,
   "Instrumentalness": 0.0000304,
   "Liveness": 0.177,
   "Valence": 0.813,
   "Tempo": 112.109,
   "Type": "audio_features",
   "ID": "02Y78WneC8bUaKWouKl00v",
   "Uri": "spotify:track:02Y78WneC8bUaKWouKl00v",
   "Ref_Track": "https://api.spotify.com/v1/tracks/02Y78WneC8bUaKWouKl00v",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/02Y78WneC8bUaKWouKl00v",
   "Duration_ms": 177534,
   "time_signature": 4,
   "Genre": "indieemorock"
 },
 {
   
   "Name": "VadVarldenBehoverArKarleken",
   "Danceability": 0.428,
   "Energy": 0.447,
   "Key": 10,
   "Loudness": -5.885,
   "Mode": 0,
   "Speechness": 0.0247,
   "Acousticness": 0.756,
   "Instrumentalness": 0.00000411,
   "Liveness": 0.418,
   "Valence": 0.334,
   "Tempo": 81.136,
   "Type": "audio_features",
   "ID": "3HqDJqFm11FxrHX1Twe1fy",
   "Uri": "spotify:track:3HqDJqFm11FxrHX1Twe1fy",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3HqDJqFm11FxrHX1Twe1fy",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3HqDJqFm11FxrHX1Twe1fy",
   "Duration_ms": 216440,
   "time_signature": 3,
   "Genre": "newwavepop"
 },
 {
   
   "Name": "TooMuchOfHeaven",
   "Danceability": 0.693,
   "Energy": 0.551,
   "Key": 8,
   "Loudness": -13.426,
   "Mode": 1,
   "Speechness": 0.0827,
   "Acousticness": 0.0575,
   "Instrumentalness": 0,
   "Liveness": 0.0916,
   "Valence": 0.459,
   "Tempo": 98.973,
   "Type": "audio_features",
   "ID": "3ssiAIWNW0giyu4as7XvqR",
   "Uri": "spotify:track:3ssiAIWNW0giyu4as7XvqR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3ssiAIWNW0giyu4as7XvqR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3ssiAIWNW0giyu4as7XvqR",
   "Duration_ms": 249191,
   "time_signature": 4,
   "Genre": "europop"
 },
 {
   
   "Name": "Dvadinaradruze",
   "Danceability": 0.373,
   "Energy": 0.574,
   "Key": 9,
   "Loudness": -8.829,
   "Mode": 0,
   "Speechness": 0.0509,
   "Acousticness": 0.898,
   "Instrumentalness": 0.00000418,
   "Liveness": 0.541,
   "Valence": 0.396,
   "Tempo": 123.469,
   "Type": "audio_features",
   "ID": "26rv9czRVC0tETNzXPcDPZ",
   "Uri": "spotify:track:26rv9czRVC0tETNzXPcDPZ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/26rv9czRVC0tETNzXPcDPZ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/26rv9czRVC0tETNzXPcDPZ",
   "Duration_ms": 239891,
   "time_signature": 4,
   "Genre": "yugoslavrock"
 },
 {
   
   "Name": "Ceamaifrumoasazi-Original",
   "Danceability": 0.663,
   "Energy": 0.263,
   "Key": 0,
   "Loudness": -18.885,
   "Mode": 0,
   "Speechness": 0.0354,
   "Acousticness": 0.295,
   "Instrumentalness": 0.00437,
   "Liveness": 0.111,
   "Valence": 0.573,
   "Tempo": 86.097,
   "Type": "audio_features",
   "ID": "5V58UNpo9epT4fvmcnrRNt",
   "Uri": "spotify:track:5V58UNpo9epT4fvmcnrRNt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5V58UNpo9epT4fvmcnrRNt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5V58UNpo9epT4fvmcnrRNt",
   "Duration_ms": 124160,
   "time_signature": 4,
   "Genre": "romanianindie"
 },
 {
   
   "Name": "AbOvo",
   "Danceability": 0.393,
   "Energy": 0.0429,
   "Key": 9,
   "Loudness": -25.727,
   "Mode": 0,
   "Speechness": 0.0341,
   "Acousticness": 0.992,
   "Instrumentalness": 0.925,
   "Liveness": 0.0821,
   "Valence": 0.0394,
   "Tempo": 135.405,
   "Type": "audio_features",
   "ID": "3CI3uK4pduq7bx1jJ6En6C",
   "Uri": "spotify:track:3CI3uK4pduq7bx1jJ6En6C",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3CI3uK4pduq7bx1jJ6En6C",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3CI3uK4pduq7bx1jJ6En6C",
   "Duration_ms": 288280,
   "time_signature": 4,
   "Genre": "neoclassical"
 },
 {
   
   "Name": "Nublado",
   "Danceability": 0.49,
   "Energy": 0.311,
   "Key": 2,
   "Loudness": -10.389,
   "Mode": 0,
   "Speechness": 0.128,
   "Acousticness": 0.806,
   "Instrumentalness": 0.000359,
   "Liveness": 0.111,
   "Valence": 0.139,
   "Tempo": 128.874,
   "Type": "audio_features",
   "ID": "1ojvH9o4L38zEeIi6WuQue",
   "Uri": "spotify:track:1ojvH9o4L38zEeIi6WuQue",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1ojvH9o4L38zEeIi6WuQue",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1ojvH9o4L38zEeIi6WuQue",
   "Duration_ms": 218517,
   "time_signature": 3,
   "Genre": "guatemalanindie"
 },
 {
   
   "Name": "Ferrari",
   "Danceability": 0.442,
   "Energy": 0.652,
   "Key": 11,
   "Loudness": -8.636,
   "Mode": 0,
   "Speechness": 0.0405,
   "Acousticness": 0.00235,
   "Instrumentalness": 0.00000106,
   "Liveness": 0.5,
   "Valence": 0.18,
   "Tempo": 75.576,
   "Type": "audio_features",
   "ID": "7xrwGUa11hnnxXWeTIzcHf",
   "Uri": "spotify:track:7xrwGUa11hnnxXWeTIzcHf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7xrwGUa11hnnxXWeTIzcHf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7xrwGUa11hnnxXWeTIzcHf",
   "Duration_ms": 184173,
   "time_signature": 4,
   "Genre": "indiepoptimism"
 },
 {
   
   "Name": "Ruzezpapiru",
   "Danceability": 0.35,
   "Energy": 0.63,
   "Key": 2,
   "Loudness": -7.069,
   "Mode": 0,
   "Speechness": 0.0337,
   "Acousticness": 0.57,
   "Instrumentalness": 0,
   "Liveness": 0.0783,
   "Valence": 0.757,
   "Tempo": 187.215,
   "Type": "audio_features",
   "ID": "7ofZpnyzDnCN6fRcEyQMhL",
   "Uri": "spotify:track:7ofZpnyzDnCN6fRcEyQMhL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7ofZpnyzDnCN6fRcEyQMhL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7ofZpnyzDnCN6fRcEyQMhL",
   "Duration_ms": 142720,
   "time_signature": 4,
   "Genre": "czechfolk"
 },
 {
   
   "Name": "ChumpSuey",
   "Danceability": 0.789,
   "Energy": 0.739,
   "Key": 9,
   "Loudness": -8.876,
   "Mode": 1,
   "Speechness": 0.0527,
   "Acousticness": 0.0226,
   "Instrumentalness": 0.878,
   "Liveness": 0.309,
   "Valence": 0.749,
   "Tempo": 109.077,
   "Type": "audio_features",
   "ID": "1TTbSC0v0D0jWMDPxJrIsI",
   "Uri": "spotify:track:1TTbSC0v0D0jWMDPxJrIsI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1TTbSC0v0D0jWMDPxJrIsI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1TTbSC0v0D0jWMDPxJrIsI",
   "Duration_ms": 265947,
   "time_signature": 4,
   "Genre": "jazzelectricbass"
 },
 {
   
   "Name": "Sørensen:Lullabies",
   "Danceability": 0.476,
   "Energy": 0.00241,
   "Key": 4,
   "Loudness": -35.684,
   "Mode": 0,
   "Speechness": 0.0779,
   "Acousticness": 0.989,
   "Instrumentalness": 0.909,
   "Liveness": 0.0484,
   "Valence": 0.156,
   "Tempo": 71.866,
   "Type": "audio_features",
   "ID": "5VozZ3wOuOpBAeHv7VaRIk",
   "Uri": "spotify:track:5VozZ3wOuOpBAeHv7VaRIk",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5VozZ3wOuOpBAeHv7VaRIk",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5VozZ3wOuOpBAeHv7VaRIk",
   "Duration_ms": 193556,
   "time_signature": 4,
   "Genre": "danishclassical"
 },
 {
   
   "Name": "Breakin\\ItDown",
   "Danceability": 0.745,
   "Energy": 0.591,
   "Key": 9,
   "Loudness": -6.007,
   "Mode": 0,
   "Speechness": 0.0381,
   "Acousticness": 0.124,
   "Instrumentalness": 0.0676,
   "Liveness": 0.0848,
   "Valence": 0.522,
   "Tempo": 99.998,
   "Type": "audio_features",
   "ID": "0niIl5noAbDrXC6sJ0F3zO",
   "Uri": "spotify:track:0niIl5noAbDrXC6sJ0F3zO",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0niIl5noAbDrXC6sJ0F3zO",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0niIl5noAbDrXC6sJ0F3zO",
   "Duration_ms": 383933,
   "time_signature": 4,
   "Genre": "deepsmoothjazz"
 },
 {
   
   "Name": "JumptoIt-RadioMix",
   "Danceability": 0.776,
   "Energy": 0.698,
   "Key": 11,
   "Loudness": -6.952,
   "Mode": 1,
   "Speechness": 0.164,
   "Acousticness": 0.243,
   "Instrumentalness": 0.00000539,
   "Liveness": 0.0716,
   "Valence": 0.928,
   "Tempo": 120.274,
   "Type": "audio_features",
   "ID": "28ihR0IVqNXJUHrvax2PeP",
   "Uri": "spotify:track:28ihR0IVqNXJUHrvax2PeP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/28ihR0IVqNXJUHrvax2PeP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/28ihR0IVqNXJUHrvax2PeP",
   "Duration_ms": 255547,
   "time_signature": 4,
   "Genre": "post-disco"
 },
 {
   
   "Name": "Don\\tPretend",
   "Danceability": 0.697,
   "Energy": 0.551,
   "Key": 11,
   "Loudness": -8.833,
   "Mode": 1,
   "Speechness": 0.0815,
   "Acousticness": 0.258,
   "Instrumentalness": 0.00551,
   "Liveness": 0.124,
   "Valence": 0.219,
   "Tempo": 89,
   "Type": "audio_features",
   "ID": "78P2cNBhbdjXWIRYuEXkV6",
   "Uri": "spotify:track:78P2cNBhbdjXWIRYuEXkV6",
   "Ref_Track": "https://api.spotify.com/v1/tracks/78P2cNBhbdjXWIRYuEXkV6",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/78P2cNBhbdjXWIRYuEXkV6",
   "Duration_ms": 165840,
   "time_signature": 4,
   "Genre": "r&b"
 },
 {
   
   "Name": "Eishalle",
   "Danceability": 0.257,
   "Energy": 0.662,
   "Key": 7,
   "Loudness": -5.025,
   "Mode": 0,
   "Speechness": 0.0361,
   "Acousticness": 0.55,
   "Instrumentalness": 0.902,
   "Liveness": 0.0715,
   "Valence": 0.0377,
   "Tempo": 144.336,
   "Type": "audio_features",
   "ID": "0ADLoeitpiFlEjSeCCHyGE",
   "Uri": "spotify:track:0ADLoeitpiFlEjSeCCHyGE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0ADLoeitpiFlEjSeCCHyGE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0ADLoeitpiFlEjSeCCHyGE",
   "Duration_ms": 894280,
   "time_signature": 4,
   "Genre": "martialindustrial"
 },
 {
   
   "Name": "SevenDaysinSunnyJune",
   "Danceability": 0.707,
   "Energy": 0.797,
   "Key": 7,
   "Loudness": -7.143,
   "Mode": 1,
   "Speechness": 0.0435,
   "Acousticness": 0.2,
   "Instrumentalness": 0,
   "Liveness": 0.302,
   "Valence": 0.633,
   "Tempo": 105.395,
   "Type": "audio_features",
   "ID": "04hWLKwZKdwl1mZHafiphV",
   "Uri": "spotify:track:04hWLKwZKdwl1mZHafiphV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/04hWLKwZKdwl1mZHafiphV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/04hWLKwZKdwl1mZHafiphV",
   "Duration_ms": 237867,
   "time_signature": 4,
   "Genre": "melbourneindie"
 },
 {
   
   "Name": "Sorry",
   "Danceability": 0.744,
   "Energy": 0.79,
   "Key": 8,
   "Loudness": -4.617,
   "Mode": 0,
   "Speechness": 0.0562,
   "Acousticness": 0.0547,
   "Instrumentalness": 0.000802,
   "Liveness": 0.32,
   "Valence": 0.847,
   "Tempo": 125.002,
   "Type": "audio_features",
   "ID": "23Q3zB4aIt4vvGknhBSE7O",
   "Uri": "spotify:track:23Q3zB4aIt4vvGknhBSE7O",
   "Ref_Track": "https://api.spotify.com/v1/tracks/23Q3zB4aIt4vvGknhBSE7O",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/23Q3zB4aIt4vvGknhBSE7O",
   "Duration_ms": 188640,
   "time_signature": 4,
   "Genre": "deepdisco"
 },
 {
   
   "Name": "Lgbt",
   "Danceability": 0.793,
   "Energy": 0.86,
   "Key": 0,
   "Loudness": -8.663,
   "Mode": 0,
   "Speechness": 0.172,
   "Acousticness": 0.169,
   "Instrumentalness": 0.0000173,
   "Liveness": 0.101,
   "Valence": 0.392,
   "Tempo": 124.961,
   "Type": "audio_features",
   "ID": "0lsw4q8Jei7gEoV7kFe3DS",
   "Uri": "spotify:track:0lsw4q8Jei7gEoV7kFe3DS",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0lsw4q8Jei7gEoV7kFe3DS",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0lsw4q8Jei7gEoV7kFe3DS",
   "Duration_ms": 161332,
   "time_signature": 4,
   "Genre": "lgbtq+hiphop"
 },
 {
   
   "Name": "Ladmigværeden",
   "Danceability": 0.425,
   "Energy": 0.686,
   "Key": 9,
   "Loudness": -6.504,
   "Mode": 1,
   "Speechness": 0.054,
   "Acousticness": 0.0972,
   "Instrumentalness": 0.000023,
   "Liveness": 0.227,
   "Valence": 0.797,
   "Tempo": 183.913,
   "Type": "audio_features",
   "ID": "2CGq1pCAMaislF8b88F5Mf",
   "Uri": "spotify:track:2CGq1pCAMaislF8b88F5Mf",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2CGq1pCAMaislF8b88F5Mf",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2CGq1pCAMaislF8b88F5Mf",
   "Duration_ms": 140800,
   "time_signature": 4,
   "Genre": "dansktop"
 },
 {
   
   "Name": "GuardeNaMente",
   "Danceability": 0.654,
   "Energy": 0.859,
   "Key": 9,
   "Loudness": -3.947,
   "Mode": 0,
   "Speechness": 0.0364,
   "Acousticness": 0.0157,
   "Instrumentalness": 0,
   "Liveness": 0.0683,
   "Valence": 0.408,
   "Tempo": 124.92,
   "Type": "audio_features",
   "ID": "3quvkPGcVsYFwrmYZTSvfo",
   "Uri": "spotify:track:3quvkPGcVsYFwrmYZTSvfo",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3quvkPGcVsYFwrmYZTSvfo",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3quvkPGcVsYFwrmYZTSvfo",
   "Duration_ms": 265107,
   "time_signature": 4,
   "Genre": "brazilianindierock"
 },
 {
   
   "Name": "Verse",
   "Danceability": 0.458,
   "Energy": 0.33,
   "Key": 2,
   "Loudness": -14.644,
   "Mode": 0,
   "Speechness": 0.0327,
   "Acousticness": 0.772,
   "Instrumentalness": 0.00784,
   "Liveness": 0.0895,
   "Valence": 0.134,
   "Tempo": 116.218,
   "Type": "audio_features",
   "ID": "4UXDfbLAlocNcu426BpQGt",
   "Uri": "spotify:track:4UXDfbLAlocNcu426BpQGt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4UXDfbLAlocNcu426BpQGt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4UXDfbLAlocNcu426BpQGt",
   "Duration_ms": 572640,
   "time_signature": 3,
   "Genre": "spiritualjazz"
 },
 {
   
   "Name": "Operator[That\\sNotTheWayItFeels]",
   "Danceability": 0.692,
   "Energy": 0.623,
   "Key": 7,
   "Loudness": -6.227,
   "Mode": 1,
   "Speechness": 0.0298,
   "Acousticness": 0.744,
   "Instrumentalness": 0.00000338,
   "Liveness": 0.0865,
   "Valence": 0.832,
   "Tempo": 129.966,
   "Type": "audio_features",
   "ID": "4v51rv7iRmKL2c0AgeAHDr",
   "Uri": "spotify:track:4v51rv7iRmKL2c0AgeAHDr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4v51rv7iRmKL2c0AgeAHDr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4v51rv7iRmKL2c0AgeAHDr",
   "Duration_ms": 229320,
   "time_signature": 4,
   "Genre": "americanfolkrevival"
 },
 {
   
   "Name": "JaseyRae",
   "Danceability": 0.543,
   "Energy": 0.429,
   "Key": 2,
   "Loudness": -5.673,
   "Mode": 1,
   "Speechness": 0.0256,
   "Acousticness": 0.429,
   "Instrumentalness": 0,
   "Liveness": 0.274,
   "Valence": 0.476,
   "Tempo": 85.015,
   "Type": "audio_features",
   "ID": "2Pmbapgk17cDACiOJGBKKr",
   "Uri": "spotify:track:2Pmbapgk17cDACiOJGBKKr",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Pmbapgk17cDACiOJGBKKr",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Pmbapgk17cDACiOJGBKKr",
   "Duration_ms": 213947,
   "time_signature": 4,
   "Genre": "acousticpunk"
 },
 {
   
   "Name": "ThisMoment-ProgMix",
   "Danceability": 0.704,
   "Energy": 0.572,
   "Key": 11,
   "Loudness": -8.288,
   "Mode": 1,
   "Speechness": 0.0509,
   "Acousticness": 0.0277,
   "Instrumentalness": 0.748,
   "Liveness": 0.074,
   "Valence": 0.143,
   "Tempo": 130.02,
   "Type": "audio_features",
   "ID": "7DEC6CmKOZL8ukdYJbS3k2",
   "Uri": "spotify:track:7DEC6CmKOZL8ukdYJbS3k2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7DEC6CmKOZL8ukdYJbS3k2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7DEC6CmKOZL8ukdYJbS3k2",
   "Duration_ms": 519942,
   "time_signature": 4,
   "Genre": "progressiveupliftingtrance"
 },
 {
   
   "Name": "MikroSteps",
   "Danceability": 0.469,
   "Energy": 0.595,
   "Key": 1,
   "Loudness": -8.046,
   "Mode": 1,
   "Speechness": 0.0319,
   "Acousticness": 0.817,
   "Instrumentalness": 0.495,
   "Liveness": 0.172,
   "Valence": 0.241,
   "Tempo": 90.417,
   "Type": "audio_features",
   "ID": "08TGs4NB20iOEwICLAUrmp",
   "Uri": "spotify:track:08TGs4NB20iOEwICLAUrmp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/08TGs4NB20iOEwICLAUrmp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/08TGs4NB20iOEwICLAUrmp",
   "Duration_ms": 273846,
   "time_signature": 4,
   "Genre": "microtonal"
 },
 {
   
   "Name": "TeenageBirdsong",
   "Danceability": 0.633,
   "Energy": 0.866,
   "Key": 7,
   "Loudness": -7.166,
   "Mode": 1,
   "Speechness": 0.0558,
   "Acousticness": 0.475,
   "Instrumentalness": 0.723,
   "Liveness": 0.0955,
   "Valence": 0.0625,
   "Tempo": 195.986,
   "Type": "audio_features",
   "ID": "11uFqlWnAlFMeQmjHKY38X",
   "Uri": "spotify:track:11uFqlWnAlFMeQmjHKY38X",
   "Ref_Track": "https://api.spotify.com/v1/tracks/11uFqlWnAlFMeQmjHKY38X",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/11uFqlWnAlFMeQmjHKY38X",
   "Duration_ms": 205421,
   "time_signature": 4,
   "Genre": "electronic"
 },
 {
   
   "Name": "SleepParalysis",
   "Danceability": 0.512,
   "Energy": 0.726,
   "Key": 8,
   "Loudness": -10.127,
   "Mode": 1,
   "Speechness": 0.0457,
   "Acousticness": 0.208,
   "Instrumentalness": 0.857,
   "Liveness": 0.082,
   "Valence": 0.0351,
   "Tempo": 125.008,
   "Type": "audio_features",
   "ID": "1uwzAmgnBBO5fi6N4JQnlt",
   "Uri": "spotify:track:1uwzAmgnBBO5fi6N4JQnlt",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1uwzAmgnBBO5fi6N4JQnlt",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1uwzAmgnBBO5fi6N4JQnlt",
   "Duration_ms": 206784,
   "time_signature": 4,
   "Genre": "witchhouse"
 },
 {
   
   "Name": "Hinode",
   "Danceability": 0.679,
   "Energy": 0.818,
   "Key": 4,
   "Loudness": -6.409,
   "Mode": 0,
   "Speechness": 0.105,
   "Acousticness": 0.000643,
   "Instrumentalness": 0.00127,
   "Liveness": 0.097,
   "Valence": 0.29,
   "Tempo": 140.042,
   "Type": "audio_features",
   "ID": "6jwPRNKpY9fNHq4txVcAem",
   "Uri": "spotify:track:6jwPRNKpY9fNHq4txVcAem",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6jwPRNKpY9fNHq4txVcAem",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6jwPRNKpY9fNHq4txVcAem",
   "Duration_ms": 277293,
   "time_signature": 4,
   "Genre": "doujin"
 },
 {
   
   "Name": "Silversplit",
   "Danceability": 0.612,
   "Energy": 0.892,
   "Key": 11,
   "Loudness": -13.402,
   "Mode": 0,
   "Speechness": 0.0826,
   "Acousticness": 0.000104,
   "Instrumentalness": 0.709,
   "Liveness": 0.0855,
   "Valence": 0.198,
   "Tempo": 139.978,
   "Type": "audio_features",
   "ID": "6m1laiZvs2t1synBBr2pya",
   "Uri": "spotify:track:6m1laiZvs2t1synBBr2pya",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6m1laiZvs2t1synBBr2pya",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6m1laiZvs2t1synBBr2pya",
   "Duration_ms": 303816,
   "time_signature": 4,
   "Genre": "germantechno"
 },
 {
   
   "Name": "ByeByeBlackbird",
   "Danceability": 0.525,
   "Energy": 0.168,
   "Key": 9,
   "Loudness": -12.552,
   "Mode": 1,
   "Speechness": 0.0329,
   "Acousticness": 0.892,
   "Instrumentalness": 0.39,
   "Liveness": 0.153,
   "Valence": 0.131,
   "Tempo": 78.906,
   "Type": "audio_features",
   "ID": "2iGbLTqpJYeH3tMWuQ8I1z",
   "Uri": "spotify:track:2iGbLTqpJYeH3tMWuQ8I1z",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2iGbLTqpJYeH3tMWuQ8I1z",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2iGbLTqpJYeH3tMWuQ8I1z",
   "Duration_ms": 187648,
   "time_signature": 4,
   "Genre": "contemporaryjazz"
 },
 {
   
   "Name": "GnossienneNo.1",
   "Danceability": 0.423,
   "Energy": 0.00731,
   "Key": 0,
   "Loudness": -30.5,
   "Mode": 0,
   "Speechness": 0.0499,
   "Acousticness": 0.995,
   "Instrumentalness": 0.903,
   "Liveness": 0.097,
   "Valence": 0.131,
   "Tempo": 87.144,
   "Type": "audio_features",
   "ID": "2q91WtqcZ6Rku2roVwjmwl",
   "Uri": "spotify:track:2q91WtqcZ6Rku2roVwjmwl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2q91WtqcZ6Rku2roVwjmwl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2q91WtqcZ6Rku2roVwjmwl",
   "Duration_ms": 295173,
   "time_signature": 4,
   "Genre": "lateromanticera"
 },
 {
   
   "Name": "Swimming",
   "Danceability": 0.179,
   "Energy": 0.991,
   "Key": 1,
   "Loudness": -1.655,
   "Mode": 1,
   "Speechness": 0.133,
   "Acousticness": 0.000158,
   "Instrumentalness": 0.00376,
   "Liveness": 0.0898,
   "Valence": 0.27,
   "Tempo": 83.97,
   "Type": "audio_features",
   "ID": "24wZn1djFi2bgYPJDRZD5d",
   "Uri": "spotify:track:24wZn1djFi2bgYPJDRZD5d",
   "Ref_Track": "https://api.spotify.com/v1/tracks/24wZn1djFi2bgYPJDRZD5d",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/24wZn1djFi2bgYPJDRZD5d",
   "Duration_ms": 176548,
   "time_signature": 4,
   "Genre": "minneapolispunk"
 },
 {
   
   "Name": "Diskotek",
   "Danceability": 0.821,
   "Energy": 0.653,
   "Key": 0,
   "Loudness": -5.495,
   "Mode": 1,
   "Speechness": 0.186,
   "Acousticness": 0.0252,
   "Instrumentalness": 0,
   "Liveness": 0.166,
   "Valence": 0.201,
   "Tempo": 136.023,
   "Type": "audio_features",
   "ID": "3hLlXmMzCVo04WHmWACs8O",
   "Uri": "spotify:track:3hLlXmMzCVo04WHmWACs8O",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3hLlXmMzCVo04WHmWACs8O",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3hLlXmMzCVo04WHmWACs8O",
   "Duration_ms": 158879,
   "time_signature": 4,
   "Genre": "turkishhiphop"
 },
 {
   
   "Name": "ItsInHisKiss",
   "Danceability": 0.576,
   "Energy": 0.76,
   "Key": 9,
   "Loudness": -3.935,
   "Mode": 1,
   "Speechness": 0.1,
   "Acousticness": 0.656,
   "Instrumentalness": 0,
   "Liveness": 0.142,
   "Valence": 0.939,
   "Tempo": 121.496,
   "Type": "audio_features",
   "ID": "6TNCYMSq7L3SfOLcGbYHFz",
   "Uri": "spotify:track:6TNCYMSq7L3SfOLcGbYHFz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6TNCYMSq7L3SfOLcGbYHFz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6TNCYMSq7L3SfOLcGbYHFz",
   "Duration_ms": 133982,
   "time_signature": 4,
   "Genre": "girlgroup"
 },
 {
   
   "Name": "Hamachidori",
   "Danceability": 0.64,
   "Energy": 0.0782,
   "Key": 6,
   "Loudness": -17.123,
   "Mode": 1,
   "Speechness": 0.0383,
   "Acousticness": 0.88,
   "Instrumentalness": 0.00000705,
   "Liveness": 0.095,
   "Valence": 0.339,
   "Tempo": 82.167,
   "Type": "audio_features",
   "ID": "5vjDUO1IgDNN3pIfAvuBAI",
   "Uri": "spotify:track:5vjDUO1IgDNN3pIfAvuBAI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5vjDUO1IgDNN3pIfAvuBAI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5vjDUO1IgDNN3pIfAvuBAI",
   "Duration_ms": 356040,
   "time_signature": 4,
   "Genre": "okinawanfolk"
 },
 {
   
   "Name": "Yes!IAmaLongWayfromHome",
   "Danceability": 0.417,
   "Energy": 0.257,
   "Key": 2,
   "Loudness": -15.197,
   "Mode": 1,
   "Speechness": 0.0375,
   "Acousticness": 0.214,
   "Instrumentalness": 0.489,
   "Liveness": 0.152,
   "Valence": 0.0333,
   "Tempo": 132.576,
   "Type": "audio_features",
   "ID": "2XoDCSU6sEjFGFrLsoC1pu",
   "Uri": "spotify:track:2XoDCSU6sEjFGFrLsoC1pu",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2XoDCSU6sEjFGFrLsoC1pu",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2XoDCSU6sEjFGFrLsoC1pu",
   "Duration_ms": 357160,
   "time_signature": 4,
   "Genre": "atmosphericpost-rock"
 },
 {
   
   "Name": "Rock\\N\\RollOutlaw",
   "Danceability": 0.533,
   "Energy": 0.772,
   "Key": 4,
   "Loudness": -11.588,
   "Mode": 1,
   "Speechness": 0.0312,
   "Acousticness": 0.151,
   "Instrumentalness": 0.468,
   "Liveness": 0.27,
   "Valence": 0.617,
   "Tempo": 93.057,
   "Type": "audio_features",
   "ID": "2Ng8rpzfNPWHxCy91598wE",
   "Uri": "spotify:track:2Ng8rpzfNPWHxCy91598wE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Ng8rpzfNPWHxCy91598wE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Ng8rpzfNPWHxCy91598wE",
   "Duration_ms": 201200,
   "time_signature": 4,
   "Genre": "australianrock"
 },
 {
   
   "Name": "Se...",
   "Danceability": 0.575,
   "Energy": 0.392,
   "Key": 9,
   "Loudness": -10.383,
   "Mode": 1,
   "Speechness": 0.035,
   "Acousticness": 0.609,
   "Instrumentalness": 0.0000745,
   "Liveness": 0.0624,
   "Valence": 0.498,
   "Tempo": 179.789,
   "Type": "audio_features",
   "ID": "0PgsB53yhlKs8D19LgYU4i",
   "Uri": "spotify:track:0PgsB53yhlKs8D19LgYU4i",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0PgsB53yhlKs8D19LgYU4i",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0PgsB53yhlKs8D19LgYU4i",
   "Duration_ms": 291533,
   "time_signature": 4,
   "Genre": "novampb"
 },
 {
   
   "Name": "EasyToLove",
   "Danceability": 0.46,
   "Energy": 0.771,
   "Key": 9,
   "Loudness": -7.451,
   "Mode": 1,
   "Speechness": 0.0483,
   "Acousticness": 0.0152,
   "Instrumentalness": 0.0686,
   "Liveness": 0.265,
   "Valence": 0.519,
   "Tempo": 118.124,
   "Type": "audio_features",
   "ID": "3bJ73tmHnoeBfDZ4pLZqZ8",
   "Uri": "spotify:track:3bJ73tmHnoeBfDZ4pLZqZ8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3bJ73tmHnoeBfDZ4pLZqZ8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3bJ73tmHnoeBfDZ4pLZqZ8",
   "Duration_ms": 289773,
   "time_signature": 3,
   "Genre": "sydneyindie"
 },
 {
   
   "Name": "FeatheredIndians",
   "Danceability": 0.536,
   "Energy": 0.574,
   "Key": 7,
   "Loudness": -6.705,
   "Mode": 1,
   "Speechness": 0.0254,
   "Acousticness": 0.75,
   "Instrumentalness": 0.00277,
   "Liveness": 0.105,
   "Valence": 0.877,
   "Tempo": 87.194,
   "Type": "audio_features",
   "ID": "2tgQaL85WoRfgEa4hFQgrE",
   "Uri": "spotify:track:2tgQaL85WoRfgEa4hFQgrE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2tgQaL85WoRfgEa4hFQgrE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2tgQaL85WoRfgEa4hFQgrE",
   "Duration_ms": 224947,
   "time_signature": 4,
   "Genre": "stlindie"
 },
 {
   
   "Name": "Tallis:IfYeLoveMe",
   "Danceability": 0.202,
   "Energy": 0.0489,
   "Key": 4,
   "Loudness": -28.848,
   "Mode": 1,
   "Speechness": 0.0468,
   "Acousticness": 0.996,
   "Instrumentalness": 0.177,
   "Liveness": 0.0906,
   "Valence": 0.0624,
   "Tempo": 80.259,
   "Type": "audio_features",
   "ID": "7kQKsxbRIgSbM1rxZi5s9V",
   "Uri": "spotify:track:7kQKsxbRIgSbM1rxZi5s9V",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7kQKsxbRIgSbM1rxZi5s9V",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7kQKsxbRIgSbM1rxZi5s9V",
   "Duration_ms": 124133,
   "time_signature": 3,
   "Genre": "chamberensemble"
 },
 {
   
   "Name": "TheFieldsOfAthenry",
   "Danceability": 0.414,
   "Energy": 0.249,
   "Key": 4,
   "Loudness": -13.351,
   "Mode": 1,
   "Speechness": 0.0323,
   "Acousticness": 0.744,
   "Instrumentalness": 0.0016,
   "Liveness": 0.0972,
   "Valence": 0.229,
   "Tempo": 113.012,
   "Type": "audio_features",
   "ID": "3BPcgBQKNJnwLjcwXNPyx0",
   "Uri": "spotify:track:3BPcgBQKNJnwLjcwXNPyx0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3BPcgBQKNJnwLjcwXNPyx0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3BPcgBQKNJnwLjcwXNPyx0",
   "Duration_ms": 280333,
   "time_signature": 4,
   "Genre": "traditionalfolk"
 },
 {
   
   "Name": "Mademoiselle",
   "Danceability": 0.794,
   "Energy": 0.702,
   "Key": 6,
   "Loudness": -5.656,
   "Mode": 0,
   "Speechness": 0.0346,
   "Acousticness": 0.0671,
   "Instrumentalness": 0,
   "Liveness": 0.155,
   "Valence": 0.535,
   "Tempo": 121.938,
   "Type": "audio_features",
   "ID": "2aPnpV1hT7l3eP10uSGK6c",
   "Uri": "spotify:track:2aPnpV1hT7l3eP10uSGK6c",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2aPnpV1hT7l3eP10uSGK6c",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2aPnpV1hT7l3eP10uSGK6c",
   "Duration_ms": 189344,
   "time_signature": 4,
   "Genre": "hippop"
 },
 {
   
   "Name": "Destiny",
   "Danceability": 0.774,
   "Energy": 0.852,
   "Key": 6,
   "Loudness": -8.079,
   "Mode": 0,
   "Speechness": 0.0464,
   "Acousticness": 0.00109,
   "Instrumentalness": 0.872,
   "Liveness": 0.238,
   "Valence": 0.92,
   "Tempo": 126.992,
   "Type": "audio_features",
   "ID": "2zKrpaY05x7l7ec2RiPCbc",
   "Uri": "spotify:track:2zKrpaY05x7l7ec2RiPCbc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2zKrpaY05x7l7ec2RiPCbc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2zKrpaY05x7l7ec2RiPCbc",
   "Duration_ms": 299490,
   "time_signature": 4,
   "Genre": "funkybreaks"
 },
 {
   
   "Name": "KickinUpMud",
   "Danceability": 0.783,
   "Energy": 0.614,
   "Key": 5,
   "Loudness": -5.935,
   "Mode": 0,
   "Speechness": 0.29,
   "Acousticness": 0.0417,
   "Instrumentalness": 0,
   "Liveness": 0.0938,
   "Valence": 0.768,
   "Tempo": 65.005,
   "Type": "audio_features",
   "ID": "6eHTrSCKzmYNQjXtTKDpHV",
   "Uri": "spotify:track:6eHTrSCKzmYNQjXtTKDpHV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6eHTrSCKzmYNQjXtTKDpHV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6eHTrSCKzmYNQjXtTKDpHV",
   "Duration_ms": 216493,
   "time_signature": 4,
   "Genre": "countryrap"
 },
 {
   
   "Name": "Mademoiselle",
   "Danceability": 0.794,
   "Energy": 0.702,
   "Key": 6,
   "Loudness": -5.656,
   "Mode": 0,
   "Speechness": 0.0346,
   "Acousticness": 0.0671,
   "Instrumentalness": 0,
   "Liveness": 0.155,
   "Valence": 0.535,
   "Tempo": 121.938,
   "Type": "audio_features",
   "ID": "2aPnpV1hT7l3eP10uSGK6c",
   "Uri": "spotify:track:2aPnpV1hT7l3eP10uSGK6c",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2aPnpV1hT7l3eP10uSGK6c",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2aPnpV1hT7l3eP10uSGK6c",
   "Duration_ms": 189344,
   "time_signature": 4,
   "Genre": "poprap"
 },
 {
   
   "Name": "TheyReminisceoverYou-SingleVersion",
   "Danceability": 0.761,
   "Energy": 0.683,
   "Key": 2,
   "Loudness": -10.889,
   "Mode": 1,
   "Speechness": 0.164,
   "Acousticness": 0.141,
   "Instrumentalness": 0,
   "Liveness": 0.342,
   "Valence": 0.671,
   "Tempo": 101.787,
   "Type": "audio_features",
   "ID": "2Mb3zpobD0CvJGWv6NpsPy",
   "Uri": "spotify:track:2Mb3zpobD0CvJGWv6NpsPy",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Mb3zpobD0CvJGWv6NpsPy",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Mb3zpobD0CvJGWv6NpsPy",
   "Duration_ms": 286693,
   "time_signature": 4,
   "Genre": "australianundergroundhiphop"
 },
 {
   
   "Name": "YoMeLlamoCumbia",
   "Danceability": 0.546,
   "Energy": 0.39,
   "Key": 9,
   "Loudness": -13.176,
   "Mode": 0,
   "Speechness": 0.0705,
   "Acousticness": 0.861,
   "Instrumentalness": 0.00496,
   "Liveness": 0.124,
   "Valence": 0.686,
   "Tempo": 87.11,
   "Type": "audio_features",
   "ID": "3rKrypBgAbjWzSN9ajvyXE",
   "Uri": "spotify:track:3rKrypBgAbjWzSN9ajvyXE",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3rKrypBgAbjWzSN9ajvyXE",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3rKrypBgAbjWzSN9ajvyXE",
   "Duration_ms": 269560,
   "time_signature": 4,
   "Genre": "folclorcolombiano"
 },
 {
   
   "Name": "Burattino",
   "Danceability": 0.681,
   "Energy": 0.711,
   "Key": 7,
   "Loudness": -6.513,
   "Mode": 1,
   "Speechness": 0.0743,
   "Acousticness": 0.145,
   "Instrumentalness": 0,
   "Liveness": 0.22,
   "Valence": 0.575,
   "Tempo": 128.135,
   "Type": "audio_features",
   "ID": "0ee5NBrsqfguBEBsUjomNv",
   "Uri": "spotify:track:0ee5NBrsqfguBEBsUjomNv",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0ee5NBrsqfguBEBsUjomNv",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0ee5NBrsqfguBEBsUjomNv",
   "Duration_ms": 216933,
   "time_signature": 4,
   "Genre": "italianhiphop"
 },
 {
   
   "Name": "GrowingMould",
   "Danceability": 0.791,
   "Energy": 0.578,
   "Key": 3,
   "Loudness": -8.647,
   "Mode": 0,
   "Speechness": 0.0488,
   "Acousticness": 0.143,
   "Instrumentalness": 0.000369,
   "Liveness": 0.0953,
   "Valence": 0.622,
   "Tempo": 128.89,
   "Type": "audio_features",
   "ID": "2PpglLOBqlTejK76gghHS8",
   "Uri": "spotify:track:2PpglLOBqlTejK76gghHS8",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2PpglLOBqlTejK76gghHS8",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2PpglLOBqlTejK76gghHS8",
   "Duration_ms": 179731,
   "time_signature": 4,
   "Genre": "aucklandindie"
 },
 {
   
   "Name": "CzyTenPaniPani",
   "Danceability": 0.615,
   "Energy": 0.771,
   "Key": 0,
   "Loudness": -3.658,
   "Mode": 0,
   "Speechness": 0.0509,
   "Acousticness": 0.383,
   "Instrumentalness": 0,
   "Liveness": 0.0635,
   "Valence": 0.883,
   "Tempo": 172.061,
   "Type": "audio_features",
   "ID": "22iMyCNRjIYCNvRynvgEQB",
   "Uri": "spotify:track:22iMyCNRjIYCNvRynvgEQB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/22iMyCNRjIYCNvRynvgEQB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/22iMyCNRjIYCNvRynvgEQB",
   "Duration_ms": 175547,
   "time_signature": 4,
   "Genre": "polishpop"
 },
 {
   
   "Name": "FaceBehindHerCigarette",
   "Danceability": 0.737,
   "Energy": 0.733,
   "Key": 5,
   "Loudness": -5.738,
   "Mode": 0,
   "Speechness": 0.0344,
   "Acousticness": 0.075,
   "Instrumentalness": 0.201,
   "Liveness": 0.169,
   "Valence": 0.78,
   "Tempo": 119.993,
   "Type": "audio_features",
   "ID": "6Um81qv4wpI4VeZFEt1l0F",
   "Uri": "spotify:track:6Um81qv4wpI4VeZFEt1l0F",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6Um81qv4wpI4VeZFEt1l0F",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6Um81qv4wpI4VeZFEt1l0F",
   "Duration_ms": 199827,
   "time_signature": 4,
   "Genre": "welshindie"
 },
 {
   
   "Name": "LettersToThePresident",
   "Danceability": 0.612,
   "Energy": 0.673,
   "Key": 1,
   "Loudness": -14.293,
   "Mode": 1,
   "Speechness": 0.0361,
   "Acousticness": 0.0035,
   "Instrumentalness": 0,
   "Liveness": 0.0554,
   "Valence": 0.51,
   "Tempo": 102.996,
   "Type": "audio_features",
   "ID": "3ockDGgrp9VGlsz9QGw3Pg",
   "Uri": "spotify:track:3ockDGgrp9VGlsz9QGw3Pg",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3ockDGgrp9VGlsz9QGw3Pg",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3ockDGgrp9VGlsz9QGw3Pg",
   "Duration_ms": 195547,
   "time_signature": 4,
   "Genre": "christianpunk"
 },
 {
   
   "Name": "FortunateSon",
   "Danceability": 0.643,
   "Energy": 0.669,
   "Key": 0,
   "Loudness": -7.485,
   "Mode": 1,
   "Speechness": 0.0398,
   "Acousticness": 0.208,
   "Instrumentalness": 0.00664,
   "Liveness": 0.151,
   "Valence": 0.609,
   "Tempo": 132.709,
   "Type": "audio_features",
   "ID": "3yI282DoIJyERd0vGukMoB",
   "Uri": "spotify:track:3yI282DoIJyERd0vGukMoB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3yI282DoIJyERd0vGukMoB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3yI282DoIJyERd0vGukMoB",
   "Duration_ms": 140773,
   "time_signature": 4,
   "Genre": "classicgaragerock"
 },
 {
   
   "Name": "Everflow",
   "Danceability": 0.525,
   "Energy": 0.472,
   "Key": 0,
   "Loudness": -11.442,
   "Mode": 1,
   "Speechness": 0.0327,
   "Acousticness": 0.651,
   "Instrumentalness": 0.925,
   "Liveness": 0.0957,
   "Valence": 0.062,
   "Tempo": 120.049,
   "Type": "audio_features",
   "ID": "2g0lmCToSrX89PHy67Mq0z",
   "Uri": "spotify:track:2g0lmCToSrX89PHy67Mq0z",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2g0lmCToSrX89PHy67Mq0z",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2g0lmCToSrX89PHy67Mq0z",
   "Duration_ms": 218227,
   "time_signature": 4,
   "Genre": "ambientworship"
 },
 {
   
   "Name": "FollowTheSun",
   "Danceability": 0.615,
   "Energy": 0.403,
   "Key": 0,
   "Loudness": -10.594,
   "Mode": 1,
   "Speechness": 0.0409,
   "Acousticness": 0.603,
   "Instrumentalness": 0.0000645,
   "Liveness": 0.106,
   "Valence": 0.193,
   "Tempo": 123.846,
   "Type": "audio_features",
   "ID": "3Y7fpFZbHLpAvWJJYGehz0",
   "Uri": "spotify:track:3Y7fpFZbHLpAvWJJYGehz0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3Y7fpFZbHLpAvWJJYGehz0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3Y7fpFZbHLpAvWJJYGehz0",
   "Duration_ms": 256267,
   "time_signature": 4,
   "Genre": "australianindiefolk"
 },
 {
   
   "Name": "IhrwolltetSpaß",
   "Danceability": 0.613,
   "Energy": 0.958,
   "Key": 9,
   "Loudness": -5.004,
   "Mode": 1,
   "Speechness": 0.0677,
   "Acousticness": 0.00587,
   "Instrumentalness": 0,
   "Liveness": 0.037,
   "Valence": 0.686,
   "Tempo": 144.95,
   "Type": "audio_features",
   "ID": "5aEucuIVnTeOPJ8ruBQ0Ok",
   "Uri": "spotify:track:5aEucuIVnTeOPJ8ruBQ0Ok",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5aEucuIVnTeOPJ8ruBQ0Ok",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5aEucuIVnTeOPJ8ruBQ0Ok",
   "Duration_ms": 221707,
   "time_signature": 4,
   "Genre": "medievalrock"
 },
 {
   
   "Name": "TakeonMe",
   "Danceability": 0.573,
   "Energy": 0.902,
   "Key": 6,
   "Loudness": -7.638,
   "Mode": 0,
   "Speechness": 0.054,
   "Acousticness": 0.018,
   "Instrumentalness": 0.00125,
   "Liveness": 0.0928,
   "Valence": 0.876,
   "Tempo": 84.412,
   "Type": "audio_features",
   "ID": "2WfaOiMkCvy7F5fcp2zZ8L",
   "Uri": "spotify:track:2WfaOiMkCvy7F5fcp2zZ8L",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2WfaOiMkCvy7F5fcp2zZ8L",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2WfaOiMkCvy7F5fcp2zZ8L",
   "Duration_ms": 225280,
   "time_signature": 4,
   "Genre": "post-romanticera"
 },
 {
   
   "Name": "Persephone(TheGatheringOfFlowers)[Remastered]",
   "Danceability": 0.166,
   "Energy": 0.183,
   "Key": 0,
   "Loudness": -9.738,
   "Mode": 0,
   "Speechness": 0.0378,
   "Acousticness": 0.0187,
   "Instrumentalness": 0.0161,
   "Liveness": 0.111,
   "Valence": 0.0348,
   "Tempo": 71.9,
   "Type": "audio_features",
   "ID": "6J7t5b6cTWhhGTbkSbedBd",
   "Uri": "spotify:track:6J7t5b6cTWhhGTbkSbedBd",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6J7t5b6cTWhhGTbkSbedBd",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6J7t5b6cTWhhGTbkSbedBd",
   "Duration_ms": 393427,
   "time_signature": 3,
   "Genre": "etherealwave"
 },
 {
   
   "Name": "TheTown(SabziRemix)",
   "Danceability": 0.612,
   "Energy": 0.607,
   "Key": 8,
   "Loudness": -7.452,
   "Mode": 1,
   "Speechness": 0.294,
   "Acousticness": 0.304,
   "Instrumentalness": 0,
   "Liveness": 0.0966,
   "Valence": 0.657,
   "Tempo": 84.535,
   "Type": "audio_features",
   "ID": "6vZ9kWTiZVEvuO5ZdfO3Cx",
   "Uri": "spotify:track:6vZ9kWTiZVEvuO5ZdfO3Cx",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6vZ9kWTiZVEvuO5ZdfO3Cx",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6vZ9kWTiZVEvuO5ZdfO3Cx",
   "Duration_ms": 266294,
   "time_signature": 4,
   "Genre": "portlandhiphop"
 },
 {
   
   "Name": "Intergalactic-Remastered",
   "Danceability": 0.734,
   "Energy": 0.864,
   "Key": 2,
   "Loudness": -6.119,
   "Mode": 1,
   "Speechness": 0.303,
   "Acousticness": 0.022,
   "Instrumentalness": 0.00000994,
   "Liveness": 0.246,
   "Valence": 0.47,
   "Tempo": 105.933,
   "Type": "audio_features",
   "ID": "5fpizYGbi5IQoEraj6FP0R",
   "Uri": "spotify:track:5fpizYGbi5IQoEraj6FP0R",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5fpizYGbi5IQoEraj6FP0R",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5fpizYGbi5IQoEraj6FP0R",
   "Duration_ms": 231493,
   "time_signature": 4,
   "Genre": "bboy"
 },
 {
   
   "Name": "MakeItwithYou",
   "Danceability": 0.629,
   "Energy": 0.356,
   "Key": 4,
   "Loudness": -11.135,
   "Mode": 1,
   "Speechness": 0.0246,
   "Acousticness": 0.66,
   "Instrumentalness": 0.000617,
   "Liveness": 0.173,
   "Valence": 0.472,
   "Tempo": 83.886,
   "Type": "audio_features",
   "ID": "11gfsr13S8qsfN48IILcHU",
   "Uri": "spotify:track:11gfsr13S8qsfN48IILcHU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/11gfsr13S8qsfN48IILcHU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/11gfsr13S8qsfN48IILcHU",
   "Duration_ms": 192200,
   "time_signature": 4,
   "Genre": "mellowgold"
 },
 {
   
   "Name": "GameofPricks",
   "Danceability": 0.326,
   "Energy": 0.906,
   "Key": 9,
   "Loudness": -4.229,
   "Mode": 1,
   "Speechness": 0.0473,
   "Acousticness": 0.000519,
   "Instrumentalness": 0.00963,
   "Liveness": 0.146,
   "Valence": 0.312,
   "Tempo": 139.093,
   "Type": "audio_features",
   "ID": "3vwST30FQzi06Ay3ZG3cMp",
   "Uri": "spotify:track:3vwST30FQzi06Ay3ZG3cMp",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3vwST30FQzi06Ay3ZG3cMp",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3vwST30FQzi06Ay3ZG3cMp",
   "Duration_ms": 135160,
   "time_signature": 4,
   "Genre": "gbvfi"
 },
 {
   
   "Name": "KillThisLove",
   "Danceability": 0.738,
   "Energy": 0.861,
   "Key": 2,
   "Loudness": -4.141,
   "Mode": 1,
   "Speechness": 0.237,
   "Acousticness": 0.32,
   "Instrumentalness": 0.00175,
   "Liveness": 0.325,
   "Valence": 0.58,
   "Tempo": 131.974,
   "Type": "audio_features",
   "ID": "0M98PvIvx7vZ8LDpzMw1hB",
   "Uri": "spotify:track:0M98PvIvx7vZ8LDpzMw1hB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0M98PvIvx7vZ8LDpzMw1hB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0M98PvIvx7vZ8LDpzMw1hB",
   "Duration_ms": 189052,
   "time_signature": 4,
   "Genre": "koreanpop"
 },
 {
   
   "Name": "YouWorryMe",
   "Danceability": 0.665,
   "Energy": 0.639,
   "Key": 2,
   "Loudness": -7.747,
   "Mode": 1,
   "Speechness": 0.0276,
   "Acousticness": 0.121,
   "Instrumentalness": 0.327,
   "Liveness": 0.0952,
   "Valence": 0.642,
   "Tempo": 100.082,
   "Type": "audio_features",
   "ID": "0gqxf8wrEkewjmZB7OT4mL",
   "Uri": "spotify:track:0gqxf8wrEkewjmZB7OT4mL",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0gqxf8wrEkewjmZB7OT4mL",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0gqxf8wrEkewjmZB7OT4mL",
   "Duration_ms": 214160,
   "time_signature": 4,
   "Genre": "alternativerootsrock"
 },
 {
   
   "Name": "Razem",
   "Danceability": 0.435,
   "Energy": 0.901,
   "Key": 8,
   "Loudness": -5.347,
   "Mode": 1,
   "Speechness": 0.0459,
   "Acousticness": 0.0607,
   "Instrumentalness": 0,
   "Liveness": 0.356,
   "Valence": 0.272,
   "Tempo": 159.957,
   "Type": "audio_features",
   "ID": "16U1n89NQ5hbOJL4AHbhu9",
   "Uri": "spotify:track:16U1n89NQ5hbOJL4AHbhu9",
   "Ref_Track": "https://api.spotify.com/v1/tracks/16U1n89NQ5hbOJL4AHbhu9",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/16U1n89NQ5hbOJL4AHbhu9",
   "Duration_ms": 219847,
   "time_signature": 4,
   "Genre": "polishpunk"
 },
 {
   
   "Name": "AMessagetoYouRudy-2002RemasteredVersion",
   "Danceability": 0.906,
   "Energy": 0.45,
   "Key": 0,
   "Loudness": -8.003,
   "Mode": 1,
   "Speechness": 0.0627,
   "Acousticness": 0.149,
   "Instrumentalness": 0.000232,
   "Liveness": 0.168,
   "Valence": 0.969,
   "Tempo": 103.476,
   "Type": "audio_features",
   "ID": "2EwEtZrsBpjLmwhe7GCGhs",
   "Uri": "spotify:track:2EwEtZrsBpjLmwhe7GCGhs",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2EwEtZrsBpjLmwhe7GCGhs",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2EwEtZrsBpjLmwhe7GCGhs",
   "Duration_ms": 172600,
   "time_signature": 4,
   "Genre": "russianreggae"
 },
 {
   
   "Name": "MostPeopleIKnowThinkThatI\\mCrazy(Live)",
   "Danceability": 0.206,
   "Energy": 0.812,
   "Key": 7,
   "Loudness": -7.393,
   "Mode": 1,
   "Speechness": 0.0467,
   "Acousticness": 0.0187,
   "Instrumentalness": 0.000577,
   "Liveness": 0.939,
   "Valence": 0.5,
   "Tempo": 135.134,
   "Type": "audio_features",
   "ID": "1XWhHbMMJBBByf2rZfR1sJ",
   "Uri": "spotify:track:1XWhHbMMJBBByf2rZfR1sJ",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1XWhHbMMJBBByf2rZfR1sJ",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1XWhHbMMJBBByf2rZfR1sJ",
   "Duration_ms": 448907,
   "time_signature": 4,
   "Genre": "deepchristianrock"
 },
 {
   
   "Name": "WeeBabyBlues",
   "Danceability": 0.687,
   "Energy": 0.667,
   "Key": 2,
   "Loudness": -7.837,
   "Mode": 0,
   "Speechness": 0.0311,
   "Acousticness": 0.446,
   "Instrumentalness": 0.00957,
   "Liveness": 0.276,
   "Valence": 0.923,
   "Tempo": 123.617,
   "Type": "audio_features",
   "ID": "0VziYoppHx4lOJQUDOqDl1",
   "Uri": "spotify:track:0VziYoppHx4lOJQUDOqDl1",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0VziYoppHx4lOJQUDOqDl1",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0VziYoppHx4lOJQUDOqDl1",
   "Duration_ms": 193000,
   "time_signature": 4,
   "Genre": "bluesband"
 },
 {
   
   "Name": "Ladigueducul",
   "Danceability": 0.817,
   "Energy": 0.669,
   "Key": 0,
   "Loudness": -7.73,
   "Mode": 1,
   "Speechness": 0.269,
   "Acousticness": 0.248,
   "Instrumentalness": 0,
   "Liveness": 0.299,
   "Valence": 0.681,
   "Tempo": 121.955,
   "Type": "audio_features",
   "ID": "65edR4OzvYxteptpMk35ht",
   "Uri": "spotify:track:65edR4OzvYxteptpMk35ht",
   "Ref_Track": "https://api.spotify.com/v1/tracks/65edR4OzvYxteptpMk35ht",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/65edR4OzvYxteptpMk35ht",
   "Duration_ms": 146600,
   "time_signature": 4,
   "Genre": "chansonpaillarde"
 },
 {
   
   "Name": "GodspeedYou-CharmingHorsesEdit",
   "Danceability": 0.763,
   "Energy": 0.793,
   "Key": 2,
   "Loudness": -6.843,
   "Mode": 1,
   "Speechness": 0.0314,
   "Acousticness": 0.173,
   "Instrumentalness": 0.0000172,
   "Liveness": 0.222,
   "Valence": 0.361,
   "Tempo": 121.964,
   "Type": "audio_features",
   "ID": "3jnYgNN7k7FuojVkgE3Wnj",
   "Uri": "spotify:track:3jnYgNN7k7FuojVkgE3Wnj",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3jnYgNN7k7FuojVkgE3Wnj",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3jnYgNN7k7FuojVkgE3Wnj",
   "Duration_ms": 198893,
   "time_signature": 4,
   "Genre": "nordichouse"
 },
 {
   
   "Name": "Jenifer",
   "Danceability": 0.599,
   "Energy": 0.698,
   "Key": 0,
   "Loudness": -8.975,
   "Mode": 1,
   "Speechness": 0.0436,
   "Acousticness": 0.578,
   "Instrumentalness": 0,
   "Liveness": 0.0932,
   "Valence": 0.902,
   "Tempo": 169.798,
   "Type": "audio_features",
   "ID": "7hiceWoDGGP4RadNyGxRdm",
   "Uri": "spotify:track:7hiceWoDGGP4RadNyGxRdm",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7hiceWoDGGP4RadNyGxRdm",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7hiceWoDGGP4RadNyGxRdm",
   "Duration_ms": 231160,
   "time_signature": 4,
   "Genre": "rockcatala"
 },
 {
   
   "Name": "Soft",
   "Danceability": 0.695,
   "Energy": 0.66,
   "Key": 0,
   "Loudness": -7.51,
   "Mode": 1,
   "Speechness": 0.0407,
   "Acousticness": 0.64,
   "Instrumentalness": 0.816,
   "Liveness": 0.0814,
   "Valence": 0.784,
   "Tempo": 82.523,
   "Type": "audio_features",
   "ID": "442GUiZkEs0Ve67zeJtj63",
   "Uri": "spotify:track:442GUiZkEs0Ve67zeJtj63",
   "Ref_Track": "https://api.spotify.com/v1/tracks/442GUiZkEs0Ve67zeJtj63",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/442GUiZkEs0Ve67zeJtj63",
   "Duration_ms": 150907,
   "time_signature": 4,
   "Genre": "rhythmandblues"
 },
 {
   
   "Name": "Happier",
   "Danceability": 0.687,
   "Energy": 0.792,
   "Key": 5,
   "Loudness": -2.749,
   "Mode": 1,
   "Speechness": 0.0452,
   "Acousticness": 0.191,
   "Instrumentalness": 0,
   "Liveness": 0.167,
   "Valence": 0.671,
   "Tempo": 100.015,
   "Type": "audio_features",
   "ID": "2dpaYNEQHiRxtZbfNsse99",
   "Uri": "spotify:track:2dpaYNEQHiRxtZbfNsse99",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2dpaYNEQHiRxtZbfNsse99",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2dpaYNEQHiRxtZbfNsse99",
   "Duration_ms": 214290,
   "time_signature": 4,
   "Genre": "handsup"
 },
 {
   
   "Name": "OMagnumMysterium:Omagnummysterium",
   "Danceability": 0.0623,
   "Energy": 0.0116,
   "Key": 2,
   "Loudness": -27.893,
   "Mode": 1,
   "Speechness": 0.0567,
   "Acousticness": 0.991,
   "Instrumentalness": 0.445,
   "Liveness": 0.0816,
   "Valence": 0.0331,
   "Tempo": 65.057,
   "Type": "audio_features",
   "ID": "0S0YKiEdR9cT9pYgEaTevF",
   "Uri": "spotify:track:0S0YKiEdR9cT9pYgEaTevF",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0S0YKiEdR9cT9pYgEaTevF",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0S0YKiEdR9cT9pYgEaTevF",
   "Duration_ms": 415800,
   "time_signature": 3,
   "Genre": "chamberchoir"
 },
 {
   
   "Name": "EnterSandman",
   "Danceability": 0.579,
   "Energy": 0.824,
   "Key": 6,
   "Loudness": -8.71,
   "Mode": 0,
   "Speechness": 0.03,
   "Acousticness": 0.00206,
   "Instrumentalness": 0.00903,
   "Liveness": 0.059,
   "Valence": 0.635,
   "Tempo": 123.331,
   "Type": "audio_features",
   "ID": "1hKdDCpiI9mqz1jVHRKG0E",
   "Uri": "spotify:track:1hKdDCpiI9mqz1jVHRKG0E",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1hKdDCpiI9mqz1jVHRKG0E",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1hKdDCpiI9mqz1jVHRKG0E",
   "Duration_ms": 331573,
   "time_signature": 4,
   "Genre": "thrashmetal"
 },
 {
   
   "Name": "GodSaveOurQueen(BritishNationalAnthem)",
   "Danceability": 0.118,
   "Energy": 0.275,
   "Key": 3,
   "Loudness": -15.351,
   "Mode": 1,
   "Speechness": 0.0345,
   "Acousticness": 0.859,
   "Instrumentalness": 0.903,
   "Liveness": 0.0885,
   "Valence": 0.229,
   "Tempo": 87.268,
   "Type": "audio_features",
   "ID": "0iIJAyiAZHoIxKYMhsfmCA",
   "Uri": "spotify:track:0iIJAyiAZHoIxKYMhsfmCA",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0iIJAyiAZHoIxKYMhsfmCA",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0iIJAyiAZHoIxKYMhsfmCA",
   "Duration_ms": 142987,
   "time_signature": 4,
   "Genre": "britishchoir"
 },
 {
   
   "Name": "ThisTime",
   "Danceability": 0.462,
   "Energy": 0.965,
   "Key": 9,
   "Loudness": -6.73,
   "Mode": 1,
   "Speechness": 0.05,
   "Acousticness": 0.00046,
   "Instrumentalness": 0.000529,
   "Liveness": 0.243,
   "Valence": 0.423,
   "Tempo": 102.564,
   "Type": "audio_features",
   "ID": "38slJ4r0KTGdBlfznzA0hc",
   "Uri": "spotify:track:38slJ4r0KTGdBlfznzA0hc",
   "Ref_Track": "https://api.spotify.com/v1/tracks/38slJ4r0KTGdBlfznzA0hc",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/38slJ4r0KTGdBlfznzA0hc",
   "Duration_ms": 292480,
   "time_signature": 4,
   "Genre": "swedishhardrock"
 },
 {
   
   "Name": "SigamosBailando",
   "Danceability": 0.724,
   "Energy": 0.865,
   "Key": 4,
   "Loudness": -2.945,
   "Mode": 0,
   "Speechness": 0.0376,
   "Acousticness": 0.0297,
   "Instrumentalness": 0,
   "Liveness": 0.0499,
   "Valence": 0.594,
   "Tempo": 108.03,
   "Type": "audio_features",
   "ID": "07XhZyYKgZMT4SBAddwVhl",
   "Uri": "spotify:track:07XhZyYKgZMT4SBAddwVhl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/07XhZyYKgZMT4SBAddwVhl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/07XhZyYKgZMT4SBAddwVhl",
   "Duration_ms": 189160,
   "time_signature": 4,
   "Genre": "regionalmexicanpop"
 },
 {
   
   "Name": "Awaken",
   "Danceability": 0.299,
   "Energy": 0.926,
   "Key": 10,
   "Loudness": -6.745,
   "Mode": 0,
   "Speechness": 0.0861,
   "Acousticness": 0.0000693,
   "Instrumentalness": 0.379,
   "Liveness": 0.117,
   "Valence": 0.191,
   "Tempo": 164.016,
   "Type": "audio_features",
   "ID": "0kNqCedrYcDW3DazvznEkg",
   "Uri": "spotify:track:0kNqCedrYcDW3DazvznEkg",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0kNqCedrYcDW3DazvznEkg",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0kNqCedrYcDW3DazvznEkg",
   "Duration_ms": 395080,
   "time_signature": 4,
   "Genre": "progressivedeathcore"
 },
 {
   
   "Name": "LoveSomeone",
   "Danceability": 0.423,
   "Energy": 0.813,
   "Key": 9,
   "Loudness": -5.011,
   "Mode": 1,
   "Speechness": 0.0507,
   "Acousticness": 0.218,
   "Instrumentalness": 0.00000162,
   "Liveness": 0.0732,
   "Valence": 0.421,
   "Tempo": 173.995,
   "Type": "audio_features",
   "ID": "43CFDpciGFDm226POTLEXU",
   "Uri": "spotify:track:43CFDpciGFDm226POTLEXU",
   "Ref_Track": "https://api.spotify.com/v1/tracks/43CFDpciGFDm226POTLEXU",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/43CFDpciGFDm226POTLEXU",
   "Duration_ms": 211720,
   "time_signature": 4,
   "Genre": "manitobacountry"
 },
 {
   
   "Name": "Sonatapastorale:IIa.Pastorale",
   "Danceability": 0.204,
   "Energy": 0.0174,
   "Key": 5,
   "Loudness": -28.902,
   "Mode": 1,
   "Speechness": 0.0481,
   "Acousticness": 0.992,
   "Instrumentalness": 0.766,
   "Liveness": 0.147,
   "Valence": 0.0448,
   "Tempo": 82.945,
   "Type": "audio_features",
   "ID": "6Bx0DQ8gexi34whikRVtHz",
   "Uri": "spotify:track:6Bx0DQ8gexi34whikRVtHz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6Bx0DQ8gexi34whikRVtHz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6Bx0DQ8gexi34whikRVtHz",
   "Duration_ms": 181600,
   "time_signature": 4,
   "Genre": "historicclassicalperformance"
 },
 {
   
   "Name": "YogadoSonoMacio",
   "Danceability": 0.197,
   "Energy": 0.0152,
   "Key": 5,
   "Loudness": -34.308,
   "Mode": 1,
   "Speechness": 0.0616,
   "Acousticness": 0.984,
   "Instrumentalness": 0.837,
   "Liveness": 0.0885,
   "Valence": 0.0666,
   "Tempo": 67.756,
   "Type": "audio_features",
   "ID": "0SUYpyczCC59xE8FBW32Ba",
   "Uri": "spotify:track:0SUYpyczCC59xE8FBW32Ba",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0SUYpyczCC59xE8FBW32Ba",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0SUYpyczCC59xE8FBW32Ba",
   "Duration_ms": 210152,
   "time_signature": 4,
   "Genre": "spaceambient"
 },
 {
   
   "Name": "Untold",
   "Danceability": 0.3,
   "Energy": 0.596,
   "Key": 4,
   "Loudness": -12.806,
   "Mode": 0,
   "Speechness": 0.0768,
   "Acousticness": 0.191,
   "Instrumentalness": 0.567,
   "Liveness": 0.383,
   "Valence": 0.116,
   "Tempo": 177.501,
   "Type": "audio_features",
   "ID": "356N82z0OcAbFvMmUOV6ud",
   "Uri": "spotify:track:356N82z0OcAbFvMmUOV6ud",
   "Ref_Track": "https://api.spotify.com/v1/tracks/356N82z0OcAbFvMmUOV6ud",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/356N82z0OcAbFvMmUOV6ud",
   "Duration_ms": 258561,
   "time_signature": 3,
   "Genre": "downtempo"
 },
 {
   
   "Name": "Kika",
   "Danceability": 0.92,
   "Energy": 0.644,
   "Key": 4,
   "Loudness": -5.642,
   "Mode": 0,
   "Speechness": 0.215,
   "Acousticness": 0.159,
   "Instrumentalness": 0,
   "Liveness": 0.143,
   "Valence": 0.553,
   "Tempo": 137.997,
   "Type": "audio_features",
   "ID": "0O8KPTW6lbJXPwLfC306td",
   "Uri": "spotify:track:0O8KPTW6lbJXPwLfC306td",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0O8KPTW6lbJXPwLfC306td",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0O8KPTW6lbJXPwLfC306td",
   "Duration_ms": 222616,
   "time_signature": 4,
   "Genre": "romaniantrap"
 },
 {
   
   "Name": "EbbandFlow",
   "Danceability": 0.426,
   "Energy": 0.521,
   "Key": 5,
   "Loudness": -6.288,
   "Mode": 1,
   "Speechness": 0.0256,
   "Acousticness": 0.0107,
   "Instrumentalness": 0.0000587,
   "Liveness": 0.0937,
   "Valence": 0.443,
   "Tempo": 165.091,
   "Type": "audio_features",
   "ID": "1o8MaDqJF3J2DRWuyNiDFl",
   "Uri": "spotify:track:1o8MaDqJF3J2DRWuyNiDFl",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1o8MaDqJF3J2DRWuyNiDFl",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1o8MaDqJF3J2DRWuyNiDFl",
   "Duration_ms": 197560,
   "time_signature": 3,
   "Genre": "deepsouthernsoul"
 },
 {
   
   "Name": "Lifestyle",
   "Danceability": 0.686,
   "Energy": 0.793,
   "Key": 8,
   "Loudness": -7.174,
   "Mode": 1,
   "Speechness": 0.0426,
   "Acousticness": 0.0303,
   "Instrumentalness": 0.0422,
   "Liveness": 0.367,
   "Valence": 0.745,
   "Tempo": 159.996,
   "Type": "audio_features",
   "ID": "01Ua8CqXLI0jt8o6iuNOF2",
   "Uri": "spotify:track:01Ua8CqXLI0jt8o6iuNOF2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/01Ua8CqXLI0jt8o6iuNOF2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/01Ua8CqXLI0jt8o6iuNOF2",
   "Duration_ms": 200156,
   "time_signature": 4,
   "Genre": "rapmetal"
 },
 {
   
   "Name": "Dosnívané",
   "Danceability": 0.543,
   "Energy": 0.807,
   "Key": 4,
   "Loudness": -4.871,
   "Mode": 0,
   "Speechness": 0.172,
   "Acousticness": 0.363,
   "Instrumentalness": 0,
   "Liveness": 0.0886,
   "Valence": 0.633,
   "Tempo": 180.303,
   "Type": "audio_features",
   "ID": "3M3fUa89iD3O75auTu8z2f",
   "Uri": "spotify:track:3M3fUa89iD3O75auTu8z2f",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3M3fUa89iD3O75auTu8z2f",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3M3fUa89iD3O75auTu8z2f",
   "Duration_ms": 207064,
   "time_signature": 4,
   "Genre": "czechhiphop"
 },
 {
   
   "Name": "214.0",
   "Danceability": 0.537,
   "Energy": 0.561,
   "Key": 4,
   "Loudness": -6.961,
   "Mode": 0,
   "Speechness": 0.0297,
   "Acousticness": 0.423,
   "Instrumentalness": 0.00000164,
   "Liveness": 0.134,
   "Valence": 0.242,
   "Tempo": 78.13,
   "Type": "audio_features",
   "ID": "7gZ3kWNtIxFgxjsm5OTVMB",
   "Uri": "spotify:track:7gZ3kWNtIxFgxjsm5OTVMB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7gZ3kWNtIxFgxjsm5OTVMB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7gZ3kWNtIxFgxjsm5OTVMB",
   "Duration_ms": 273200,
   "time_signature": 4,
   "Genre": "classicopm"
 },
 {
   
   "Name": "Slide(feat.Blueface&LilTjay)",
   "Danceability": 0.532,
   "Energy": 0.704,
   "Key": 5,
   "Loudness": -3.895,
   "Mode": 0,
   "Speechness": 0.26,
   "Acousticness": 0.093,
   "Instrumentalness": 0,
   "Liveness": 0.184,
   "Valence": 0.591,
   "Tempo": 96.004,
   "Type": "audio_features",
   "ID": "40Zb4FZ6nS1Hj8RVfaLkCV",
   "Uri": "spotify:track:40Zb4FZ6nS1Hj8RVfaLkCV",
   "Ref_Track": "https://api.spotify.com/v1/tracks/40Zb4FZ6nS1Hj8RVfaLkCV",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/40Zb4FZ6nS1Hj8RVfaLkCV",
   "Duration_ms": 186344,
   "time_signature": 4,
   "Genre": "j-rap"
 },
 {
   
   "Name": "AmparitoRoca(PasodobleTorero)",
   "Danceability": 0.366,
   "Energy": 0.27,
   "Key": 0,
   "Loudness": -9.357,
   "Mode": 1,
   "Speechness": 0.0409,
   "Acousticness": 0.953,
   "Instrumentalness": 0.357,
   "Liveness": 0.102,
   "Valence": 0.439,
   "Tempo": 118.504,
   "Type": "audio_features",
   "ID": "1eLRVy5ROoqL843hwGE6bB",
   "Uri": "spotify:track:1eLRVy5ROoqL843hwGE6bB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1eLRVy5ROoqL843hwGE6bB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1eLRVy5ROoqL843hwGE6bB",
   "Duration_ms": 184947,
   "time_signature": 4,
   "Genre": "pasodobles"
 },
 {
   
   "Name": "Soldi",
   "Danceability": 0.69,
   "Energy": 0.581,
   "Key": 3,
   "Loudness": -9.832,
   "Mode": 0,
   "Speechness": 0.0466,
   "Acousticness": 0.0404,
   "Instrumentalness": 0,
   "Liveness": 0.111,
   "Valence": 0.372,
   "Tempo": 94.904,
   "Type": "audio_features",
   "ID": "2dxky69jKzbtUfA3Hl8Nuo",
   "Uri": "spotify:track:2dxky69jKzbtUfA3Hl8Nuo",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2dxky69jKzbtUfA3Hl8Nuo",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2dxky69jKzbtUfA3Hl8Nuo",
   "Duration_ms": 195476,
   "time_signature": 4,
   "Genre": "eurovision"
 },
 {
   
   "Name": "FreeBird",
   "Danceability": 0.252,
   "Energy": 0.844,
   "Key": 0,
   "Loudness": -8.121,
   "Mode": 1,
   "Speechness": 0.0572,
   "Acousticness": 0.0765,
   "Instrumentalness": 0.00018,
   "Liveness": 0.084,
   "Valence": 0.351,
   "Tempo": 118.158,
   "Type": "audio_features",
   "ID": "5EWPGh7jbTNO2wakv8LjUI",
   "Uri": "spotify:track:5EWPGh7jbTNO2wakv8LjUI",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5EWPGh7jbTNO2wakv8LjUI",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5EWPGh7jbTNO2wakv8LjUI",
   "Duration_ms": 547107,
   "time_signature": 4,
   "Genre": "southernrock"
 },
 {
   
   "Name": "Lucyenne-Editmix",
   "Danceability": 0.542,
   "Energy": 0.881,
   "Key": 5,
   "Loudness": -5.835,
   "Mode": 1,
   "Speechness": 0.0432,
   "Acousticness": 0.0259,
   "Instrumentalness": 0,
   "Liveness": 0.239,
   "Valence": 0.816,
   "Tempo": 176.06,
   "Type": "audio_features",
   "ID": "3fECeRvwsBKFjq7IrIbNuB",
   "Uri": "spotify:track:3fECeRvwsBKFjq7IrIbNuB",
   "Ref_Track": "https://api.spotify.com/v1/tracks/3fECeRvwsBKFjq7IrIbNuB",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/3fECeRvwsBKFjq7IrIbNuB",
   "Duration_ms": 173093,
   "time_signature": 4,
   "Genre": "italianska"
 },
 {
   
   "Name": "PorOndeAndei-AoVivo",
   "Danceability": 0.303,
   "Energy": 0.791,
   "Key": 0,
   "Loudness": -4.995,
   "Mode": 1,
   "Speechness": 0.0336,
   "Acousticness": 0.375,
   "Instrumentalness": 0.0000173,
   "Liveness": 0.725,
   "Valence": 0.385,
   "Tempo": 86.255,
   "Type": "audio_features",
   "ID": "4CpwoEs39CydHJuTCl9kfm",
   "Uri": "spotify:track:4CpwoEs39CydHJuTCl9kfm",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4CpwoEs39CydHJuTCl9kfm",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4CpwoEs39CydHJuTCl9kfm",
   "Duration_ms": 251933,
   "time_signature": 4,
   "Genre": "mpb"
 },
 {
   
   "Name": "Flamengo",
   "Danceability": 0.683,
   "Energy": 0.499,
   "Key": 7,
   "Loudness": -11.935,
   "Mode": 1,
   "Speechness": 0.0343,
   "Acousticness": 0.814,
   "Instrumentalness": 0.905,
   "Liveness": 0.107,
   "Valence": 0.945,
   "Tempo": 93.728,
   "Type": "audio_features",
   "ID": "1Ktxc4v4Y3iH1LpHJqbFtW",
   "Uri": "spotify:track:1Ktxc4v4Y3iH1LpHJqbFtW",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1Ktxc4v4Y3iH1LpHJqbFtW",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1Ktxc4v4Y3iH1LpHJqbFtW",
   "Duration_ms": 265693,
   "time_signature": 4,
   "Genre": "choro"
 },
 {
   
   "Name": "SiTúTeVas",
   "Danceability": 0.721,
   "Energy": 0.912,
   "Key": 10,
   "Loudness": -4.304,
   "Mode": 1,
   "Speechness": 0.0645,
   "Acousticness": 0.136,
   "Instrumentalness": 0.00000227,
   "Liveness": 0.121,
   "Valence": 0.298,
   "Tempo": 99.985,
   "Type": "audio_features",
   "ID": "59h2LTeAoyQQWzZ8h8BciR",
   "Uri": "spotify:track:59h2LTeAoyQQWzZ8h8BciR",
   "Ref_Track": "https://api.spotify.com/v1/tracks/59h2LTeAoyQQWzZ8h8BciR",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/59h2LTeAoyQQWzZ8h8BciR",
   "Duration_ms": 208411,
   "time_signature": 4,
   "Genre": "cantautor"
 },
 {
   
   "Name": "Medusa",
   "Danceability": 0.709,
   "Energy": 0.868,
   "Key": 10,
   "Loudness": -3.136,
   "Mode": 0,
   "Speechness": 0.276,
   "Acousticness": 0.151,
   "Instrumentalness": 0,
   "Liveness": 0.385,
   "Valence": 0.654,
   "Tempo": 101.008,
   "Type": "audio_features",
   "ID": "2QrU6RUAgremF9q47WBgp0",
   "Uri": "spotify:track:2QrU6RUAgremF9q47WBgp0",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2QrU6RUAgremF9q47WBgp0",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2QrU6RUAgremF9q47WBgp0",
   "Duration_ms": 153600,
   "time_signature": 4,
   "Genre": "undergroundrap"
 },
 {
   
   "Name": "Sanity",
   "Danceability": 0.292,
   "Energy": 0.926,
   "Key": 1,
   "Loudness": -7.645,
   "Mode": 1,
   "Speechness": 0.0832,
   "Acousticness": 0.0000125,
   "Instrumentalness": 0.00135,
   "Liveness": 0.63,
   "Valence": 0.701,
   "Tempo": 135.986,
   "Type": "audio_features",
   "ID": "1sT8LCwZPD2g37dJ1uYNG7",
   "Uri": "spotify:track:1sT8LCwZPD2g37dJ1uYNG7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1sT8LCwZPD2g37dJ1uYNG7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1sT8LCwZPD2g37dJ1uYNG7",
   "Duration_ms": 102547,
   "time_signature": 4,
   "Genre": "thrashcore"
 },
 {
   
   "Name": "Telephonefeat.5lack",
   "Danceability": 0.73,
   "Energy": 0.52,
   "Key": 11,
   "Loudness": -5.862,
   "Mode": 0,
   "Speechness": 0.0347,
   "Acousticness": 0.747,
   "Instrumentalness": 0.0000879,
   "Liveness": 0.123,
   "Valence": 0.166,
   "Tempo": 101.533,
   "Type": "audio_features",
   "ID": "7aoO8k6WRlPo1VZhEnqP14",
   "Uri": "spotify:track:7aoO8k6WRlPo1VZhEnqP14",
   "Ref_Track": "https://api.spotify.com/v1/tracks/7aoO8k6WRlPo1VZhEnqP14",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/7aoO8k6WRlPo1VZhEnqP14",
   "Duration_ms": 256013,
   "time_signature": 4,
   "Genre": "japaneser&b"
 },
 {
   
   "Name": "ChegadeSaudade",
   "Danceability": 0.418,
   "Energy": 0.248,
   "Key": 2,
   "Loudness": -15.956,
   "Mode": 1,
   "Speechness": 0.0341,
   "Acousticness": 0.705,
   "Instrumentalness": 0,
   "Liveness": 0.193,
   "Valence": 0.654,
   "Tempo": 176.634,
   "Type": "audio_features",
   "ID": "0QhoniumuDQIQY46aIebRq",
   "Uri": "spotify:track:0QhoniumuDQIQY46aIebRq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0QhoniumuDQIQY46aIebRq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0QhoniumuDQIQY46aIebRq",
   "Duration_ms": 121574,
   "time_signature": 4,
   "Genre": "bossanovajazz"
 },
 {
   
   "Name": "Létolásky",
   "Danceability": 0.768,
   "Energy": 0.622,
   "Key": 9,
   "Loudness": -5.97,
   "Mode": 1,
   "Speechness": 0.035,
   "Acousticness": 0.369,
   "Instrumentalness": 0,
   "Liveness": 0.102,
   "Valence": 0.811,
   "Tempo": 115.008,
   "Type": "audio_features",
   "ID": "0YkGvh5WGrNRnVGd0mNYY2",
   "Uri": "spotify:track:0YkGvh5WGrNRnVGd0mNYY2",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0YkGvh5WGrNRnVGd0mNYY2",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0YkGvh5WGrNRnVGd0mNYY2",
   "Duration_ms": 203000,
   "time_signature": 4,
   "Genre": "czechpop"
 },
 {
   
   "Name": "Pushin\\TooHard",
   "Danceability": 0.509,
   "Energy": 0.841,
   "Key": 8,
   "Loudness": -6.412,
   "Mode": 0,
   "Speechness": 0.0453,
   "Acousticness": 0.383,
   "Instrumentalness": 0.0000479,
   "Liveness": 0.278,
   "Valence": 0.833,
   "Tempo": 142.324,
   "Type": "audio_features",
   "ID": "5ONuCkzWepR86zviTzRicz",
   "Uri": "spotify:track:5ONuCkzWepR86zviTzRicz",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5ONuCkzWepR86zviTzRicz",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5ONuCkzWepR86zviTzRicz",
   "Duration_ms": 159493,
   "time_signature": 4,
   "Genre": "freakbeat"
 },
 {
   
   "Name": "Loop",
   "Danceability": 0.676,
   "Energy": 0.508,
   "Key": 2,
   "Loudness": -7.515,
   "Mode": 1,
   "Speechness": 0.0577,
   "Acousticness": 0.564,
   "Instrumentalness": 0.000142,
   "Liveness": 0.101,
   "Valence": 0.323,
   "Tempo": 106.015,
   "Type": "audio_features",
   "ID": "2Kcs3QR8VfcFG7mUeewnyP",
   "Uri": "spotify:track:2Kcs3QR8VfcFG7mUeewnyP",
   "Ref_Track": "https://api.spotify.com/v1/tracks/2Kcs3QR8VfcFG7mUeewnyP",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/2Kcs3QR8VfcFG7mUeewnyP",
   "Duration_ms": 238895,
   "time_signature": 4,
   "Genre": "kindierock"
 },
 {
   
   "Name": "ConCalma",
   "Danceability": 0.737,
   "Energy": 0.86,
   "Key": 8,
   "Loudness": -2.652,
   "Mode": 0,
   "Speechness": 0.0593,
   "Acousticness": 0.11,
   "Instrumentalness": 0.00000194,
   "Liveness": 0.0574,
   "Valence": 0.656,
   "Tempo": 93.989,
   "Type": "audio_features",
   "ID": "5w9c2J52mkdntKOmRLeM2m",
   "Uri": "spotify:track:5w9c2J52mkdntKOmRLeM2m",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5w9c2J52mkdntKOmRLeM2m",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5w9c2J52mkdntKOmRLeM2m",
   "Duration_ms": 193227,
   "time_signature": 4,
   "Genre": "deepdancepop"
 },
 {
   
   "Name": "Onkaikkimaksettu",
   "Danceability": 0.476,
   "Energy": 0.522,
   "Key": 3,
   "Loudness": -9.683,
   "Mode": 1,
   "Speechness": 0.0384,
   "Acousticness": 0.185,
   "Instrumentalness": 0.00351,
   "Liveness": 0.368,
   "Valence": 0.165,
   "Tempo": 149.954,
   "Type": "audio_features",
   "ID": "0mN2127JzhGslleBtAKJqs",
   "Uri": "spotify:track:0mN2127JzhGslleBtAKJqs",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0mN2127JzhGslleBtAKJqs",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0mN2127JzhGslleBtAKJqs",
   "Duration_ms": 265333,
   "time_signature": 4,
   "Genre": "finnishworship"
 },
 {
   
   "Name": "ITookaPillinIbiza",
   "Danceability": 0.672,
   "Energy": 0.254,
   "Key": 0,
   "Loudness": -16.608,
   "Mode": 0,
   "Speechness": 0.0515,
   "Acousticness": 0.857,
   "Instrumentalness": 0.908,
   "Liveness": 0.105,
   "Valence": 0.697,
   "Tempo": 102.716,
   "Type": "audio_features",
   "ID": "1csgfyFfIrSk5sIgK411du",
   "Uri": "spotify:track:1csgfyFfIrSk5sIgK411du",
   "Ref_Track": "https://api.spotify.com/v1/tracks/1csgfyFfIrSk5sIgK411du",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/1csgfyFfIrSk5sIgK411du",
   "Duration_ms": 174031,
   "time_signature": 4,
   "Genre": "fingerstyle"
 },
 {
   
   "Name": "ChegadeSaudade",
   "Danceability": 0.418,
   "Energy": 0.248,
   "Key": 2,
   "Loudness": -15.956,
   "Mode": 1,
   "Speechness": 0.0341,
   "Acousticness": 0.705,
   "Instrumentalness": 0,
   "Liveness": 0.193,
   "Valence": 0.654,
   "Tempo": 176.634,
   "Type": "audio_features",
   "ID": "0QhoniumuDQIQY46aIebRq",
   "Uri": "spotify:track:0QhoniumuDQIQY46aIebRq",
   "Ref_Track": "https://api.spotify.com/v1/tracks/0QhoniumuDQIQY46aIebRq",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/0QhoniumuDQIQY46aIebRq",
   "Duration_ms": 121574,
   "time_signature": 4,
   "Genre": "bossanova"
 },
 {
   
   "Name": "SymphonyinDMajor:I.Largo-Allegro",
   "Danceability": 0.354,
   "Energy": 0.121,
   "Key": 2,
   "Loudness": -21.184,
   "Mode": 1,
   "Speechness": 0.0392,
   "Acousticness": 0.949,
   "Instrumentalness": 0.74,
   "Liveness": 0.12,
   "Valence": 0.309,
   "Tempo": 80.758,
   "Type": "audio_features",
   "ID": "4aA2ynktTBMMRu9K8R4c4z",
   "Uri": "spotify:track:4aA2ynktTBMMRu9K8R4c4z",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4aA2ynktTBMMRu9K8R4c4z",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4aA2ynktTBMMRu9K8R4c4z",
   "Duration_ms": 789533,
   "time_signature": 4,
   "Genre": "earlyromanticera"
 },
 {
   
   "Name": "Iemanja-LiveFromBrazil/2007",
   "Danceability": 0.655,
   "Energy": 0.754,
   "Key": 7,
   "Loudness": -6.017,
   "Mode": 1,
   "Speechness": 0.0342,
   "Acousticness": 0.147,
   "Instrumentalness": 0.0000475,
   "Liveness": 0.974,
   "Valence": 0.583,
   "Tempo": 123.071,
   "Type": "audio_features",
   "ID": "6kehLkQ93haVlp2MkqkL4V",
   "Uri": "spotify:track:6kehLkQ93haVlp2MkqkL4V",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6kehLkQ93haVlp2MkqkL4V",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6kehLkQ93haVlp2MkqkL4V",
   "Duration_ms": 271173,
   "time_signature": 4,
   "Genre": "brazilianreggae"
 },
 {
   
   "Name": "GrazingInTheGrass",
   "Danceability": 0.791,
   "Energy": 0.71,
   "Key": 7,
   "Loudness": -6.604,
   "Mode": 0,
   "Speechness": 0.0305,
   "Acousticness": 0.798,
   "Instrumentalness": 0.941,
   "Liveness": 0.292,
   "Valence": 0.935,
   "Tempo": 109.983,
   "Type": "audio_features",
   "ID": "4ewr2YZx2pXsxDTC4mWFob",
   "Uri": "spotify:track:4ewr2YZx2pXsxDTC4mWFob",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4ewr2YZx2pXsxDTC4mWFob",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4ewr2YZx2pXsxDTC4mWFob",
   "Duration_ms": 174067,
   "time_signature": 4,
   "Genre": "southafricanjazz"
 },
 {
   
   "Name": "JönATré",
   "Danceability": 0.663,
   "Energy": 0.589,
   "Key": 10,
   "Loudness": -6.736,
   "Mode": 0,
   "Speechness": 0.3,
   "Acousticness": 0.0231,
   "Instrumentalness": 0,
   "Liveness": 0.115,
   "Valence": 0.34,
   "Tempo": 93.198,
   "Type": "audio_features",
   "ID": "28jnpbWzIPIgDLjlqj6esb",
   "Uri": "spotify:track:28jnpbWzIPIgDLjlqj6esb",
   "Ref_Track": "https://api.spotify.com/v1/tracks/28jnpbWzIPIgDLjlqj6esb",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/28jnpbWzIPIgDLjlqj6esb",
   "Duration_ms": 244460,
   "time_signature": 4,
   "Genre": "hungarianhiphop"
 },
 {
   
   "Name": "TheFinalComedown",
   "Danceability": 0.75,
   "Energy": 0.955,
   "Key": 1,
   "Loudness": -8.074,
   "Mode": 1,
   "Speechness": 0.0459,
   "Acousticness": 0.16,
   "Instrumentalness": 0.482,
   "Liveness": 0.0888,
   "Valence": 0.923,
   "Tempo": 105.638,
   "Type": "audio_features",
   "ID": "4rIXPKi6nsXrGAueC0fNgh",
   "Uri": "spotify:track:4rIXPKi6nsXrGAueC0fNgh",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4rIXPKi6nsXrGAueC0fNgh",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4rIXPKi6nsXrGAueC0fNgh",
   "Duration_ms": 207867,
   "time_signature": 4,
   "Genre": "latinafrobeat"
 },
 {
   
   "Name": "Threads",
   "Danceability": 0.12,
   "Energy": 0.0436,
   "Key": 4,
   "Loudness": -22.044,
   "Mode": 1,
   "Speechness": 0.0383,
   "Acousticness": 0.79,
   "Instrumentalness": 0.889,
   "Liveness": 0.112,
   "Valence": 0.0361,
   "Tempo": 72.339,
   "Type": "audio_features",
   "ID": "30VnmNoXmeNMlDR6MxLP5U",
   "Uri": "spotify:track:30VnmNoXmeNMlDR6MxLP5U",
   "Ref_Track": "https://api.spotify.com/v1/tracks/30VnmNoXmeNMlDR6MxLP5U",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/30VnmNoXmeNMlDR6MxLP5U",
   "Duration_ms": 192793,
   "time_signature": 4,
   "Genre": "meditation"
 },
 {
   
   "Name": "SincerelyYours",
   "Danceability": 0.548,
   "Energy": 0.599,
   "Key": 7,
   "Loudness": -6.015,
   "Mode": 0,
   "Speechness": 0.0342,
   "Acousticness": 0.171,
   "Instrumentalness": 0.00000171,
   "Liveness": 0.106,
   "Valence": 0.499,
   "Tempo": 170.04,
   "Type": "audio_features",
   "ID": "6NYperSEpMfiIU5cUBGHZC",
   "Uri": "spotify:track:6NYperSEpMfiIU5cUBGHZC",
   "Ref_Track": "https://api.spotify.com/v1/tracks/6NYperSEpMfiIU5cUBGHZC",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/6NYperSEpMfiIU5cUBGHZC",
   "Duration_ms": 208973,
   "time_signature": 4,
   "Genre": "australianpop"
 },
 {
   
   "Name": "LasFloresdeTuFlorero",
   "Danceability": 0.766,
   "Energy": 0.671,
   "Key": 0,
   "Loudness": -5.243,
   "Mode": 1,
   "Speechness": 0.0359,
   "Acousticness": 0.113,
   "Instrumentalness": 0.0000207,
   "Liveness": 0.102,
   "Valence": 0.81,
   "Tempo": 141.998,
   "Type": "audio_features",
   "ID": "4uO0NyK4WLuzfTGzc49X3x",
   "Uri": "spotify:track:4uO0NyK4WLuzfTGzc49X3x",
   "Ref_Track": "https://api.spotify.com/v1/tracks/4uO0NyK4WLuzfTGzc49X3x",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/4uO0NyK4WLuzfTGzc49X3x",
   "Duration_ms": 174000,
   "time_signature": 4,
   "Genre": "ranchera"
 },
 {
   
   "Name": "Poloneesijapolska",
   "Danceability": 0.299,
   "Energy": 0.404,
   "Key": 2,
   "Loudness": -9.061,
   "Mode": 1,
   "Speechness": 0.0449,
   "Acousticness": 0.889,
   "Instrumentalness": 0.745,
   "Liveness": 0.0954,
   "Valence": 0.436,
   "Tempo": 108.255,
   "Type": "audio_features",
   "ID": "5RBztafIKWgQbxqRObQvkm",
   "Uri": "spotify:track:5RBztafIKWgQbxqRObQvkm",
   "Ref_Track": "https://api.spotify.com/v1/tracks/5RBztafIKWgQbxqRObQvkm",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/5RBztafIKWgQbxqRObQvkm",
   "Duration_ms": 316067,
   "time_signature": 4,
   "Genre": "finnishfolk"
 },
 {
   
   "Name": "AreWeReady?(Wreck)",
   "Danceability": 0.601,
   "Energy": 0.784,
   "Key": 2,
   "Loudness": -5.622,
   "Mode": 0,
   "Speechness": 0.0333,
   "Acousticness": 0.00476,
   "Instrumentalness": 0.0127,
   "Liveness": 0.347,
   "Valence": 0.726,
   "Tempo": 94.019,
   "Type": "audio_features",
   "ID": "215Z4s5KDIi4BjRlJotgi7",
   "Uri": "spotify:track:215Z4s5KDIi4BjRlJotgi7",
   "Ref_Track": "https://api.spotify.com/v1/tracks/215Z4s5KDIi4BjRlJotgi7",
   "URL_features": "https://api.spotify.com/v1/audio-analysis/215Z4s5KDIi4BjRlJotgi7",
   "Duration_ms": 230853,
   "time_signature": 4,
   "Genre": "britishindierock"
 }
]
